var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _path12, _circle, _g25, _g26, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiPageDesign2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 808.1,
    width: 471.9,
    height: 471.6,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1259.7,294.5l-1.3-28.3,29.6-4.2v-.8l-29.3,4.2,12.6-32.1,17.8,11.3.4-.6-18.2-11.5-12.4-26.8,31.2,18.2.4-.8-31.9-18.4,19.7-12.6h0l11.1-8.2-.4-.6-10.9,8-14.7-15.3,26.2-27.9-.6-.6-25.2,26.8,12.6-39.6,15.1-10.3-.4-.6-14.7,10.1-8.4-29.3,29.8,2.1v-.8l-29.8-2.1-6.3-64.8,27.7,21,.4-.6-28.1-21.4,26.6-41.1-.6-.4-26.6,41.1-40.2-13.4,14.9-27.3-.8-.4-14.9,27.5-23.5-3.6-1.5-23.7h-.8l1.5,23.9-20.5,13.6L1140.8.4l-.6.6,33.5,32.5h-47.4l11.9-37.3h-.8c0-.2-11.9,36.7-11.9,36.7l-19.5-35.4-.8.4,19.9,36.1-16.8,20.8-63.7-57.2-.6.6,64.1,57.4,12.2,36.1h0l71.5,28.1,19.5,32.9c-2.9,12.2-10.3,43.6-11.1,44.9h0v.2h0c.4,4.8,21,55.1,27.3,70.9h0l31,25.8,25.6,37.7.6-.4-25.6-37.7.6.6ZM1258.8,293.7l-30.2-24.9,20.1-28.9,8.8,25.8,1.3,27.9v.2ZM1249.6,238.3l8.6-32.7,12.4,26.6-21,6.3v-.2ZM1231.6,206.9l18.4-53.7,12.4,22.2-30.8,31.4h0ZM1250,150.5l-12.6-89.7,29.3,42.8-16.8,47ZM1173.9,34.4l-53,56.4-11.9-35.4,17-21h48ZM1121.7,91.4l45.7-21.6,22,7.3,2.5,41.7-70-27.5h-.2ZM1193,119.9l32.1-17.6,4.6,29.8-17.6,20.3-19.1-32.3v-.2ZM1227.6,266.2c-4.2-10.5-9-22.4-13.4-33.5l10.9-7.5,2.5,41.1h0ZM1225.9,225.1l22.4,14-19.7,28.5-2.7-42.3v-.2ZM1213.8,231.8c-6.5-16.1-11.7-30.2-12.4-33.1l28.7,10.1-5,15.3-11.3,7.8h0ZM1236.2,59.7l-11.1,41.5-32.3,17.6-2.5-41.7,45.9-17.6v.2ZM1236.8,61.2l12.6,89.9-18.9-19.1-4.6-30.2,10.9-40.5v-.2ZM1249.4,152.2l-23.3,18.4-13.6-17.6,17.6-20.3,19.1,19.5h.2ZM1249,153.4l-18.2,53.2-4.2-35.2,22.6-18h-.2ZM1230.1,207.9l-28.5-9.9,24.1-25.8,4.4,35.6ZM1201.8,196.4c2.1-7.5,9-36.9,10.3-42.6l13.2,17.4-23.7,25.2h.2ZM1167,69.2l-44.4,21,51.6-54.7-7.1,33.7ZM1175.2,34.6l60.6,24.3-45.9,17.6-21.8-7.3,7.3-34.6h-.2ZM1230.9,208.8l26.6-4-8.8,33.5-22.8-14.3s5-15.3,5-15.3ZM1219.8,24.1l16.1,34-60.2-24.3,20.3-13.4,23.7,3.6v.2ZM1260.3,37.5l-23.3,20.8-16.1-33.7,39.2,13h.2ZM1266.8,101.9l-29.3-42.8,23.3-20.8,6.1,63.5ZM1267.4,104.8l8.4,29.1-12.8,40.5-12.4-22.2,17-47.4h-.2ZM1277.5,191.4l-19.7,12.6-26,4,31.2-31.7,14.7,15.3-.2-.2ZM1270.4,233.1l-12.4,31.4-8.6-25.2,21-6.1v-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 248.4,
    width: 471.9,
    height: 471.6,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6,428.2l1.3,28.3-29.6,4.2v.8l29.3-4.2-12.6,32.1-17.8-11.3-.4.6,18.2,11.5,12.4,26.8-31.2-18.2-.4.8,31.9,18.4-19.5,12.6h0l-11.1,8.2.4.6,10.9-8,14.7,15.3-26.2,27.9.6.6,25.2-26.8-12.6,39.6-15.1,10.3.4.6,14.7-10.1,8.4,29.3-29.8-2.1v.8l29.8,2.1,6.3,64.8-27.7-21-.4.6,28.1,21.4-26.6,41.1.6.4,26.6-41.1,40.2,13.4-14.9,27.3.8.4,14.9-27.5,23.5,3.6,1.5,23.7h.8l-1.5-23.9,20.5-13.6,34.2,33.1.6-.6-33.5-32.5h47.4l-11.9,37.3h.8c0,.2,11.9-36.7,11.9-36.7l19.5,35.4.8-.4-19.9-36.1,16.8-20.8,63.7,57.2.6-.6-64.1-57.4-12.2-36.1h0l-71.5-28.1-19.5-32.9c2.9-12.2,10.3-43.6,11.1-44.9s0,0,0,0v-.2h0c-.4-4.8-21-55.1-27.3-70.9h0l-31-25.8L-.6,389.2l-.6.4,27,38.6h-.2ZM26.6,429l30.2,24.9-20.1,28.9-8.8-25.8-1.3-27.9v-.2ZM35.8,484.2l-8.6,32.7-12.4-26.6,21-6.3v.2ZM53.9,515.8l-18.4,53.7-12.4-22.2,30.8-31.4ZM35.2,572.2l12.6,89.7-29.3-42.8,16.8-47ZM111.5,688.1l53-56.4,11.9,35.4-17,21h-48ZM163.7,631.1l-45.7,21.6-22-7.3-2.5-41.7,70,27.5h.2ZM92.4,602.8l-32.1,17.6-4.6-29.8,17.6-20.3,19.1,32.3v.2ZM57.9,456.3c4.2,10.5,9,22.4,13.4,33.5l-10.9,7.5s-2.5-41.1-2.5-41.1ZM59.5,497.4l-22.4-14,19.7-28.5,2.7,42.3v.2ZM71.7,490.7c6.5,16.1,11.7,30.2,12.4,33.1l-28.7-10.1,5-15.3,11.3-7.8ZM49.3,663l11.1-41.5,32.3-17.6,2.5,41.7-45.9,17.6v-.2ZM48.6,661.5l-12.6-89.9,18.9,19.1,4.6,30.2-10.9,40.5v.2ZM36.1,570.5l23.3-18.4,13.6,17.6-17.6,20.3-19.1-19.5h-.2ZM36.3,569.1l18.2-53.2,4.2,35.2-22.6,18h.2ZM55.3,514.8l28.5,9.9-24.1,25.8-4.4-35.6ZM83.6,526.1c-2.1,7.5-9,36.9-10.3,42.6l-13.2-17.4,23.7-25.2h-.2ZM118.4,653.3l44.4-21-51.6,54.7,7.1-33.7ZM110.3,688.1l-60.6-24.3,45.9-17.6,21.8,7.3-7.3,34.6h.2ZM54.5,513.7l-26.6,4,8.8-33.5,22.8,14.3-5,15.3h0ZM65.6,698.4l-16.1-34,60.2,24.3-20.3,13.4-23.7-3.6v-.2ZM25.2,685l23.3-20.8,16.1,33.7-39.2-13h-.2ZM18.7,620.6l29.3,42.8-23.3,20.8-6.1-63.5ZM18,617.7l-8.4-29.1,12.8-40.5,12.4,22.2-17,47.4h.2ZM7.8,531.3l19.7-12.6,26-4-31.2,31.7-14.7-15.3.2.2ZM15.1,489.4l12.4-31.4,8.6,25.2-21,6.1v.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.4,267c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM582,273.2c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.1,303.3c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM719.8,309.5c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.3,228.9c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM436,235.1c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.7,167.2c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM564.6,173.4c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.7,173c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM375.4,179.2c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.3,343.7c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM800,349.9c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.5,453.5c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM669.4,459.7c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M815.6,494.5c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM820.4,500.8c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.4,526.7c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM368.2,532.9c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779.3,161.1c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2,6.2-2.8,6.2-6.2-2.8-6.2-6.2-6.2ZM784,167.2c0,2.7-2.2,4.8-4.8,4.8s-1-.3-1-1,0-.5.3-.7c.2-.2.3-.3.7-.3,1.5,0,2.8-1.2,2.8-2.8s.3-1,1-1,1,.5,1,1h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#151516",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.1,
    y: 395.8,
    width: 140.6,
    height: 32.3,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.1,
    y: 395.8,
    width: 140.6,
    height: 32.3,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.7,406.8l3,6.5h-6.2l3.2-6.5ZM468.6,403l-8.5,18h2l2.8-6h7.8l2.8,6h2l-8.3-18h-.7Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.4,
    y: 399.5,
    width: 25,
    height: 25,
    transform: "translate(-154 452.2) rotate(-45)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.9,
    y: 403,
    width: 1.8,
    height: 18,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.9,
    y: 404.9,
    width: 14,
    height: 14,
    transform: "translate(-150.4 460.7) rotate(-45)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.8,416.9c0-.2,0-.3.2-.5,0,0,.3-.2.5-.2,1,0,2-.8,2-2s.3-.7.7-.7.7.3.7.7c0,1.8-1.5,3.2-3.2,3.2s-.7-.3-.7-.7M399.4,414.4c0,2.3,1.8,4.2,4.2,4.2s4.2-1.8,4.2-4.2-1.8-4.2-4.2-4.2-4.2,1.8-4.2,4.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.4,
    y: 409.3,
    width: 10.5,
    height: 10.5,
    transform: "translate(-99.6 129.1) rotate(-16.2)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.6,409.8c-.5.5-.5,1.2,0,1.7,0,0,.2,0,.3.3.7,1,.5,2.2-.3,3s-2,1-3,.3c-.2,0-.3-.2-.5-.3-.7-.5-1.2-.3-1.7,0-.5.5-.5,1.2,0,1.7s1.2.5,1.5.2c.2,0,.3-.3.5-.3.8-.5,2-.5,2.8,0,.8.5,1.2,1.7.8,2.7,0,.5-.5.8-.7,1.2-.3.5-.2,1.2.3,1.5.5.5,1,.5,1.5,0,.5-.3.7-.8.3-1.5,0-.3-.3-.5-.5-.8-.5-.8-.5-1.7,0-2.3.3-.8,1.2-1.2,2-1.2s1.7.3,2.2,1.3c.5,1,.3,1.8-.3,2.7-.5.7-.5,1.5,0,1.8.5.3,1.2.3,1.7,0,.5-.5.5-1.2,0-1.8-.8-1.2-.8-2.2,0-3.3.5-.7.5-1.2,0-1.8-.5-.7-1.2-.5-1.7,0-.5.3-1,.5-1.7.7-.8,0-1.7-.3-2-1.2-.3-1-.3-2,.5-2.8.5-.5.5-1.2,0-1.7-.3-.3-.5-.3-.8-.3s-.5,0-.8.3l-.5.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.4,
    y: 406.6,
    width: 18.1,
    height: 18.1,
    transform: "translate(-193.3 400.1) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.9,404.5c-.5.5-.5,1.2,0,1.7,0,.2.2.3.3.5.5.8.5,1.5,0,2.3-.3.8-1.2,1.3-2,1.3s-1.7-.5-2-1.3c-.5-.8-.3-1.8.3-2.7.5-.7.5-1.2,0-1.8-.5-.5-1.2-.5-1.7,0-.5.5-.5,1.2,0,1.8.5.5.7,1,.7,1.7s-.2,1.2-.8,1.5c-1,.8-2.2.8-3.3,0-.5-.5-1.2-.5-1.7,0-.5.5-.5,1.2,0,1.7.5.5,1.2.5,1.7,0,1.3-1,2.2-1,3.3,0,.7.5,1.2.5,1.8,0,1-.8,2.3-.8,3.2,0s.8,2.2,0,3.3c-.5.7-.5,1.2,0,1.8.5.5,1.2.3,1.7,0,.5-.5.5-1.2,0-1.7-.8-1.2-.8-2.2,0-3.3.5-.7.5-1.2,0-1.8-.8-1.2-.8-2.2,0-3.2h.2c.3-.8.3-1.5-.3-1.8-.2-.2-.5-.3-.8-.3s-.5,0-.8.3h.3Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.5,
    y: 401.4,
    width: 18.1,
    height: 18.1,
    transform: "translate(-184.5 409.6) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.3,407c-.7.5-.5,1.2,0,1.8.8,1.2.8,2.2,0,3.2-.5.5-.5,1.2,0,1.7,1,1.3,1,2.5,0,3.7-.3.5-.3,1.2.2,1.7.5.5,1.2.5,1.5,0,1.3-1,2.5-1,3.7,0,.3.3.8.3,1.3,0s.5-.8.5-1.3c-.2-.8-1.2-1.2-2-.5-1.2.8-2.5.8-3.5-.2-.8-.8-.8-2.3,0-3.2.8-1,2.2-1,3.3,0,.5.5,1.2.5,1.7,0,1.5-1,2-1,3.5,0,.5.3,1,.3,1.5,0s.7-1.2.3-1.7c-.5-.5-1.2-.7-1.8,0-1.3,1-2.2,1-3.3,0-.5-.5-1.2-.5-1.7,0-.5.3-1,.7-1.7.7-1,0-1.7-.5-2-1.5-.5-1-.3-1.8.3-2.7.5-.8.5-1.3,0-1.8-.3-.2-.5-.3-.8-.3s-.5,0-.8.3l-.2.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.9,
    y: 403.6,
    width: 18.3,
    height: 18.3,
    transform: "translate(-187 408.5) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.3,407.1c-1.3.8-2.2.8-3.3,0-.5-.5-1.2-.5-1.7,0-.5.5-.3,1.2,0,1.7.8,1.3.8,2,0,3.5-.5.7-.5,1.2,0,1.7s1.2.3,1.5,0c.5-.5.5-1.2,0-1.7,0-.2-.2-.3-.3-.5-.5-.8-.5-1.7,0-2.5s1.2-1.2,2.2-1.2,1.7.5,2,1.3c.5,1,.3,2-.5,2.8-.5.5-.5,1.2,0,1.7s1.2.5,1.7,0,.5-1.2,0-1.7c-1-1.3-1-2,0-3.5.5-.5.5-1.2,0-1.7-.2-.3-.5-.3-.8-.3s-.7,0-.8.3h.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.1,
    y: 404.7,
    width: 11.1,
    height: 11.1,
    transform: "translate(-189.2 398.4) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.4,402c-1.5,1-2,1-3.5,0-.5-.3-1.2-.3-1.7,0-.5.5-.5,1.2,0,1.7,1.2,1.5,1,2,0,3.5-.3.3-.3.8,0,1.3.3.5.5.7,1.2.7s.8-.2,1-.7c.3-.5.3-.8,0-1.3-.2-.2-.3-.3-.5-.7-.5-.8-.3-2,.2-2.7.7-.7,1.3-1,2.3-.8,1,.2,1.7.8,1.8,2,0,.8-.3,1.5-.8,2.2-.5.5-.3,1.2.2,1.7.5.3,1.2.3,1.7,0,.5-.5.5-1,0-1.7-1-1.5-1-2,0-3.5.3-.5.3-1.2,0-1.7-.3-.2-.5-.3-.8-.3s-.5,0-.8.3h-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.2,
    y: 399.9,
    width: 11,
    height: 11,
    transform: "translate(-180.6 408) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.6,399.6c-1,.8-2,.8-3.2,0-.8-.5-1.3-.5-1.8,0-.5.5-.5,1.2,0,1.7.5.5,1.2.5,1.8,0,.5-.5,1-.7,1.7-.7s.3,0,.3,0c1.7.5,2.3,2.3,1.2,3.8-.3.5-.5,1-.3,1.7.3.5,1.2.8,1.7.3.7-.5.8-1.2.3-1.8-.8-1.3-1-2.2,0-3.3.5-.7.7-1.2,0-1.8s-.5-.3-.8-.3-.7.2-1,.5h.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 397.3,
    width: 11.1,
    height: 11.1,
    transform: "translate(-181.2 401.6) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.1,407.5c-.3.5-.2.8,0,1.3,1.2,1.3,1.2,2.5,0,3.8-.5.5-.3,1.2.2,1.5.5.5,1.2.5,1.7,0,.5-.5.7-1,.3-1.5-1.2-1.3-1-2.5,0-3.8.5-.8,0-1.8-1.2-1.8s-.8.2-1,.5h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.5,
    y: 406.7,
    width: 7.8,
    height: 7.5,
    transform: "translate(-181.8 415.4) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.6,414.9c-.3.5-.3,1.2,0,1.7.5.5,1.2.5,1.8,0,.5-.5,1-.7,1.7-.7s1.2.3,1.5.7c.5.5,1.2.5,1.8,0,.5-.5.5-1.2,0-1.7-.5-.7-1.2-.5-1.8,0-1.2,1-2.2.8-3.3,0-.3-.3-.7-.3-1-.3s-.7,0-.8.5l.2-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 411.7,
    width: 7.3,
    height: 7.7,
    transform: "translate(-189 409.4) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.6,404.8c-.3.5-.3,1,0,1.5,1,1.3,1,2,0,3.5-.2.3-.3.5-.3.8,0,.5.3,1,.8,1.2.5,0,1,0,1.3-.5.3-.5.3-1,0-1.5-1.2-1.7-1.2-2,0-3.7.5-.8.2-1.7-.7-2h-.3c-.3,0-.7.2-1,.5l.2.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.1,
    y: 404.3,
    width: 7.5,
    height: 7.2,
    transform: "translate(-185.7 401.5) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.3,417.3c-.5.5-.5,1.2,0,1.7.8,1.2.8,2.2,0,3.2,0,.2-.3.3-.3.5-.3.5-.3,1,0,1.3.3.5.8.5,1.3.3.5-.3.8-.7.8-1.2s0-.5-.3-.8c-1-1.3-1-2,0-3.5.5-.7.5-1.2,0-1.7-.3-.3-.5-.3-.8-.3s-.5,0-.8.3l.2.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.3,
    y: 416.9,
    width: 7.7,
    height: 7.3,
    transform: "translate(-196.1 403.7) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.4,399.8c-.3.5-.3,1,0,1.5,1,1.5,1,2,0,3.5-.3.3-.5.8-.2,1.3.3.7,1.2.8,1.7.5.7-.3.8-1.2.3-1.8-1-1.5-1-2,0-3.5.2-.3.3-.5.3-.8,0-.5-.3-.8-.8-1.2h-.5c-.3,0-.7.2-.8.5h0Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.7,
    y: 399.3,
    width: 7.7,
    height: 7.2,
    transform: "translate(-183.8 395.9) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.5,405c-.3.5-.3.8,0,1.3,1,1.2,1,2.5,0,3.7-.5.5-.3,1.2.2,1.7.5.3,1,.3,1.5,0,.5-.5.7-1,.2-1.5-1.2-1.3-1.2-2.5,0-3.8.3-.3.3-.8,0-1.2-.3-.3-.5-.7-1.2-.7s-.8.2-1,.7l.3-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.7,
    y: 404.3,
    width: 7.7,
    height: 7.2,
    transform: "translate(-189.2 393.8) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.1,402.3c-.5.5-.3,1,0,1.5.5.5,1,.7,1.5.3,1.3-1,2.5-1.2,3.8,0,.3.3.8.3,1.2,0,.3-.3.5-.5.7-1.2,0-.3-.2-.8-.5-1-.3-.2-.8-.3-1.2,0-1.3,1.2-2.5,1.2-3.8,0-.2-.2-.3-.3-.7-.3s-.7.2-1,.5v.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.1,
    y: 399.1,
    width: 7.2,
    height: 7.5,
    transform: "translate(-182.1 399.7) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.4,400.5c0,.7.5,1.2,1.2,1.2s1.3-.5,1.3-1.2-.7-1.2-1.3-1.2-1.2.7-1.2,1.3v-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 398.6,
    width: 3.5,
    height: 3.5,
    transform: "translate(-176.8 406.2) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.8,403.1c0,.7.5,1.2,1.2,1.2s1.2-.5,1.2-1.2-.5-1.2-1.3-1.2-1.2.5-1.2,1.3l.2-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.4,
    y: 401.2,
    width: 3.5,
    height: 3.5,
    transform: "translate(-184.6 394.1) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.8,418.3c0,.7.5,1.2,1.3,1.2s1.2-.5,1.2-1.2-.5-1.2-1.2-1.2-1.2.7-1.2,1.2h-.2Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.3,
    y: 416.3,
    width: 3.5,
    height: 3.5,
    transform: "translate(-195.9 399) rotate(-48.3)",
    fill: "none",
    strokeWidth: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "#0d1b2a",
    opacity: 0.8,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.3,641.2h-5.2c0,7.7,3.2,14.5,8.2,19.6l3.7-3.7c-4-4.2-6.5-9.6-6.5-15.8l-.2-.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,661.5l-.3-.3c-5.3-5.5-8.3-12.6-8.3-19.9v-.5h5.8l.4.4v.2c0,5.7,2.3,11.2,6.4,15.5l.3.3-4.3,4.3ZM326.6,641.7c.1,6.8,2.8,13.4,7.7,18.5l3-3c-4-4.3-6.2-9.8-6.3-15.5h-4.4Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338,624.6l-3.7-3.7c-5,5-8.2,12-8.2,19.6h5.2c0-6.2,2.7-11.8,6.7-16h0Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,641h-6.1v-.5c0-7.4,3-14.7,8.3-20l.3-.3,4.3,4.3-.3.3c-4.2,4.4-6.5,9.9-6.5,15.7v.5ZM326.6,640.1h4.3c.1-5.6,2.4-11.1,6.5-15.5l-3-3c-4.8,5-7.6,11.7-7.7,18.5Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.3,617.6v-5.2c-7.7,0-14.5,3.2-19.6,8.2l3.7,3.7c4.2-4,9.6-6.5,15.8-6.5l.2-.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,624.9l-4.3-4.3.3-.3c5.5-5.3,12.6-8.3,19.9-8.3h.5v5.8l-.4.4h-.2c-5.7,0-11.2,2.3-15.5,6.4l-.3.3ZM335.3,620.6l3,3c4.3-4,9.8-6.2,15.5-6.3v-4.4c-6.8.1-13.4,2.8-18.5,7.7Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.3,657.3l-3.7,3.7c5,5,12,8.2,19.6,8.2v-5.2c-6.2,0-11.8-2.7-16-6.7Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.7,669.6h-.5c-7.4,0-14.7-3-19.9-8.3l-.3-.3,4.3-4.3.3.3c4.4,4.2,9.9,6.5,15.7,6.5h.5v6.1ZM335.3,661c5,4.8,11.7,7.6,18.5,7.7v-4.3c-5.6-.1-11.1-2.4-15.5-6.5l-3,3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.7,640.5h5.2c0-7.7-3.2-14.6-8.2-19.6l-3.7,3.7c4,4.2,6.5,9.8,6.7,16h0Z",
    fill: "#ff3169",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3,641h-6v-.4c-.2-5.9-2.5-11.5-6.5-15.7l-.3-.3,4.3-4.3.3.3c5.3,5.3,8.3,12.5,8.3,20v.5ZM378.2,640.1h4.3c-.1-6.9-2.9-13.6-7.7-18.5l-3,3c3.9,4.2,6.2,9.7,6.5,15.5Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.6,624.2l3.7-3.7c-5-5-12-8-19.6-8.2v5.2c6.2,0,11.8,2.5,15.8,6.5l.2.2Z",
    fill: "#ff3169",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,624.9l-.5-.5c-4-4-9.7-6.4-15.5-6.4h-.5v-6.1h.5c7.7.2,14.8,3.1,19.9,8.3l.3.3-4.3,4.3ZM355,617.1c5.8.1,11.4,2.5,15.5,6.5l3-3c-4.9-4.7-11.4-7.4-18.5-7.7v4.2Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.7,641.2c0,6.2-2.5,11.8-6.5,15.8l3.7,3.7c5-5,8-12,8.2-19.6h-5.2l-.2.2Z",
    fill: "#ff3169",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.9,661.3l-4.3-4.3.3-.3c4-4,6.4-9.7,6.4-15.5v-.2l.4-.4h5.8v.5c-.2,7.7-3.1,14.8-8.3,19.9l-.3.3ZM371.9,657l3,3c4.7-4.9,7.4-11.4,7.7-18.5h-4.4c0,5.8-2.4,11.4-6.3,15.5Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.8,664v5.2c7.7,0,14.6-3.2,19.6-8.2l-3.7-3.7c-4.2,4-9.8,6.5-16,6.7Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,669.6h-.5v-6h.4c5.9-.2,11.5-2.5,15.7-6.5l.3-.3,4.3,4.3-.3.3c-5.3,5.3-12.5,8.3-19.9,8.3ZM355.2,664.4v4.3c6.9-.1,13.6-2.9,18.5-7.7l-3-3c-4.2,3.9-9.7,6.2-15.5,6.5Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.1,653l4,4c4-4.2,6.5-9.6,6.5-15.8h-5.7c0,4.7-2,8.8-5,12l.2-.2Z",
    fill: "#ffa523",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,657.7l-4.3-4.3h.1c0-.1-.3-.5-.3-.5,3.1-3.3,4.9-7.5,4.9-11.7v-.5h6.6v.5c0,6-2.3,11.7-6.6,16.1l-.3.3ZM367.7,653l3.4,3.4c3.8-4.1,5.9-9.3,6-14.7h-4.8c-.1,4.1-1.8,8.1-4.7,11.3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342.3,653.5l-4,4c4.2,4,9.8,6.5,16,6.7v-5.7c-4.7,0-8.8-2-12-5Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.7,664.6h-.5c-6.1-.2-11.9-2.6-16.3-6.8l-.3-.3,4.6-4.6.3.3c3.3,3.1,7.5,4.9,11.7,4.9h.5v6.6ZM338.9,657.5c4.1,3.8,9.3,5.9,14.9,6.2v-4.7c-4.2-.1-8.2-1.8-11.5-4.8l-3.4,3.4Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.8,658.3v5.7c6.2,0,11.8-2.7,16-6.7l-4-4c-3.2,3-7.3,5-12,5Z",
    fill: "#ffa523",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,664.4h-.5v-6.6h.5c4.2,0,8.4-1.7,11.7-4.9l.3-.3,4.6,4.6-.3.3c-4.6,4.4-10.3,6.8-16.3,6.8ZM355.2,658.8v4.8c5.4-.1,10.7-2.3,14.9-6.2l-3.4-3.4c-3.3,3-7.4,4.7-11.5,4.8Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.7,628.2l4-4c-4.2-4-9.6-6.5-15.8-6.5v5.7c4.7,0,8.8,2,12,5l-.2-.2Z",
    fill: "#ffa523",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,628.7c-3.3-3.1-7.5-4.9-11.7-4.9h-.5v-6.6h.5c5.9,0,11.7,2.3,16.1,6.6l.3.3-4.3,4.3h-.1c0-.1-.3.2-.3.2ZM355.4,623c4.1.1,8.1,1.7,11.3,4.7l3.4-3.4c-4.1-3.8-9.3-5.9-14.7-6v4.8Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M342,628.6l-4-4c-4,4.2-6.5,9.8-6.7,16h5.7c0-4.7,2-8.8,5-12Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.4,641h-6.6v-.5c.2-6.1,2.6-11.9,6.8-16.3l.3-.3,4.6,4.6-.3.3c-3.1,3.3-4.9,7.5-4.9,11.7v.5ZM331.8,640.1h4.7c.1-4.2,1.8-8.2,4.8-11.5l-3.4-3.4c-3.8,4.1-5.9,9.3-6.2,14.9Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.3,623.2v-5.7c-6.2,0-11.8,2.5-15.8,6.5l4,4c3.2-3,7.3-4.8,12-5l-.2.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,628.7l-4.6-4.6.3-.3c4.2-4.2,10.1-6.6,16.1-6.6h.5v5.5h.8s-1.7,1.7-1.7,1.7v-.8c-4.2.3-8,2-11.1,4.8l-.3.3ZM339.1,624.1l3.4,3.4c3.2-2.9,7.1-4.5,11.4-4.8v-4.6c-5.5.1-10.8,2.3-14.7,6Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.1,640.5h5.7c0-6.2-2.7-11.8-6.7-16l-4,4c3,3.2,5,7.3,5,12Z",
    fill: "#ffa523",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.2,641h-6.6v-.5c0-4.2-1.7-8.4-4.9-11.7l-.3-.3,4.6-4.6.3.3c4.4,4.6,6.8,10.3,6.8,16.3v.5ZM372.5,640.1h4.8c-.1-5.4-2.3-10.7-6.2-14.9l-3.4,3.4c3,3.3,4.7,7.4,4.8,11.5Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337,641.2h-5.7c0,6.2,2.5,11.8,6.5,15.8l4-4c-3-3.2-4.8-7.3-5-12l.2.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.8,657.6l-.3-.3c-4.2-4.2-6.6-10.1-6.6-16.1v-.5h5.5v-.8s1.7,1.7,1.7,1.7h-.8c.3,4.2,2,8,4.8,11.1l.3.3-4.6,4.6ZM331.8,641.7c.1,5.5,2.3,10.8,6,14.7l3.4-3.4c-2.9-3.2-4.5-7.1-4.8-11.4h-4.6Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.1,632.9l-4.3-4.3c-3,3.2-5,7.3-5,12h6c0-3,1.3-5.7,3.2-7.7h.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2,641h-6.9v-.5c0-4.4,1.8-8.8,5.1-12.3l.3-.3,5.4,5.4h-1.1c-1.9,2.1-2.9,4.7-2.9,7.2v.5ZM337.3,640.1h5.1c.1-2.6,1.2-5.1,3.1-7.3l-3.6-3.6c-2.8,3.1-4.4,7-4.5,10.9Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.8,652.4v6c4.7,0,8.8-2,12-5l-4.3-4.3c-2,2-4.7,3.2-7.7,3.2v.2Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,658.8h-.5v-7.1h.5c2.8,0,5.4-1,7.3-3l.3-.3,5,5-.3.3c-3.5,3.3-7.8,5.1-12.3,5.1ZM355.2,652.6v5.3c3.9-.1,7.7-1.7,10.9-4.5l-3.7-3.7c-2,1.8-4.5,2.9-7.2,3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.8,632.9c2,2,3.2,4.7,3.2,7.7h6c0-4.7-2-8.8-5-12l-4.3,4.3h.2Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.4,641h-6.9v-.5c0-2.8-1-5.2-2.9-7.2h-1.1l5.4-5.4.3.3c3.3,3.5,5.1,7.8,5.1,12.3v.5ZM366.4,640.1h5.1c-.1-3.9-1.7-7.7-4.5-10.9l-3.6,3.6c1.9,2,2.9,4.5,3.1,7.3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.9,648.7l4.3,4.3c3-3.2,4.8-7.3,5-12h-6c0,3-1.3,5.7-3.2,7.7h-.2Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.3,653.7l-5.4-5.4h1.1c1.9-2.1,2.9-4.7,2.9-7.2v-.5h6.9v.5c-.2,4.7-2,8.9-5.1,12.3l-.3.3ZM363.6,648.8l3.6,3.6c2.7-3,4.3-6.8,4.5-10.9h-5.1c-.1,2.6-1.2,5.1-3.1,7.3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.4,649.2l-4.3,4.3c3.2,3,7.3,5,12,5v-6c-3,0-5.7-1.3-7.7-3.2v-.2Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,659h-.5c-4.4,0-8.8-1.8-12.3-5.1l-.3-.3,5.4-5.4v1.1c2.1,1.9,4.7,2.9,7.2,2.9h.5v6.9ZM342.8,653.5c3.1,2.8,7,4.4,10.9,4.5v-5.1c-2.6-.1-5.1-1.2-7.3-3.1l-3.6,3.6Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M343,641.2h-6c0,4.7,2,8.8,5,12l4.3-4.3c-1.8-2-3-4.7-3.2-7.7h-.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.9,653.8l-.3-.3c-3.3-3.5-5.1-7.8-5.1-12.3v-.5h7v.4c.2,2.8,1.3,5.4,3.1,7.4l.3.3-5,5ZM337.4,641.7c.1,3.9,1.7,7.7,4.5,10.9l3.7-3.7c-1.7-2-2.7-4.5-3-7.2h-5.3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.4,632.4l4.3-4.3c-3.2-3-7.3-4.8-12-5v6c3,0,5.7,1.3,7.7,3.2v.2Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,633.5v-1.1c-2.1-1.9-4.7-2.9-7.2-2.9h-.5v-6.9h.5c4.7.2,8.9,2,12.3,5.1l.3.3-5.4,5.4ZM355.2,628.6c2.6.1,5.1,1.2,7.3,3.1l3.6-3.6c-3-2.7-6.8-4.3-10.9-4.5v5.1Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.3,629.4v-6c-4.7,0-8.8,2-12,5l4.3,4.3c2-1.8,4.7-3,7.7-3.2v-.2Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,633.3l-5-5,.3-.3c3.5-3.3,7.8-5.1,12.3-5.1h.5v7h-.4c-2.8.2-5.4,1.3-7.4,3.1l-.3.3ZM342.9,628.4l3.7,3.7c2-1.7,4.5-2.7,7.2-3v-5.3c-3.9.1-7.7,1.7-10.9,4.5Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.4,641.2h-5.5c0,3,1.3,5.7,3.2,7.7l3.8-3.8c-.8-1-1.5-2.3-1.5-3.8h0Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.1,649.5l-.3-.3c-2.1-2.3-3.3-5.1-3.3-8v-.5h6.4v.5c0,1.5.8,2.8,1.4,3.5l.3.3-4.4,4.5ZM343.4,641.7c.1,2.3,1.1,4.6,2.7,6.5l3.2-3.2c-.6-.8-1.2-1.9-1.3-3.3h-4.6Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.8,647v5.5c3,0,5.7-1.3,7.7-3.2l-3.8-3.8c-1,1-2.3,1.5-3.8,1.7v-.2Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,653h-.5v-5.9h.4v-.3c1.5-.2,2.7-.7,3.5-1.5l.3-.3,4.5,4.5-.3.3c-2.3,2.1-5.1,3.3-8,3.3ZM355.2,647.6v4.5c2.3-.1,4.6-1.1,6.5-2.7l-3.2-3.2c-.9.7-2,1.2-3.4,1.4Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360.6,640.5h5.5c0-3-1.3-5.7-3.2-7.7l-3.8,3.8c1,1,1.5,2.3,1.7,3.8h-.2Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,641h-5.9v-.4h-.3c-.2-1.5-.7-2.7-1.5-3.5l-.3-.3,4.5-4.5.3.3c2.1,2.3,3.3,5.1,3.3,8v.5ZM361.1,640.1h4.5c-.1-2.3-1.1-4.6-2.7-6.5l-3.2,3.2c.7.9,1.2,2,1.4,3.4Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.3,645.4l-3.8,3.8c2,2,4.7,3.2,7.7,3.2v-5.5c-1.5,0-2.8-.7-3.8-1.7v.2Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,652.8h-.5c-3,0-5.8-1.2-8-3.3l-.3-.3,4-4v-1.1l.8.8c1,1,2.2,1.5,3.5,1.5h.5v6.4ZM347.1,649.2c1.8,1.7,4.1,2.6,6.6,2.7v-4.6c-1.2,0-2.3-.6-3.3-1.4l-3.3,3.3Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.9,636.7l-3.8-3.8c-2,2-3.2,4.7-3.2,7.7h5.5c0-1.5.7-2.8,1.7-3.8h-.2Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9,641h-6.4v-.5c0-3,1.2-5.8,3.3-8l.3-.3,4,4h1.1l-.8.8c-1,1-1.5,2.2-1.5,3.5v.5ZM343.4,640.1h4.6c0-1.2.6-2.3,1.4-3.3l-3.3-3.3c-1.7,1.8-2.6,4.1-2.7,6.6Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.3,634.7v-5.5c-3,0-5.7,1.3-7.7,3.2l3.8,3.8c1-.8,2.3-1.5,3.8-1.5Z",
    fill: "#f2f2f2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4,636.8l-4.4-4.4.3-.3c2.3-2.1,5.1-3.3,8-3.3h.5v6.4h-.5c-1.5,0-2.8.8-3.5,1.4l-.3.3ZM347.3,632.4l3.2,3.2c.8-.6,1.9-1.2,3.3-1.3v-4.6c-2.3.1-4.6,1.1-6.5,2.7Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.6,636.4l3.8-3.8c-2-1.8-4.7-3-7.7-3.2v5.5c1.5,0,2.8.7,3.8,1.5Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,637l-.3-.3c-.8-.6-2-1.4-3.5-1.4h-.5v-6.4h.5c3,.2,5.8,1.4,7.9,3.3l.3.3-4.4,4.5ZM355.2,634.5c1.4.1,2.5.7,3.3,1.3l3.2-3.2c-1.8-1.5-4.1-2.5-6.5-2.7v4.6Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.1,644.9l3.8,3.8c1.8-2,3-4.7,3.2-7.7h-5.5c0,1.5-.7,2.8-1.5,3.8h0Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,649.3l-4.4-4.4.3-.3c.6-.8,1.4-2,1.4-3.5v-.5h6.4v.5c-.2,3-1.4,5.8-3.3,7.9l-.3.3ZM359.7,644.8l3.2,3.2c1.5-1.8,2.5-4.1,2.7-6.5h-4.6c-.1,1.4-.7,2.5-1.3,3.3Z",
    fill: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.9,631.5h0c0,0-.2,0-.2,0h0c0-.2,0-.2-.1-.2s-.1,0-.1.2v.3h0s.1,0,.2,0c.2,0,.3.1.3.4v.2c0,.2-.1.4-.4.4s-.4-.1-.4-.4v-.8c0-.2.1-.4.4-.4s.4.1.4.4ZM350.4,632.2v.2c0,.1,0,.2.1.2s.1,0,.1-.2v-.2c0-.1,0-.2-.1-.2s-.1,0-.1.2Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.8,631.6h0c0,.2,0,.3-.2.4h0c.1,0,.2.2.2.3h0c0,.3-.1.5-.4.5s-.4-.1-.4-.4h0c0-.3,0-.4.2-.4h0c-.1,0-.2-.1-.2-.3h0c0-.3.1-.5.4-.5s.4.1.4.4ZM351.3,632.2h0c0,.2,0,.3.1.3s.1,0,.1-.2h0c0-.2,0-.3-.1-.3s-.1,0-.1.2ZM351.3,631.6h0c0,.2,0,.3.1.3s.1,0,.1-.2h0c0-.2,0-.3-.1-.3s-.1,0-.1.2Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,631.4v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352.1,632.7l.7-1.6h.1l-.7,1.6h-.1ZM352.1,631.4v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0ZM353.1,632.2v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352.8,632.2v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0Z",
    fill: "#00b4b0",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.5,615.9v-1.2h-.3v-.2c.2,0,.3,0,.4-.2h.2v1.5h-.2Z",
    fill: "#ff3169",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,614.8h0c0,.2,0,.3-.2.4h0c.1,0,.2.2.2.3h0c0,.3-.1.5-.4.5s-.4-.1-.4-.4h0c0-.3,0-.4.2-.4h0c-.1,0-.2-.1-.2-.3h0c0-.3.1-.5.4-.5s.4.1.4.4ZM351.1,615.4h0c0,.2,0,.3.1.3s.1,0,.1-.2h0c0-.2,0-.3-.1-.3s-.1,0-.1.2ZM351.1,614.8h0c0,.2,0,.3.1.3s.1,0,.1-.2h0c0-.2,0-.3-.1-.3s-.1,0-.1.2Z",
    fill: "#ff3169",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,614.6v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM351.9,615.9l.7-1.6h.1l-.7,1.6h-.1ZM351.9,614.6v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0ZM352.9,615.4v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352.6,615.4v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0Z",
    fill: "#ff3169",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351,626.5v.2h-.1v.3h-.2v-.3h-.5v-.2l.5-1h.2v1h.1ZM350.4,626.5h.3v-.5h0l-.3.5Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,625.8h-.4v.4s0,0,0,0c0,0,0,0,.2,0,.2,0,.3.1.3.4v.3c0,.2-.1.4-.4.4s-.4-.1-.4-.4h0c0,0,.2,0,.2,0h0c0,.2,0,.2.1.2s.1,0,.1-.2v-.3c0-.1,0-.2-.1-.2s-.1,0-.1.1h0s-.2,0-.2,0v-.9h.7v.2Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,625.8v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352.1,627.1l.7-1.6h.1l-.7,1.6h-.1ZM352.1,625.8v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0ZM353.1,626.5v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352.7,626.5v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0Z",
    fill: "#9f49a3",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.9,619.7h0c0,.2,0,.3-.2.4h0c.1,0,.2.2.2.3h0c0,.3-.1.5-.4.5s-.4-.1-.4-.4h0c0,0,.2-.1.2-.1h0c0,.2,0,.3.1.3s.1,0,.1-.2h0c0-.3,0-.3-.2-.3h0v-.2h0c.1,0,.2,0,.2-.2h0c0-.2,0-.3-.1-.3s-.1,0-.1.2h0c0,0-.2,0-.2,0h0c0-.3.1-.5.4-.5s.4.1.4.4Z",
    fill: "#ffa523",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,619.6h-.4v.4s0,0,0,0c0,0,0,0,.2,0,.2,0,.3.1.3.4v.3c0,.2-.1.4-.4.4s-.4-.1-.4-.4h0c0,0,.2,0,.2,0h0c0,.2,0,.2.1.2s.1,0,.1-.2v-.3c0-.1,0-.2-.1-.2s-.1,0-.1.1h0s-.2,0-.2,0v-.9h.7v.2Z",
    fill: "#ffa523",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,619.6v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352,620.9l.7-1.6h.1l-.7,1.6h-.1ZM352.1,619.6v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0ZM353,620.4v.3c0,.1,0,.2-.2.2s-.2,0-.2-.2v-.3c0-.1,0-.2.2-.2s.2,0,.2.2ZM352.7,620.4v.3c0,0,0,0,0,0s0,0,0,0v-.3c0,0,0,0,0,0s0,0,0,0Z",
    fill: "#ffa523",
    strokeWidth: 0
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1252 233.1 1249.4 234.7 1249.4 233.1 1252 233.1",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.9 233.1 1249.4 239.9 1249.4 234.7 1252 233.1 1259.9 233.1",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1267.8 233.1 1249.4 245 1249.4 239.9 1259.9 233.1 1267.8 233.1",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.4 236.6 1249.4 250.1 1249.4 245 1267.8 233.1 1270.4 233.1 1270.4 236.6",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.4 241.7 1249.5 255.1 1249.4 254.9 1249.4 250.1 1270.4 236.6 1270.4 241.7",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.4 246.8 1251.8 258.7 1249.5 255.1 1270.4 241.7 1270.4 246.8",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.4 251.9 1254.2 262.3 1251.8 258.7 1270.4 246.8 1270.4 251.9",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.4 257 1258.6 264.5 1255.6 264.5 1254.2 262.3 1270.4 251.9 1270.4 257",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.4 262.1 1266.5 264.5 1258.6 264.5 1270.4 257 1270.4 262.1",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.5 264.5 1270.4 262.1 1270.4 264.5 1266.5 264.5",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1237.1 176.3 1231.8 179.7 1231.8 176.3 1237.1 176.3",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.1 176.3 1231.8 184.8 1231.8 179.7 1237.1 176.3 1245.1 176.3",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253 176.3 1231.8 189.9 1231.8 184.8 1245.1 176.3 1253 176.3",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.9 176.3 1231.8 195 1231.8 189.9 1253 176.3 1260.9 176.3",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1268.8 176.3 1231.8 200.1 1231.8 195 1260.9 176.3 1268.8 176.3",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.2 176.3 1272.1 179.3 1231.8 205.3 1231.8 200.1 1268.8 176.3 1270.2 176.3",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1272.1 179.3 1274.5 182.9 1235.5 207.9 1231.8 207.9 1231.8 205.3 1272.1 179.3",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1274.5 182.9 1276.8 186.5 1243.5 207.9 1235.5 207.9 1274.5 182.9",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1276.8 186.5 1277.7 187.9 1277.7 191 1251.4 207.9 1243.5 207.9 1276.8 186.5",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1277.7 196.1 1259.3 207.9 1251.4 207.9 1277.7 191 1277.7 196.1",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1277.7 201.2 1267.2 207.9 1259.3 207.9 1277.7 196.1 1277.7 201.2",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1277.7 206.3 1275.2 207.9 1267.2 207.9 1277.7 201.2 1277.7 206.3",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.2 207.9 1277.7 206.3 1277.7 207.9 1275.2 207.9",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253 104.8 1250.7 106.3 1250.7 104.8 1253 104.8",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.9 104.8 1250.7 111.4 1250.7 106.3 1253 104.8 1260.9 104.8",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1268.9 104.8 1250.7 116.5 1250.7 111.4 1260.9 104.8 1268.9 104.8",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270 104.8 1272 107.9 1250.7 121.6 1250.7 116.5 1268.9 104.8 1270 104.8",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1272 107.9 1274.3 111.5 1250.7 126.7 1250.7 121.6 1272 107.9",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1274.3 111.5 1275.8 113.8 1275.8 115.7 1250.7 131.9 1250.7 126.7 1274.3 111.5",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 120.8 1250.7 137 1250.7 131.9 1275.8 115.7 1275.8 120.8",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 125.9 1250.7 142.1 1250.7 137 1275.8 120.8 1275.8 125.9",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 131 1250.7 147.2 1250.7 142.1 1275.8 125.9 1275.8 131",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 136.1 1250.7 152.3 1250.7 147.2 1275.8 131 1275.8 136.1",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 141.2 1250.7 157.4 1250.7 152.3 1275.8 136.1 1275.8 141.2",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 146.3 1252.3 161.4 1250.7 158.9 1250.7 157.4 1275.8 141.2 1275.8 146.3",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 151.4 1254.6 165 1252.3 161.4 1275.8 146.3 1275.8 151.4",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 156.5 1256.9 168.6 1254.6 165 1275.8 151.4 1275.8 156.5",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 161.6 1259.3 172.3 1256.9 168.6 1275.8 156.5 1275.8 161.6",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 166.7 1263.8 174.4 1260.6 174.4 1259.3 172.3 1275.8 161.6 1275.8 166.7",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1275.8 171.8 1271.8 174.4 1263.8 174.4 1275.8 166.7 1275.8 171.8",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1271.8 174.4 1275.8 171.8 1275.8 174.4 1271.8 174.4",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.2 38.4 1237.4 43.4 1237.4 38.4 1245.2 38.4",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253.2 38.4 1237.4 48.5 1237.4 43.4 1245.2 38.4 1253.2 38.4",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1261.1 38.4 1237.4 53.6 1237.4 48.5 1253.2 38.4 1261.1 38.4",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1263.1 38.4 1264.8 41.1 1237.4 58.7 1237.4 53.6 1261.1 38.4 1263.1 38.4",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1264.8 41.1 1266.8 44.1 1266.8 44.9 1237.9 63.5 1237.4 62.8 1237.4 58.7 1264.8 41.1",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 50 1240.2 67.1 1237.9 63.5 1266.8 44.9 1266.8 50",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 55.1 1242.5 70.7 1240.2 67.1 1266.8 50 1266.8 55.1",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 60.2 1244.9 74.3 1242.5 70.7 1266.8 55.1 1266.8 60.2",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 65.3 1247.2 77.9 1244.9 74.3 1266.8 60.2 1266.8 65.3",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 70.4 1249.5 81.5 1247.2 77.9 1266.8 65.3 1266.8 70.4",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 75.5 1251.8 85.2 1249.5 81.5 1266.8 70.4 1266.8 75.5",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 80.6 1254.2 88.8 1251.8 85.2 1266.8 75.5 1266.8 80.6",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 85.7 1256.5 92.4 1254.2 88.8 1266.8 80.6 1266.8 85.7",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 90.8 1258.8 96 1256.5 92.4 1266.8 85.7 1266.8 90.8",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 95.9 1261.1 99.6 1258.8 96 1266.8 90.8 1266.8 95.9",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 101 1265.5 101.9 1262.6 101.9 1261.1 99.6 1266.8 95.9 1266.8 101",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1265.5 101.9 1266.8 101 1266.8 101.9 1265.5 101.9",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.1 24.5 1220.9 28.5 1220.9 24.5 1227.1 24.5",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1235 24.5 1220.9 33.6 1220.9 28.5 1227.1 24.5 1235 24.5",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1242.9 24.5 1221.7 38.2 1220.9 36.9 1220.9 33.6 1235 24.5 1242.9 24.5",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1250.9 24.5 1224 41.8 1221.7 38.2 1242.9 24.5 1250.9 24.5",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1254.3 24.5 1255.6 26.6 1226.4 45.4 1224 41.8 1250.9 24.5 1254.3 24.5",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.8,
    y: 35.6,
    width: 34.8,
    height: 4.3,
    transform: "translate(177.4 678.6) rotate(-32.8)",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1227.1,
    y: 39.3,
    width: 34.8,
    height: 4.3,
    transform: "translate(175.8 680.4) rotate(-32.8)",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.3 33.8 1260.3 33.8 1260.3 38.9 1233.3 56.2 1231 52.6 1260.3 33.8",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.3 44 1238.1 58.3 1234.6 58.3 1233.3 56.2 1260.3 38.9 1260.3 44",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.3 49.1 1246 58.3 1238.1 58.3 1260.3 44 1260.3 49.1",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.3 54.2 1253.9 58.3 1246 58.3 1260.3 49.1 1260.3 54.2",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253.9 58.3 1260.3 54.2 1260.3 58.3 1253.9 58.3",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1178.1 20.3 1175.8 21.8 1175.8 20.3 1178.1 20.3",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1186 20.3 1175.8 26.9 1175.8 21.8 1178.1 20.3 1186 20.3",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1194 20.3 1175.8 32 1175.8 26.9 1186 20.3 1194 20.3",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1201.9 20.3 1175.8 37.1 1175.8 32 1194 20.3 1201.9 20.3",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1209.8 20.3 1178 40.8 1175.8 37.4 1175.8 37.1 1201.9 20.3 1209.8 20.3",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1217.7 20.3 1180.3 44.4 1178 40.8 1209.8 20.3 1217.7 20.3",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1219.9 20.3 1221.6 23 1182.6 48 1180.3 44.4 1217.7 20.3 1219.9 20.3",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.1,
    y: 35.2,
    width: 46.3,
    height: 4.3,
    transform: "translate(171.4 657.5) rotate(-32.8)",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1182.4,
    y: 38.8,
    width: 46.3,
    height: 4.3,
    transform: "translate(169.9 659.3) rotate(-32.8)",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1226.3 30.2 1228.6 33.8 1190.9 58.1 1189.1 58.1 1187.3 55.3 1226.3 30.2",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1228.6 33.8 1230.9 37.4 1198.8 58.1 1190.9 58.1 1228.6 33.8",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.9 37.4 1233.2 41 1206.7 58.1 1198.8 58.1 1230.9 37.4",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.2 41 1235.5 44.6 1214.6 58.1 1206.7 58.1 1233.2 41",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1235.5 44.6 1236 45.3 1236 49.4 1222.6 58.1 1214.6 58.1 1235.5 44.6",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236 54.5 1230.5 58.1 1222.6 58.1 1236 49.4 1236 54.5",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.5 58.1 1236 54.5 1236 58.1 1230.5 58.1",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1232.5 204.8 1225.9 209 1225.9 204.8 1232.5 204.8",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1240.4 204.8 1225.9 214.1 1225.9 209 1232.5 204.8 1240.4 204.8",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 204.8 1225.9 219.2 1225.9 214.1 1240.4 204.8 1248.3 204.8",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1256.3 204.8 1225.9 224.3 1225.9 219.2 1248.3 204.8 1256.3 204.8",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 209.1 1226.7 229 1225.9 227.8 1225.9 224.3 1256.3 204.8 1257.6 204.8 1257.6 209.1",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 214.2 1229 232.6 1226.7 229 1257.6 209.1 1257.6 214.2",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 219.3 1231.3 236.2 1229 232.6 1257.6 214.2 1257.6 219.3",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 224.4 1235.9 238.3 1232.7 238.3 1231.3 236.2 1257.6 219.3 1257.6 224.4",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 229.5 1243.8 238.3 1235.9 238.3 1257.6 224.4 1257.6 229.5",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 234.6 1251.7 238.3 1243.8 238.3 1257.6 229.5 1257.6 234.6",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1251.7 238.3 1257.6 234.6 1257.6 238.3 1251.7 238.3",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1171.8 34.6 1168.1 37 1168.1 34.6 1171.8 34.6",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1179.8 34.6 1168.1 42.1 1168.1 37 1171.8 34.6 1179.8 34.6",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1187.7 34.6 1168.1 47.2 1168.1 42.1 1179.8 34.6 1187.7 34.6",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1195.6 34.6 1168.1 52.3 1168.1 47.2 1187.7 34.6 1195.6 34.6",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1203.5 34.6 1168.1 57.4 1168.1 52.3 1195.6 34.6 1203.5 34.6",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1211.5 34.6 1168.1 62.5 1168.1 57.4 1203.5 34.6 1211.5 34.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1219.4 34.6 1168.1 67.6 1168.1 62.5 1211.5 34.6 1219.4 34.6",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1222.5 34.6 1223.9 36.8 1168.1 72.7 1168.1 67.6 1219.4 34.6 1222.5 34.6",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1223.9 36.8 1226.2 40.4 1170.3 76.4 1168.1 72.9 1168.1 72.7 1223.9 36.8",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1226.2 40.4 1228.6 44 1178.1 76.5 1170.4 76.5 1170.3 76.4 1226.2 40.4",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1228.6 44 1230.9 47.6 1186 76.5 1178.1 76.5 1228.6 44",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.9 47.6 1233.2 51.2 1193.9 76.5 1186 76.5 1230.9 47.6",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.2 51.2 1235.5 54.8 1201.8 76.5 1193.9 76.5 1233.2 51.2",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1235.5 54.8 1235.8 55.2 1235.8 59.8 1209.8 76.5 1201.8 76.5 1235.5 54.8",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1235.8 64.9 1217.7 76.5 1209.8 76.5 1235.8 59.8 1235.8 64.9",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1235.8 70 1225.6 76.5 1217.7 76.5 1235.8 64.9 1235.8 70",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1235.8 75.1 1233.5 76.5 1225.6 76.5 1235.8 70 1235.8 75.1",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.5 76.5 1235.8 75.1 1235.8 76.5 1233.5 76.5",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1123 35.4 1122.6 35.7 1122.6 35.4 1123 35.4",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1130.9 35.4 1122.6 40.8 1122.6 35.7 1123 35.4 1130.9 35.4",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1138.8 35.4 1122.6 45.9 1122.6 40.8 1130.9 35.4 1138.8 35.4",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1146.8 35.4 1122.6 51 1122.6 45.9 1138.8 35.4 1146.8 35.4",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1154.7 35.4 1122.6 56.1 1122.6 51 1146.8 35.4 1154.7 35.4",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1162.6 35.4 1122.6 61.2 1122.6 56.1 1154.7 35.4 1162.6 35.4",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1170.5 35.4 1122.6 66.3 1122.6 61.2 1162.6 35.4 1170.5 35.4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 38.2 1122.6 71.4 1122.6 66.3 1170.5 35.4 1174.1 35.4 1174.1 38.2",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 43.3 1122.6 76.5 1122.6 71.4 1174.1 38.2 1174.1 43.3",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 48.4 1122.6 81.6 1122.6 76.5 1174.1 43.3 1174.1 48.4",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 53.5 1122.6 86.7 1122.6 81.6 1174.1 48.4 1174.1 53.5",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 58.6 1125.2 90.1 1122.6 90.1 1122.6 86.7 1174.1 53.5 1174.1 58.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 63.7 1133.1 90.1 1125.2 90.1 1174.1 58.6 1174.1 63.7",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 68.8 1141.1 90.1 1133.1 90.1 1174.1 63.7 1174.1 68.8",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 73.9 1149 90.1 1141.1 90.1 1174.1 68.8 1174.1 73.9",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 79 1156.9 90.1 1149 90.1 1174.1 73.9 1174.1 79",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 84.1 1164.8 90.1 1156.9 90.1 1174.1 79 1174.1 84.1",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.1 89.3 1172.8 90.1 1164.8 90.1 1174.1 84.1 1174.1 89.3",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1172.8 90.1 1174.1 89.3 1174.1 90.1 1172.8 90.1",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1208.6 153.9 1201.6 158.3 1201.6 153.9 1208.6 153.9",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.5 153.9 1216.5 153.9 1201.6 163.4 1201.6 158.3 1208.6 153.9 1216.5 153.9",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.5 153.9 1218.8 157.5 1201.6 168.5 1201.6 163.4 1216.5 153.9",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1218.8 157.5 1221.1 161.1 1201.6 173.7 1201.6 168.5 1218.8 157.5",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1221.1 161.1 1223.4 164.7 1201.6 178.8 1201.6 173.7 1221.1 161.1",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1223.4 164.7 1225.3 167.6 1225.3 168.6 1201.6 183.9 1201.6 178.8 1223.4 164.7",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.3 173.7 1201.6 189 1201.6 183.9 1225.3 168.6 1225.3 173.7",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.3 178.8 1201.6 194.1 1201.6 189 1225.3 173.7 1225.3 178.8",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.3 183.9 1205.9 196.4 1201.6 196.4 1201.6 194.1 1225.3 178.8 1225.3 183.9",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.3 189 1213.8 196.4 1205.9 196.4 1225.3 183.9 1225.3 189",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.3 194.1 1221.7 196.4 1213.8 196.4 1225.3 189 1225.3 194.1",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1221.7 196.4 1225.3 194.1 1225.3 196.4 1221.7 196.4",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1203.7 172.3 1201.6 173.7 1201.6 172.3 1203.7 172.3",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1211.6 172.3 1201.6 178.8 1201.6 173.7 1203.7 172.3 1211.6 172.3",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1219.5 172.3 1201.6 183.9 1201.6 178.8 1211.6 172.3 1219.5 172.3",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.5 172.3 1201.6 189 1201.6 183.9 1219.5 172.3 1227.5 172.3",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1228.1 172.3 1230.1 175.5 1230.1 175.7 1201.6 194.1 1201.6 189 1227.5 172.3 1228.1 172.3",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 180.8 1201.6 199.2 1201.6 194.1 1230.1 175.7 1230.1 180.8",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 185.9 1202.7 203.5 1201.6 201.8 1201.6 199.2 1230.1 180.8 1230.1 185.9",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 191 1205.1 207.2 1202.7 203.5 1230.1 185.9 1230.1 191",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 196.1 1211.8 207.9 1205.6 207.9 1205.1 207.2 1230.1 191 1230.1 196.1",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 201.2 1219.7 207.9 1211.8 207.9 1230.1 196.1 1230.1 201.2",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 206.3 1227.6 207.9 1219.7 207.9 1230.1 201.2 1230.1 206.3",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 207.9 1230.1 206.3 1230.1 207.9 1227.6 207.9",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233 153.4 1226.5 157.6 1226.5 153.4 1233 153.4",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1240.9 153.4 1226.5 162.7 1226.5 157.6 1233 153.4 1240.9 153.4",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.8 153.4 1226.5 167.8 1226.5 162.7 1240.9 153.4 1248.8 153.4",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 158.3 1226.5 172.9 1226.5 167.8 1248.8 153.4 1249.2 153.4 1249.2 158.3",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 163.4 1226.5 178 1226.5 172.9 1249.2 158.3 1249.2 163.4",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 168.5 1226.5 183.1 1226.5 178 1249.2 163.4 1249.2 168.5",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 173.6 1226.5 188.2 1226.5 183.1 1249.2 168.5 1249.2 173.6",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 178.7 1226.5 193.3 1226.5 188.2 1249.2 173.6 1249.2 178.7",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 183.8 1226.5 198.4 1226.5 193.3 1249.2 178.7 1249.2 183.8",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 188.9 1226.5 203.5 1226.5 198.4 1249.2 183.8 1249.2 188.9",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 194 1229.6 206.7 1228.4 206.7 1226.5 203.9 1226.5 203.5 1249.2 188.9 1249.2 194",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 199.2 1237.5 206.7 1229.6 206.7 1249.2 194 1249.2 199.2",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 204.3 1245.4 206.7 1237.5 206.7 1249.2 199.2 1249.2 204.3",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.4 206.7 1249.2 204.3 1249.2 206.7 1245.4 206.7",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1217.6 132.7 1212.5 136 1212.5 132.7 1217.6 132.7",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.6 132.7 1212.5 141.1 1212.5 136 1217.6 132.7 1225.6 132.7",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.5 132.7 1212.5 146.2 1212.5 141.1 1225.6 132.7 1233.5 132.7",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.2 132.7 1239.9 133.7 1212.5 151.3 1212.5 146.2 1233.5 132.7 1239.2 132.7",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.9 133.7 1242.2 137.3 1212.5 156.4 1212.5 151.3 1239.9 133.7",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1242.2 137.3 1244.5 140.9 1214.7 160.1 1212.5 156.7 1212.5 156.4 1242.2 137.3",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1213,
    y: 150.2,
    width: 35.5,
    height: 4.3,
    transform: "translate(113.5 690.7) rotate(-32.8)",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1215.4,
    y: 153.8,
    width: 35.5,
    height: 4.3,
    transform: "translate(112 692.5) rotate(-32.8)",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 148.1 1249.4 148.5 1249.4 153.1 1222.1 170.6 1221.5 170.6 1219.3 167.3 1249.2 148.1",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 158.2 1230.1 170.6 1222.1 170.6 1249.4 153.1 1249.4 158.2",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 163.3 1238 170.6 1230.1 170.6 1249.4 158.2 1249.4 163.3",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 168.4 1245.9 170.6 1238 170.6 1249.4 163.3 1249.4 168.4",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.9 170.6 1249.4 168.4 1249.4 170.6 1245.9 170.6",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.5 61.2 1225.9 66.1 1225.9 61.2 1233.5 61.2",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.2 61.2 1239.9 62.2 1225.9 71.2 1225.9 66.1 1233.5 61.2 1239.2 61.2",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.9 62.2 1242.2 65.8 1225.9 76.3 1225.9 71.2 1239.9 62.2",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1242.2 65.8 1244.5 69.5 1225.9 81.4 1225.9 76.3 1242.2 65.8",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1244.5 69.5 1246.8 73.1 1225.9 86.5 1225.9 81.4 1244.5 69.5",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1246.8 73.1 1249.2 76.7 1225.9 91.6 1225.9 86.5 1246.8 73.1",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 76.7 1249.4 77 1249.4 81.6 1225.9 96.7 1225.9 91.6 1249.2 76.7",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 86.7 1225.9 101.8 1225.9 96.7 1249.4 81.6 1249.4 86.7",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 91.8 1225.9 106.9 1225.9 101.8 1249.4 86.7 1249.4 91.8",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 96.9 1225.9 112.1 1225.9 106.9 1249.4 91.8 1249.4 96.9",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 102 1225.9 117.2 1225.9 112.1 1249.4 96.9 1249.4 102",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 107.1 1225.9 122.3 1225.9 117.2 1249.4 102 1249.4 107.1",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 112.2 1225.9 127.4 1225.9 122.3 1249.4 107.1 1249.4 112.2",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 117.3 1227.7 131.3 1225.9 128.6 1225.9 127.4 1249.4 112.2 1249.4 117.3",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 122.5 1230 134.9 1227.7 131.3 1249.4 117.3 1249.4 122.5",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 127.6 1232.3 138.5 1230 134.9 1249.4 122.5 1249.4 127.6",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 132.7 1234.7 142.2 1232.3 138.5 1249.4 127.6 1249.4 132.7",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 137.8 1237 145.8 1234.7 142.2 1249.4 132.7 1249.4 137.8",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 142.9 1239.3 149.4 1237 145.8 1249.4 137.8 1249.4 142.9",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.4 148 1244.5 151.1 1240.4 151.1 1239.3 149.4 1249.4 142.9 1249.4 148",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1244.5 151.1 1249.4 148 1249.4 151.1 1244.5 151.1",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1196.5 59.5 1190.3 63.5 1190.3 59.5 1196.5 59.5",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1204.4 59.5 1190.3 68.6 1190.3 63.5 1196.5 59.5 1204.4 59.5",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1212.4 59.5 1190.3 73.8 1190.3 68.6 1204.4 59.5 1212.4 59.5",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1220.3 59.5 1190.3 78.9 1190.3 73.8 1212.4 59.5 1220.3 59.5",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1228.2 59.5 1190.3 84 1190.3 78.9 1220.3 59.5 1228.2 59.5",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.1 59.5 1190.3 89.1 1190.3 84 1228.2 59.5 1236.1 59.5",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 64.6 1190.3 94.2 1190.3 89.1 1236.1 59.5 1236.2 59.5 1236.2 64.6",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 69.7 1190.3 99.3 1190.3 94.2 1236.2 64.6 1236.2 69.7",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 74.8 1190.3 104.4 1190.3 99.3 1236.2 69.7 1236.2 74.8",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 79.9 1190.3 109.5 1190.3 104.4 1236.2 74.8 1236.2 79.9",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 85 1190.3 114.6 1190.3 109.5 1236.2 79.9 1236.2 85",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 90.1 1191.6 118.9 1190.4 118.9 1190.3 118.6 1190.3 114.6 1236.2 85 1236.2 90.1",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 95.2 1199.5 118.9 1191.6 118.9 1236.2 90.1 1236.2 95.2",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 100.3 1207.4 118.9 1199.5 118.9 1236.2 95.2 1236.2 100.3",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 105.4 1215.4 118.9 1207.4 118.9 1236.2 100.3 1236.2 105.4",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 110.5 1223.3 118.9 1215.4 118.9 1236.2 105.4 1236.2 110.5",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1236.2 115.6 1231.2 118.9 1223.3 118.9 1236.2 110.5 1236.2 115.6",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1231.2 118.9 1236.2 115.6 1236.2 118.9 1231.2 118.9",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1202.3 198.7 1201.4 199.3 1201.4 198.7 1202.3 198.7",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1210.2 198.7 1201.4 204.4 1201.4 199.3 1202.3 198.7 1210.2 198.7",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1218.2 198.7 1201.4 209.5 1201.4 204.4 1210.2 198.7 1218.2 198.7",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1226 198.7 1226 198.8 1201.4 214.6 1201.4 209.5 1218.2 198.7 1226 198.7",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1226 198.8 1228.4 202.4 1202.9 218.7 1201.4 216.3 1201.4 214.6 1226 198.8",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1228.4 202.4 1230.1 205.1 1230.1 206.3 1205.3 222.3 1202.9 218.7 1228.4 202.4",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 211.4 1207.6 225.9 1205.3 222.3 1230.1 206.3 1230.1 211.4",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 216.5 1209.9 229.6 1207.6 225.9 1230.1 211.4 1230.1 216.5",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 221.6 1214.3 231.8 1211.4 231.8 1209.9 229.6 1230.1 216.5 1230.1 221.6",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.1 226.8 1222.2 231.8 1214.3 231.8 1230.1 221.6 1230.1 226.8",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1222.2 231.8 1230.1 226.8 1230.1 231.8 1222.2 231.8",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1232.6 225.1 1225.9 229.5 1225.9 225.1 1232.6 225.1",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1240.5 225.1 1225.9 234.6 1225.9 229.5 1232.6 225.1 1240.5 225.1",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1241.7 225.1 1243.7 228.2 1225.9 239.7 1225.9 234.6 1240.5 225.1 1241.7 225.1",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1243.7 228.2 1246 231.8 1225.9 244.8 1225.9 239.7 1243.7 228.2",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1246 231.8 1248.3 235.4 1225.9 249.9 1225.9 244.8 1246 231.8",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 235.4 1248.3 235.5 1248.3 240.5 1225.9 255 1225.9 249.9 1248.3 235.4",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 245.6 1225.9 260.1 1225.9 255 1248.3 240.5 1248.3 245.6",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 250.7 1225.9 265.2 1225.9 260.1 1248.3 245.6 1248.3 250.7",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 255.8 1230 267.7 1226.3 267.7 1225.9 267.1 1225.9 265.2 1248.3 250.7 1248.3 255.8",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 260.9 1237.9 267.7 1230 267.7 1248.3 255.8 1248.3 260.9",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.3 266 1245.8 267.7 1237.9 267.7 1248.3 260.9 1248.3 266",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.8 267.7 1248.3 266 1248.3 267.7 1245.8 267.7",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.8 225.1 1214.2 226.8 1214.2 225.1 1216.8 225.1",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1224.7 225.1 1214.2 231.9 1214.2 226.8 1216.8 225.1 1224.7 225.1",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.5 225.1 1227.6 225.3 1227.6 228.4 1214.2 237 1214.2 231.9 1224.7 225.1 1227.5 225.1",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 233.5 1214.2 242.1 1214.2 237 1227.6 228.4 1227.6 233.5",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 238.6 1214.2 247.2 1214.2 242.1 1227.6 233.5 1227.6 238.6",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 243.7 1215.7 251.4 1214.2 249.1 1214.2 247.2 1227.6 238.6 1227.6 243.7",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 248.8 1218 255 1215.7 251.4 1227.6 243.7 1227.6 248.8",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 253.9 1220.3 258.6 1218 255 1227.6 248.8 1227.6 253.9",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 259 1222.6 262.2 1220.3 258.6 1227.6 253.9 1227.6 259",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.6 264.1 1224.9 265.8 1222.6 262.2 1227.6 259 1227.6 264.1",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.2 266.2 1224.9 265.8 1227.6 264.1 1227.6 266.2 1225.2 266.2",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1193.5 102.3 1193 102.6 1193 102.3 1193.5 102.3",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1201.4 102.3 1193 107.7 1193 102.6 1193.5 102.3 1201.4 102.3",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1209.4 102.3 1193 112.8 1193 107.7 1201.4 102.3 1209.4 102.3",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1217.3 102.3 1193 117.9 1193 112.8 1209.4 102.3 1217.3 102.3",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1225.2 102.3 1193 123 1193 117.9 1217.3 102.3 1225.2 102.3",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.5 102.3 1229.1 104.9 1193.8 127.7 1193 126.5 1193 123 1225.2 102.3 1227.5 102.3",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.1 104.9 1229.7 105.8 1229.7 109.6 1196.1 131.3 1193.8 127.7 1229.1 104.9",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 114.7 1198.4 134.9 1196.1 131.3 1229.7 109.6 1229.7 114.7",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 119.8 1200.7 138.5 1198.4 134.9 1229.7 114.7 1229.7 119.8",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 124.9 1203.1 142.1 1200.7 138.5 1229.7 119.8 1229.7 124.9",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 130 1205.4 145.7 1203.1 142.1 1229.7 124.9 1229.7 130",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 135.1 1207.7 149.3 1205.4 145.7 1229.7 130 1229.7 135.1",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 140.2 1210.8 152.4 1209.7 152.4 1207.7 149.3 1229.7 135.1 1229.7 140.2",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 145.4 1218.8 152.4 1210.8 152.4 1229.7 140.2 1229.7 145.4",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1229.7 150.5 1226.7 152.4 1218.8 152.4 1229.7 145.4 1229.7 150.5",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1226.7 152.4 1229.7 150.5 1229.7 152.4 1226.7 152.4",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1125.1 69.8 1121.7 72 1121.7 69.8 1125.1 69.8",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1133 69.8 1121.7 77.1 1121.7 72 1125.1 69.8 1133 69.8",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1140.9 69.8 1121.7 82.2 1121.7 77.1 1133 69.8 1140.9 69.8",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1148.9 69.8 1121.7 87.3 1121.7 82.2 1140.9 69.8 1148.9 69.8",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1156.8 69.8 1121.7 92.4 1121.7 87.3 1148.9 69.8 1156.8 69.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1164.7 69.8 1122.8 96.8 1121.7 95.1 1121.7 92.4 1156.8 69.8 1164.7 69.8",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1172.6 69.8 1125.1 100.4 1122.8 96.8 1164.7 69.8 1172.6 69.8",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1180.6 69.8 1127.5 104 1125.1 100.4 1172.6 69.8 1180.6 69.8",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1187.1 69.8 1187.5 70.4 1129.8 107.6 1127.5 104 1180.6 69.8 1187.1 69.8",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1125.5,
    y: 88.7,
    width: 68.6,
    height: 4.3,
    transform: "translate(135.5 642.4) rotate(-32.8)",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1189.8 74 1192 77.4 1192 77.8 1134.4 114.8 1132.1 111.2 1189.8 74",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 82.9 1136.8 118.4 1134.4 114.8 1192 77.8 1192 82.9",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 88 1144 118.9 1137 118.9 1136.8 118.4 1192 82.9 1192 88",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 93.1 1151.9 118.9 1144 118.9 1192 88 1192 93.1",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 98.2 1159.9 118.9 1151.9 118.9 1192 93.1 1192 98.2",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 103.3 1167.8 118.9 1159.9 118.9 1192 98.2 1192 103.3",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 108.4 1175.7 118.9 1167.8 118.9 1192 103.3 1192 108.4",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 113.5 1183.7 118.9 1175.7 118.9 1192 108.4 1192 113.5",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192 118.6 1191.6 118.9 1183.7 118.9 1192 113.5 1192 118.6",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1191.6 118.9 1192 118.6 1192 118.9 1191.6 118.9",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1116.7 34.4 1108.9 39.4 1108.9 34.4 1116.7 34.4",
    fill: "#636363",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1124.6 34.4 1108.9 44.5 1108.9 39.4 1116.7 34.4 1124.6 34.4",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.5 34.4 1108.9 49.6 1108.9 44.5 1124.6 34.4 1132.5 34.4",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1140.5 34.4 1108.9 54.7 1108.9 49.6 1132.5 34.4 1140.5 34.4",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1148.4 34.4 1108.9 59.8 1108.9 54.7 1140.5 34.4 1148.4 34.4",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1156.3 34.4 1108.9 64.9 1108.9 59.8 1148.4 34.4 1156.3 34.4",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1164.2 34.4 1108.9 70 1108.9 64.9 1156.3 34.4 1164.2 34.4",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1172.2 34.4 1108.9 75.1 1108.9 70 1164.2 34.4 1172.2 34.4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 38.3 1110.9 78.9 1108.9 75.9 1108.9 75.1 1172.2 34.4 1173.9 34.4 1173.9 38.3",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 43.4 1113.2 82.5 1110.9 78.9 1173.9 38.3 1173.9 43.4",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 48.6 1115.5 86.2 1113.2 82.5 1173.9 43.4 1173.9 48.6",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 53.7 1117.9 89.8 1115.5 86.2 1173.9 48.6 1173.9 53.7",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 58.8 1124.2 90.8 1118.5 90.8 1117.9 89.8 1173.9 53.7 1173.9 58.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 63.9 1132.2 90.8 1124.2 90.8 1173.9 58.8 1173.9 63.9",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 69 1140.1 90.8 1132.2 90.8 1173.9 63.9 1173.9 69",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 74.1 1148 90.8 1140.1 90.8 1173.9 69 1173.9 74.1",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 79.2 1155.9 90.8 1148 90.8 1173.9 74.1 1173.9 79.2",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 84.3 1163.9 90.8 1155.9 90.8 1173.9 79.2 1173.9 84.3",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1173.9 89.4 1171.8 90.8 1163.9 90.8 1173.9 84.3 1173.9 89.4",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1171.8 90.8 1173.9 89.4 1173.9 90.8 1171.8 90.8",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1241.6 60.8 1241.8 61 1237.4 63.8 1237.4 60.8 1241.6 60.8",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1241.8 61 1244.1 64.6 1237.4 68.9 1237.4 63.8 1241.8 61",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1244.1 64.6 1246.4 68.2 1237.4 74 1237.4 68.9 1244.1 64.6",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1246.4 68.2 1248.7 71.8 1237.4 79.1 1237.4 74 1246.4 68.2",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1248.7 71.8 1251.1 75.4 1237.4 84.2 1237.4 79.1 1248.7 71.8",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1251.1 75.4 1253.4 79 1237.4 89.3 1237.4 84.2 1251.1 75.4",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253.4 79 1255.7 82.7 1237.4 94.4 1237.4 89.3 1253.4 79",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1255.7 82.7 1258 86.3 1237.4 99.5 1237.4 94.4 1255.7 82.7",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258 86.3 1260.4 89.9 1237.4 104.6 1237.4 99.5 1258 86.3",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.4 89.9 1262.7 93.5 1237.4 109.7 1237.4 104.6 1260.4 89.9",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.7 93.5 1265 97.1 1237.4 114.8 1237.4 109.7 1262.7 93.5",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1265 97.1 1266.8 99.9 1266.8 101 1237.4 119.9 1237.4 114.8 1265 97.1",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 106.1 1237.4 125 1237.4 119.9 1266.8 101 1266.8 106.1",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 111.2 1237.4 130.1 1237.4 125 1266.8 106.1 1266.8 111.2",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 116.4 1237.7 135.1 1237.4 134.7 1237.4 130.1 1266.8 111.2 1266.8 116.4",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 121.5 1240 138.7 1237.7 135.1 1266.8 116.4 1266.8 121.5",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 126.6 1242.4 142.3 1240 138.7 1266.8 121.5 1266.8 126.6",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 131.7 1244.7 145.9 1242.4 142.3 1266.8 126.6 1266.8 131.7",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 136.8 1247 149.5 1244.7 145.9 1266.8 131.7 1266.8 136.8",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 141.9 1253.4 150.5 1247.6 150.5 1247 149.5 1266.8 136.8 1266.8 141.9",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.8 147 1261.3 150.5 1253.4 150.5 1266.8 141.9 1266.8 147",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1261.3 150.5 1266.8 147 1266.8 150.5 1261.3 150.5",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.3 153.2 1231.6 154.3 1231.6 153.2 1233.3 153.2",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1241.2 153.2 1231.6 159.5 1231.6 154.3 1233.3 153.2 1241.2 153.2",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.2 153.2 1231.6 164.6 1231.6 159.5 1241.2 153.2 1249.2 153.2",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1252.4 153.2 1253.8 155.4 1231.6 169.7 1231.6 164.6 1249.2 153.2 1252.4 153.2",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253.8 155.4 1256.1 159 1231.6 174.8 1231.6 169.7 1253.8 155.4",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1256.1 159 1258.4 162.6 1231.6 179.9 1231.6 174.8 1256.1 159",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.4 162.6 1260.7 166.2 1231.6 185 1231.6 179.9 1258.4 162.6",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.7 166.2 1262.4 168.7 1262.4 170.2 1231.6 190.1 1231.6 185 1260.7 166.2",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 175.3 1231.6 195.2 1231.6 190.1 1262.4 170.2 1262.4 175.3",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 180.4 1231.6 200.3 1231.6 195.2 1262.4 175.3 1262.4 180.4",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 185.5 1231.6 205.4 1231.6 200.3 1262.4 180.4 1262.4 185.5",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 190.6 1237.2 206.9 1231.6 206.9 1231.6 205.4 1262.4 185.5 1262.4 190.6",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 195.8 1245.1 206.9 1237.2 206.9 1262.4 190.6 1262.4 195.8",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 200.9 1253 206.9 1245.1 206.9 1262.4 195.8 1262.4 200.9",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.4 206 1260.9 206.9 1253 206.9 1262.4 200.9 1262.4 206",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.9 206.9 1262.4 206 1262.4 206.9 1260.9 206.9",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1255 205.6 1249.6 209.1 1249.6 205.6 1255 205.6",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.6 205.6 1261.3 206.7 1249.6 214.2 1249.6 209.1 1255 205.6 1260.6 205.6",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1261.3 206.7 1263.6 210.3 1249.6 219.3 1249.6 214.2 1261.3 206.7",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1263.6 210.3 1265.9 213.9 1249.6 224.4 1249.6 219.3 1263.6 210.3",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1265.9 213.9 1268.2 217.5 1249.6 229.5 1249.6 224.4 1265.9 213.9",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1268.2 217.5 1270.6 221.1 1249.6 234.6 1249.6 229.5 1268.2 217.5",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.6 221.1 1270.6 221.1 1270.6 226.2 1251.4 238.5 1249.6 238.5 1249.6 234.6 1270.6 221.1",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.6 231.3 1259.3 238.5 1251.4 238.5 1270.6 226.2 1270.6 231.3",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1270.6 236.4 1267.3 238.5 1259.3 238.5 1270.6 231.3 1270.6 236.4",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1267.3 238.5 1270.6 236.4 1270.6 238.5 1267.3 238.5",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.6 239.8 1228.6 243 1228.6 239.8 1233.6 239.8",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1241.5 239.8 1228.6 248.1 1228.6 243 1233.6 239.8 1241.5 239.8",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1249.5 239.8 1228.6 253.2 1228.6 248.1 1241.5 239.8 1249.5 239.8",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1251.1 239.8 1253 242.6 1228.6 258.3 1228.6 253.2 1249.5 239.8 1251.1 239.8",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253 242.6 1255.3 246.3 1228.6 263.4 1228.6 258.3 1253 242.6",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1255.3 246.3 1257.6 249.9 1228.6 268.5 1228.6 263.4 1255.3 246.3",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1257.6 249.9 1258.8 251.7 1258.8 254.2 1229.2 273.3 1228.6 272.4 1228.6 268.5 1257.6 249.9",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.8 259.3 1231.5 276.9 1229.2 273.3 1258.8 254.2 1258.8 259.3",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.8 264.4 1233.8 280.5 1231.5 276.9 1258.8 259.3 1258.8 264.4",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.8 269.5 1236.2 284.1 1233.8 280.5 1258.8 264.4 1258.8 269.5",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1242.3 293.7 1236.2 284.1 1258.8 269.5 1258.8 293.7 1242.3 293.7",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1120.8 -4 1063.8 32.7 1044 1.8 1044 -4 1120.8 -4",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1128.7 -4 1066.2 36.3 1063.8 32.7 1120.8 -4 1128.7 -4",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1136.6 -4 1068.5 39.9 1066.2 36.3 1128.7 -4 1136.6 -4",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1144.5 -4 1070.8 43.5 1068.5 39.9 1136.6 -4 1144.5 -4",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1152.5 -4 1073.1 47.1 1070.8 43.5 1144.5 -4 1152.5 -4",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1160.4 -4 1075.5 50.7 1073.1 47.1 1152.5 -4 1160.4 -4",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1168.3 -4 1077.8 54.3 1075.5 50.7 1160.4 -4 1168.3 -4",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1176.2 -4 1080.1 57.9 1077.8 54.3 1168.3 -4 1176.2 -4",
    fill: "#636363",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1184.2 -4 1082.4 61.5 1080.1 57.9 1176.2 -4 1184.2 -4",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192.1 -4 1084.8 65.1 1082.4 61.5 1184.2 -4 1192.1 -4",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1200 -4 1087.1 68.8 1084.8 65.1 1192.1 -4 1200 -4",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1207.9 -4 1089.4 72.4 1087.1 68.8 1200 -4 1207.9 -4",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1215.9 -4 1091.7 76 1089.4 72.4 1207.9 -4 1215.9 -4",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1223.8 -4 1094.1 79.6 1091.7 76 1215.9 -4 1223.8 -4",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1231.7 -4 1096.4 83.2 1094.1 79.6 1223.8 -4 1231.7 -4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.7 -4 1098.7 86.8 1096.4 83.2 1231.7 -4 1239.7 -4",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1247.6 -4 1101 90.4 1098.7 86.8 1239.7 -4 1247.6 -4",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1255.5 -4 1103.3 94 1101 90.4 1247.6 -4 1255.5 -4",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1263.4 -4 1105.7 97.6 1103.3 94 1255.5 -4 1263.4 -4",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1271.4 -4 1108 101.2 1105.7 97.6 1263.4 -4 1271.4 -4",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1279.3 -4 1110.3 104.8 1108 101.2 1271.4 -4 1279.3 -4",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1287.2 -4 1112.6 108.4 1110.3 104.8 1279.3 -4 1287.2 -4",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1290.4 -4 1291.8 -1.8 1115 112 1112.6 108.4 1287.2 -4 1290.4 -4",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1099.4,
    y: 54.8,
    width: 210.3,
    height: 4.3,
    transform: "translate(161 661.3) rotate(-32.8)",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1101.7,
    y: 58.4,
    width: 210.3,
    height: 4.3,
    transform: "translate(159.4 663.1) rotate(-32.8)",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1296.4 5.4 1297.8 7.6 1297.8 9.6 1121.9 122.9 1119.6 119.3 1296.4 5.4",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 14.7 1124.3 126.5 1121.9 122.9 1297.8 9.6 1297.8 14.7",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 19.8 1126.6 130.1 1124.3 126.5 1297.8 14.7 1297.8 19.8",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 24.9 1128.9 133.7 1126.6 130.1 1297.8 19.8 1297.8 24.9",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 30 1131.2 137.3 1128.9 133.7 1297.8 24.9 1297.8 30",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 35.1 1133.6 140.9 1131.2 137.3 1297.8 30 1297.8 35.1",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 40.2 1135.9 144.5 1133.6 140.9 1297.8 35.1 1297.8 40.2",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 45.3 1138.2 148.1 1135.9 144.5 1297.8 40.2 1297.8 45.3",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 50.4 1140.5 151.7 1138.2 148.1 1297.8 45.3 1297.8 50.4",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 55.5 1142.8 155.3 1140.5 151.7 1297.8 50.4 1297.8 55.5",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 60.6 1145.2 159 1142.8 155.3 1297.8 55.5 1297.8 60.6",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 65.7 1147.5 162.6 1145.2 159 1297.8 60.6 1297.8 65.7",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 70.9 1149.8 166.2 1147.5 162.6 1297.8 65.7 1297.8 70.9",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 76 1152.1 169.8 1149.8 166.2 1297.8 70.9 1297.8 76",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 81.1 1154.5 173.4 1152.1 169.8 1297.8 76 1297.8 81.1",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 86.2 1156.8 177 1154.5 173.4 1297.8 81.1 1297.8 86.2",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 91.3 1159.1 180.6 1156.8 177 1297.8 86.2 1297.8 91.3",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 96.4 1161.4 184.2 1159.1 180.6 1297.8 91.3 1297.8 96.4",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 101.5 1163.8 187.8 1161.4 184.2 1297.8 96.4 1297.8 101.5",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 106.6 1166.1 191.4 1163.8 187.8 1297.8 101.5 1297.8 106.6",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 111.7 1168.4 195 1166.1 191.4 1297.8 106.6 1297.8 111.7",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 116.8 1170.7 198.6 1168.4 195 1297.8 111.7 1297.8 116.8",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 121.9 1173.1 202.2 1170.7 198.6 1297.8 116.8 1297.8 121.9",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 127 1175.4 205.9 1173.1 202.2 1297.8 121.9 1297.8 127",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 132.1 1177.7 209.5 1175.4 205.9 1297.8 127 1297.8 132.1",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 137.2 1180 213.1 1177.7 209.5 1297.8 132.1 1297.8 137.2",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 142.3 1182.3 216.7 1180 213.1 1297.8 137.2 1297.8 142.3",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 147.4 1184.7 220.3 1182.3 216.7 1297.8 142.3 1297.8 147.4",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 152.5 1187 223.9 1184.7 220.3 1297.8 147.4 1297.8 152.5",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 157.6 1189.3 227.5 1187 223.9 1297.8 152.5 1297.8 157.6",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 162.7 1191.6 231.1 1189.3 227.5 1297.8 157.6 1297.8 162.7",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 167.8 1194 234.7 1191.6 231.1 1297.8 162.7 1297.8 167.8",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 172.9 1196.3 238.3 1194 234.7 1297.8 167.8 1297.8 172.9",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 178 1198.6 241.9 1196.3 238.3 1297.8 172.9 1297.8 178",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 183.1 1200.9 245.5 1198.6 241.9 1297.8 178 1297.8 183.1",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 188.2 1203.3 249.1 1200.9 245.5 1297.8 183.1 1297.8 188.2",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 193.4 1205.6 252.8 1203.3 249.1 1297.8 188.2 1297.8 193.4",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 198.5 1207.9 256.4 1205.6 252.8 1297.8 193.4 1297.8 198.5",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 203.6 1210.2 260 1207.9 256.4 1297.8 198.5 1297.8 203.6",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 208.7 1212.6 263.6 1210.2 260 1297.8 203.6 1297.8 208.7",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 213.8 1214.9 267.2 1212.6 263.6 1297.8 208.7 1297.8 213.8",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 218.9 1217.2 270.8 1214.9 267.2 1297.8 213.8 1297.8 218.9",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 224 1219.5 274.4 1217.2 270.8 1297.8 218.9 1297.8 224",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 229.1 1221.8 278 1219.5 274.4 1297.8 224 1297.8 229.1",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 234.2 1224.2 281.6 1221.8 278 1297.8 229.1 1297.8 234.2",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 239.3 1226.5 285.2 1224.2 281.6 1297.8 234.2 1297.8 239.3",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1297.8 244.4 1228.8 288.8 1226.5 285.2 1297.8 239.3 1297.8 244.4",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1256.6 332 1228.8 288.8 1297.8 244.4 1297.8 332 1256.6 332",
    fill: "#a4a4a4",
    strokeWidth: 0
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-2)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "31.5 489.4 36.1 486.5 36.1 489.4 31.5 489.4",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.5 489.4 36.1 481.4 36.1 486.5 31.5 489.4 23.5 489.4",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.6 489.4 36.1 476.2 36.1 481.4 23.5 489.4 15.6 489.4",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 484.6 36.1 471.1 36.1 476.2 15.6 489.4 15.1 489.4 15.1 484.6",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 479.5 35.3 466.5 36.1 467.6 36.1 471.1 15.1 484.6 15.1 479.5",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 474.4 33 462.8 35.3 466.5 15.1 479.5 15.1 474.4",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 469.2 30.6 459.2 33 462.8 15.1 474.4 15.1 469.2",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 464.1 24.6 458 29.8 458 30.6 459.2 15.1 469.2 15.1 464.1",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 459 16.7 458 24.6 458 15.1 464.1 15.1 459",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.7 458 15.1 459 15.1 458 16.7 458",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.4 546.4 53.5 541.9 53.5 546.4 46.4 546.4",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.5 546.4 53.5 536.8 53.5 541.9 46.4 546.4 38.5 546.4",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.5 546.4 53.5 531.7 53.5 536.8 38.5 546.4 30.5 546.4",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.5 546.4 53.5 526.5 53.5 531.7 30.5 546.4 22.5 546.4",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 546.4 14.9 546.2 53.5 521.4 53.5 526.5 22.5 546.4 15 546.4",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.9 546.2 12.6 542.6 53.5 516.3 53.5 521.4 14.9 546.2",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.6 542.6 10.2 539 47.8 514.8 53.5 514.8 53.5 516.3 12.6 542.6",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.2 539 7.9 535.4 39.9 514.8 47.8 514.8 10.2 539",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.9 535.4 7.5 534.8 7.5 530.5 31.9 514.8 39.9 514.8 7.9 535.4",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.5 525.3 23.9 514.8 31.9 514.8 7.5 530.5 7.5 525.3",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.5 520.2 16 514.8 23.9 514.8 7.5 525.3 7.5 520.2",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.5 515.1 8 514.8 16 514.8 7.5 520.2 7.5 515.1",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8 514.8 7.5 515.1 7.5 514.8 8 514.8",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.2 617.7 34.8 615.4 34.8 617.7 31.2 617.7",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.3 617.7 34.8 610.3 34.8 615.4 31.2 617.7 23.3 617.7",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.4 617.7 15.4 617.6 34.8 605.2 34.8 610.3 23.3 617.7 15.4 617.7",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.4 617.6 13.1 614 34.8 600 34.8 605.2 15.4 617.6",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.1 614 10.7 610.4 34.8 594.9 34.8 600 13.1 614",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.7 610.4 9.6 608.7 9.6 606 34.8 589.8 34.8 594.9 10.7 610.4",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 600.9 34.8 584.7 34.8 589.8 9.6 606 9.6 600.9",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 595.7 34.8 579.5 34.8 584.7 9.6 600.9 9.6 595.7",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 590.6 34.8 574.4 34.8 579.5 9.6 595.7 9.6 590.6",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 585.5 34.8 569.3 34.8 574.4 9.6 590.6 9.6 585.5",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 580.4 34.8 564.2 34.8 569.3 9.6 585.5 9.6 580.4",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 575.2 32.7 560.4 34.8 563.6 34.8 564.2 9.6 580.4 9.6 575.2",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 570.1 30.4 556.8 32.7 560.4 9.6 575.2 9.6 570.1",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 565 28 553.1 30.4 556.8 9.6 570.1 9.6 565",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 559.9 25.7 549.5 28 553.1 9.6 565 9.6 559.9",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 554.7 19.9 548.1 24.8 548.1 25.7 549.5 9.6 559.9 9.6 554.7",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.6 549.6 12 548.1 19.9 548.1 9.6 554.7 9.6 549.6",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12 548.1 9.6 549.6 9.6 548.1 12 548.1",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.4 684.2 48 683.8 48 684.2 47.4 684.2",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.4 684.2 48 678.6 48 683.8 47.4 684.2 39.4 684.2",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.5 684.2 48 673.5 48 678.6 39.4 684.2 31.5 684.2",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.5 684.2 48 668.4 48 673.5 31.5 684.2 23.5 684.2",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.4 684.2 20.4 681.1 48 663.3 48 668.4 23.5 684.2 22.4 684.2",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.4 681.1 18.7 678.4 18.7 677 47.3 658.6 48 659.7 48 663.3 20.4 681.1",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 671.9 45 655 47.3 658.6 18.7 677 18.7 671.9",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 666.8 42.6 651.4 45 655 18.7 671.9 18.7 666.8",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 661.7 40.3 647.7 42.6 651.4 18.7 666.8 18.7 661.7",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 656.5 38 644.1 40.3 647.7 18.7 661.7 18.7 656.5",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 651.4 35.6 640.5 38 644.1 18.7 656.5 18.7 651.4",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 646.3 33.3 636.9 35.6 640.5 18.7 651.4 18.7 646.3",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 641.2 31 633.2 33.3 636.9 18.7 646.3 18.7 641.2",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 636 28.6 629.6 31 633.2 18.7 641.2 18.7 636",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 630.9 26.3 626 28.6 629.6 18.7 636 18.7 630.9",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 625.8 24 622.4 26.3 626 18.7 630.9 18.7 625.8",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 620.7 18.7 620.6 22.8 620.6 24 622.4 18.7 625.8 18.7 620.7",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7 620.6 18.7 620.7 18.7 620.6 18.7 620.6",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.7 698 64.6 693.6 64.6 698 57.7 698",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.8 698 64.6 688.5 64.6 693.6 57.7 698 49.8 698",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.8 698 63.5 684 64.6 685.6 64.6 688.5 49.8 698 41.8 698",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.9 698 61.2 680.4 63.5 684 41.8 698 33.9 698",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.1 698 29.6 695.6 58.9 676.8 61.2 680.4 33.9 698 31.1 698",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 682.2,
    width: 34.8,
    height: 4.3,
    transform: "translate(-363.6 132.3) rotate(-32.8)",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.3 692 25.2 688.7 25.2 688.2 54.2 669.5 56.5 673.1 27.3 692",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.2 683.1 51.9 665.9 54.2 669.5 25.2 688.2 25.2 683.1",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.2 678 46.5 664.2 50.8 664.2 51.9 665.9 25.2 683.1 25.2 678",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.2 672.9 38.5 664.2 46.5 664.2 25.2 678 25.2 672.9",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.2 667.7 30.6 664.2 38.5 664.2 25.2 672.9 25.2 667.7",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.6 664.2 25.2 667.7 25.2 664.2 30.6 664.2",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107 702.2 109.6 700.5 109.6 702.2 107 702.2",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99 702.2 109.6 695.3 109.6 700.5 107 702.2 99 702.2",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91 702.2 109.6 690.2 109.6 695.3 99 702.2 91 702.2",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.1 702.2 109.6 685.1 109.6 690.2 91 702.2 83.1 702.2",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 702.2 107.3 681.5 109.6 685.1 109.6 685.1 83.1 702.2 75.1 702.2",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.2 702.2 105 677.8 107.3 681.5 75.1 702.2 67.2 702.2",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.5 702.2 63.7 699.3 102.6 674.2 105 677.8 67.2 702.2 65.5 702.2",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 682.8,
    width: 46.3,
    height: 4.3,
    transform: "translate(-357.7 153.4) rotate(-32.8)",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 679.2,
    width: 46.3,
    height: 4.3,
    transform: "translate(-356.1 151.6) rotate(-32.8)",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59 692.1 56.7 688.4 93.9 664.5 96.4 664.5 98 667 59 692.1",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.7 688.4 54.3 684.8 86 664.5 93.9 664.5 56.7 688.4",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.3 684.8 52 681.2 78 664.5 86 664.5 54.3 684.8",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 681.2 49.7 677.6 70 664.5 78 664.5 52 681.2",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.7 677.6 49.5 677.2 49.5 672.6 62.1 664.5 70 664.5 49.7 677.6",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.5 667.4 54.1 664.5 62.1 664.5 49.5 672.6 49.5 667.4",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.1 664.5 49.5 667.4 49.5 664.5 54.1 664.5",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.2 517.7 59.5 517.5 59.5 517.7 59.2 517.7",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.2 517.7 59.5 512.4 59.5 517.5 59.2 517.7 51.2 517.7",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.3 517.7 59.5 507.2 59.5 512.4 51.2 517.7 43.3 517.7",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.3 517.7 59.5 502.1 59.5 507.2 43.3 517.7 35.3 517.7",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 517.4 59.5 497 59.5 502.1 35.3 517.7 27.9 517.7 27.9 517.4",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 512.2 58.2 492.7 59.5 494.7 59.5 497 27.9 517.4 27.9 512.2",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 507.1 55.9 489.1 58.2 492.7 27.9 512.2 27.9 507.1",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 502 53.6 485.5 55.9 489.1 27.9 507.1 27.9 502",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 496.9 47.6 484.2 52.7 484.2 53.6 485.5 27.9 502 27.9 496.9",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 491.8 39.6 484.2 47.6 484.2 27.9 496.9 27.9 491.8",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.9 486.6 31.7 484.2 39.6 484.2 27.9 491.8 27.9 486.6",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.7 484.2 27.9 486.6 27.9 484.2 31.7 484.2",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.8 688.1 117.4 685.2 117.4 688.1 112.8 688.1",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.9 688.1 117.4 680.1 117.4 685.2 112.8 688.1 104.9 688.1",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.9 688.1 117.4 675 117.4 680.1 104.9 688.1 96.9 688.1",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89 688.1 117.4 669.8 117.4 675 96.9 688.1 89 688.1",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81 688.1 117.4 664.7 117.4 669.8 89 688.1 81 688.1",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.1 688.1 117.4 659.6 117.4 664.7 81 688.1 73.1 688.1",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.1 688.1 117.4 654.5 117.4 659.6 73.1 688.1 65.1 688.1",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63 688.1 61.3 685.5 117.2 649.5 117.4 649.9 117.4 654.5 65.1 688.1 63 688.1",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.3 685.5 58.9 681.9 114.3 646.2 115 646.2 117.2 649.5 61.3 685.5",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.9 681.9 56.6 678.2 106.3 646.2 114.3 646.2 58.9 681.9",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.6 678.2 54.3 674.6 98.4 646.2 106.3 646.2 56.6 678.2",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.3 674.6 51.9 671 90.4 646.2 98.4 646.2 54.3 674.6",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.9 671 49.7 667.5 49.7 667.3 82.5 646.2 90.4 646.2 51.9 671",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.7 662.2 74.5 646.2 82.5 646.2 49.7 667.3 49.7 662.2",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.7 657.1 66.5 646.2 74.5 646.2 49.7 662.2 49.7 657.1",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.7 651.9 58.6 646.2 66.5 646.2 49.7 657.1 49.7 651.9",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.7 646.8 50.6 646.2 58.6 646.2 49.7 651.9 49.7 646.8",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.6 646.2 49.7 646.8 49.7 646.2 50.6 646.2",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.2 687.1 162.9 686.7 162.9 687.1 162.2 687.1",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.3 687.1 162.9 681.5 162.9 686.7 162.2 687.1 154.3 687.1",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.3 687.1 162.9 676.4 162.9 681.5 154.3 687.1 146.3 687.1",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.4 687.1 162.9 671.3 162.9 676.4 146.3 687.1 138.4 687.1",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.4 687.1 162.9 666.2 162.9 671.3 138.4 687.1 130.4 687.1",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.4 687.1 162.9 661.1 162.9 666.2 130.4 687.1 122.4 687.1",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.5 687.1 162.9 655.9 162.9 661.1 122.4 687.1 114.5 687.1",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 684 162.9 650.8 162.9 655.9 114.5 687.1 111.3 687.1 111.3 684",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 678.9 162.9 645.7 162.9 650.8 111.3 684 111.3 678.9",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 673.8 162.9 640.6 162.9 645.7 111.3 678.9 111.3 673.8",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 668.6 162.9 635.4 162.9 640.6 111.3 673.8 111.3 668.6",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 663.5 159.7 632.4 162.9 632.4 162.9 635.4 111.3 668.6 111.3 663.5",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 658.4 151.7 632.4 159.7 632.4 111.3 663.5 111.3 658.4",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 653.3 143.7 632.4 151.7 632.4 111.3 658.4 111.3 653.3",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 648.1 135.8 632.4 143.7 632.4 111.3 653.3 111.3 648.1",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 643 127.8 632.4 135.8 632.4 111.3 648.1 111.3 643",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 637.9 119.9 632.4 127.8 632.4 111.3 643 111.3 637.9",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 632.8 111.9 632.4 119.9 632.4 111.3 637.9 111.3 632.8",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.9 632.4 111.3 632.8 111.3 632.4 111.9 632.4",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.5 568.7 83.8 568.5 83.8 568.7 83.5 568.7",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.6 568.7 83.8 563.3 83.8 568.5 83.5 568.7 75.6 568.7",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69 568.7 68.6 568 83.8 558.2 83.8 563.3 75.6 568.7 69 568.7",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.6 568 66.3 564.4 83.8 553.1 83.8 558.2 68.6 568",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.3 564.4 63.9 560.8 83.8 548 83.8 553.1 66.3 564.4",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.9 560.8 61.6 557.2 83.8 542.8 83.8 548 63.9 560.8",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.6 557.2 60.2 554.9 60.2 553 83.8 537.7 83.8 542.8 61.6 557.2",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.2 547.8 83.8 532.6 83.8 537.7 60.2 553 60.2 547.8",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.2 542.7 83.8 527.5 83.8 532.6 60.2 547.8 60.2 542.7",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.2 537.6 78 526.1 83.8 526.1 83.8 527.5 60.2 542.7 60.2 537.6",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.2 532.5 70 526.1 78 526.1 60.2 537.6 60.2 532.5",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.2 527.3 62.1 526.1 70 526.1 60.2 532.5 60.2 527.3",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.1 526.1 60.2 527.3 60.2 526.1 62.1 526.1",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80 550.4 83.8 548 83.8 550.4 80 550.4",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1 550.4 83.8 542.8 83.8 548 80 550.4 72.1 550.4",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.1 550.4 83.8 537.7 83.8 542.8 72.1 550.4 64.1 550.4",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.4 550.4 57 549.9 83.8 532.6 83.8 537.7 64.1 550.4 57.4 550.4",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57 549.9 55.3 547.3 55.3 545.8 83.8 527.5 83.8 532.6 57 549.9",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 540.7 83.8 522.3 83.8 527.5 55.3 545.8 55.3 540.7",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 535.6 82.2 518.3 83.8 520.9 83.8 522.3 55.3 540.7 55.3 535.6",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 530.4 79.7 514.8 79.9 514.8 82.2 518.3 55.3 535.6 55.3 530.4",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 525.3 71.7 514.8 79.7 514.8 55.3 530.4 55.3 525.3",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 520.2 63.7 514.8 71.7 514.8 55.3 525.3 55.3 520.2",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 515.1 55.8 514.8 63.7 514.8 55.3 520.2 55.3 515.1",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 514.8 55.3 515.1 55.3 514.8 55.8 514.8",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51 569.1 58.7 564.1 58.7 569.1 51 569.1",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.1 569.1 58.7 559 58.7 564.1 51 569.1 43.1 569.1",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 568.5 58.7 553.9 58.7 559 43.1 569.1 36.1 569.1 36.1 568.5",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 563.4 58.7 548.8 58.7 553.9 36.1 568.5 36.1 563.4",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 558.2 58.7 543.7 58.7 548.8 36.1 563.4 36.1 558.2",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 553.1 58.7 538.5 58.7 543.7 36.1 558.2 36.1 553.1",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 548 58.7 533.4 58.7 538.5 36.1 553.1 36.1 548",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 542.9 58.7 528.3 58.7 533.4 36.1 548 36.1 542.9",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 537.7 58.7 523.2 58.7 528.3 36.1 542.9 36.1 537.7",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 532.6 58.4 518.2 58.7 518.6 58.7 523.2 36.1 537.7 36.1 532.6",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 527.5 54.2 515.8 56.9 515.8 58.4 518.2 36.1 532.6 36.1 527.5",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 522.4 46.2 515.8 54.2 515.8 36.1 527.5 36.1 522.4",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 517.2 38.2 515.8 46.2 515.8 36.1 522.4 36.1 517.2",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.2 515.8 36.1 517.2 36.1 515.8 38.2 515.8",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.2 590 72.9 585.7 72.9 590 66.2 590",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.3 590 72.9 580.6 72.9 585.7 66.2 590 58.3 590",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.3 590 72.9 575.5 72.9 580.6 58.3 590 50.3 590",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.2 590 45.1 588.3 72.9 570.3 72.9 575.5 50.3 590 46.2 590",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.1 588.3 42.8 584.7 72.6 565.5 72.9 566 72.9 570.3 45.1 588.3",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 571.1,
    width: 35.5,
    height: 4.3,
    transform: "translate(-301.3 121.9) rotate(-32.8)",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 567.5,
    width: 35.5,
    height: 4.3,
    transform: "translate(-299.7 120) rotate(-32.8)",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.1 577.4 36.1 574.2 36.1 573.6 65.6 554.6 67.9 558.2 38.1 577.4",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 568.5 61.5 552.1 64 552.1 65.6 554.6 36.1 573.6 36.1 568.5",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 563.4 53.5 552.1 61.5 552.1 36.1 568.5 36.1 563.4",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 558.2 45.6 552.1 53.5 552.1 36.1 563.4 36.1 558.2",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 553.1 37.6 552.1 45.6 552.1 36.1 558.2 36.1 553.1",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.6 552.1 36.1 553.1 36.1 552.1 37.6 552.1",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.7 661.5 59.5 661 59.5 661.5 58.7 661.5",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.7 661.5 59.5 655.8 59.5 661 58.7 661.5 50.7 661.5",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.3 661.5 45.2 659.9 59.5 650.7 59.5 655.8 50.7 661.5 46.3 661.5",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.2 659.9 42.9 656.3 59.5 645.6 59.5 650.7 45.2 659.9",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.9 656.3 40.6 652.7 59.5 640.5 59.5 645.6 42.9 656.3",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.6 652.7 38.2 649.1 59.5 635.3 59.5 640.5 40.6 652.7",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.2 649.1 36.1 645.7 36.1 645.3 59.5 630.2 59.5 635.3 38.2 649.1",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 640.2 59.5 625.1 59.5 630.2 36.1 645.3 36.1 640.2",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 635.1 59.5 620 59.5 625.1 36.1 640.2 36.1 635.1",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 630 59.5 614.9 59.5 620 36.1 635.1 36.1 630",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 624.8 59.5 609.7 59.5 614.9 36.1 630 36.1 624.8",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 619.7 59.5 604.6 59.5 609.7 36.1 624.8 36.1 619.7",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 614.6 59.5 599.5 59.5 604.6 36.1 619.7 36.1 614.6",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 609.5 59.5 594.4 59.5 599.5 36.1 614.6 36.1 609.5",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 604.3 57.3 590.7 59.5 594.1 59.5 594.4 36.1 609.5 36.1 604.3",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 599.2 55 587 57.3 590.7 36.1 604.3 36.1 599.2",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 594.1 52.6 583.4 55 587 36.1 599.2 36.1 594.1",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 589 50.3 579.8 52.6 583.4 36.1 594.1 36.1 589",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 583.8 48 576.2 50.3 579.8 36.1 589 36.1 583.8",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 578.7 45.6 572.6 48 576.2 36.1 583.8 36.1 578.7",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.1 573.6 39.2 571.6 45 571.6 45.6 572.6 36.1 578.7 36.1 573.6",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.2 571.6 36.1 573.6 36.1 571.6 39.2 571.6",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.9 663.2 95.2 658.5 95.2 663.2 87.9 663.2",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80 663.2 95.2 653.4 95.2 658.5 87.9 663.2 80 663.2",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72 663.2 95.2 648.3 95.2 653.4 80 663.2 72 663.2",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64 663.2 95.2 643.2 95.2 648.3 72 663.2 64 663.2",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.1 663.2 95.2 638 95.2 643.2 64 663.2 56.1 663.2",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 662.5 95.2 632.9 95.2 638 56.1 663.2 49.3 663.2 49.3 662.5",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 657.3 95.2 627.8 95.2 632.9 49.3 662.5 49.3 657.3",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 652.2 95.2 622.7 95.2 627.8 49.3 657.3 49.3 652.2",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 647.1 95.2 617.5 95.2 622.7 49.3 652.2 49.3 647.1",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 642 95.2 612.4 95.2 617.5 49.3 647.1 49.3 642",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 636.8 95.2 607.3 95.2 612.4 49.3 642 49.3 636.8",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 631.7 92.5 603.9 95 603.9 95.2 604.1 95.2 607.3 49.3 636.8 49.3 631.7",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 626.6 84.5 603.9 92.5 603.9 49.3 631.7 49.3 626.6",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 621.5 76.6 603.9 84.5 603.9 49.3 626.6 49.3 621.5",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 616.3 68.6 603.9 76.6 603.9 49.3 621.5 49.3 616.3",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 611.2 60.7 603.9 68.6 603.9 49.3 616.3 49.3 611.2",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.3 606.1 52.7 603.9 60.7 603.9 49.3 611.2 49.3 606.1",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.7 603.9 49.3 606.1 49.3 603.9 52.7 603.9",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.6 523.8 84.1 522.2 84.1 523.8 81.6 523.8",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.6 523.8 84.1 517.1 84.1 522.2 81.6 523.8 73.6 523.8",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.7 523.8 84.1 511.9 84.1 517.1 73.6 523.8 65.7 523.8",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.4 523.8 58.9 523 84.1 506.8 84.1 511.9 65.7 523.8 59.4 523.8",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.9 523 56.6 519.4 82 503 84.1 506.2 84.1 506.8 58.9 523",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.6 519.4 55.3 517.4 55.3 515.1 79.7 499.4 82 503 56.6 519.4",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 509.9 77.4 495.8 79.7 499.4 55.3 515.1 55.3 509.9",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 504.8 75 492.1 77.4 495.8 55.3 509.9 55.3 504.8",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 499.7 69.3 490.7 74.1 490.7 75 492.1 55.3 504.8 55.3 499.7",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.3 494.6 61.4 490.7 69.3 490.7 55.3 499.7 55.3 494.6",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.4 490.7 55.3 494.6 55.3 490.7 61.4 490.7",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.9 497.4 59.5 497 59.5 497.4 58.9 497.4",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51 497.4 59.5 491.9 59.5 497 58.9 497.4 51 497.4",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.8 497.4 43.5 497 59.5 486.7 59.5 491.9 51 497.4 43.8 497.4",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.5 497 41.2 493.4 59.5 481.6 59.5 486.7 43.5 497",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 493.4 38.9 489.8 59.5 476.5 59.5 481.6 41.2 493.4",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.9 489.8 37.1 487 37.1 485.8 59.5 471.4 59.5 476.5 38.9 489.8",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 480.7 59.5 466.2 59.5 471.4 37.1 485.8 37.1 480.7",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 475.6 59.5 461.1 59.5 466.2 37.1 480.7 37.1 475.6",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 470.4 59.5 456 59.5 461.1 37.1 475.6 37.1 470.4",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 465.3 53.4 454.8 59.2 454.8 59.5 455.4 59.5 456 37.1 470.4 37.1 465.3",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 460.2 45.4 454.8 53.4 454.8 37.1 465.3 37.1 460.2",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.1 455.1 37.5 454.8 45.4 454.8 37.1 460.2 37.1 455.1",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.5 454.8 37.1 455.1 37.1 454.8 37.5 454.8",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.9 497.4 71.3 494.6 71.3 497.4 66.9 497.4",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.9 497.4 71.3 489.4 71.3 494.6 66.9 497.4 58.9 497.4",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58 497.4 57.9 497.2 57.9 492.9 71.3 484.3 71.3 489.4 58.9 497.4 58 497.4",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 487.8 71.3 479.2 71.3 484.3 57.9 492.9 57.9 487.8",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 482.7 71.3 474.1 71.3 479.2 57.9 487.8 57.9 482.7",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 477.6 69.2 470.3 71.3 473.4 71.3 474.1 57.9 482.7 57.9 477.6",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 472.5 66.9 466.6 69.2 470.3 57.9 477.6 57.9 472.5",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 467.3 64.6 463 66.9 466.6 57.9 472.5 57.9 467.3",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 462.2 62.2 459.4 64.6 463 57.9 467.3 57.9 462.2",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9 457.1 59.1 456.3 60.2 456.3 62.2 459.4 57.9 462.2 57.9 457.1",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.1 456.3 57.9 457.1 57.9 456.3 59.1 456.3",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.7 620.4 92.4 619.3 92.4 620.4 90.7 620.4",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.7 620.4 92.4 614.2 92.4 619.3 90.7 620.4 82.7 620.4",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.7 620.4 92.4 609 92.4 614.2 82.7 620.4 74.7 620.4",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.8 620.4 92.4 603.9 92.4 609 74.7 620.4 66.8 620.4",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.8 620.4 92.4 598.8 92.4 603.9 66.8 620.4 58.8 620.4",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58 620.4 55.9 617.2 91.3 594.4 92.4 596.3 92.4 598.8 58.8 620.4 58 620.4",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.9 617.2 55.8 617 55.8 612.2 88.9 590.8 91.3 594.4 55.9 617.2",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 607 86.6 587.2 88.9 590.8 55.8 612.2 55.8 607",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 601.9 84.3 583.6 86.6 587.2 55.8 607 55.8 601.9",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 596.8 81.9 579.9 84.3 583.6 55.8 601.9 55.8 596.8",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 591.7 79.6 576.3 81.9 579.9 55.8 596.8 55.8 591.7",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 586.5 77.3 572.7 79.6 576.3 55.8 591.7 55.8 586.5",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 581.4 73 570.3 75.7 570.3 77.3 572.7 55.8 586.5 55.8 581.4",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 576.3 65 570.3 73 570.3 55.8 581.4 55.8 576.3",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 571.2 57.1 570.3 65 570.3 55.8 576.3 55.8 571.2",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.1 570.3 55.8 571.2 55.8 570.3 57.1 570.3",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.9 652.7 163.7 650.3 163.7 652.7 159.9 652.7",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152 652.7 163.7 645.1 163.7 650.3 159.9 652.7 152 652.7",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144 652.7 163.7 640 163.7 645.1 152 652.7 144 652.7",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136 652.7 163.7 634.9 163.7 640 144 652.7 136 652.7",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.1 652.7 163.7 629.8 163.7 634.9 136 652.7 128.1 652.7",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.1 652.7 162.4 625.5 163.7 627.4 163.7 629.8 128.1 652.7 120.1 652.7",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.2 652.7 160.1 621.8 162.4 625.5 120.1 652.7 112.2 652.7",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.2 652.7 157.8 618.2 160.1 621.8 112.2 652.7 104.2 652.7",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.4 652.7 97.7 651.7 155.4 614.6 157.8 618.2 104.2 652.7 98.4 652.7",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 629.2,
    width: 68.6,
    height: 4.3,
    transform: "translate(-321.8 168.4) rotate(-32.8)",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.4 648.1 93.5 645.2 93.5 644.2 150.8 607.3 153.1 611 95.4 648.1",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 639.1 148.5 603.7 150.8 607.3 93.5 644.2 93.5 639.1",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 634 140.6 603.7 148.4 603.7 148.5 603.7 93.5 639.1 93.5 634",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 628.9 132.6 603.7 140.6 603.7 93.5 634 93.5 628.9",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 623.7 124.7 603.7 132.6 603.7 93.5 628.9 93.5 623.7",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 618.6 116.7 603.7 124.7 603.7 93.5 623.7 93.5 618.6",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 613.5 108.8 603.7 116.7 603.7 93.5 618.6 93.5 613.5",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.5 608.4 100.8 603.7 108.8 603.7 93.5 613.5 93.5 608.4",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.8 603.7 93.5 608.4 93.5 603.7 100.8 603.7",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.6 688.1 176.5 683 176.5 688.1 168.6 688.1",
    fill: "#636363",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.6 688.1 176.5 677.9 176.5 683 168.6 688.1 160.6 688.1",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.6 688.1 176.5 672.8 176.5 677.9 160.6 688.1 152.6 688.1",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.7 688.1 176.5 667.7 176.5 672.8 152.6 688.1 144.7 688.1",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.7 688.1 176.5 662.5 176.5 667.7 144.7 688.1 136.7 688.1",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.8 688.1 176.5 657.4 176.5 662.5 136.7 688.1 128.8 688.1",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.8 688.1 176.5 652.3 176.5 657.4 128.8 688.1 120.8 688.1",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.8 688.1 176.5 647.2 176.5 652.3 120.8 688.1 112.8 688.1",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 683.9 174.4 643.4 176.5 646.6 176.5 647.2 112.8 688.1 111.5 688.1 111.5 683.9",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 678.7 172.1 639.7 174.4 643.4 111.5 683.9 111.5 678.7",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 673.6 169.8 636.1 172.1 639.7 111.5 678.7 111.5 673.6",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 668.5 167.4 632.5 169.8 636.1 111.5 673.6 111.5 668.5",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 663.4 160.6 631.7 166.9 631.7 167.4 632.5 111.5 668.5 111.5 663.4",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 658.2 152.7 631.7 160.6 631.7 111.5 663.4 111.5 658.2",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 653.1 144.7 631.7 152.7 631.7 111.5 658.2 111.5 653.1",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 648 136.8 631.7 144.7 631.7 111.5 653.1 111.5 648",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 642.9 128.8 631.7 136.8 631.7 111.5 648 111.5 642.9",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 637.7 120.8 631.7 128.8 631.7 111.5 642.9 111.5 637.7",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 632.6 112.9 631.7 120.8 631.7 111.5 637.7 111.5 632.6",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.9 631.7 111.5 632.6 111.5 631.7 112.9 631.7",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.6 661.9 43.2 661.3 47.8 658.3 47.8 661.9 43.6 661.9",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.2 661.3 40.8 657.6 47.8 653.2 47.8 658.3 43.2 661.3",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.8 657.6 38.5 654 47.8 648 47.8 653.2 40.8 657.6",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.5 654 36.2 650.4 47.8 642.9 47.8 648 38.5 654",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.2 650.4 33.8 646.8 47.8 637.8 47.8 642.9 36.2 650.4",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.8 646.8 31.5 643.1 47.8 632.7 47.8 637.8 33.8 646.8",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.5 643.1 29.2 639.5 47.8 627.5 47.8 632.7 31.5 643.1",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.2 639.5 26.8 635.9 47.8 622.4 47.8 627.5 29.2 639.5",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.8 635.9 24.5 632.3 47.8 617.3 47.8 622.4 26.8 635.9",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.5 632.3 22.2 628.7 47.8 612.2 47.8 617.3 24.5 632.3",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.2 628.7 19.8 625 47.8 607 47.8 612.2 22.2 628.7",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.8 625 18.4 622.9 18.4 620.8 47.8 601.9 47.8 607 19.8 625",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 615.7 47.8 596.8 47.8 601.9 18.4 620.8 18.4 615.7",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 610.6 47.8 591.7 47.8 596.8 18.4 615.7 18.4 610.6",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 605.4 47.1 587 47.8 588.1 47.8 591.7 18.4 610.6 18.4 605.4",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 600.3 44.8 583.4 47.1 587 18.4 605.4 18.4 600.3",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 595.2 42.4 579.7 44.8 583.4 18.4 600.3 18.4 595.2",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 590.1 40.1 576.1 42.4 579.7 18.4 595.2 18.4 590.1",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 584.9 37.8 572.5 40.1 576.1 18.4 590.1 18.4 584.9",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 579.8 30.2 572.2 37.6 572.2 37.8 572.5 18.4 584.9 18.4 579.8",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.4 574.7 22.3 572.2 30.2 572.2 18.4 579.8 18.4 574.7",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.3 572.2 18.4 574.7 18.4 572.2 22.3 572.2",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.4 569.5 53.9 567.3 53.9 569.5 50.4 569.5",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.4 569.5 53.9 562.1 53.9 567.3 50.4 569.5 42.4 569.5",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.5 569.5 53.9 557 53.9 562.1 42.4 569.5 34.5 569.5",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33 569.5 31.1 566.5 53.9 551.9 53.9 557 34.5 569.5 33 569.5",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.1 566.5 28.8 562.9 53.9 546.8 53.9 551.9 31.1 566.5",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.8 562.9 26.5 559.3 53.9 541.6 53.9 546.8 28.8 562.9",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.5 559.3 24.1 555.7 53.9 536.5 53.9 541.6 26.5 559.3",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.1 555.7 23.1 554 23.1 551.2 53.9 531.4 53.9 536.5 24.1 555.7",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1 546.1 53.9 526.3 53.9 531.4 23.1 551.2 23.1 546.1",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1 541 53.9 521.1 53.9 526.3 23.1 546.1 23.1 541",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1 535.8 53.9 516 53.9 521.1 23.1 541 23.1 535.8",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1 530.7 46.2 515.8 53.9 515.8 53.9 516 23.1 535.8 23.1 530.7",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1 525.6 38.2 515.8 46.2 515.8 23.1 530.7 23.1 525.6",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1 520.5 30.3 515.8 38.2 515.8 23.1 525.6 23.1 520.5",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.3 515.8 23.1 520.5 23.1 515.8 30.3 515.8",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.6 516.9 35.8 512.2 35.8 516.9 28.6 516.9",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.9 516.9 23.6 515 35.8 507.1 35.8 512.2 28.6 516.9 24.9 516.9",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.6 515 21.3 511.4 35.8 502 35.8 507.1 23.6 515",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.3 511.4 19 507.7 35.8 496.9 35.8 502 21.3 511.4",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19 507.7 16.6 504.1 35.8 491.7 35.8 496.9 19 507.7",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.6 504.1 14.9 501.4 14.9 500.1 35.8 486.6 35.8 491.7 16.6 504.1",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.9 495 32 484 35.8 484 35.8 486.6 14.9 500.1 14.9 495",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.9 489.9 24.1 484 32 484 14.9 495 14.9 489.9",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.9 484.7 16.1 484 24.1 484 14.9 489.9 14.9 484.7",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.1 484 14.9 484.7 14.9 484 16.1 484",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.6 482.9 56.8 478.3 56.8 482.9 49.6 482.9",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.6 482.9 56.8 473.1 56.8 478.3 49.6 482.9 41.6 482.9",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.3 482.9 34.1 482.6 56.8 468 56.8 473.1 41.6 482.9 34.3 482.9",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.1 482.6 31.8 479 56.8 462.9 56.8 468 34.1 482.6",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.8 479 29.4 475.4 56.8 457.8 56.8 462.9 31.8 479",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.4 475.4 27.1 471.7 56.8 452.6 56.8 457.8 29.4 475.4",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.1 471.7 26.6 471 26.6 466.9 55.5 448.3 56.8 450.3 56.8 452.6 27.1 471.7",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.6 461.8 53.2 444.7 55.5 448.3 26.6 466.9 26.6 461.8",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.6 456.7 50.9 441.1 53.2 444.7 26.6 461.8 26.6 456.7",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.6 451.6 48.5 437.5 50.9 441.1 26.6 456.7 26.6 451.6",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.1 429 48.5 437.5 26.6 451.6 26.6 429 43.1 429",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.7 726.5 221.6 689.9 241.3 720.5 241.3 726.5 164.7 726.5",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.7 726.5 219.2 686.3 221.6 689.9 164.7 726.5 156.7 726.5",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.8 726.5 216.9 682.6 219.2 686.3 156.7 726.5 148.8 726.5",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.8 726.5 214.6 679 216.9 682.6 148.8 726.5 140.8 726.5",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.9 726.5 212.2 675.4 214.6 679 140.8 726.5 132.9 726.5",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.9 726.5 209.9 671.8 212.2 675.4 132.9 726.5 124.9 726.5",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.9 726.5 207.6 668.1 209.9 671.8 124.9 726.5 116.9 726.5",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109 726.5 205.2 664.5 207.6 668.1 116.9 726.5 109 726.5",
    fill: "#636363",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101 726.5 202.9 660.9 205.2 664.5 109 726.5 101 726.5",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.1 726.5 200.6 657.3 202.9 660.9 101 726.5 93.1 726.5",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.1 726.5 198.2 653.7 200.6 657.3 93.1 726.5 85.1 726.5",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.1 726.5 195.9 650 198.2 653.7 85.1 726.5 77.1 726.5",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.2 726.5 193.6 646.4 195.9 650 77.1 726.5 69.2 726.5",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.2 726.5 191.2 642.8 193.6 646.4 69.2 726.5 61.2 726.5",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.3 726.5 188.9 639.2 191.2 642.8 61.2 726.5 53.3 726.5",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 726.5 186.6 635.5 188.9 639.2 53.3 726.5 45.3 726.5",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.3 726.5 184.2 631.9 186.6 635.5 45.3 726.5 37.3 726.5",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.4 726.5 181.9 628.3 184.2 631.9 37.3 726.5 29.4 726.5",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.4 726.5 179.6 624.7 181.9 628.3 29.4 726.5 21.4 726.5",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.5 726.5 177.2 621.1 179.6 624.7 21.4 726.5 13.5 726.5",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.5 726.5 174.9 617.4 177.2 621.1 13.5 726.5 5.5 726.5",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-2.4 726.5 172.6 613.8 174.9 617.4 5.5 726.5 -2.4 726.5",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-5 726.5 -6.6 724.1 170.2 610.2 172.6 613.8 -2.4 726.5 -5 726.5",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24.5,
    y: 663.2,
    width: 210.4,
    height: 4.3,
    transform: "translate(-347.3 149.6) rotate(-32.8)",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: -26.9,
    y: 659.5,
    width: 210.4,
    height: 4.3,
    transform: "translate(-345.7 147.7) rotate(-32.8)",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-11.3 716.8 -12.4 715.1 -12.4 712.4 163.3 599.3 165.6 602.9 -11.3 716.8",
    fill: "#757575",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 707.3 160.9 595.7 163.3 599.3 -12.4 712.4 -12.4 707.3",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 702.1 158.6 592.1 160.9 595.7 -12.4 707.3 -12.4 702.1",
    fill: "#777",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 697 156.3 588.4 158.6 592.1 -12.4 702.1 -12.4 697",
    fill: "#787878",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 691.9 153.9 584.8 156.3 588.4 -12.4 697 -12.4 691.9",
    fill: "#797979",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 686.8 151.6 581.2 153.9 584.8 -12.4 691.9 -12.4 686.8",
    fill: "#7a7a7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 681.6 149.3 577.6 151.6 581.2 -12.4 686.8 -12.4 681.6",
    fill: "#7b7b7b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 676.5 146.9 574 149.3 577.6 -12.4 681.6 -12.4 676.5",
    fill: "#7c7c7c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 671.4 144.6 570.3 146.9 574 -12.4 676.5 -12.4 671.4",
    fill: "#7d7d7d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 666.3 142.3 566.7 144.6 570.3 -12.4 671.4 -12.4 666.3",
    fill: "#7e7e7e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 661.1 139.9 563.1 142.3 566.7 -12.4 666.3 -12.4 661.1",
    fill: "#7f7f7f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 656 137.6 559.5 139.9 563.1 -12.4 661.1 -12.4 656",
    fill: "#818181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 650.9 135.3 555.8 137.6 559.5 -12.4 656 -12.4 650.9",
    fill: "#828282",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 645.8 132.9 552.2 135.3 555.8 -12.4 650.9 -12.4 645.8",
    fill: "#838383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 640.6 130.6 548.6 132.9 552.2 -12.4 645.8 -12.4 640.6",
    fill: "#848484",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 635.5 128.3 545 130.6 548.6 -12.4 640.6 -12.4 635.5",
    fill: "#858585",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 630.4 125.9 541.4 128.3 545 -12.4 635.5 -12.4 630.4",
    fill: "#868686",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 625.3 123.6 537.7 125.9 541.4 -12.4 630.4 -12.4 625.3",
    fill: "#878787",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 620.2 121.3 534.1 123.6 537.7 -12.4 625.3 -12.4 620.2",
    fill: "#888",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 615 118.9 530.5 121.3 534.1 -12.4 620.2 -12.4 615",
    fill: "#898989",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 609.9 116.6 526.9 118.9 530.5 -12.4 615 -12.4 609.9",
    fill: "#8a8a8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 604.8 114.3 523.2 116.6 526.9 -12.4 609.9 -12.4 604.8",
    fill: "#8b8b8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 599.7 111.9 519.6 114.3 523.2 -12.4 604.8 -12.4 599.7",
    fill: "#8c8c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 594.5 109.6 516 111.9 519.6 -12.4 599.7 -12.4 594.5",
    fill: "#8d8d8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 589.4 107.3 512.4 109.6 516 -12.4 594.5 -12.4 589.4",
    fill: "#8e8e8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 584.3 104.9 508.8 107.3 512.4 -12.4 589.4 -12.4 584.3",
    fill: "#8f8f8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 579.2 102.6 505.1 104.9 508.8 -12.4 584.3 -12.4 579.2",
    fill: "#909090",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 574 100.3 501.5 102.6 505.1 -12.4 579.2 -12.4 574",
    fill: "#919191",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 568.9 97.9 497.9 100.3 501.5 -12.4 574 -12.4 568.9",
    fill: "#929292",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 563.8 95.6 494.3 97.9 497.9 -12.4 568.9 -12.4 563.8",
    fill: "#939393",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 558.7 93.3 490.6 95.6 494.3 -12.4 563.8 -12.4 558.7",
    fill: "#949494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 553.5 90.9 487 93.3 490.6 -12.4 558.7 -12.4 553.5",
    fill: "#959595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 548.4 88.6 483.4 90.9 487 -12.4 553.5 -12.4 548.4",
    fill: "#969696",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 543.3 86.3 479.8 88.6 483.4 -12.4 548.4 -12.4 543.3",
    fill: "#979797",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 538.2 84 476.1 86.3 479.8 -12.4 543.3 -12.4 538.2",
    fill: "#989898",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 533 81.6 472.5 84 476.1 -12.4 538.2 -12.4 533",
    fill: "#999",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 527.9 79.3 468.9 81.6 472.5 -12.4 533 -12.4 527.9",
    fill: "#9a9a9a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 522.8 77 465.3 79.3 468.9 -12.4 527.9 -12.4 522.8",
    fill: "#9b9b9b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 517.7 74.6 461.7 77 465.3 -12.4 522.8 -12.4 517.7",
    fill: "#9c9c9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 512.5 72.3 458 74.6 461.7 -12.4 517.7 -12.4 512.5",
    fill: "#9d9d9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 507.4 70 454.4 72.3 458 -12.4 512.5 -12.4 507.4",
    fill: "#9e9e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 502.3 67.6 450.8 70 454.4 -12.4 507.4 -12.4 502.3",
    fill: "#9f9f9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 497.2 65.3 447.2 67.6 450.8 -12.4 502.3 -12.4 497.2",
    fill: "#a0a0a0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 492 63 443.5 65.3 447.2 -12.4 497.2 -12.4 492",
    fill: "#a1a1a1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 486.9 60.6 439.9 63 443.5 -12.4 492 -12.4 486.9",
    fill: "#a2a2a2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 481.8 58.3 436.3 60.6 439.9 -12.4 486.9 -12.4 481.8",
    fill: "#a3a3a3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-12.4 476.7 56 432.7 58.3 436.3 -12.4 481.8 -12.4 476.7",
    fill: "#a4a4a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28 389.2 56 432.7 -12.4 476.7 -12.4 389.2 28 389.2",
    fill: "#a4a4a4",
    strokeWidth: 0
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.9,330.4c-.3,0-.5-.2-.6-.5,0,0-.5-2.3-1.3-6.5,0-.3.1-.6.5-.7.3,0,.6.1.7.5.8,4.2,1.3,6.5,1.3,6.5,0,.3-.1.6-.5.7,0,0,0,0-.1,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.4,310.7c-.3,0-.5-.2-.6-.5-.4-2.6-.8-5.3-1.1-7.9,0-.2,0-.3.1-.4.1-.1.2-.2.4-.2.3,0,.6.2.7.5.4,2.6.7,5.3,1.1,7.9,0,0,0,0,0,0,0,.3-.2.5-.5.6,0,0,0,0,0,0ZM367.3,294.9c-.3,0-.6-.2-.6-.5h0,0c-.3-2.6-.6-5.3-.9-8,0-.3.2-.6.5-.7.3,0,.6.2.7.5.3,2.7.5,5.4.9,7.9h0c0,.4-.2.6-.5.7h0ZM365.7,278.9c-.3,0-.6-.2-.6-.5-.2-2.5-.4-5.2-.6-8,0-.3.2-.6.6-.6.4,0,.6.2.6.6.2,2.7.4,5.4.6,8h0c0,.4-.2.6-.5.6h0ZM364.6,263c-.3,0-.6-.2-.6-.6h0c-.1-2.7-.2-5.4-.3-8,0-.2,0-.3.2-.4.1-.1.2-.2.4-.2h0c.3,0,.6.3.6.6,0,2.7.2,5.3.3,8h0c0,.4-.2.6-.6.6h0ZM364.2,247h0c-.3,0-.6-.3-.6-.6,0-1.9,0-3.5,0-5.1s0-1.8,0-3c0-.3.3-.6.6-.6s.6.3.6.6c0,1.1,0,2.1,0,3,0,1.7,0,3.4,0,5,0,.3-.3.6-.6.6ZM364.3,231h0c-.3,0-.6-.3-.6-.6h0c0-2.7.2-5.4.3-8,0-.3.3-.6.6-.6s.6.3.6.6c-.1,2.6-.2,5.3-.3,8,0,.3-.3.6-.6.6ZM365.1,215h0c-.3,0-.6-.3-.5-.6h0c.2-2.7.4-5.4.7-8,0-.3.3-.6.7-.5.2,0,.3.1.4.2.1.1.1.3.1.4-.2,2.6-.5,5.2-.7,8,0,.3-.3.5-.6.5ZM366.6,199.1s0,0,0,0c-.3,0-.5-.3-.5-.6s0,0,0,0h0,0c.3-2.7.7-5.3,1.1-8,0-.3.3-.5.7-.5.3,0,.6.4.5.7-.4,2.6-.7,5.3-1.1,7.9,0,.3-.3.5-.6.5ZM368.9,183.3s0,0-.1,0c-.3,0-.5-.3-.5-.6,0,0,0,0,0,0h0s0,0,0,0c.5-2.6,1-5.2,1.5-7.9,0-.3.4-.5.7-.5.3,0,.5.4.5.7-.5,2.6-1,5.2-1.5,7.8,0,.3-.3.5-.6.5ZM372.2,167.6s0,0-.1,0c-.3,0-.5-.3-.5-.6s0-.1,0-.1c.6-2.6,1.3-5.2,2-7.8,0-.3.4-.5.7-.4.2,0,.3.1.4.3,0,.1.1.3,0,.4-.7,2.5-1.4,5.1-2,7.7,0,.3-.3.5-.6.5ZM376.4,152.2c0,0-.1,0-.2,0-.2,0-.4-.3-.4-.6s0-.1,0-.2h0s0,0,0,0c.8-2.6,1.7-5.1,2.6-7.6.1-.3.5-.5.8-.4.1,0,.3.2.3.3,0,.1,0,.3,0,.5-.9,2.5-1.8,5-2.6,7.6,0,.2-.3.4-.6.4ZM381.9,137.1c0,0-.2,0-.2,0-.2,0-.4-.3-.4-.5s0-.2,0-.2c.6-1.5,1.2-2.9,1.8-4.3.1-.3.5-.4.8-.3.1,0,.3.2.3.3,0,.1,0,.3,0,.5-.6,1.4-1.2,2.9-1.8,4.2-.1.2-.3.4-.6.4Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,126.7c0,0-.2,0-.3,0-.3-.1-.4-.5-.3-.8l3-6c.1-.3.5-.4.8-.3.3.1.4.5.3.8l-3,6c-.1.2-.3.3-.5.3Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.2,321.4h0c-.3,0-.6-.3-.6-.6s0-2.4.2-6.7c0-.3.3-.6.6-.6.3,0,.6.3.6.6-.2,4.3-.2,6.6-.2,6.6,0,.3-.3.6-.6.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.5,300.1h0c-.3,0-.5-.3-.5-.6h0c.3-2.9.6-5.9.9-8.8,0-.3.3-.6.7-.5s.6.3.5.7c-.3,2.9-.6,5.8-.9,8.7,0,.3-.3.5-.6.5ZM421.5,282.6h0c-.3,0-.5-.3-.5-.6,0,0,0,0,0,0,.4-2.9.8-5.8,1.3-8.7,0-.3.4-.6.7-.5.3,0,.6.4.5.7-.4,2.8-.9,5.7-1.3,8.7,0,.3-.3.5-.6.5ZM424.2,265.2s0,0-.1,0c-.3,0-.5-.3-.5-.6s0,0,0-.1c.5-2.9,1.1-5.8,1.7-8.7,0-.3.4-.5.7-.5.2,0,.3.1.4.2,0,.1.1.3,0,.5-.6,2.8-1.2,5.7-1.7,8.6h0c0,.3-.3.6-.6.6ZM427.9,248c0,0,0,0-.1,0-.3,0-.5-.3-.5-.6s0,0,0-.1c.7-2.8,1.4-5.7,2.2-8.5,0-.3.4-.5.7-.4.3,0,.5.4.4.7-.8,2.8-1.5,5.6-2.2,8.5,0,.3-.3.5-.6.5ZM432.5,231c0,0-.1,0-.2,0-.2,0-.4-.3-.4-.6s0-.1,0-.2c.9-2.9,1.8-5.7,2.7-8.4.1-.3.5-.5.8-.4s.5.5.4.8c-.9,2.7-1.9,5.5-2.7,8.3,0,.2-.3.4-.6.4ZM438.3,214.4c0,0-.1,0-.2,0-.2,0-.4-.3-.4-.6,0,0,0-.1,0-.2,1.1-2.8,2.2-5.5,3.4-8.1.1-.3.5-.4.8-.3.3.1.4.5.3.8-1.1,2.6-2.3,5.3-3.4,8.1,0,.2-.3.4-.5.4ZM445.4,198.3c0,0-.2,0-.3,0-.2-.1-.3-.3-.3-.6s0-.2,0-.3c.7-1.3,1.3-2.5,1.9-3.7.1-.3.5-.4.8-.2.1,0,.2.2.3.4,0,.1,0,.3,0,.5-.6,1.2-1.3,2.4-1.9,3.6-.1.2-.3.3-.5.3Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8,188.3c-.1,0-.2,0-.3,0-.3-.2-.4-.5-.2-.8,1.2-2,2.4-3.9,3.5-5.7.2-.3.5-.4.8-.2.3.2.4.5.2.8-1.1,1.8-2.3,3.7-3.5,5.6-.1.2-.3.3-.5.3Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.8,501.2c-.5,0-1-.2-1.3-.5,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4,0-.5.2-1,.6-1.3.7-.7,2-.7,2.7,0,.4.3.6.8.6,1.3s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.1.2-.2.3-.3.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.6,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM820.2,499.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM795.8,499.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM771.4,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM747,499.3c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM722.6,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM698.2,499.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM673.8,499.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM649.4,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM625,499.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM600.6,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM576.2,499.3c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM551.8,499.3c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM527.4,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM503,499.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM478.6,499.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887,501.2c-.5,0-1-.2-1.3-.5-.4-.4-.6-.8-.6-1.3s.2-1,.6-1.3c0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5.4.3.6.8.6,1.3s-.2,1-.6,1.3c-.3.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.4,73.3c-.5,0-1-.2-1.4-.6-.3-.4-.6-.8-.6-1.3s.2-1,.6-1.3c.4-.5,1.1-.7,1.7-.5.1,0,.2,0,.4.1.1,0,.2.1.3.2,0,0,.2.1.3.2,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM818.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM792.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM766.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM740.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM714.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM688.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM662.8,71.4c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM636.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM610.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM584.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM558.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM532.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM506.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM480.8,71.4c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.3,73.3c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2,0,0-.2-.2-.3-.2-.4-.4-.6-.8-.6-1.3s.2-1,.6-1.3c0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5.4.3.6.8.6,1.3s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.2.2-.2.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.8,98.4c-.5,0-1-.2-1.4-.6,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4,0-.5.2-1,.5-1.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5s.6.8.6,1.3-.2,1-.6,1.3c-.3.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM804.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM779.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM754.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM729.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM704.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM679.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM654.5,96.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM629.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM604.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM579.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM554.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM529.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM504.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM479.5,96.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.5,98.4c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2,0,0-.2-.1-.3-.2-.3-.4-.5-.8-.5-1.3s.2-1,.5-1.3c0,0,.2-.2.3-.2,0,0,.2-.1.3-.2.1,0,.2,0,.4-.1.2,0,.5,0,.7,0,.1,0,.2,0,.4.1.1,0,.2,0,.3.2.1,0,.2.1.3.2,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.1.2-.2.3,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.4,123.5c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2-.4-.4-.5-.9-.5-1.4s.2-1,.5-1.3c.5-.4,1.1-.6,1.7-.5.1,0,.2,0,.4.1.1,0,.2.1.3.2.1,0,.2.1.3.2.4.4.6.8.6,1.3s-.2,1-.6,1.4c-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.4,121.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM817.4,121.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM793.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM769.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM745.4,121.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM721.4,121.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM697.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM673.4,121.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM649.4,121.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM625.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM601.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM577.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM553.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM529.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM505.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM481.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM457.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM433.4,121.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875,123.5c-.5,0-1-.2-1.3-.6-.4-.4-.6-.9-.6-1.4s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1,0-.2.2-.3,0-.1.1-.2.2-.3.4-.4,1.1-.6,1.7-.5.1,0,.2,0,.4.1.1,0,.2.1.3.2,0,0,.2.1.3.2,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2,0,.4,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.4,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.9,148.8c-.5,0-1-.2-1.3-.6s-.2-.2-.2-.3c0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4,0-.5.2-1,.6-1.3s1.1-.6,1.7-.5c.1,0,.2,0,.4.1.1,0,.2.1.3.2.1,0,.2.2.3.2.3.4.6.8.6,1.3s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.1.2-.2.3,0,0-.2.2-.3.2s-.2.1-.3.2c-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM877.6,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM852.2,146.9c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM826.8,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM801.4,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM776,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM750.6,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM725.2,146.9c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM699.8,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM674.4,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM649,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM623.6,146.9c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM598.2,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM572.8,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM547.4,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM522,146.9c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM496.6,146.9c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM471.2,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM445.8,146.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM420.4,146.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.4,148.8c-.5,0-1-.2-1.3-.6-.4-.4-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1.1-.2.2-.3,0-.1.2-.2.2-.3.4-.4,1.1-.6,1.7-.5.1,0,.2,0,.4.1.1,0,.2.1.3.2,0,0,.2.2.3.2,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.2.2-.2.3,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.4,173.9c-.5,0-1-.2-1.3-.6-.4-.3-.6-.8-.6-1.3s.2-1,.6-1.3c0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5.3.4.5.8.5,1.3s-.2,1-.5,1.3-.2.2-.3.2-.2.1-.3.2c-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.5,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM878.1,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM852.7,172c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM827.3,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM801.9,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM776.5,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM751.1,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM725.7,172c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM700.3,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM674.9,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM649.5,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM624.1,172c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM598.7,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM573.3,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM547.9,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM522.5,172c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM497.1,172c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM471.7,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM446.3,172c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM420.9,172c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.7,173.9c-.5,0-1-.2-1.3-.6,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1.1-.2.2-.3,0-.1.2-.2.2-.3.7-.7,2-.7,2.7,0,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.2.2-.2.3-.3.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.7,199.1c-.5,0-1-.2-1.3-.5-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.3c.7-.7,2-.7,2.7,0s.5.8.5,1.3-.2,1-.6,1.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.8,197.2c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM839.7,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM815.6,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM791.5,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM767.4,197.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM743.3,197.2c0-1.1.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM719.2,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM695.1,197.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM671,197.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM646.9,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM622.8,197.2c0-1.1.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM598.7,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM574.6,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM550.5,197.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM526.4,197.2c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM502.3,197.2c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM478.2,197.2c0-1.1.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM454.1,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM430,197.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM405.9,197.2c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888,199.1c-.5,0-1-.2-1.3-.5s-.6-.9-.6-1.4.2-1,.6-1.3c.7-.7,2-.7,2.7,0,.4.4.6.8.6,1.3s-.2,1-.6,1.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.2,224.4c-.5,0-1-.2-1.3-.6-.4-.4-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1.1-.2.2-.3,0-.1.2-.2.2-.3.7-.7,2-.7,2.7,0,.4.4.6.8.6,1.3s-.2,1-.6,1.3c-.3.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.3,222.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM840.2,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM816.1,222.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM792,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM767.9,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM743.8,222.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM719.7,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM695.6,222.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM671.5,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM647.4,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM623.3,222.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM599.2,222.5c0-1.1.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM575.1,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM551,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM526.9,222.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM502.8,222.5c0-1.1.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM478.7,222.5c0-1.1.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM454.6,222.5c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM430.5,222.5c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM406.4,222.5c0-1.1.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.1,224.4c-.5,0-1-.2-1.3-.6-.4-.4-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1,0-.2.2-.3,0-.1.2-.2.2-.3.7-.7,2-.7,2.7,0,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.3-.3.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.7,249.5c-.5,0-1-.2-1.3-.6s-.2-.2-.2-.3c0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1.1-.2.2-.3,0-.1.2-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.1.2-.2.3-.3.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.9,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM842.7,247.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM818.5,247.6c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM794.3,247.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM770.1,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM745.9,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM721.7,247.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM697.5,247.6c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM673.3,247.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM649.1,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM624.9,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM600.7,247.6c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM576.5,247.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM552.3,247.6c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM528.1,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM503.9,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM479.7,247.6c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM455.5,247.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM431.3,247.6c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM407.1,247.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.3,249.5c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.3c.4-.4,1.1-.6,1.7-.5.1,0,.2,0,.4.1.1,0,.2.1.3.2.1,0,.2.1.3.2.4.4.5.8.5,1.3s-.2,1-.5,1.4c-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.2,274.6c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.3c.7-.7,2-.7,2.7,0,.4.4.6.8.6,1.3s-.2,1-.6,1.4c-.3.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.1,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM875.5,272.7c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM850.9,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM826.3,272.7c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM801.7,272.7c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM777.1,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM752.5,272.7c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM727.9,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM703.3,272.7c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM678.7,272.7c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM654.1,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM629.5,272.7c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM604.9,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM580.3,272.7c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM555.7,272.7c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM531.1,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM506.5,272.7c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM481.9,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM457.3,272.7c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM432.7,272.7c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM408.1,272.7c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941,274.6c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2,0,0-.2-.1-.3-.2,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4,0-.5.2-1,.5-1.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5.3.4.6.8.6,1.3s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.2.2-.2.3-.3.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.6,299.9c-.5,0-1-.2-1.3-.6,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4,0-.5.2-1,.6-1.3.7-.7,2-.7,2.7,0,.4.4.5.8.5,1.3s-.2,1-.6,1.3c-.3.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.4,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM872,298c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM847.6,298c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM823.2,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM798.8,298c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM774.4,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM750,298c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM725.6,298c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM701.2,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM676.8,298c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM652.4,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM628,298c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM603.6,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM579.2,298c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM554.8,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM530.4,298c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM506,298c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.8,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM481.6,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM457.2,298c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM432.8,298c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM408.4,298c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1.1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938,299.9c-.1,0-.2,0-.4,0-.1,0-.2,0-.4,0-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4,0-.5.2-1,.6-1.3.4-.5,1.1-.6,1.7-.5.1,0,.2,0,.3.1.1,0,.2.1.3.2.1,0,.2.2.3.2.4.4.6.8.6,1.3s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.1.2-.2.3,0,0-.2.2-.3.2,0,0-.2.1-.3.2-.1,0-.2,0-.3,0-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.6,325c-.5,0-1-.2-1.3-.5-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.3c0,0,.2-.2.3-.2,0,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5.4.3.6.8.6,1.3s-.2,1-.6,1.4c-.4.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.7,323.1c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM871,323.1c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM846.3,323.1c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM821.6,323.1c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM796.9,323.1c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM772.2,323.1c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM747.5,323.1c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM722.8,323.1c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM698.1,323.1c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM673.4,323.1c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM648.7,323.1c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM624,323.1c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM599.3,323.1c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM574.6,323.1c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM549.9,323.1c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM525.2,323.1c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM500.5,323.1c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM475.8,323.1c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.2,325c-.5,0-1-.2-1.3-.5-.3-.4-.5-.9-.5-1.4s.2-1,.5-1.3c.7-.7,2-.7,2.7,0,.4.3.6.8.6,1.3s-.2,1-.6,1.4c-.3.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.2,350.1c-.5,0-1-.2-1.4-.6-.4-.4-.5-.8-.5-1.3s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.2,0,.5,0,.7,0,.1,0,.2,0,.4.1.1,0,.2.1.3.2.1,0,.2.1.3.2,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.3,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM858.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM832.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM806.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM780.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM754.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM728.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM702.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM676.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM650.6,348.2c0-1.1.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM624.6,348.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM598.6,348.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM572.6,348.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM546.6,348.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM520.6,348.2c0-1.1.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.4,350.1c-.5,0-1-.2-1.3-.6-.4-.4-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1,0-.2.2-.3,0-.1.2-.2.2-.3.7-.7,2-.7,2.7,0,0,0,.2.2.2.3,0,.1.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4,0,.5-.2,1-.5,1.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.5,375.3c-.5,0-1-.2-1.3-.6-.4-.4-.6-.8-.6-1.4s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0,0,.1-.2.2-.3.7-.7,2-.7,2.7,0,0,0,.2.2.2.3s.1.2.2.3c0,.1,0,.2.1.3,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.4,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.9,373.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM855.3,373.3c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM830.7,373.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM806.1,373.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM781.5,373.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM756.9,373.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM732.3,373.3c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM707.7,373.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM683.1,373.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM658.5,373.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM633.9,373.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM609.3,373.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM584.7,373.3c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM560.1,373.3c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM535.5,373.3c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.3,375.3c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2,0-.4,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2,0-.3,0-.1.1-.2.2-.3,0,0,.2-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.2,0,.5,0,.7,0,.1,0,.2,0,.4.1.1,0,.2.1.3.2.1,0,.2.2.3.2,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1,0,.2-.2.3,0,0-.1.2-.2.3,0,0-.2.2-.3.2,0,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.5,400.5c-.5,0-1-.2-1.4-.6-.4-.3-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3s.2-.2.3-.2c.1,0,.2-.1.3-.2.1,0,.2,0,.3-.1.6-.1,1.3,0,1.7.5,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861,398.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM834.6,398.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM808.3,398.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM782,398.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM755.8,398.6c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM729.5,398.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM703.1,398.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM676.8,398.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM650.5,398.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM624.2,398.6c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM597.9,398.6c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM571.6,398.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM545.3,398.6c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.8,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.8,400.5c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2,0,0-.2-.2-.3-.2,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2.1-.4,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.2,0,.5,0,.8,0,.1,0,.2,0,.3.1.1,0,.2.1.3.2,0,0,.2.2.3.2s.2.2.2.3c0,0,.1.2.2.3,0,.1,0,.2.1.4,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,0-.2.2-.2.3,0,0-.2.2-.3.2s-.2.1-.3.2c-.1,0-.2,0-.3.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.2,425.7c-.5,0-1-.2-1.4-.6-.4-.4-.5-.8-.5-1.3s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3s.2-.2.3-.2.2-.1.3-.2c.1,0,.2,0,.4-.1.2,0,.5,0,.7,0,.1,0,.2,0,.3.1.1,0,.2,0,.3.2.1,0,.2.2.3.2s.2.2.2.3c0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.9,423.8c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM829.8,423.8c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM803.7,423.8c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM777.6,423.8c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM751.5,423.8c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM725.4,423.8c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM699.3,423.8c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM673.2,423.8c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM647.1,423.8c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM621,423.8c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM594.9,423.8c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM568.8,423.8c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM542.7,423.8c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.3,425.7c-.5,0-1-.2-1.3-.6,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2-.1-.4,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3.4-.4,1.1-.7,1.7-.5.1,0,.2,0,.4.1.1,0,.2,0,.3.2.1,0,.2.2.3.2,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.2.2-.2.3,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.2,450.8c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2-.4-.3-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0-.1.2-.2.2-.3.5-.4,1.1-.7,1.7-.5.1,0,.2,0,.4.1.1,0,.2.1.3.2.1,0,.2.2.3.2,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4s0,.2,0,.4c0,.1,0,.2-.1.3,0,.1-.1.2-.2.3,0,.1-.1.2-.2.3,0,0-.2.2-.3.2-.1,0-.2.1-.3.2-.1,0-.2,0-.4.1-.1,0-.2,0-.4,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.2,448.9c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM847,448.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM822.8,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM798.6,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM774.4,448.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM750.2,448.9c0-1,.8-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM726,448.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1.1,0-1.9-.9-1.9-1.9ZM701.8,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.8,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM677.6,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM653.4,448.9c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM629.2,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM605,448.9c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM580.8,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM556.6,448.9c0-1,.9-1.9,1.9-1.9h0c1.1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9ZM532.4,448.9c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.9-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896,450.8c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.2-.3-.2,0,0-.2-.2-.2-.3,0,0-.1-.2-.2-.3,0-.1,0-.2-.1-.3,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.2,0,.5,0,.8,0,.1,0,.2,0,.3.1.1,0,.2.1.3.2,0,0,.2.2.3.2,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4,0,.5-.2,1-.5,1.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.7,476.1c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2-.1,0-.2-.2-.3-.2-.4-.4-.6-.8-.6-1.3s0-.2,0-.4c0-.1,0-.2.1-.3,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3.7-.7,2-.7,2.7,0,0,0,.2.2.2.3,0,0,.1.2.2.3,0,.1,0,.2.1.3,0,.1,0,.2,0,.4,0,.5-.2,1-.6,1.3-.4.4-.8.5-1.3.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.7,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM875.2,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM849.7,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM824.2,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM798.7,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM773.2,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM747.7,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM722.2,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM696.7,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM671.2,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM645.7,474.2c0-1,.9-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1,0-1.9-.8-1.9-1.9ZM620.2,474.2c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM594.7,474.2c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM569.2,474.2c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM543.7,474.2c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9ZM518.2,474.2c0-1,.8-1.9,1.9-1.9h0c1,0,1.9.9,1.9,1.9h0c0,1-.9,1.9-1.9,1.9h0c-1.1,0-1.9-.8-1.9-1.9Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.7,476.1c-.1,0-.2,0-.4,0-.1,0-.2,0-.4-.1-.1,0-.2-.1-.3-.2,0,0-.2-.2-.3-.2,0,0-.2-.2-.2-.3,0-.1-.1-.2-.2-.3,0-.1,0-.2,0-.4,0-.1,0-.2,0-.4s0-.2,0-.4c0-.1,0-.2,0-.3,0-.1.1-.2.2-.3,0-.1.1-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2-.1.3-.2.1,0,.2,0,.4-.1.6-.1,1.3,0,1.7.5s.6.8.6,1.3,0,.2,0,.4c0,.1,0,.2-.1.4,0,.1-.1.2-.2.3,0,.1-.2.2-.2.3-.4.4-.8.6-1.3.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M673.7,119.1c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM673.7,54.6c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M673.7,119.1c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM673.7,54.6c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5,118.1c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM410.5,53.6c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M479.9,186.7c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM479.9,122.1c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M678.3,224.6c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM678.3,160c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M838.9,96.3c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM838.9,31.8c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M900.8,194.1c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM900.8,129.6c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M911.1,312.9c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM911.1,248.4c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M826.6,460.2c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM826.6,395.6c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M929.2,506.7c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM929.2,442.2c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M517,139.3",
    fill: "none",
    stroke: "#405a8e",
    strokeDasharray: "0 0 0 8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M451.9,330.2c0,0-.2,0-.3,0-.3-.1-.4-.5-.3-.8,0,0,1-2.2,3-5.9.2-.3.5-.4.8-.2.3.2.4.5.2.8-2,3.6-3,5.8-3,5.8-.1.2-.3.3-.5.3Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4,312.6h0c-.1,0-.2,0-.3,0-.2-.1-.3-.3-.3-.5,0-.1,0-.2,0-.3,1.3-2.4,2.7-4.8,4-7.1.2-.3.5-.4.8-.2.1,0,.2.2.3.4,0,.2,0,.3,0,.5-1.4,2.4-2.7,4.8-4,7.1-.1.2-.3.3-.5.3ZM469.4,298.5c-.1,0-.2,0-.3,0-.2-.1-.3-.3-.3-.5s0-.2,0-.3c1.3-2.3,2.7-4.6,4.1-7,.2-.3.5-.4.8-.2.1,0,.2.2.3.4,0,.1,0,.3,0,.4-1.4,2.4-2.8,4.7-4.1,7h0c-.1.2-.3.3-.5.3ZM477.8,284.6c-.1,0-.2,0-.3,0-.2-.1-.3-.3-.3-.5s0-.2,0-.3c1.4-2.3,2.9-4.7,4.3-6.9.2-.3.5-.4.8-.2.3.2.4.5.2.8-1.5,2.4-2.9,4.7-4.2,6.9-.1.2-.3.3-.5.3ZM486.3,270.8c-.1,0-.2,0-.3-.1-.2-.1-.3-.3-.3-.5,0-.1,0-.2,0-.3,1.6-2.5,3-4.7,4.4-6.8.2-.3.6-.4.8-.2.3.2.3.6.2.8-1.5,2.2-2.9,4.5-4.4,6.8h0c-.1.2-.3.3-.5.3ZM495.2,257.2c-.1,0-.2,0-.3-.1-.2-.1-.3-.3-.3-.5s0-.2.1-.3c1.5-2.2,3-4.5,4.5-6.7.2-.3.6-.3.8-.2.3.2.3.6.2.8-1.5,2.1-2.9,4.4-4.5,6.7-.1.2-.3.3-.5.3ZM504.3,243.8c-.1,0-.2,0-.3-.1-.2-.1-.3-.3-.3-.5s0-.2.1-.3c1.6-2.4,3.1-4.5,4.6-6.6.2-.3.6-.3.8-.1.1,0,.2.2.2.4,0,.2,0,.3-.1.5-1.5,2.1-3.1,4.4-4.6,6.6-.1.2-.3.3-.5.3ZM513.6,230.5c-.1,0-.2,0-.3-.1-.2-.1-.2-.3-.2-.5s0-.3.1-.4c1.5-2.1,3.1-4.3,4.8-6.6.2-.2.6-.3.8-.1.3.2.3.6.1.8-1.6,2.1-3.2,4.3-4.8,6.5-.1.1-.3.2-.5.2ZM523.2,217.5c-.1,0-.2,0-.4-.1-.1-.1-.2-.3-.2-.5,0-.1,0-.2.1-.4,1.7-2.3,3.3-4.4,4.9-6.4.2-.3.6-.3.8-.1.3.2.3.6.1.8-1.6,2.1-3.3,4.3-4.9,6.4-.1.1-.3.2-.5.2ZM533.1,204.7c-.1,0-.3,0-.4-.1-.1-.1-.2-.3-.2-.5,0-.1,0-.3.1-.4,1.7-2.2,3.4-4.3,5.1-6.3.2-.2.6-.3.8,0,.3.2.3.6,0,.8-1.7,2.2-3.4,4.3-5.1,6.3-.1.1-.3.2-.5.2ZM543.4,192.1h0c-.1,0-.3,0-.4-.1-.1-.1-.2-.3-.2-.5s0-.2,0-.3h0,0c0-.1,0-.1,0-.1,1.8-2.1,3.5-4.2,5.2-6.2.2-.2.6-.3.9,0,.2.2.3.6,0,.9-1.7,2-3.5,4.1-5.2,6.2-.1.1-.3.2-.5.2ZM553.9,179.8c-.1,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4s0-.3.1-.4c1.7-2,3.5-4,5.4-6.1.2-.2.6-.2.9,0,.2.2.3.6,0,.9-1.7,1.9-3.5,4-5.4,6-.1.1-.3.2-.4.2ZM564.7,167.7c-.1,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4s0-.3.2-.4c1.8-2,3.7-4,5.6-5.9.2-.2.6-.2.9,0,.2.2.2.6,0,.8-1.9,1.9-3.7,3.9-5.5,5.9-.1.1-.3.2-.4.2ZM575.9,156c-.2,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4s0-.3.2-.4c1.9-2,3.9-3.9,5.8-5.7.2-.2.6-.2.9,0,.1.1.2.3.2.4s0,.3-.2.4c-1.9,1.8-3.8,3.8-5.7,5.7h0c-.1.1-.2.2-.4.2ZM587.5,144.7c-.2,0-.3,0-.4-.2-.1-.1-.2-.2-.2-.4,0-.2,0-.3.2-.5,1.9-1.8,4-3.7,6-5.5.2-.2.6-.2.9,0,.2.2.2.6,0,.9-2,1.8-4,3.7-5.9,5.5-.1,0-.3.2-.4.2ZM599.5,133.8c-.2,0-.3,0-.5-.2,0-.1-.2-.3-.1-.4,0-.2,0-.3.2-.4,2-1.8,4.1-3.6,6.2-5.3.2-.2.6-.2.9,0,.2.3.2.6,0,.9-2,1.7-4,3.4-6.1,5.2h-.1c-.1.2-.2.2-.4.2ZM612,123.4c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.3.2-.5,2.1-1.7,4.3-3.4,6.4-5,.3-.2.6-.1.8.1,0,.1.1.3.1.4,0,.2-.1.3-.2.4-2.1,1.6-4.2,3.2-6.4,5,0,0-.2.1-.4.1ZM624.8,113.5c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5.6-.4,1.2-.9,1.8-1.3.3-.2.6-.1.8.1.2.3.1.6-.1.8-.6.4-1.2.8-1.8,1.3-.1,0-.2.1-.4.1Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.1,108.4c-.2,0-.4,0-.5-.2-.2-.3-.1-.6.1-.8,1.8-1.3,3.7-2.5,5.5-3.7.3-.2.6,0,.8.2.2.3,0,.7-.2.8-1.8,1.1-3.6,2.3-5.5,3.6-.1,0-.2.1-.4.1Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M481.9,353.5c-.2,0-.3,0-.5-.2-.2-.3-.2-.6,0-.8,0,0,1.9-1.5,5-4.3.2-.2.6-.2.8,0,.2.2.2.6,0,.8-3.1,2.8-5,4.3-5,4.3-.1,0-.2.1-.4.1Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.5,341c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5c1.2-1,2.4-2.1,3.7-3.2l2-1.7c.2-.2.6-.2.9,0,.2.2.2.6,0,.9l-2.7,2.3c-1,.9-2,1.7-3,2.5h0c-.1.1-.2.2-.4.2ZM507.9,331.3c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5c1-.9,2.1-1.8,3.2-2.7.8-.7,1.7-1.4,2.5-2.1.2-.2.6-.2.8,0,.1.1.2.3.1.4,0,.2,0,.3-.2.4-1.4,1.2-2.8,2.3-4.1,3.5l-1.6,1.4c-.1,0-.2.1-.4.1ZM519.4,321.5c-.2,0-.3,0-.5-.2,0,0-.1-.2-.1-.4,0-.2,0-.4.2-.5,1.5-1.3,3-2.6,4.6-3.9l1.1-1c.2-.2.6-.2.8,0,.1.1.1.3.1.4,0,.2,0,.3-.2.4l-.8.6c-1.7,1.4-3.3,2.8-5,4.2-.1,0-.2.1-.4.1ZM530.9,311.8c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.3.2-.5h.1c1.8-1.7,3.7-3.2,5.6-4.9.2-.2.6-.2.8,0,.2.3.2.6,0,.8-1.9,1.6-3.9,3.2-5.7,4.8-.1.1-.2.1-.4.1ZM542.3,302.1c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5c1.8-1.5,3.6-3,5.4-4.6l.3-.3c.2-.2.6-.2.9,0,.2.2.2.6,0,.9-1.2,1-2.4,2.1-3.6,3.1l-2.1,1.8c-.1,0-.2.1-.4.1ZM553.8,292.5c-.2,0-.3,0-.4-.2,0-.1-.1-.2-.1-.4,0-.2,0-.3.2-.5h0s0,0,0,0c1.9-1.6,3.8-3.2,5.7-4.8.2-.2.6-.2.9,0,.2.3.2.6,0,.9-1.8,1.5-3.5,3-5.3,4.5l-.5.4c-.1,0-.2.1-.4.1ZM565.3,282.8c-.2,0-.3,0-.4-.2,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5l5.8-4.8c.2-.2.6-.2.9,0,.2.2.2.6,0,.8-1.9,1.6-3.8,3.2-5.8,4.8h0c0,0,0,0,0,0,0,0-.2,0-.3,0ZM576.9,273.2c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.3.2-.5,1.9-1.6,3.9-3.2,5.8-4.8.2-.2.6-.2.8,0,.2.3.2.6,0,.9-1.9,1.6-3.8,3.2-5.8,4.8h0c-.1.1-.2.1-.4.1ZM588.4,263.6c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4s0-.3.2-.5c2-1.6,3.9-3.2,5.8-4.8.2-.2.6-.2.9,0,.1.1.1.3.1.4,0,.2,0,.3-.2.4l-.4.3c-1.8,1.5-3.6,3-5.4,4.5-.1,0-.2.1-.4.1ZM600,254c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5c1.9-1.6,3.9-3.2,5.8-4.8.2-.2.6-.2.9,0,0,.1.1.3.1.4s0,.3-.2.4c-1.9,1.6-3.8,3.2-5.8,4.8-.1,0-.2.1-.4.1ZM611.6,244.5c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5c1.6-1.3,3.7-3,5.8-4.7.2-.2.6-.2.9,0,.2.3.2.6,0,.8-1.7,1.4-3.6,2.9-5.8,4.7-.1,0-.2.1-.4.1ZM623.3,235.1c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5,2.1-1.7,4-3.2,5.9-4.7.2-.2.6-.2.8,0,.1.1.1.3.1.4,0,.2-.1.3-.2.4-1.7,1.3-3.5,2.8-5.9,4.7-.1,0-.2.1-.4.1ZM635.1,225.7c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5,2-1.6,4-3.1,5.9-4.6.3-.2.7-.1.8.1.2.3.2.6-.1.8-1.9,1.5-3.9,3-5.9,4.6-.1,0-.2.1-.4.1Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.9,213.7c-.2,0-.4,0-.5-.2-.2-.3-.1-.6.1-.8,2.3-1.7,4.4-3,5.8-3.6.3-.1.7,0,.8.3.1.3,0,.7-.3.8-1.3.6-3.4,1.8-5.5,3.4-.1,0-.2.1-.4.1Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495,374.5c-.2,0-.5-.1-.6-.4-.1-.3,0-.7.3-.8,0,0,2.2-.8,6.1-2.6.3-.1.7,0,.8.3.1.3,0,.7-.3.8-4,1.8-6.2,2.7-6.2,2.7,0,0-.1,0-.2,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.6,366.1c-.2,0-.5-.1-.6-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.4-1.1,4.9-2.3,7.4-3.6.3-.1.7,0,.8.3,0,.1,0,.3,0,.5,0,.1-.2.3-.3.3-2.4,1.2-4.8,2.3-7.4,3.5h0c0,0-.2,0-.2,0ZM528.4,358.9c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.2,4.8-2.4,7.3-3.7.3-.1.7,0,.8.3,0,.1,0,.3,0,.5,0,.1-.2.3-.3.3-2.5,1.3-5,2.5-7.3,3.7,0,0-.2,0-.3,0ZM543,351.5c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.4-1.3,4.9-2.6,7.3-3.8.3-.1.7,0,.8.2,0,.1,0,.3,0,.5,0,.2-.1.3-.3.4-2.4,1.3-4.8,2.6-7.3,3.8,0,0-.2,0-.3,0ZM557.5,343.8c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.2,4.6-2.5,7.2-3.9.3-.2.7,0,.8.2.2.3,0,.7-.2.8-2.4,1.3-4.8,2.6-7.2,3.9,0,0-.2,0-.3,0ZM571.9,335.8h0c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.3,4.7-2.7,7.1-4.1.3-.2.7,0,.8.2s0,.6-.2.8c-2.4,1.4-4.8,2.8-7.1,4.1,0,0-.2,0-.3,0ZM586.1,327.6c-.2,0-.4-.1-.5-.3,0-.1,0-.2,0-.3,0-.2.1-.4.3-.5,2.5-1.5,4.8-2.8,7.1-4.2.3-.2.7,0,.8.2,0,.1.1.3,0,.5,0,.1-.1.3-.3.4-2.3,1.4-4.6,2.7-7.1,4.2,0,0-.2,0-.3,0ZM600.2,319.2c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.2-1.3,4.5-2.7,7-4.3.3-.2.7,0,.8.2.2.3,0,.6-.2.8-2.2,1.4-4.6,2.8-7,4.3,0,0-.2,0-.3,0ZM614.1,310.5c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.5-1.6,4.7-3,6.9-4.4.3-.2.6,0,.8.2.2.3,0,.6-.2.8-2.2,1.4-4.6,2.9-6.9,4.4,0,0-.2,0-.3,0ZM627.9,301.6c-.2,0-.4,0-.5-.3,0,0-.1-.2-.1-.3,0-.2.1-.4.3-.5,2.3-1.6,4.6-3.1,6.8-4.6.3-.2.6-.1.8.2s.1.6-.2.8c-2.4,1.6-4.6,3.1-6.8,4.5h0c-.1,0-.2.1-.3.1ZM641.5,292.5c-.2,0-.4-.1-.5-.3,0-.1-.1-.2-.1-.3,0-.2.1-.4.3-.5,2.3-1.6,4.6-3.2,6.7-4.7.3-.2.6-.1.8.1.2.3.1.6-.1.8-2.4,1.7-4.6,3.2-6.8,4.7h0c0,0-.2.1-.3.1ZM655,283c-.2,0-.4-.1-.5-.3,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5,2.1-1.5,4.4-3.1,6.7-4.8.2-.2.6-.1.8.1.2.3.1.6-.1.8-2.2,1.6-4.4,3.2-6.7,4.8,0,0-.2.1-.3.1ZM668.2,273.4c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5,2.2-1.6,4.4-3.3,6.5-4.9.2-.2.6-.1.8.1,0,.1.1.3.1.4,0,.2,0,.3-.2.4-2.2,1.7-4.4,3.3-6.5,5-.1,0-.2.1-.4.1ZM681.3,263.4c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4s0-.3.1-.4h0,.1c0-.1,0-.1,0-.1,2.2-1.7,4.3-3.4,6.4-5.1.2-.2.6-.2.8,0,.1.1.1.3.1.5,0,.2,0,.3-.2.4-2.1,1.7-4.3,3.4-6.5,5.1,0,0-.2.1-.4.1ZM694.1,253.2c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.3.1-.4h0,.1c0-.1,0-.1,0-.1,2.2-1.8,4.3-3.5,6.3-5.2.2-.2.6-.2.8,0,.2.2.2.6,0,.8-2.1,1.8-4.2,3.5-6.3,5.2-.1,0-.2.1-.4.1ZM706.7,242.6h0c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4,0-.2,0-.4.2-.5,2-1.7,4-3.5,6.2-5.4.2-.2.6-.2.8,0,0,.1.2.3.1.4,0,.2,0,.3-.2.4-2,1.8-4.1,3.6-6.2,5.4-.1,0-.2.1-.4.1ZM719,231.8c-.2,0-.3,0-.5-.2-.1-.1-.2-.3-.2-.4s0-.3.2-.4c2-1.9,4.1-3.7,6-5.5.2-.2.6-.2.9,0,.1.1.2.3.2.4,0,.2,0,.3-.2.4-2,1.9-4,3.7-6,5.5-.1.1-.2.1-.4.1ZM730.9,220.7c-.2,0-.3,0-.4-.2s-.2-.3-.2-.4c0-.2,0-.3.2-.4,2.1-2,4-3.9,5.9-5.7.2-.2.6-.2.8,0,.1.1.2.3.2.4s0,.3-.2.4c-1.9,1.9-3.9,3.8-5.9,5.7-.1.1-.3.2-.4.2ZM742.6,209.2c-.2,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4s0-.3.2-.4c1.9-1.9,3.8-3.9,5.7-5.9.2-.2.6-.2.8,0,.2.2.2.6,0,.9-1.9,1.9-3.8,3.9-5.7,5.9-.1.1-.3.2-.4.2ZM754,197.3c-.1,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4s0-.2,0-.3h0,0c0-.1,0-.1,0-.1,1.8-2,3.7-4,5.5-6,.2-.2.6-.3.9,0,.2.2.3.6,0,.8-1.8,2-3.6,4-5.5,6.1-.1.1-.3.2-.4.2ZM764.9,185.1c-.1,0-.3,0-.4-.1-.1-.1-.2-.3-.2-.4,0-.2,0-.3.1-.4,1.8-2.1,3.6-4.2,5.3-6.3.2-.2.6-.3.8,0,.1,0,.2.2.2.4,0,.2,0,.3-.1.4-1.7,2-3.5,4.1-5.3,6.3h0c-.1.1-.3.2-.4.2ZM775.5,172.5c-.1,0-.3,0-.4-.1-.1-.1-.2-.3-.2-.5,0-.1,0-.3.1-.4,1.7-2.1,3.4-4.3,5.1-6.4.2-.2.6-.3.8-.1.3.2.3.6.1.8-1.7,2.2-3.4,4.4-5.1,6.5h0c0,.1,0,0,0,0-.1,0-.2.1-.4.1ZM785.5,159.4c-.1,0-.2,0-.4-.1-.1-.1-.2-.3-.2-.5s0-.3.1-.4c1.6-2.1,3.2-4.4,4.8-6.6.2-.3.6-.3.8-.1.1,0,.2.2.2.4,0,.2,0,.3-.1.5-1.6,2.2-3.2,4.5-4.8,6.7-.1.1-.3.2-.5.2ZM795,146c-.1,0-.2,0-.3-.1-.2-.1-.3-.3-.3-.5s0-.2.1-.3c1.5-2.2,3-4.5,4.5-6.9.2-.3.6-.4.8-.2.3.2.3.5.2.8-1.5,2.3-3,4.6-4.5,6.9-.1.2-.3.3-.5.3ZM803.9,132.2c-.1,0-.2,0-.3,0-.2-.1-.3-.3-.3-.5s0-.2,0-.2h0,0c0,0,0,0,0-.1,1.4-2.3,2.8-4.7,4.2-7,.2-.3.5-.4.8-.2.3.2.4.5.2.8-1.4,2.4-2.8,4.7-4.2,7.1h0c-.1.2-.3.3-.5.3ZM812.1,118c-.1,0-.2,0-.3,0-.2-.1-.3-.3-.3-.5s0-.1,0-.2h0,0c0,0,0-.1,0-.1,1.3-2.4,2.6-4.9,3.8-7.2.1-.3.5-.4.8-.3.1,0,.2.2.3.4s0,.3,0,.5c-1.2,2.4-2.5,4.8-3.8,7.3-.1.2-.3.3-.5.3Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.1,102.3c0,0-.2,0-.3,0-.3-.1-.4-.5-.3-.8.5-1,1-2,1.4-3,.5-1,.9-2,1.4-3,.1-.3.5-.4.8-.3.3.1.4.5.3.8-.5,1-1,2-1.4,3-.5,1-.9,2-1.4,3-.1.2-.3.3-.5.3Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M502.8,400.4c-.3,0-.5-.2-.6-.5,0-.3.1-.6.4-.7,0,0,2.2-.5,6.5-1.7.3,0,.6.1.7.4,0,.3-.1.6-.4.7-4.3,1.2-6.5,1.7-6.5,1.7,0,0,0,0-.1,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.1,394.9c-.3,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.3.2-.5.4-.6,2.5-.8,5.1-1.6,7.7-2.4.3,0,.6,0,.8.4.1.3,0,.6-.4.8-2.5.8-5.1,1.6-7.7,2.4,0,0-.1,0-.2,0ZM537.6,390c-.3,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.3.2-.5.4-.6,2.4-.8,5-1.7,7.7-2.6.3-.1.7,0,.8.4,0,.2,0,.3,0,.5s-.2.2-.4.3c-2.6.9-5.2,1.8-7.7,2.6,0,0-.1,0-.2,0ZM552.9,384.7c-.2,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.2.2-.5.4-.5h0s0,0,0,0c2.7-1,5.2-1.8,7.6-2.7.3-.1.7,0,.8.4,0,.2,0,.3,0,.5,0,.1-.2.3-.3.3-2.5.9-5,1.8-7.6,2.7h0c0,0-.1,0-.2,0ZM568.2,379.2c-.2,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.2.2-.5.4-.6,2.5-.9,5.1-1.9,7.6-2.9.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.5,1-5.1,1.9-7.6,2.8,0,0-.1,0-.2,0ZM583.3,373.5c-.2,0-.5-.1-.6-.4,0,0,0-.1,0-.2,0-.2.1-.5.3-.6h0s0,0,0,0h0c2.7-1.1,5.1-2,7.5-3,.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.5,1-5,2-7.5,3h0c0,0-.1,0-.2,0ZM598.4,367.4c-.2,0-.5-.1-.6-.4,0,0,0-.2,0-.2,0-.2,0-.3.2-.4h0,.3c2.9-1.3,5.2-2.3,7.5-3.2.3-.1.7,0,.8.3,0,.1,0,.3,0,.5,0,.1-.2.3-.3.3-2.5,1-5,2.1-7.5,3.1,0,0-.1,0-.2,0ZM613.3,361.1c-.2,0-.5-.1-.5-.4,0,0,0-.2,0-.2,0-.2.1-.5.4-.6,2.4-1,4.9-2.1,7.4-3.2.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.5,1.1-5,2.2-7.4,3.2,0,0-.2,0-.2,0ZM628.2,354.6c-.2,0-.4-.1-.5-.4,0,0,0-.2,0-.2,0-.2.1-.5.3-.6,2.6-1.2,5-2.3,7.4-3.4.3-.1.7,0,.8.3,0,.1,0,.3,0,.5,0,.1-.2.3-.3.3-2.3,1.1-4.7,2.2-7.4,3.4,0,0-.2,0-.2,0ZM642.9,347.9c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.5-1.2,4.9-2.3,7.3-3.5.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.6,1.3-5,2.4-7.3,3.5,0,0-.2,0-.3,0ZM657.5,340.8c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.1,4.7-2.3,7.2-3.6.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.4,1.2-4.8,2.4-7.3,3.6,0,0-.2,0-.3,0ZM672,333.6c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.6-1.3,4.9-2.5,7.2-3.7.3-.1.7,0,.8.2.1.3,0,.6-.2.8-2.5,1.3-4.9,2.5-7.2,3.7h0c0,0-.2,0-.3,0ZM686.3,326c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.4-1.3,4.8-2.6,7.1-3.8.3-.2.7,0,.8.2.2.3,0,.6-.2.8-2.3,1.3-4.7,2.6-7.1,3.9,0,0-.2,0-.3,0ZM700.5,318.3c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.4-1.3,4.8-2.7,7-4,.3-.2.7,0,.8.2.2.3,0,.7-.2.8-2.3,1.3-4.7,2.7-7.1,4,0,0-.2,0-.3,0ZM714.6,310.2c-.2,0-.4-.1-.5-.3,0-.1,0-.2,0-.3,0-.2.1-.4.3-.5,2.4-1.4,4.8-2.8,7-4.1.3-.2.7,0,.8.2.2.3,0,.7-.2.8-2.3,1.3-4.6,2.7-7,4.1-.1,0-.2,0-.3,0ZM728.5,301.9c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2,0-.3.2-.4h0,.2c0-.1,0-.1,0-.1,2.4-1.5,4.7-2.9,6.9-4.2.3-.2.7,0,.8.2.2.3,0,.6-.2.8-2.4,1.5-4.7,2.9-6.9,4.3-.1,0-.2,0-.3,0ZM742.3,293.3c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2,0-.4.3-.5,2.3-1.4,4.5-2.9,6.8-4.4.3-.2.7-.1.8.2.2.3.1.6-.2.8-2.3,1.5-4.6,3-6.8,4.4-.1,0-.2,0-.3,0ZM755.8,284.4c-.2,0-.4-.1-.5-.3,0-.1,0-.2,0-.3,0-.2,0-.4.3-.5,2.3-1.5,4.5-3,6.7-4.5.3-.2.7-.1.8.2.2.3.1.6-.2.8-2.1,1.4-4.2,2.9-6.7,4.5-.1,0-.2.1-.3.1ZM769.2,275.3c-.2,0-.4-.1-.5-.3,0-.1-.1-.2-.1-.3,0-.2,0-.4.2-.5,2.2-1.6,4.5-3.1,6.6-4.7.3-.2.6-.1.8.1.2.3.1.6-.1.8-2.2,1.6-4.4,3.1-6.6,4.7-.1,0-.2.1-.3.1ZM782.4,265.9c-.2,0-.4,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5h0s0,0,0,0c2.1-1.5,4.3-3.2,6.5-4.8.3-.2.7-.1.8.1.2.3.2.6-.1.8-2.2,1.7-4.4,3.3-6.5,4.8,0,0-.2.1-.3.1ZM795.3,256.1c-.2,0-.4,0-.5-.2,0,0-.1-.2-.1-.4,0-.1,0-.3.1-.4h0,.1c0,0,0,0,0-.1,2.1-1.7,4.3-3.3,6.4-5,.2-.2.7-.1.8.1.1.1.1.3.1.4,0,.2,0,.3-.2.4-2,1.6-4.1,3.2-6.4,5h0c-.1,0-.2.1-.4.1ZM808,246.1c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.4.2-.5c2.1-1.7,4.2-3.4,6.3-5.1.2-.2.6-.2.8,0,.2.3.2.6,0,.8-2.1,1.8-4.2,3.5-6.3,5.1-.1,0-.2.1-.4.1ZM820.5,235.8c-.2,0-.3,0-.5-.2,0-.1-.1-.2-.1-.4s0-.3.2-.5h0c2.1-1.8,4.1-3.6,6.1-5.3.2-.2.6-.2.9,0,0,.1.2.3.1.4,0,.2,0,.3-.2.4-1.9,1.7-3.9,3.4-6.1,5.3-.1,0-.2.1-.4.1ZM832.7,225.1c-.2,0-.3,0-.5-.2-.1-.1-.2-.3-.2-.4s0-.2.1-.4h0,0c0-.1,0-.1,0-.1,2-1.8,4-3.6,6-5.4.2-.2.6-.2.8,0,.1.1.2.3.2.4,0,.2,0,.3-.2.4-2.1,1.9-4.1,3.7-6,5.4-.1,0-.2.2-.4.2ZM844.7,214.2c-.2,0-.3,0-.4-.2,0-.1-.2-.3-.2-.4s0-.3.1-.4h0,0c0-.1,0-.1,0-.1,1.9-1.8,3.9-3.7,5.8-5.5.2-.2.6-.2.8,0,.2.2.2.6,0,.9-2,1.9-4,3.8-5.8,5.6-.1.1-.3.2-.4.2ZM856.3,202.9c-.2,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4s0-.3.2-.4c2-2,3.9-3.9,5.7-5.8.2-.2.6-.2.8,0,.1.1.2.3.2.4,0,.2,0,.3-.2.4-1.8,1.9-3.8,3.8-5.7,5.8-.1.1-.3.2-.4.2Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.7,192.3c-.1,0-.3,0-.4-.2-.2-.2-.3-.6,0-.8.8-.8,1.5-1.6,2.3-2.4.7-.8,1.5-1.6,2.2-2.4.2-.2.6-.3.8,0,.2.2.3.6,0,.8-.8.8-1.5,1.6-2.3,2.4-.7.8-1.5,1.6-2.2,2.4-.1.1-.3.2-.4.2Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.8,419.9h-6.7c-.3,0-.6-.3-.6-.6s.3-.6.6-.6h6.7c.3,0,.6.3.6.6s-.3.6-.6.6Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.3,419.4h0c-.3,0-.6-.2-.6-.6h0c0-.3.2-.6.6-.6,2.8-.1,5.5-.3,8.1-.5.3,0,.6.2.6.6,0,.2,0,.3-.1.4-.1.1-.2.2-.4.2-2.7.2-5.4.3-8.1.5h0ZM539.5,418.3c-.3,0-.6-.2-.6-.5h0c0-.4.2-.6.6-.7,2.7-.2,5.4-.4,8.1-.7.3,0,.6.2.6.5,0,.3-.2.6-.5.6-2.5.2-5.2.5-8.1.7h0s0,0,0,0h0ZM555.6,416.9h0s0,0,0,0c-.3,0-.6-.2-.6-.5,0,0,0,0,0,0,0-.3.2-.5.5-.6h0s0,0,0,0c2.6-.3,5.3-.5,8-.8.3,0,.6.2.7.5,0,.3-.2.6-.5.7-2.8.3-5.5.6-8.1.9h0ZM571.8,415.1c-.3,0-.6-.2-.6-.5,0,0,0,0,0,0,0-.3.2-.6.5-.6h0s0,0,0,0c2.9-.4,5.5-.7,8-1,.3,0,.6.2.7.5,0,.2,0,.3-.1.4-.1.1-.2.2-.4.2-2.6.4-5.4.7-8,1h0ZM587.8,413c-.3,0-.6-.2-.6-.5,0,0,0,0,0,0,0-.3.2-.6.5-.6,2.5-.4,5.2-.8,8-1.2.3,0,.6.2.7.5,0,.2,0,.3-.1.5,0,.1-.2.2-.4.2-2.7.4-5.4.8-8,1.2,0,0,0,0,0,0ZM603.8,410.5c-.3,0-.5-.2-.6-.5h0c0-.4.2-.6.5-.7,2.6-.5,5.3-.9,8-1.4.3,0,.6.2.7.5,0,.3-.2.6-.5.7-2.6.5-5.2.9-8,1.4,0,0,0,0,0,0ZM619.8,407.6c-.3,0-.5-.2-.6-.5,0,0,0,0,0-.1,0-.3.2-.5.5-.6,2.7-.5,5.4-1,7.9-1.5.3,0,.7.1.7.5,0,.3-.1.6-.5.7-2.7.5-5.4,1-7.9,1.5h0s0,0-.1,0ZM635.7,404.5c-.3,0-.5-.2-.6-.5,0,0,0,0,0-.1,0-.3.2-.5.5-.6,2.6-.5,5.3-1.1,7.9-1.7.3,0,.6.1.7.5,0,.2,0,.3,0,.5,0,.1-.2.2-.4.3-2.6.6-5.2,1.2-7.9,1.7h0s0,0-.1,0ZM651.6,401h0c-.3,0-.6-.2-.7-.5,0,0,0-.1,0-.2,0-.3.2-.5.4-.6h0s0,0,0,0c2.8-.7,5.4-1.3,7.8-1.9.3,0,.6.1.7.4,0,.3-.1.6-.4.7-2.6.6-5.3,1.3-7.9,1.9h0ZM667.2,397.2c-.3,0-.5-.2-.6-.5,0,0,0-.1,0-.2,0-.3.2-.5.5-.6,2.5-.6,5.1-1.3,7.8-2,.3,0,.7.1.7.4,0,.1,0,.3,0,.4,0,.1-.2.2-.4.3-2.6.7-5.2,1.4-7.8,2,0,0,0,0-.1,0ZM682.9,393c-.3,0-.5-.2-.6-.4,0,0,0,0,0-.1,0-.3.2-.5.4-.6,2.8-.8,5.3-1.5,7.8-2.2.3,0,.6.1.7.4,0,.2,0,.3,0,.5s-.2.2-.4.3c-2.5.7-5.1,1.5-7.8,2.2h0s0,0-.1,0ZM698.5,388.5c-.3,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.3.2-.5.4-.6,2.5-.8,5.1-1.6,7.7-2.4.3,0,.6,0,.8.4,0,.3,0,.6-.4.8-2.5.8-5.1,1.6-7.8,2.4,0,0-.1,0-.2,0ZM713.9,383.6c-.3,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.3.2-.5.4-.6,2.7-.9,5.2-1.7,7.7-2.5.3-.1.7,0,.8.4.1.3,0,.7-.4.8-2.6.9-5.1,1.7-7.6,2.5h0c0,0-.1,0-.2,0ZM729.3,378.5c-.2,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.2.2-.5.4-.6,2.5-.9,5.1-1.8,7.6-2.7.3-.1.7,0,.8.4,0,.1,0,.3,0,.5,0,.1-.2.3-.3.3-2.4.9-5,1.8-7.5,2.7h-.1c0,0-.1,0-.2,0ZM744.5,372.9c-.2,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.2.1-.5.4-.6,2.6-1,5.1-2,7.5-2.9.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.4,1-4.9,1.9-7.6,2.9h0c0,0-.1,0-.2,0ZM759.6,367c-.2,0-.5-.1-.6-.4,0,0,0-.1,0-.2,0-.2.1-.4.3-.5h0s0,0,0,0c2.5-1,5-2,7.4-3.1.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.4,1-5,2.1-7.5,3.1h0s0,0,0,0c0,0-.1,0-.2,0ZM774.5,360.8c-.2,0-.5-.1-.5-.4,0,0,0-.1,0-.2,0-.2.1-.5.4-.6,2.4-1,4.9-2.1,7.4-3.3.3-.1.7,0,.8.3,0,.1,0,.3,0,.5,0,.2-.2.3-.3.3-2.4,1.1-4.9,2.2-7.4,3.3,0,0-.2,0-.2,0ZM789.3,354.1c-.2,0-.5-.1-.5-.4,0,0,0-.2,0-.3,0-.2.2-.4.4-.5,2.4-1.1,4.8-2.2,7.3-3.4.3-.1.7,0,.8.3.1.3,0,.7-.3.8-2.5,1.2-4.9,2.3-7.3,3.4h0c0,0-.2,0-.2,0ZM804,347.2c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2,0-.3.2-.5h0,.2c0,0,0,0,0-.1,2.3-1.2,4.8-2.4,7.2-3.6.3-.1.7,0,.8.3.2.3,0,.7-.3.8-2.4,1.2-4.8,2.4-7.2,3.6,0,0-.2,0-.3,0ZM818.4,339.8c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.2,4.7-2.5,7.1-3.8.3-.1.7,0,.8.2,0,.1.1.3,0,.5,0,.1-.1.3-.3.4-2.3,1.3-4.7,2.6-7.1,3.8,0,0-.2,0-.3,0ZM832.6,332.1c-.2,0-.4-.1-.5-.3,0,0,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.3,4.7-2.6,7-4,.3-.2.7,0,.8.2,0,.1.1.3,0,.4,0,.2-.1.3-.3.4-2.3,1.4-4.7,2.7-7,4,0,0-.2,0-.3,0ZM846.7,324c-.2,0-.4-.1-.5-.3,0-.1,0-.2,0-.3,0-.2.1-.4.3-.5,2.3-1.4,4.7-2.8,6.9-4.2.3-.2.7,0,.8.2,0,.1.1.3,0,.5,0,.1-.1.3-.3.4-2.3,1.4-4.6,2.8-6.9,4.2h0c0,0-.2,0-.3,0ZM860.5,315.5c-.2,0-.4-.1-.5-.3,0-.1,0-.2-.1-.3,0-.2.1-.4.3-.5,2.3-1.4,4.6-2.9,6.8-4.4.3-.2.7-.1.8.2,0,.1.1.3,0,.4,0,.2-.1.3-.3.4-2.2,1.4-4.5,2.9-6.7,4.3h-.1c-.1.2-.2.2-.3.2Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.2,305.1c-.2,0-.4,0-.5-.3-.2-.3,0-.7.2-.8,1.8-1.2,3.7-2.5,5.4-3.8l.7,1c-1.8,1.3-3.7,2.7-5.5,3.8,0,0-.2,0-.3,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.3,447.8s0,0,0,0c-4.1-.7-6.5-1.2-6.5-1.2-.3,0-.5-.4-.5-.7,0-.3.4-.5.7-.5,0,0,2.4.5,6.5,1.2.3,0,.6.4.5.7,0,.3-.3.5-.6.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.2,460.3c-1.2,0-2.3,0-3.5,0s-.3,0-.4-.2c-.1-.1-.2-.3-.2-.4,0-.3.3-.6.6-.6h0c2.5,0,5,0,8.2,0,.3,0,.6.3.6.6s0,.3-.2.4c-.1.1-.3.2-.4.2-1.5,0-3,0-4.7,0ZM639.5,460.2h0c-2.6,0-5.2,0-8.2-.2-.3,0-.6-.3-.6-.6h0c0-.4.3-.6.6-.6h0c2.7,0,5.5.1,8.2.2.2,0,.3,0,.4.2.1.1.2.3.2.4,0,.3-.3.6-.6.6ZM664.1,460.2h0c-.3,0-.6-.3-.6-.6s0-.3.2-.4c.1-.1.3-.2.4-.2,2.7,0,5.4-.1,8.2-.2h0c.3,0,.6.2.6.6s-.2.6-.6.6c-2.7,0-5.4.1-8.2.2ZM623.1,459.8h0c-2.8-.1-5.6-.2-8.2-.3-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h.1c2.7.1,5.4.2,8.1.3.3,0,.6.3.6.6,0,.3-.3.6-.6.6ZM680.5,459.7c-.3,0-.6-.2-.6-.6,0,0,0,0,0,0,0-.3.3-.6.6-.6,2.7-.1,5.5-.3,8.2-.4.3,0,.6.2.6.6,0,.2,0,.3-.1.4-.1.1-.2.2-.4.2-2.8.2-5.5.3-8.2.4h0ZM606.7,459.1h0c-2.5-.1-5.2-.3-8.2-.5-.3,0-.6-.3-.6-.6h0c0-.4.3-.6.6-.6,2.7.2,5.4.3,8.2.5.3,0,.6.3.6.6,0,.3-.3.6-.6.6ZM696.8,458.8h0c-.3,0-.6-.2-.6-.6h0c0-.3.2-.6.5-.6,2.7-.2,5.4-.4,8.2-.6.3,0,.6.2.7.5,0,.2,0,.3-.1.4-.1.1-.2.2-.4.2-2.7.2-5.5.5-8.2.7h0ZM590.3,458h0c-3-.2-5.7-.4-8.1-.6h0c-.3,0-.5-.3-.5-.6h0c0-.4.3-.6.6-.6,2.7.2,5.4.4,8.2.6.3,0,.6.3.6.6,0,.3-.3.6-.6.6ZM713.2,457.3c-.3,0-.6-.2-.6-.5h0c0-.4.2-.6.5-.7,2.6-.3,5.3-.6,8.1-.9.3,0,.6.2.7.5,0,.3-.2.6-.5.7-2.6.3-5.4.6-8.2.9h0ZM574,456.7h0c-2.7-.2-5.5-.5-8.2-.8-.3,0-.5-.3-.5-.6h0c0-.4.2-.6.5-.6h0s.1,0,.1,0c0,0,0,0,0,0,2.8.3,5.5.5,8.1.8.2,0,.3,0,.4.2.1.1.1.3.1.4,0,.3-.3.5-.6.5ZM729.5,455.3h0c-.3,0-.6-.2-.6-.5h0c0-.4.2-.6.5-.7,2.7-.4,5.4-.8,8.1-1.2.3,0,.6.2.7.5,0,.2,0,.3-.1.4,0,.1-.2.2-.4.2-2.6.4-5.4.9-8.1,1.2h0ZM557.7,455.1s0,0,0,0c-2.8-.3-5.5-.6-8.1-.9h0c-.3,0-.5-.3-.5-.6s0,0,0,0c0-.3.3-.6.7-.5,2.8.3,5.5.6,8.1.9.2,0,.3,0,.4.2.1.1.1.3.1.4,0,.3-.3.5-.6.5ZM541.4,453.3h0c-2.8-.3-5.5-.7-8.1-1-.3,0-.5-.3-.5-.6,0,0,0,0,0,0,0-.3.3-.6.7-.5,2.5.3,5.3.7,8.1,1,.2,0,.3,0,.4.2.1.1.1.3.1.4,0,.3-.3.5-.6.5ZM745.7,452.7c-.3,0-.5-.2-.6-.5,0,0,0,0,0-.1,0-.3.2-.5.5-.6,2.7-.5,5.4-1,8-1.6.3,0,.6.1.7.5,0,.3-.1.6-.5.7-2.6.5-5.3,1.1-8.1,1.6,0,0,0,0-.1,0ZM525.1,451.1h0c-2.7-.4-5.4-.8-8.1-1.2h0s0,0,0,0c-.3,0-.5-.3-.5-.6s0,0,0,0c0-.3.4-.6.7-.5h0s0,0,0,0c2.5.4,5.2.8,8.1,1.2.3,0,.6.3.5.7,0,.3-.3.5-.6.5ZM761.7,449.2c-.3,0-.5-.2-.6-.5,0,0,0-.1,0-.2,0-.3.2-.5.5-.6,2.7-.6,5.3-1.3,7.9-2,.3,0,.6,0,.7.4,0,.3-.1.7-.4.7-2.6.7-5.3,1.4-8,2,0,0,0,0-.1,0ZM777.5,445c-.3,0-.5-.2-.6-.4,0,0,0-.1,0-.2,0-.3.2-.5.4-.6,1.4-.4,2.8-.9,4.1-1.3.3-.1.7,0,.8.4,0,.2,0,.3,0,.5,0,.1-.2.2-.3.3-1.3.4-2.8.9-4.1,1.3,0,0-.1,0-.2,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.1,441.5c-.2,0-.5-.1-.6-.4-.1-.3,0-.7.3-.8.8-.3,1.7-.6,2.5-.9,1.3-.5,2.5-.9,3.7-1.4.3-.1.7,0,.8.3.1.3,0,.7-.3.8-1.2.5-2.4,1-3.7,1.4-.8.3-1.6.6-2.4.9,0,0-.1,0-.2,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.5,475.3c0,0-.1,0-.2,0-4.2-1.3-6.3-2-6.3-2-.3,0-.5-.4-.4-.8,0-.3.4-.5.8-.4,0,0,2.2.7,6.3,2,.3.1.5.4.4.8,0,.3-.3.4-.6.4Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.5,506.3h-1.5c-.2,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4,0-.3.3-.6.6-.6h1.5c2.4,0,4.5,0,6.5,0,.3,0,.6.3.6.6,0,.3-.3.6-.6.6-2.2,0-4.3,0-6.5,0ZM710.2,506.3h0c-2.6,0-5.2,0-7.9-.1-.3,0-.6-.3-.6-.6h0c0-.4.3-.6.6-.6,2.6,0,5.3,0,7.9.1.3,0,.6.3.6.6,0,.3-.3.6-.6.6ZM733.9,506.2h0c-.3,0-.6-.3-.6-.6,0-.2,0-.3.2-.4.1-.1.3-.2.4-.2,2.5,0,5.2-.1,7.9-.2h0c.3,0,.6.3.6.6,0,.3-.2.6-.6.6-2.7,0-5.4.1-7.9.2ZM694.4,506h0c-2.7,0-5.4-.2-7.9-.2-.3,0-.6-.3-.6-.6h0c0-.4.3-.6.6-.6h0c2.8.1,5.4.2,7.9.2.2,0,.3,0,.4.2.1.1.2.3.2.4,0,.3-.3.6-.6.6ZM749.7,505.8h0c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c2.6,0,5.2-.2,7.9-.3.3,0,.6.2.6.6,0,.2,0,.3-.2.4-.1.1-.2.2-.4.2-2.5.1-5.1.2-7.9.3h0ZM678.6,505.4h0c-2.7-.1-5.4-.2-7.9-.4-.3,0-.6-.3-.6-.6h0c0-.4.3-.6.6-.6,2.6.1,5.3.3,7.9.4.2,0,.3,0,.4.2.1.1.2.3.2.4,0,.3-.3.6-.6.6ZM765.5,505.2c-.3,0-.6-.2-.6-.6h0c0-.3.2-.6.6-.6,2.5-.1,5.1-.3,7.9-.4.3,0,.6.2.6.6,0,.2,0,.3-.2.4,0,.1-.2.2-.4.2-2.7.2-5.3.3-7.9.4h0ZM662.8,504.6h0c-2.6-.2-5.2-.3-7.9-.5h0c-.3,0-.6-.3-.6-.6h0c0-.4.3-.7.6-.6,2.3.2,4.8.3,7.9.5.2,0,.3,0,.4.2.1.1.2.3.1.4,0,.3-.3.6-.6.6ZM781.3,504.3c-.3,0-.6-.2-.6-.5h0c0-.4.2-.6.6-.6,2.9-.2,5.5-.4,7.9-.6.3,0,.6.2.6.5,0,.3-.2.6-.5.7-2.6.2-5.3.4-7.9.6h0ZM647.1,503.5h0c-2.9-.2-5.5-.5-7.9-.7h0c-.3,0-.6-.3-.6-.6h0c0-.4.3-.6.7-.6,2.7.2,5.3.4,7.9.6.3,0,.6.3.5.6,0,.3-.3.6-.6.6ZM797,503.1c-.3,0-.6-.2-.6-.5h0c0-.4.2-.6.5-.7,2.4-.2,5-.4,7.9-.7.4,0,.6.2.7.5,0,.2,0,.3-.1.4,0,.1-.2.2-.4.2-2.4.2-5,.5-7.8.7h0s0,0,0,0ZM631.3,502.1h0c-2.6-.2-5.2-.5-7.9-.8-.3,0-.5-.3-.5-.6h0c0-.4.3-.6.7-.6,2.5.3,5.1.5,7.9.8.2,0,.3,0,.4.2,0,.1.1.3.1.4,0,.3-.3.5-.6.5ZM812.7,501.6c-.3,0-.6-.2-.6-.5,0,0,0,0,0,0,0-.3.2-.6.5-.6,2.8-.3,5.3-.6,7.9-.8.3,0,.6.2.7.5,0,.2,0,.3-.1.5,0,.1-.2.2-.4.2-2.7.3-5.4.6-7.9.8h0ZM615.6,500.5h0c-2.6-.3-5.3-.6-7.9-.9-.3,0-.5-.3-.5-.6h0c0-.4.3-.6.7-.6,2.5.3,5.2.6,7.8.9.2,0,.3,0,.4.2.1.1.2.3.1.4,0,.3-.3.5-.6.5ZM828.5,499.8h0c-.3,0-.6-.2-.6-.5h0c0-.4.2-.6.5-.7,2.8-.4,5.4-.7,7.8-1,.3,0,.6.2.7.5,0,.3-.2.6-.5.7-2.5.3-5.2.7-7.8,1h0ZM599.9,498.6h0c-2.8-.4-5.4-.7-7.8-1.1h0c-.3,0-.5-.3-.5-.6s0,0,0,0c0-.3.3-.6.7-.5,2.8.4,5.3.7,7.8,1.1.2,0,.3,0,.4.2.1.1.1.3.1.4,0,.3-.3.5-.6.5ZM844.1,497.8c-.3,0-.6-.2-.6-.5,0,0,0,0,0,0,0-.3.2-.5.5-.6,2.6-.4,5.2-.7,7.8-1.1.3,0,.6.2.7.5,0,.3-.2.6-.5.7-2.6.4-5.2.8-7.8,1.1h0s0,0,0,0ZM584.3,496.4s0,0,0,0c-2.7-.4-5.4-.8-7.8-1.2-.3,0-.5-.3-.5-.6s0,0,0,0c0-.3.4-.5.7-.5,2.5.4,5.1.8,7.8,1.2.2,0,.3.1.4.2.1.1.1.3.1.5,0,.3-.3.5-.6.5ZM859.8,495.5c-.3,0-.5-.2-.6-.5h0c0-.4.2-.6.5-.7,2.5-.4,5-.8,7.8-1.2.3,0,.6.2.7.5,0,.3-.2.6-.5.7-2.6.4-5.2.8-7.8,1.3h0ZM568.7,493.9s0,0-.1,0c-2.7-.5-5.3-.9-7.8-1.3h0c-.3,0-.5-.3-.4-.6h0c0-.4.4-.6.7-.6,2.6.5,5.3.9,7.8,1.4.3,0,.5.4.5.7,0,.3-.3.5-.6.5ZM875.3,492.9c-.3,0-.5-.2-.6-.5,0,0,0,0,0,0,0-.3.2-.6.5-.6,2.8-.5,5.3-.9,7.8-1.4.3,0,.6.2.7.5,0,.2,0,.3,0,.5s-.2.2-.4.2c-2.5.5-5,.9-7.8,1.4,0,0,0,0-.1,0ZM553.1,491.1s0,0-.1,0c-2.6-.5-5.2-1-7.8-1.5-.3,0-.5-.3-.5-.6,0,0,0,0,0-.1,0-.3.4-.5.7-.5h0c2.4.5,5,1,7.7,1.5.2,0,.3.1.4.2,0,.1.1.3,0,.5,0,.3-.3.5-.6.5ZM537.6,488.1s0,0-.1,0c-2.5-.5-5.1-1.1-7.7-1.7-.3,0-.5-.3-.5-.6s0,0,0-.1c0-.3.4-.5.7-.5,2.4.5,5,1.1,7.7,1.7.3,0,.5.4.5.7,0,.3-.3.5-.6.5ZM522.2,484.7s0,0-.1,0c-2.6-.6-5.1-1.2-7.7-1.8-.3,0-.5-.3-.5-.6,0,0,0,0,0-.1,0-.3.4-.5.7-.4,2.5.6,5.1,1.2,7.7,1.8.3,0,.5.4.4.7,0,.3-.3.5-.6.5ZM506.8,480.9c0,0-.1,0-.2,0-2.5-.6-5.1-1.3-7.6-2h-.4c0-.1.2-.1.2-.1-.2-.1-.2-.3-.2-.5s0-.1,0-.2c0-.3.4-.5.7-.4h0c2.5.7,5.1,1.4,7.6,2,.3,0,.5.4.4.7,0,.3-.3.4-.6.4Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.3,489.7c-.3,0-.5-.2-.6-.5,0-.3.1-.6.5-.7,1.1-.3,2.2-.5,3.3-.7,1.1-.2,2.1-.4,3.2-.7.3,0,.6.1.7.5,0,.3-.1.6-.5.7-1.1.3-2.2.5-3.3.7-1.1.2-2.1.4-3.2.7,0,0,0,0-.1,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.7,503.1c-.1,0-.3,0-.4-.1-.3-.2-.3-.6,0-.8,2.7-3.3,4.3-5,4.4-5,.2-.2.6-.2.8,0,.2.2.2.6,0,.8s-1.7,1.7-4.3,4.9c-.1.1-.3.2-.5.2Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,587.2h0c-.3,0-.6-.3-.6-.6,0-2.8.2-5.6.3-8.3h0c0-.3.3-.6.6-.6.3,0,.6.3.6.6s0,0,0,0c-.1,2.7-.3,5.5-.3,8.3,0,.3-.3.6-.6.6ZM355.2,570.6h0c-.3,0-.6-.3-.5-.7.3-2.8.6-5.5,1-8.3,0-.3.3-.6.7-.5.3,0,.5.3.5.6h0c-.4,2.8-.7,5.5-1,8.3,0,.3-.3.5-.6.5ZM357.5,554.1s0,0-.1,0c-.3,0-.5-.4-.5-.7.5-2.8,1.1-5.5,1.7-8.2,0-.3.4-.5.7-.5.3,0,.5.3.5.6,0,0,0,0,0,.1-.6,2.7-1.2,5.4-1.7,8.1,0,.3-.3.5-.6.5ZM361.3,538c0,0-.1,0-.2,0-.3,0-.5-.4-.4-.8.8-2.7,1.6-5.4,2.6-7.9.1-.3.5-.5.8-.4.2,0,.4.3.4.6s0,.1,0,.2h0s0,0,0,0c-.9,2.6-1.8,5.2-2.5,7.8,0,.2-.3.4-.6.4ZM366.9,522.4c0,0-.2,0-.2,0-.1,0-.3-.2-.3-.3,0-.2,0-.3,0-.5,1.1-2.6,2.3-5.1,3.6-7.5v-.2c.1,0,.1,0,.1,0,.2-.2.5-.2.7-.1.2.1.3.3.3.5,0,0,0,.2,0,.3h0s0,0,0,0c-1.2,2.4-2.4,4.9-3.5,7.5-.1.2-.3.4-.6.4Z",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,602.5c-.3,0-.6-.2-.6-.6-.2-2.4-.2-4.6-.2-6.7s.3-.6.6-.6.6.3.6.6c0,2.1,0,4.3.2,6.6,0,.3-.2.6-.6.6,0,0,0,0,0,0Z",
    fill: "#405a8e",
    strokeWidth: 0
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "575.1 271.5 574.5 271.7 574.5 271.5 575.1 271.5",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "576.6 271.5 574.5 272.1 574.5 271.7 575.1 271.5 576.6 271.5",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.1 271.5 574.5 272.6 574.5 272.1 576.6 271.5 578.1 271.5",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.7 271.5 574.5 273 574.5 272.6 578.1 271.5 579.7 271.5",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.2 271.5 574.5 273.5 574.5 273 579.7 271.5 581.2 271.5",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 271.7 574.5 273.9 574.5 273.5 581.2 271.5 582 271.5 582 271.7",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 272.2 574.5 274.3 574.5 273.9 582 271.7 582 272.2",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 272.6 574.5 274.8 574.5 274.3 582 272.2 582 272.6",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 273.1 574.5 275.2 574.5 274.8 582 272.6 582 273.1",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 273.5 574.5 275.7 574.5 275.2 582 273.1 582 273.5",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 274 574.5 276.1 574.5 275.7 582 273.5 582 274",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 274.4 574.5 276.6 574.5 276.1 582 274 582 274.4",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 274.8 574.5 277 574.5 276.6 582 274.4 582 274.8",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 275.3 574.5 277.4 574.5 277 582 274.8 582 275.3",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 275.7 574.5 277.9 574.5 277.4 582 275.3 582 275.7",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 276.3 575.9 278 574.5 278 574.5 277.9 582 275.7 582 276.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 276.8 577.7 278 575.9 278 582 276.3 582 276.8",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 277.3 579.6 278 577.7 278 582 276.8 582 277.3",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582 277.9 581.4 278 579.6 278 582 277.3 582 277.9",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.4 278 582 277.9 582 278 581.4 278",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "572 267 571.2 267.3 571.2 267 572 267",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "573.6 267 571.2 267.7 571.2 267.3 572 267 573.6 267",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "575.3 267 571.2 268.2 571.2 267.7 573.6 267 575.3 267",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "576.8 267 571.2 268.7 571.2 268.2 575.3 267 576.8 267",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.3 267 571.2 269.1 571.2 268.7 576.8 267 578.3 267",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.9 267 571.2 269.5 571.2 269.1 578.3 267 579.9 267",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.4 267 571.2 270 571.2 269.5 579.9 267 581.4 267",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583 267 571.2 270.4 571.2 270 581.4 267 583 267",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 267.3 571.2 270.9 571.2 270.4 583 267 583.5 267 583.5 267.3",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 267.8 571.2 271.3 571.2 270.9 583.5 267.3 583.5 267.8",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 268.2 571.2 271.8 571.2 271.3 583.5 267.8 583.5 268.2",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 268.7 571.2 272.2 571.2 271.8 583.5 268.2 583.5 268.7",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 269.1 571.2 272.6 571.2 272.2 583.5 268.7 583.5 269.1",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 269.5 571.2 273.1 571.2 272.6 583.5 269.1 583.5 269.5",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 270 571.2 273.5 571.2 273.1 583.5 269.5 583.5 270",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 270.4 571.2 274 571.2 273.5 583.5 270 583.5 270.4",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 270.9 571.2 274.4 571.2 274 583.5 270.4 583.5 270.9",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 271.3 571.2 274.9 571.2 274.4 583.5 270.9 583.5 271.3",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 271.8 571.2 275.3 571.2 274.9 583.5 271.3 583.5 271.8",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 272.2 571.2 275.7 571.2 275.3 583.5 271.8 583.5 272.2",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 272.6 571.2 276.2 571.2 275.7 583.5 272.2 583.5 272.6",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 273.1 571.2 276.6 571.2 276.2 583.5 272.6 583.5 273.1",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 273.5 571.2 277.1 571.2 276.6 583.5 273.1 583.5 273.5",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 274 571.2 277.5 571.2 277.1 583.5 273.5 583.5 274",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 274.4 571.2 278 571.2 277.5 583.5 274 583.5 274.4",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 274.9 571.2 278.4 571.2 278 583.5 274.4 583.5 274.9",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 275.3 571.2 278.8 571.2 278.4 583.5 274.9 583.5 275.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 275.8 571.3 279.4 571.2 279.4 571.2 278.8 583.5 275.3 583.5 275.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 276.4 573.1 279.4 571.3 279.4 583.5 275.8 583.5 276.4",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 276.9 575 279.4 573.1 279.4 583.5 276.4 583.5 276.9",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 277.4 576.8 279.4 575 279.4 583.5 276.9 583.5 277.4",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 278 578.7 279.4 576.8 279.4 583.5 277.4 583.5 278",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 278.5 580.5 279.4 578.7 279.4 583.5 278 583.5 278.5",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.5 279 582.3 279.4 580.5 279.4 583.5 278.5 583.5 279",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.3 279.4 583.5 279 583.5 279.4 582.3 279.4",
    fill: "#777",
    strokeWidth: 0
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "712.8 307.8 712.3 308 712.3 307.8 712.8 307.8",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.3 307.8 712.3 308.4 712.3 308 712.8 307.8 714.3 307.8",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "715.9 307.8 712.3 308.8 712.3 308.4 714.3 307.8 715.9 307.8",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "717.4 307.8 712.3 309.3 712.3 308.8 715.9 307.8 717.4 307.8",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719 307.8 712.3 309.7 712.3 309.3 717.4 307.8 719 307.8",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 308 712.3 310.2 712.3 309.7 719 307.8 719.8 307.8 719.8 308",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 308.5 712.3 310.6 712.3 310.2 719.8 308 719.8 308.5",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 308.9 712.3 311.1 712.3 310.6 719.8 308.5 719.8 308.9",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 309.3 712.3 311.5 712.3 311.1 719.8 308.9 719.8 309.3",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 309.8 712.3 311.9 712.3 311.5 719.8 309.3 719.8 309.8",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 310.2 712.3 312.4 712.3 311.9 719.8 309.8 719.8 310.2",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 310.7 712.3 312.8 712.3 312.4 719.8 310.2 719.8 310.7",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 311.1 712.3 313.3 712.3 312.8 719.8 310.7 719.8 311.1",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 311.6 712.3 313.7 712.3 313.3 719.8 311.1 719.8 311.6",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 312 712.3 314.2 712.3 313.7 719.8 311.6 719.8 312",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 312.5 713.7 314.3 712.3 314.3 712.3 314.2 719.8 312 719.8 312.5",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 313.1 715.5 314.3 713.7 314.3 719.8 312.5 719.8 313.1",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 313.6 717.3 314.3 715.5 314.3 719.8 313.1 719.8 313.6",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.8 314.1 719.2 314.3 717.3 314.3 719.8 313.6 719.8 314.1",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.2 314.3 719.8 314.1 719.8 314.3 719.2 314.3",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "709.7 303.3 709 303.5 709 303.3 709.7 303.3",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "711.4 303.3 709 304 709 303.5 709.7 303.3 711.4 303.3",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713 303.3 709 304.5 709 304 711.4 303.3 713 303.3",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.6 303.3 709 304.9 709 304.5 713 303.3 714.6 303.3",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "716.1 303.3 709 305.4 709 304.9 714.6 303.3 716.1 303.3",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "717.6 303.3 709 305.8 709 305.4 716.1 303.3 717.6 303.3",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.2 303.3 709 306.3 709 305.8 717.6 303.3 719.2 303.3",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.7 303.3 709 306.7 709 306.3 719.2 303.3 720.7 303.3",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 303.6 709 307.1 709 306.7 720.7 303.3 721.3 303.3 721.3 303.6",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 304 709 307.6 709 307.1 721.3 303.6 721.3 304",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 304.5 709 308 709 307.6 721.3 304 721.3 304.5",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 304.9 709 308.5 709 308 721.3 304.5 721.3 304.9",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 305.4 709 308.9 709 308.5 721.3 304.9 721.3 305.4",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 305.8 709 309.4 709 308.9 721.3 305.4 721.3 305.8",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 306.3 709 309.8 709 309.4 721.3 305.8 721.3 306.3",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 306.7 709 310.2 709 309.8 721.3 306.3 721.3 306.7",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 307.1 709 310.7 709 310.2 721.3 306.7 721.3 307.1",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 307.6 709 311.1 709 310.7 721.3 307.1 721.3 307.6",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 308 709 311.6 709 311.1 721.3 307.6 721.3 308",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 308.5 709 312 709 311.6 721.3 308 721.3 308.5",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 308.9 709 312.5 709 312 721.3 308.5 721.3 308.9",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 309.4 709 312.9 709 312.5 721.3 308.9 721.3 309.4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 309.8 709 313.3 709 312.9 721.3 309.4 721.3 309.8",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 310.2 709 313.8 709 313.3 721.3 309.8 721.3 310.2",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 310.7 709 314.2 709 313.8 721.3 310.2 721.3 310.7",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 311.1 709 314.7 709 314.2 721.3 310.7 721.3 311.1",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 311.6 709 315.1 709 314.7 721.3 311.1 721.3 311.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 312.1 709 315.6 709 315.6 709 315.1 721.3 311.6 721.3 312.1",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 312.6 710.9 315.6 709 315.6 721.3 312.1 721.3 312.6",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 313.2 712.7 315.6 710.9 315.6 721.3 312.6 721.3 313.2",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 313.7 714.6 315.6 712.7 315.6 721.3 313.2 721.3 313.7",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 314.2 716.4 315.6 714.6 315.6 721.3 313.7 721.3 314.2",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 314.8 718.3 315.6 716.4 315.6 721.3 314.2 721.3 314.8",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.3 315.3 720.1 315.6 718.3 315.6 721.3 314.8 721.3 315.3",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.1 315.6 721.3 315.3 721.3 315.6 720.1 315.6",
    fill: "#777",
    strokeWidth: 0
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "429.6 233.4 428.5 233.8 428.5 233.4 429.6 233.4",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.1 233.4 428.5 234.2 428.5 233.8 429.6 233.4 431.1 233.4",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.6 233.4 428.5 234.6 428.5 234.2 431.1 233.4 432.6 233.4",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.2 233.4 428.5 235.1 428.5 234.6 432.6 233.4 434.2 233.4",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.7 233.4 428.5 235.5 428.5 235.1 434.2 233.4 435.7 233.4",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 233.8 428.5 236 428.5 235.5 435.7 233.4 436 233.4 436 233.8",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 234.3 428.5 236.4 428.5 236 436 233.8 436 234.3",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 234.7 428.5 236.9 428.5 236.4 436 234.3 436 234.7",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 235.1 428.5 237.3 428.5 236.9 436 234.7 436 235.1",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 235.6 428.5 237.7 428.5 237.3 436 235.1 436 235.6",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 236 428.5 238.2 428.5 237.7 436 235.6 436 236",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 236.5 428.5 238.6 428.5 238.2 436 236 436 236.5",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 236.9 428.5 239.1 428.5 238.6 436 236.5 436 236.9",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 237.4 428.5 239.5 428.5 239.1 436 236.9 436 237.4",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 237.8 428.6 239.9 428.5 239.9 428.5 239.5 436 237.4 436 237.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 238.3 430.4 239.9 428.6 239.9 436 237.8 436 238.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 238.9 432.3 239.9 430.4 239.9 436 238.3 436 238.9",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 239.4 434.1 239.9 432.3 239.9 436 238.9 436 239.4",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436 239.9 435.9 239.9 434.1 239.9 436 239.4 436 239.9",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.9 239.9 436 239.9 436 239.9 435.9 239.9",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.5 228.9 425.1 229.3 425.1 228.9 426.5 228.9",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.1 228.9 425.1 229.8 425.1 229.3 426.5 228.9 428.1 228.9",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.8 228.9 425.1 230.3 425.1 229.8 428.1 228.9 429.8 228.9",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.3 228.9 425.1 230.7 425.1 230.3 429.8 228.9 431.3 228.9",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.9 228.9 425.1 231.2 425.1 230.7 431.3 228.9 432.9 228.9",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.4 228.9 425.1 231.6 425.1 231.2 432.9 228.9 434.4 228.9",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.9 228.9 425.1 232.1 425.1 231.6 434.4 228.9 435.9 228.9",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 229 425.1 232.5 425.1 232.1 435.9 228.9 437.4 228.9 437.4 229",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 229.4 425.1 232.9 425.1 232.5 437.4 229 437.4 229.4",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 229.8 425.1 233.4 425.1 232.9 437.4 229.4 437.4 229.8",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 230.3 425.1 233.8 425.1 233.4 437.4 229.8 437.4 230.3",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 230.7 425.1 234.3 425.1 233.8 437.4 230.3 437.4 230.7",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 231.2 425.1 234.7 425.1 234.3 437.4 230.7 437.4 231.2",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 231.6 425.1 235.2 425.1 234.7 437.4 231.2 437.4 231.6",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 232.1 425.1 235.6 425.1 235.2 437.4 231.6 437.4 232.1",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 232.5 425.1 236 425.1 235.6 437.4 232.1 437.4 232.5",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 232.9 425.1 236.5 425.1 236 437.4 232.5 437.4 232.9",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 233.4 425.1 236.9 425.1 236.5 437.4 232.9 437.4 233.4",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 233.8 425.1 237.4 425.1 236.9 437.4 233.4 437.4 233.8",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 234.3 425.1 237.8 425.1 237.4 437.4 233.8 437.4 234.3",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 234.7 425.1 238.3 425.1 237.8 437.4 234.3 437.4 234.7",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 235.2 425.1 238.7 425.1 238.3 437.4 234.7 437.4 235.2",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 235.6 425.1 239.1 425.1 238.7 437.4 235.2 437.4 235.6",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 236 425.1 239.6 425.1 239.1 437.4 235.6 437.4 236",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 236.5 425.1 240 425.1 239.6 437.4 236 437.4 236.5",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 236.9 425.1 240.5 425.1 240 437.4 236.5 437.4 236.9",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 237.4 425.1 240.9 425.1 240.5 437.4 236.9 437.4 237.4",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 237.9 425.8 241.3 425.1 241.3 425.1 240.9 437.4 237.4 437.4 237.9",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 238.4 427.6 241.3 425.8 241.3 437.4 237.9 437.4 238.4",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 239 429.5 241.3 427.6 241.3 437.4 238.4 437.4 239",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 239.5 431.3 241.3 429.5 241.3 437.4 239 437.4 239.5",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 240 433.2 241.3 431.3 241.3 437.4 239.5 437.4 240",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 240.6 435 241.3 433.2 241.3 437.4 240 437.4 240.6",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.4 241.1 436.9 241.3 435 241.3 437.4 240.6 437.4 241.1",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.9 241.3 437.4 241.1 437.4 241.3 436.9 241.3",
    fill: "#777",
    strokeWidth: 0
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "558.1 171.7 557.1 172 557.1 171.7 558.1 171.7",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.6 171.7 557.1 172.5 557.1 172 558.1 171.7 559.6 171.7",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.1 171.7 557.1 172.9 557.1 172.5 559.6 171.7 561.1 171.7",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.6 171.7 557.1 173.4 557.1 172.9 561.1 171.7 562.6 171.7",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.1 171.7 557.1 173.8 557.1 173.4 562.6 171.7 564.1 171.7",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 172 557.1 174.2 557.1 173.8 564.1 171.7 564.6 171.7 564.6 172",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 172.5 557.1 174.7 557.1 174.2 564.6 172 564.6 172.5",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 172.9 557.1 175.1 557.1 174.7 564.6 172.5 564.6 172.9",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 173.4 557.1 175.6 557.1 175.1 564.6 172.9 564.6 173.4",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 173.8 557.1 176 557.1 175.6 564.6 173.4 564.6 173.8",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 174.3 557.1 176.5 557.1 176 564.6 173.8 564.6 174.3",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 174.7 557.1 176.9 557.1 176.5 564.6 174.3 564.6 174.7",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 175.1 557.1 177.4 557.1 176.9 564.6 174.7 564.6 175.1",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 175.6 557.1 177.8 557.1 177.4 564.6 175.1 564.6 175.6",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 176 557.2 178.2 557.1 178.2 557.1 177.8 564.6 175.6 564.6 176",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 176.6 559 178.2 557.2 178.2 564.6 176 564.6 176.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 177.1 560.8 178.2 559 178.2 564.6 176.6 564.6 177.1",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 177.6 562.6 178.2 560.8 178.2 564.6 177.1 564.6 177.6",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.6 178.2 564.4 178.2 562.6 178.2 564.6 177.6 564.6 178.2",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.4 178.2 564.6 178.2 564.6 178.2 564.4 178.2",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555 167.2 553.6 167.7 553.6 167.2 555 167.2",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "556.6 167.2 553.6 168.1 553.6 167.7 555 167.2 556.6 167.2",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.2 167.2 553.6 168.6 553.6 168.1 556.6 167.2 558.2 167.2",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.7 167.2 553.6 169.1 553.6 168.6 558.2 167.2 559.7 167.2",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.2 167.2 553.6 169.5 553.6 169.1 559.7 167.2 561.2 167.2",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.7 167.2 553.6 169.9 553.6 169.5 561.2 167.2 562.7 167.2",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "564.2 167.2 553.6 170.4 553.6 169.9 562.7 167.2 564.2 167.2",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.7 167.2 553.6 170.8 553.6 170.4 564.2 167.2 565.7 167.2",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 167.6 553.6 171.3 553.6 170.8 565.7 167.2 565.9 167.2 565.9 167.6",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 168.1 553.6 171.7 553.6 171.3 565.9 167.6 565.9 168.1",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 168.5 553.6 172.2 553.6 171.7 565.9 168.1 565.9 168.5",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 169 553.6 172.6 553.6 172.2 565.9 168.5 565.9 169",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 169.4 553.6 173.1 553.6 172.6 565.9 169 565.9 169.4",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 169.9 553.6 173.5 553.6 173.1 565.9 169.4 565.9 169.9",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 170.3 553.6 173.9 553.6 173.5 565.9 169.9 565.9 170.3",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 170.7 553.6 174.4 553.6 173.9 565.9 170.3 565.9 170.7",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 171.2 553.6 174.8 553.6 174.4 565.9 170.7 565.9 171.2",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 171.6 553.6 175.3 553.6 174.8 565.9 171.2 565.9 171.6",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 172.1 553.6 175.7 553.6 175.3 565.9 171.6 565.9 172.1",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 172.5 553.6 176.2 553.6 175.7 565.9 172.1 565.9 172.5",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 173 553.6 176.6 553.6 176.2 565.9 172.5 565.9 173",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 173.4 553.6 177.1 553.6 176.6 565.9 173 565.9 173.4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 173.9 553.6 177.5 553.6 177.1 565.9 173.4 565.9 173.9",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 174.3 553.6 178 553.6 177.5 565.9 173.9 565.9 174.3",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 174.7 553.6 178.4 553.6 178 565.9 174.3 565.9 174.7",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 175.2 553.6 178.8 553.6 178.4 565.9 174.7 565.9 175.2",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 175.6 553.6 179.3 553.6 178.8 565.9 175.2 565.9 175.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 176.2 554.5 179.5 553.6 179.5 553.6 179.3 565.9 175.6 565.9 176.2",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 176.7 556.3 179.5 554.5 179.5 565.9 176.2 565.9 176.7",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 177.2 558.1 179.5 556.3 179.5 565.9 176.7 565.9 177.2",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 177.8 559.9 179.5 558.1 179.5 565.9 177.2 565.9 177.8",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 178.3 561.7 179.5 559.9 179.5 565.9 177.8 565.9 178.3",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 178.8 563.5 179.5 561.7 179.5 565.9 178.3 565.9 178.8",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.9 179.4 565.3 179.5 563.5 179.5 565.9 178.8 565.9 179.4",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.3 179.5 565.9 179.4 565.9 179.5 565.3 179.5",
    fill: "#777",
    strokeWidth: 0
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.4 177.5 367.9 177.7 367.9 177.5 368.4 177.5",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370 177.5 367.9 178.1 367.9 177.7 368.4 177.5 370 177.5",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.5 177.5 367.9 178.6 367.9 178.1 370 177.5 371.5 177.5",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373 177.5 367.9 179 367.9 178.6 371.5 177.5 373 177.5",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.6 177.5 367.9 179.5 367.9 179 373 177.5 374.6 177.5",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 177.7 367.9 179.9 367.9 179.5 374.6 177.5 375.4 177.5 375.4 177.7",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 178.2 367.9 180.3 367.9 179.9 375.4 177.7 375.4 178.2",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 178.6 367.9 180.8 367.9 180.3 375.4 178.2 375.4 178.6",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 179.1 367.9 181.2 367.9 180.8 375.4 178.6 375.4 179.1",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 179.5 367.9 181.7 367.9 181.2 375.4 179.1 375.4 179.5",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 180 367.9 182.1 367.9 181.7 375.4 179.5 375.4 180",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 180.4 367.9 182.6 367.9 182.1 375.4 180 375.4 180.4",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 180.8 367.9 183 367.9 182.6 375.4 180.4 375.4 180.8",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 181.3 367.9 183.4 367.9 183 375.4 180.8 375.4 181.3",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 181.7 367.9 183.9 367.9 183.4 375.4 181.3 375.4 181.7",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 182.3 369.3 184 367.9 184 367.9 183.9 375.4 181.7 375.4 182.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 182.8 371.1 184 369.3 184 375.4 182.3 375.4 182.8",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 183.3 373 184 371.1 184 375.4 182.8 375.4 183.3",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 183.9 374.8 184 373 184 375.4 183.3 375.4 183.9",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.8 184 375.4 183.9 375.4 184 374.8 184",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.4 173 364.6 173.3 364.6 173 365.4 173",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 173 364.6 173.7 364.6 173.3 365.4 173 367 173",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.6 173 364.6 174.2 364.6 173.7 367 173 368.6 173",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.2 173 364.6 174.7 364.6 174.2 368.6 173 370.2 173",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.7 173 364.6 175.1 364.6 174.7 370.2 173 371.7 173",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.3 173 364.6 175.5 364.6 175.1 371.7 173 373.3 173",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.8 173 364.6 176 364.6 175.5 373.3 173 374.8 173",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.3 173 364.6 176.4 364.6 176 374.8 173 376.3 173",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 173.3 364.6 176.9 364.6 176.4 376.3 173 376.9 173 376.9 173.3",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 173.8 364.6 177.3 364.6 176.9 376.9 173.3 376.9 173.8",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 174.2 364.6 177.8 364.6 177.3 376.9 173.8 376.9 174.2",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 174.7 364.6 178.2 364.6 177.8 376.9 174.2 376.9 174.7",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 175.1 364.6 178.6 364.6 178.2 376.9 174.7 376.9 175.1",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 175.5 364.6 179.1 364.6 178.6 376.9 175.1 376.9 175.5",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 176 364.6 179.5 364.6 179.1 376.9 175.5 376.9 176",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 176.4 364.6 180 364.6 179.5 376.9 176 376.9 176.4",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 176.9 364.6 180.4 364.6 180 376.9 176.4 376.9 176.9",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 177.3 364.6 180.9 364.6 180.4 376.9 176.9 376.9 177.3",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 177.8 364.6 181.3 364.6 180.9 376.9 177.3 376.9 177.8",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 178.2 364.6 181.7 364.6 181.3 376.9 177.8 376.9 178.2",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 178.6 364.6 182.2 364.6 181.7 376.9 178.2 376.9 178.6",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 179.1 364.6 182.6 364.6 182.2 376.9 178.6 376.9 179.1",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 179.5 364.6 183.1 364.6 182.6 376.9 179.1 376.9 179.5",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 180 364.6 183.5 364.6 183.1 376.9 179.5 376.9 180",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 180.4 364.6 184 364.6 183.5 376.9 180 376.9 180.4",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 180.9 364.6 184.4 364.6 184 376.9 180.4 376.9 180.9",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 181.3 364.6 184.9 364.6 184.4 376.9 180.9 376.9 181.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 181.8 364.7 185.4 364.6 185.4 364.6 184.9 376.9 181.3 376.9 181.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 182.4 366.5 185.4 364.7 185.4 376.9 181.8 376.9 182.4",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 182.9 368.3 185.4 366.5 185.4 376.9 182.4 376.9 182.9",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 183.4 370.2 185.4 368.3 185.4 376.9 182.9 376.9 183.4",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 184 372 185.4 370.2 185.4 376.9 183.4 376.9 184",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 184.5 373.9 185.4 372 185.4 376.9 184 376.9 184.5",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 185 375.7 185.4 373.9 185.4 376.9 184.5 376.9 185",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.7 185.4 376.9 185 376.9 185.4 375.7 185.4",
    fill: "#777",
    strokeWidth: 0
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "793.6 348.2 792.5 348.5 792.5 348.2 793.6 348.2",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "795.1 348.2 792.5 349 792.5 348.5 793.6 348.2 795.1 348.2",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "796.6 348.2 792.5 349.4 792.5 349 795.1 348.2 796.6 348.2",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "798.2 348.2 792.5 349.9 792.5 349.4 796.6 348.2 798.2 348.2",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "799.7 348.2 792.5 350.3 792.5 349.9 798.2 348.2 799.7 348.2",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 348.6 792.5 350.8 792.5 350.3 799.7 348.2 800 348.2 800 348.6",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 349 792.5 351.2 792.5 350.8 800 348.6 800 349",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 349.5 792.5 351.6 792.5 351.2 800 349 800 349.5",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 349.9 792.5 352.1 792.5 351.6 800 349.5 800 349.9",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 350.4 792.5 352.5 792.5 352.1 800 349.9 800 350.4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 350.8 792.5 353 792.5 352.5 800 350.4 800 350.8",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 351.3 792.5 353.4 792.5 353 800 350.8 800 351.3",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 351.7 792.5 353.9 792.5 353.4 800 351.3 800 351.7",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 352.1 792.5 354.3 792.5 353.9 800 351.7 800 352.1",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 352.6 792.6 354.7 792.5 354.7 792.5 354.3 800 352.1 800 352.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 353.1 794.4 354.7 792.6 354.7 800 352.6 800 353.1",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 353.7 796.3 354.7 794.4 354.7 800 353.1 800 353.7",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 354.2 798.1 354.7 796.3 354.7 800 353.7 800 354.2",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 354.7 800 354.7 798.1 354.7 800 354.2 800 354.7",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800 354.7 800 354.7 800 354.7 800 354.7",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "790.5 343.7 789.1 344.1 789.1 343.7 790.5 343.7",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "792.1 343.7 789.1 344.6 789.1 344.1 790.5 343.7 792.1 343.7",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "793.8 343.7 789.1 345.1 789.1 344.6 792.1 343.7 793.8 343.7",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "795.3 343.7 789.1 345.5 789.1 345.1 793.8 343.7 795.3 343.7",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "796.9 343.7 789.1 346 789.1 345.5 795.3 343.7 796.9 343.7",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "798.4 343.7 789.1 346.4 789.1 346 796.9 343.7 798.4 343.7",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "799.9 343.7 789.1 346.8 789.1 346.4 798.4 343.7 799.9 343.7",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 343.7 789.1 347.3 789.1 346.8 799.9 343.7 801.5 343.7 801.5 343.7",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 344.2 789.1 347.7 789.1 347.3 801.5 343.7 801.5 344.2",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 344.6 789.1 348.2 789.1 347.7 801.5 344.2 801.5 344.6",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 345.1 789.1 348.6 789.1 348.2 801.5 344.6 801.5 345.1",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 345.5 789.1 349.1 789.1 348.6 801.5 345.1 801.5 345.5",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 346 789.1 349.5 789.1 349.1 801.5 345.5 801.5 346",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 346.4 789.1 350 789.1 349.5 801.5 346 801.5 346.4",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 346.8 789.1 350.4 789.1 350 801.5 346.4 801.5 346.8",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 347.3 789.1 350.8 789.1 350.4 801.5 346.8 801.5 347.3",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 347.7 789.1 351.3 789.1 350.8 801.5 347.3 801.5 347.7",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 348.2 789.1 351.7 789.1 351.3 801.5 347.7 801.5 348.2",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 348.6 789.1 352.2 789.1 351.7 801.5 348.2 801.5 348.6",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 349.1 789.1 352.6 789.1 352.2 801.5 348.6 801.5 349.1",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 349.5 789.1 353.1 789.1 352.6 801.5 349.1 801.5 349.5",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 349.9 789.1 353.5 789.1 353.1 801.5 349.5 801.5 349.9",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 350.4 789.1 353.9 789.1 353.5 801.5 349.9 801.5 350.4",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 350.8 789.1 354.4 789.1 353.9 801.5 350.4 801.5 350.8",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 351.3 789.1 354.8 789.1 354.4 801.5 350.8 801.5 351.3",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 351.7 789.1 355.3 789.1 354.8 801.5 351.3 801.5 351.7",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 352.2 789.1 355.7 789.1 355.3 801.5 351.7 801.5 352.2",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 352.7 789.8 356.1 789.1 356.1 789.1 355.7 801.5 352.2 801.5 352.7",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 353.2 791.6 356.1 789.8 356.1 801.5 352.7 801.5 353.2",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 353.8 793.5 356.1 791.6 356.1 801.5 353.2 801.5 353.8",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 354.3 795.3 356.1 793.5 356.1 801.5 353.8 801.5 354.3",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 354.8 797.2 356.1 795.3 356.1 801.5 354.3 801.5 354.8",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 355.4 799 356.1 797.2 356.1 801.5 354.8 801.5 355.4",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "801.5 355.9 800.9 356.1 799 356.1 801.5 355.4 801.5 355.9",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "800.9 356.1 801.5 355.9 801.5 356.1 800.9 356.1",
    fill: "#777",
    strokeWidth: 0
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "662.3 458 661.9 458.2 661.9 458 662.3 458",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.8 458 661.9 458.6 661.9 458.2 662.3 458 663.8 458",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.3 458 661.9 459.1 661.9 458.6 663.8 458 665.3 458",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "666.8 458 661.9 459.5 661.9 459.1 665.3 458 666.8 458",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.3 458 661.9 460 661.9 459.5 666.8 458 668.3 458",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 458.2 661.9 460.4 661.9 460 668.3 458 669.4 458 669.4 458.2",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 458.6 661.9 460.8 661.9 460.4 669.4 458.2 669.4 458.6",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 459.1 661.9 461.3 661.9 460.8 669.4 458.6 669.4 459.1",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 459.5 661.9 461.7 661.9 461.3 669.4 459.1 669.4 459.5",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 460 661.9 462.2 661.9 461.7 669.4 459.5 669.4 460",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 460.4 661.9 462.6 661.9 462.2 669.4 460 669.4 460.4",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 460.8 661.9 463.1 661.9 462.6 669.4 460.4 669.4 460.8",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 461.3 661.9 463.5 661.9 463.1 669.4 460.8 669.4 461.3",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 461.7 661.9 464 661.9 463.5 669.4 461.3 669.4 461.7",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 462.2 661.9 464.4 661.9 464 669.4 461.7 669.4 462.2",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 462.7 663.3 464.5 661.9 464.5 661.9 464.4 669.4 462.2 669.4 462.7",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 463.2 665.1 464.5 663.3 464.5 669.4 462.7 669.4 463.2",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 463.8 666.9 464.5 665.1 464.5 669.4 463.2 669.4 463.8",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.4 464.3 668.7 464.5 666.9 464.5 669.4 463.8 669.4 464.3",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.7 464.5 669.4 464.3 669.4 464.5 668.7 464.5",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.3 453.5 658.4 453.8 658.4 453.5 659.3 453.5",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660.9 453.5 658.4 454.3 658.4 453.8 659.3 453.5 660.9 453.5",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.5 453.5 658.4 454.8 658.4 454.3 660.9 453.5 662.5 453.5",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664 453.5 658.4 455.2 658.4 454.8 662.5 453.5 664 453.5",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.5 453.5 658.4 455.6 658.4 455.2 664 453.5 665.5 453.5",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "667 453.5 658.4 456.1 658.4 455.6 665.5 453.5 667 453.5",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.5 453.5 658.4 456.5 658.4 456.1 667 453.5 668.5 453.5",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670 453.5 658.4 457 658.4 456.5 668.5 453.5 670 453.5",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 453.8 658.4 457.4 658.4 457 670 453.5 670.7 453.5 670.7 453.8",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 454.2 658.4 457.9 658.4 457.4 670.7 453.8 670.7 454.2",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 454.7 658.4 458.3 658.4 457.9 670.7 454.2 670.7 454.7",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 455.1 658.4 458.8 658.4 458.3 670.7 454.7 670.7 455.1",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 455.6 658.4 459.2 658.4 458.8 670.7 455.1 670.7 455.6",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 456 658.4 459.7 658.4 459.2 670.7 455.6 670.7 456",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 456.4 658.4 460.1 658.4 459.7 670.7 456 670.7 456.4",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 456.9 658.4 460.5 658.4 460.1 670.7 456.4 670.7 456.9",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 457.3 658.4 461 658.4 460.5 670.7 456.9 670.7 457.3",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 457.8 658.4 461.4 658.4 461 670.7 457.3 670.7 457.8",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 458.2 658.4 461.9 658.4 461.4 670.7 457.8 670.7 458.2",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 458.7 658.4 462.3 658.4 461.9 670.7 458.2 670.7 458.7",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 459.1 658.4 462.8 658.4 462.3 670.7 458.7 670.7 459.1",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 459.6 658.4 463.2 658.4 462.8 670.7 459.1 670.7 459.6",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 460 658.4 463.7 658.4 463.2 670.7 459.6 670.7 460",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 460.5 658.4 464.1 658.4 463.7 670.7 460 670.7 460.5",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 460.9 658.4 464.5 658.4 464.1 670.7 460.5 670.7 460.9",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 461.3 658.4 465 658.4 464.5 670.7 460.9 670.7 461.3",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 461.8 658.4 465.4 658.4 465 670.7 461.3 670.7 461.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 462.3 658.8 465.9 658.4 465.9 658.4 465.4 670.7 461.8 670.7 462.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 462.9 660.6 465.9 658.8 465.9 670.7 462.3 670.7 462.9",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 463.4 662.4 465.9 660.6 465.9 670.7 462.9 670.7 463.4",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 463.9 664.2 465.9 662.4 465.9 670.7 463.4 670.7 463.9",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 464.5 666 465.9 664.2 465.9 670.7 463.9 670.7 464.5",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 465 667.8 465.9 666 465.9 670.7 464.5 670.7 465",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.7 465.5 669.6 465.9 667.8 465.9 670.7 465 670.7 465.5",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.6 465.9 670.7 465.5 670.7 465.9 669.6 465.9",
    fill: "#777",
    strokeWidth: 0
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "813.4 499.1 812.9 499.3 812.9 499.1 813.4 499.1",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.9 499.1 812.9 499.7 812.9 499.3 813.4 499.1 814.9 499.1",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "816.4 499.1 812.9 500.2 812.9 499.7 814.9 499.1 816.4 499.1",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.9 499.1 812.9 500.6 812.9 500.2 816.4 499.1 817.9 499.1",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "819.4 499.1 812.9 501 812.9 500.6 817.9 499.1 819.4 499.1",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 499.3 812.9 501.5 812.9 501 819.4 499.1 820.4 499.1 820.4 499.3",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 499.7 812.9 501.9 812.9 501.5 820.4 499.3 820.4 499.7",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 500.2 812.9 502.4 812.9 501.9 820.4 499.7 820.4 500.2",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 500.6 812.9 502.8 812.9 502.4 820.4 500.2 820.4 500.6",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 501 812.9 503.3 812.9 502.8 820.4 500.6 820.4 501",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 501.5 812.9 503.7 812.9 503.3 820.4 501 820.4 501.5",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 501.9 812.9 504.2 812.9 503.7 820.4 501.5 820.4 501.9",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 502.4 812.9 504.6 812.9 504.2 820.4 501.9 820.4 502.4",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 502.8 812.9 505 812.9 504.6 820.4 502.4 820.4 502.8",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 503.3 812.9 505.5 812.9 505 820.4 502.8 820.4 503.3",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 503.8 814.3 505.6 812.9 505.6 812.9 505.5 820.4 503.3 820.4 503.8",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 504.3 816.1 505.6 814.3 505.6 820.4 503.8 820.4 504.3",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 504.9 817.9 505.6 816.1 505.6 820.4 504.3 820.4 504.9",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.4 505.4 819.7 505.6 817.9 505.6 820.4 504.9 820.4 505.4",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "819.7 505.6 820.4 505.4 820.4 505.6 819.7 505.6",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "810.9 494.5 809.4 494.9 809.4 494.5 810.9 494.5",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "812.5 494.5 809.4 495.4 809.4 494.9 810.9 494.5 812.5 494.5",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.1 494.5 809.4 495.9 809.4 495.4 812.5 494.5 814.1 494.5",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "815.6 494.5 809.4 496.3 809.4 495.9 814.1 494.5 815.6 494.5",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "817.1 494.5 809.4 496.7 809.4 496.3 815.6 494.5 817.1 494.5",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "818.6 494.5 809.4 497.2 809.4 496.7 817.1 494.5 818.6 494.5",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820.1 494.5 809.4 497.6 809.4 497.2 818.6 494.5 820.1 494.5",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.6 494.5 809.4 498.1 809.4 497.6 820.1 494.5 821.6 494.5",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 494.9 809.4 498.5 809.4 498.1 821.6 494.5 821.8 494.5 821.8 494.9",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 495.3 809.4 499 809.4 498.5 821.8 494.9 821.8 495.3",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 495.8 809.4 499.4 809.4 499 821.8 495.3 821.8 495.8",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 496.2 809.4 499.9 809.4 499.4 821.8 495.8 821.8 496.2",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 496.7 809.4 500.3 809.4 499.9 821.8 496.2 821.8 496.7",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 497.1 809.4 500.7 809.4 500.3 821.8 496.7 821.8 497.1",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 497.5 809.4 501.2 809.4 500.7 821.8 497.1 821.8 497.5",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 498 809.4 501.6 809.4 501.2 821.8 497.5 821.8 498",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 498.4 809.4 502.1 809.4 501.6 821.8 498 821.8 498.4",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 498.9 809.4 502.5 809.4 502.1 821.8 498.4 821.8 498.9",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 499.3 809.4 503 809.4 502.5 821.8 498.9 821.8 499.3",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 499.8 809.4 503.4 809.4 503 821.8 499.3 821.8 499.8",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 500.2 809.4 503.9 809.4 503.4 821.8 499.8 821.8 500.2",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 500.7 809.4 504.3 809.4 503.9 821.8 500.2 821.8 500.7",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 501.1 809.4 504.8 809.4 504.3 821.8 500.7 821.8 501.1",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 501.5 809.4 505.2 809.4 504.8 821.8 501.1 821.8 501.5",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 502 809.4 505.6 809.4 505.2 821.8 501.5 821.8 502",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 502.4 809.4 506.1 809.4 505.6 821.8 502 821.8 502.4",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 502.9 809.4 506.5 809.4 506.1 821.8 502.4 821.8 502.9",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 503.4 810.4 506.8 809.4 506.8 809.4 506.5 821.8 502.9 821.8 503.4",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 503.9 812.2 506.8 810.4 506.8 821.8 503.4 821.8 503.9",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 504.5 814 506.8 812.2 506.8 821.8 503.9 821.8 504.5",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 505 815.8 506.8 814 506.8 821.8 504.5 821.8 505",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 505.5 817.6 506.8 815.8 506.8 821.8 505 821.8 505.5",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 506.1 819.4 506.8 817.6 506.8 821.8 505.5 821.8 506.1",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.8 506.6 821.2 506.8 819.4 506.8 821.8 506.1 821.8 506.6",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.2 506.8 821.8 506.6 821.8 506.8 821.2 506.8",
    fill: "#777",
    strokeWidth: 0
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.8 531.2 360.8 531.6 360.8 531.2 361.8 531.2",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.4 531.2 360.8 532 360.8 531.6 361.8 531.2 363.4 531.2",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.9 531.2 360.8 532.4 360.8 532 363.4 531.2 364.9 531.2",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.5 531.2 360.8 532.9 360.8 532.4 364.9 531.2 366.5 531.2",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368 531.2 360.8 533.3 360.8 532.9 366.5 531.2 368 531.2",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 531.6 360.8 533.8 360.8 533.3 368 531.2 368.2 531.2 368.2 531.6",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 532.1 360.8 534.2 360.8 533.8 368.2 531.6 368.2 532.1",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 532.5 360.8 534.7 360.8 534.2 368.2 532.1 368.2 532.5",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 532.9 360.8 535.1 360.8 534.7 368.2 532.5 368.2 532.9",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 533.4 360.8 535.5 360.8 535.1 368.2 532.9 368.2 533.4",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 533.8 360.8 536 360.8 535.5 368.2 533.4 368.2 533.8",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 534.3 360.8 536.4 360.8 536 368.2 533.8 368.2 534.3",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 534.7 360.8 536.9 360.8 536.4 368.2 534.3 368.2 534.7",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 535.2 360.8 537.3 360.8 536.9 368.2 534.7 368.2 535.2",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 535.6 360.9 537.7 360.8 537.7 360.8 537.3 368.2 535.2 368.2 535.6",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 536.1 362.7 537.7 360.9 537.7 368.2 535.6 368.2 536.1",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 536.7 364.5 537.7 362.7 537.7 368.2 536.1 368.2 536.7",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 537.2 366.4 537.7 364.5 537.7 368.2 536.7 368.2 537.2",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 537.7 368.2 537.7 366.4 537.7 368.2 537.2 368.2 537.7",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 537.7 368.2 537.7 368.2 537.7 368.2 537.7",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.8 526.7 357.3 527.2 357.3 526.7 358.8 526.7",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.4 526.7 357.3 527.7 357.3 527.2 358.8 526.7 360.4 526.7",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.1 526.7 357.3 528.1 357.3 527.7 360.4 526.7 362.1 526.7",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.6 526.7 357.3 528.6 357.3 528.1 362.1 526.7 363.6 526.7",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 526.7 357.3 529 357.3 528.6 363.6 526.7 365.1 526.7",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.7 526.7 357.3 529.5 357.3 529 365.1 526.7 366.7 526.7",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 526.7 357.3 529.9 357.3 529.5 366.7 526.7 368.2 526.7",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 526.8 357.3 530.3 357.3 529.9 368.2 526.7 369.6 526.7 369.6 526.8",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 527.2 357.3 530.8 357.3 530.3 369.6 526.8 369.6 527.2",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 527.7 357.3 531.2 357.3 530.8 369.6 527.2 369.6 527.7",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 528.1 357.3 531.7 357.3 531.2 369.6 527.7 369.6 528.1",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 528.6 357.3 532.1 357.3 531.7 369.6 528.1 369.6 528.6",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 529 357.3 532.6 357.3 532.1 369.6 528.6 369.6 529",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 529.5 357.3 533 357.3 532.6 369.6 529 369.6 529.5",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 529.9 357.3 533.4 357.3 533 369.6 529.5 369.6 529.9",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 530.3 357.3 533.9 357.3 533.4 369.6 529.9 369.6 530.3",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 530.8 357.3 534.3 357.3 533.9 369.6 530.3 369.6 530.8",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 531.2 357.3 534.8 357.3 534.3 369.6 530.8 369.6 531.2",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 531.7 357.3 535.2 357.3 534.8 369.6 531.2 369.6 531.7",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 532.1 357.3 535.7 357.3 535.2 369.6 531.7 369.6 532.1",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 532.6 357.3 536.1 357.3 535.7 369.6 532.1 369.6 532.6",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 533 357.3 536.5 357.3 536.1 369.6 532.6 369.6 533",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 533.4 357.3 537 357.3 536.5 369.6 533 369.6 533.4",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 533.9 357.3 537.4 357.3 537 369.6 533.4 369.6 533.9",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 534.3 357.3 537.9 357.3 537.4 369.6 533.9 369.6 534.3",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 534.8 357.3 538.3 357.3 537.9 369.6 534.3 369.6 534.8",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 535.2 357.3 538.8 357.3 538.3 369.6 534.8 369.6 535.2",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 535.7 358.1 539.1 357.3 539.1 357.3 538.8 369.6 535.2 369.6 535.7",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 536.3 359.9 539.1 358.1 539.1 369.6 535.7 369.6 536.3",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 536.8 361.8 539.1 359.9 539.1 369.6 536.3 369.6 536.8",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 537.3 363.6 539.1 361.8 539.1 369.6 536.8 369.6 537.3",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 537.9 365.5 539.1 363.6 539.1 369.6 537.3 369.6 537.9",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 538.4 367.3 539.1 365.5 539.1 369.6 537.9 369.6 538.4",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 538.9 369.1 539.1 367.3 539.1 369.6 538.4 369.6 538.9",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.1 539.1 369.6 538.9 369.6 539.1 369.1 539.1",
    fill: "#777",
    strokeWidth: 0
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "777.2 165.6 776.5 165.8 776.5 165.6 777.2 165.6",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "778.8 165.6 776.5 166.2 776.5 165.8 777.2 165.6 778.8 165.6",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "780.4 165.6 776.5 166.7 776.5 166.2 778.8 165.6 780.4 165.6",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "781.9 165.6 776.5 167.1 776.5 166.7 780.4 165.6 781.9 165.6",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "783.5 165.6 776.5 167.6 776.5 167.1 781.9 165.6 783.5 165.6",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 165.9 776.5 168 776.5 167.6 783.5 165.6 784 165.6 784 165.9",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 166.3 776.5 168.5 776.5 168 784 165.9 784 166.3",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 166.8 776.5 168.9 776.5 168.5 784 166.3 784 166.8",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 167.2 776.5 169.3 776.5 168.9 784 166.8 784 167.2",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 167.7 776.5 169.8 776.5 169.3 784 167.2 784 167.7",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 168.1 776.5 170.2 776.5 169.8 784 167.7 784 168.1",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 168.5 776.5 170.7 776.5 170.2 784 168.1 784 168.5",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 169 776.5 171.1 776.5 170.7 784 168.5 784 169",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 169.4 776.5 171.6 776.5 171.1 784 169 784 169.4",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 169.9 776.5 172 776.5 171.6 784 169.4 784 169.9",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 170.4 778.3 172.1 776.5 172.1 776.5 172 784 169.9 784 170.4",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 171 780.1 172.1 778.3 172.1 784 170.4 784 171",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 171.5 782 172.1 780.1 172.1 784 171 784 171.5",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784 172 783.9 172.1 782 172.1 784 171.5 784 172",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "783.9 172.1 784 172 784 172.1 783.9 172.1",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "774 161.1 773.2 161.3 773.2 161.1 774 161.1",
    fill: "#555",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "775.7 161.1 773.2 161.8 773.2 161.3 774 161.1 775.7 161.1",
    fill: "#565656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "777.4 161.1 773.2 162.3 773.2 161.8 775.7 161.1 777.4 161.1",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "778.9 161.1 773.2 162.7 773.2 162.3 777.4 161.1 778.9 161.1",
    fill: "#575757",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "780.5 161.1 773.2 163.2 773.2 162.7 778.9 161.1 780.5 161.1",
    fill: "#585858",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "782 161.1 773.2 163.6 773.2 163.2 780.5 161.1 782 161.1",
    fill: "#595959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "783.6 161.1 773.2 164 773.2 163.6 782 161.1 783.6 161.1",
    fill: "#5a5a5a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.2 161.1 773.2 164.5 773.2 164 783.6 161.1 785.2 161.1",
    fill: "#5b5b5b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 161.4 773.2 164.9 773.2 164.5 785.2 161.1 785.5 161.1 785.5 161.4",
    fill: "#5c5c5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 161.9 773.2 165.4 773.2 164.9 785.5 161.4 785.5 161.9",
    fill: "#5d5d5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 162.3 773.2 165.8 773.2 165.4 785.5 161.9 785.5 162.3",
    fill: "#5e5e5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 162.8 773.2 166.3 773.2 165.8 785.5 162.3 785.5 162.8",
    fill: "#5f5f5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 163.2 773.2 166.7 773.2 166.3 785.5 162.8 785.5 163.2",
    fill: "#606060",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 163.7 773.2 167.2 773.2 166.7 785.5 163.2 785.5 163.7",
    fill: "#616161",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 164.1 773.2 167.6 773.2 167.2 785.5 163.7 785.5 164.1",
    fill: "#626262",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 164.5 773.2 168.1 773.2 167.6 785.5 164.1 785.5 164.5",
    fill: "#646464",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 165 773.2 168.5 773.2 168.1 785.5 164.5 785.5 165",
    fill: "#656565",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 165.4 773.2 169 773.2 168.5 785.5 165 785.5 165.4",
    fill: "#666",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 165.9 773.2 169.4 773.2 169 785.5 165.4 785.5 165.9",
    fill: "#676767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 166.3 773.2 169.8 773.2 169.4 785.5 165.9 785.5 166.3",
    fill: "#686868",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 166.8 773.2 170.3 773.2 169.8 785.5 166.3 785.5 166.8",
    fill: "#696969",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 167.2 773.2 170.7 773.2 170.3 785.5 166.8 785.5 167.2",
    fill: "#6a6a6a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 167.7 773.2 171.2 773.2 170.7 785.5 167.2 785.5 167.7",
    fill: "#6b6b6b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 168.1 773.2 171.6 773.2 171.2 785.5 167.7 785.5 168.1",
    fill: "#6c6c6c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 168.6 773.2 172.1 773.2 171.6 785.5 168.1 785.5 168.6",
    fill: "#6d6d6d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 169 773.2 172.5 773.2 172.1 785.5 168.6 785.5 169",
    fill: "#6e6e6e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 169.5 773.2 173 773.2 172.5 785.5 169 785.5 169.5",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 170 773.6 173.4 773.2 173.4 773.2 173 785.5 169.5 785.5 170",
    fill: "#6f6f6f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 170.5 775.5 173.4 773.6 173.4 785.5 170 785.5 170.5",
    fill: "#707070",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 171.1 777.4 173.4 775.5 173.4 785.5 170.5 785.5 171.1",
    fill: "#717171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 171.6 779.2 173.4 777.4 173.4 785.5 171.1 785.5 171.6",
    fill: "#727272",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 172.1 781.1 173.4 779.2 173.4 785.5 171.6 785.5 172.1",
    fill: "#737373",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 172.7 783 173.4 781.1 173.4 785.5 172.1 785.5 172.7",
    fill: "#747474",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.5 173.2 784.9 173.4 783 173.4 785.5 172.7 785.5 173.2",
    fill: "#767676",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "784.9 173.4 785.5 173.2 785.5 173.4 784.9 173.4",
    fill: "#777",
    strokeWidth: 0
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M354.4,673.9c-18.2,0-33.1-14.8-33.1-33.1s14.8-33.1,33.1-33.1,33.1,14.8,33.1,33.1-14.8,33.1-33.1,33.1ZM354.4,609.4c-17.4,0-31.5,14.1-31.5,31.5s14.1,31.5,31.5,31.5,31.5-14.1,31.5-31.5-14.1-31.5-31.5-31.5Z",
    fill: "#405a8e",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 410.5,
    cy: 85,
    r: 32.3,
    fill: "#73dcf4",
    strokeWidth: 0
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.8,109.8s-.2-.2-.7-.5c0,0-.2,0-.3-.3,0,0-.3-.3-.5-.3-.3-.3-.8-.7-1.2-1s-.8-.8-1.2-1.3c-.5-.5-.8-1-1.2-1.5-.2-.3-.3-.5-.5-.8-.2-.3-.3-.5-.5-.8,0-.3-.3-.7-.5-1,0-.3-.3-.7-.5-1,0-.3-.3-.7-.3-1s-.2-.7-.3-1c0-.3-.2-.7-.3-1,0-.3,0-.7-.2-1v-5.2c0-.5,0-.8.2-1.2.2-.7.7-2.2.7-2.2l5,1.3s-.5,1.5-.5,1.8v4.2c0,.2,0,.5.2.7,0,.2,0,.5.2.7,0,.2.2.5.3.7,0,.2.2.5.3.7l.3.7c0,.2.3.3.3.5s.3.3.5.5c0,.2.3.3.5.5l.8.8c.3.3.7.5.8.7.3.2.5.3.7.5,0,0,.2,0,.3.2,0,0,.3,0,.3.2.5.3.7.3.7.3l-4,6.2.5.2Z",
    fill: "#d3e8e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,59.1h0c-12.1-3.2-24.8,5.8-27.1,20.1-2,1.2-4.3,2-7,2.8-.5,0-.8.3-1,.7,0,.5.2,1,.7,1.2.2,0,4.7,1.2,7.8,1.5l15.3,1.2c.7,0,1.2,0,1.8.3l9.6,2.8c1.3.3,2.7,1.2,3.8,2.2l3,2.7c1,.8,2,1.5,3.2,1.8l7.8,2.2h.3c.5,0,.8-.3,1-.7,0-.5,0-1-.7-1.2h-.3l1.2-4.5c3.8-14.5-4.8-29.4-19.3-33.3l-.2.2Z",
    fill: "#f87043",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,81.9c.7-2,1.5-4,2.7-5.8,2.8-4.5,6.7-6.3,11-5.3,1.3-3.8,2.7-7.5,4-11.3-.5-.2-1.2-.3-1.7-.5h0c-12.1-3.2-24.8,5.7-27.1,20.1,3.7.8,7.5,1.8,11.1,2.7v.2Z",
    fill: "#ff8b4a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.6,94h0c-.3,0-.5-.5-.5-.8l.5-2c1.7-6,.7-12.3-2.5-17.6s-8.2-9.3-14.1-10.8c-1.3-.3-2.7-.5-4-.5-8.2,0-15.5,6.3-18,15.5,0,.3-.5.5-.8.5s-.5-.5-.5-.8c2.5-9.6,10.3-16.5,19.1-16.5s2.8.2,4.3.5c6.3,1.7,11.6,5.7,15,11.5,3.3,5.7,4.2,12.3,2.5,18.6l-.5,2c0,.3-.3.5-.7.5h.2Z",
    fill: "#d65b28",
    strokeWidth: 0
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 393,
    cy: 116.3,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,123.5c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM393,111.2c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.9,
    cy: 153.6,
    r: 32.3,
    fill: "#b0ffa4",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 673.7,
    cy: 86,
    r: 32.3,
    fill: "#d5abff",
    strokeWidth: 0
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 678.3,
    cy: 191.5,
    r: 32.3,
    fill: "#ffcc81",
    strokeWidth: 0
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 900.8,
    cy: 161.1,
    r: 32.3,
    fill: "#fd5d5d",
    strokeWidth: 0
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 838.9,
    cy: 63.2,
    r: 32.3,
    fill: "#8f9aca",
    strokeWidth: 0
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.1,
    cy: 279.9,
    r: 32.3,
    fill: "#c6f06d",
    strokeWidth: 0
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.6,
    cy: 427.1,
    r: 32.3,
    fill: "#ffea94",
    strokeWidth: 0
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 929.2,
    cy: 473.7,
    r: 32.3,
    fill: "#a4adff",
    strokeWidth: 0
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M694.2,85.2c-2.8-5.8-4.2-12.3-3.8-20.3v-.7h-9.3v.7c-.5,4.2-2.2,7.8-5.3,11.1-.8.8-1.3,1.8-1.8,2.8-.3-1-1-2-1.8-2.8-3.2-3.3-4.8-7-5.3-11.1v-.7h-9.6v.7c.3,7.8-1,14.5-3.8,20.3h0v22.6h41.3v-22.5h0l-.3-.2Z",
    fill: "#ffaa31",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.2,85.2c-2.8-5.8-4.2-12.3-3.8-20.3v-.7h-9.5v.7c-.5,4.2-2.2,7.8-5.3,11.1-.7.8-1.3,1.7-1.7,2.7v29.1h20.5v-22.5h0l-.2-.2Z",
    fill: "#fd8520",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "691.8 84.7 694 84.7 693.3 83.4 692.5 81.2 692.3 80.6 691.2 80.6 686.2 80.6 686.2 65.4 686.2 64.2 685 64.2 683 64.2 681.8 64.2 681.8 65.4 681.8 80.6 665.5 80.6 665.5 65.4 665.5 64.2 664.4 64.2 662.4 64.2 661.2 64.2 661.2 65.4 661.2 80.6 656.2 80.6 655.1 80.6 654.9 81.2 654.1 83.4 653.4 84.7 655.6 84.7 691.8 84.7",
    fill: "#dbede0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.1,
    y: 90.5,
    width: 41.3,
    height: 4.2,
    fill: "#dbede0",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M673.7,67.2c-3.2,0-5.8-.7-7-1.7.5,3.8,2.2,7.3,5.2,10.5.8.8,1.3,1.8,1.8,2.8.3-1,1-2,1.8-2.8,3-3.2,4.7-6.7,5.2-10.5-1.2,1-3.8,1.7-7,1.7Z",
    fill: "#af3232",
    strokeWidth: 0
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 642.6,
    cy: 100,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.6,107.2c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM642.6,94.9c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M934.9,288.7c-2.7,1.7-14.3.8-18.6-.8-5.7-2.2-19-2.5-19-2.5v6.2s.8.2,3,.3v-.7h1.8v.8h3.5v-.7h1.8v.7h2.3v-2.5c4.2.3,5.8,1.5,9.2,2.2v-1c.2,0,1.8.2,1.8.2v1.2h3.5v-1.2h1.8v1.2h3.5v-1.3h1.8v1.2c2,0,3.5-.5,3.7-1.3v-2.3h-.2v.5Z",
    fill: "#753a21",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.7,284.3c-1.5-3.2-9.5-2.3-12.8-5.3-2.7-2.3-5.8-6.2-5.7-10.5v-4.8h-15.8s-1.5,8.2-1.7,8.2c-.5,3.2-2.2,6-1.2,13.3,0,0,12.6.5,19.8,3,3.8,1.3,17,2,17.5,0,0-.7.3-2.7-.3-4l.2.2Z",
    fill: "#e19143",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.8,263.9h-12.3c-1,0-2,.8-2,2v3.3c0,1,.8,2,2,2h12l.5-7.2-.2-.2Z",
    fill: "#b16f45",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M924.7,292c-2.7,1.7-14.3.8-18.6-.8-5.7-2.2-19-2.5-19-2.5v6.2s.8.2,3,.3v-.7h1.8v.8h3.5v-.7h1.8v.7h2.3v-2.5c4.2.3,5.8,1.5,9.2,2.2v-1c.2,0,1.8.2,1.8.2v1.2h3.5v-1.2h1.8v1.2h3.5v-1.3h1.8v1.2c2,0,3.5-.5,3.7-1.3v-2.3h-.2v.5Z",
    fill: "#8b5232",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.6,287.8c-1.5-3.2-9.5-2.3-12.8-5.3-2.7-2.3-5.8-6.2-5.7-10.5v-4.8h-15.8s-1.5,8.2-1.7,8.2c-.5,3.2-2.2,6-1.2,13.3,0,0,12.6.5,19.8,3,3.8,1.3,17,2,17.5,0,0-.7.3-2.7-.3-4l.2.2Z",
    fill: "#f0ae43",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.6,267.4h-12.3c-1,0-2,.8-2,2v3.3c0,1,.8,2,2,2h12l.5-7.2-.2-.2Z",
    fill: "#bb7b5d",
    strokeWidth: 0
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 883.3,
    cy: 299,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.3,306.1c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM883.3,293.8c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M504.5,141.6l-2.3,7h0l-6.8,20.3-16.6-5.7,6.5-18.8h0l3.8-11.1c.3-1,1.3-1.5,2.3-1.2h.5c1,.5,1.5,1.5,1.2,2.5l-3.3,9.8.8.3h0l3.8-11.1c.3-1,1.3-1.5,2.3-1.2h0c1,.3,1.5,1.3,1.2,2.3l-3.8,11.1h0l1,.3,3.5-10.1c.3-1,1.3-1.5,2.3-1.2h0c1,.3,1.5,1.3,1.2,2.3l-3.5,10.1.8.3,2.3-7c.3-.8,1.3-1.3,2.2-1.2h0c.5.3,1.2,1.3.8,2.2l-.2-.2ZM495.8,170.4h0c0-.2-18.8-6.5-18.8-6.5h0c-.7,2.3.5,4.7,2.7,5.5l11,3.7c2.2.7,4.5-.5,5.3-2.7h-.2Z",
    fill: "#985a4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.4,160.7l10.5-9.3c.8-.8.8-2,0-2.8l-.7-.7c-.8-.8-2-.8-2.8,0l-3.8,3.7-3.3,9.2h.2Z",
    fill: "#bd9872",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M482.7,139.1l-3.8,11.3h0l-6.3,18.8-15.6-5.3,5.5-16h0l1.3-3.7v-.7c.2,0,2.7-7,2.7-7,.3-.8,1.3-1.3,2.2-1h0c.8.3,1.3,1.3,1,2.2l-2.3,7h.7c0,.2,3.5-10,3.5-10,.3-1,1.3-1.5,2.2-1.2h0c1,.3,1.5,1.3,1.2,2.3l-3.5,10.3h.5c0,.2.2.2.2.2l3.8-11.3c.3-.8,1.3-1.3,2.2-1.2h0c.8.3,1.3,1.3,1.2,2.2l-3.8,11.3h.7c0,.2,3.3-9.6,3.3-9.6.3-.8,1.3-1.3,2.2-1.2h0c.8.3,1.3,1.3,1.2,2.3l.2.2ZM454.6,167.4c-.2.7,0,1.5.8,1.7l15.1,5.2c.7.2,1.5,0,1.7-.8l1-2.8-17.6-6-1,2.8Z",
    fill: "#b38961",
    strokeWidth: 0
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "glass"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M831.1,48.8c0,.3-.3.7-.7.7h-4.2c-.3,0-.8,0-1,.5l-4.7,8-2.5,4.2c-.3.5-.8,1-1.3,1.5l-4.8,3.7c0-.3,0-.7-.2-1.2v-2.7c.2-.2,2-2.5,4.2-5.3.5-.7,1-1.3,1.7-2,2.8-3.7,5.8-7.5,6.3-8.2h0l7,.2h0v.5h0l.2.2Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.1,48.8h0l-5.3-.3c-.3,0-.5,0-.7.3l-5.7,9-2.2,3.7c-.2.3-.5.7-.8.8l-4.8,3.7v-4.2c.3-.3,1.5-1.8,3-3.7,3-3.5,7.2-8.7,8.7-10.5.3-.3.8-.7,1.3-.7h5.8c.3.2.5.3.5.7h0v.8l.2.3Z",
    fill: "#263248",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M866.3,63.2v3.8l-2.8-2.2-2-1.5h0c-.5-.5-1-.8-1.2-1.3h0l-2.3-4-4.8-8c-.2-.3-.5-.5-1-.5h-4.2c-.3,0-.7,0-.7-.5h0v-.3h6.8v-.2h0c.5.7,3.5,4.3,6.3,8,.5.7,1.2,1.5,1.7,2.2,2.2,2.8,4,5,4.2,5.2h0v-.7Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.3,63.2v2.7l-3-2.3-1.2-.8-.7-.5h0c-.3-.2-.5-.5-.7-.8l-2.2-3.5-5.7-9c0-.2-.3-.3-.7-.3l-5.3.3h0v-.5h0c0-.5.2-.7.5-.7h5.8c.5-.2,1,0,1.3.3,1.5,1.7,5.7,6.8,8.7,10.5,1.5,1.8,2.7,3.2,3,3.5v1.5h0v-.3Z",
    fill: "#263248",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.3,63.9v3.2h0c-.7,3-2.2,5.8-4.3,8-.5.5-1,1-1.7,1.5-.5.5-1.5,1.2-2.7,1.7h-.3c-.2,0-.5,0-.7.2-.7.2-1.3.3-2.2.3-1.3.2-3.3.3-5.7,0-1-.3-1.8-.5-2.7-1-1.5-1-2.3-2.7-2.5-3.3-.2-.5-.2-.7-.3-1.2-.7-2.2-1.7-5.2-4-5.2s-3.3,3-4,5.2c0,.5-.2.7-.3,1.2-.2.7-1,2.2-2.5,3.3-.8.5-1.5.7-2.7,1-2.3.5-4.3.3-5.7,0-.8,0-1.5-.2-2.2-.3-.2,0-.5,0-.7-.2h-.3c-1.2-.5-2.2-1.2-2.7-1.7-.5-.5-1-1-1.7-1.5-2-2-3.5-4.5-4.2-7.2,0-.2,0-.5-.2-.7,0-.3,0-.7-.2-1.2v-7.5c1,0,1.8-.2,2.8-.3h1.2c1.2,0,2.3-.2,3.7-.3h1c4.7-.3,9.6-.5,15-.7h9c4.5,0,9,.3,13.1.7h1c1.2,0,2.5.2,3.7.3h1.2c1,0,1.8.2,2.8.3v4.7h0v.7h-.3Z",
    fill: "#facb48",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M866.2,60.4c-8.2-.8-17.3-1.5-27.1-1.5s-19,.5-27.3,1.5v-2.2c7.2-.8,15.1-1.5,23.6-1.5h9c7.8.2,15,.7,21.6,1.5v2.2h.2Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M863.3,64.9c0,1,0,1.8-.2,2.5-.5,2.3-1.7,4.7-3.5,6.5-.3.5-.8.8-1.3,1.2h0c-.3.3-1,.8-2,1.2h-.2c-.2,0-.3.2-.5.2-.5,0-1,.2-1.7.3-.7,0-1.5.2-2.2.2h-1.3c-.3,0-.7,0-1-.2-1-.3-1.3-.3-1.5-.5h0c-.8-.7-1.2-1.5-1.3-1.8v-1h0c-.5-1.3-1-3.2-2.2-4.7-1-1.5-2.5-2.5-4.8-2.5-4.5,0-6.2,4.8-7,7.3v1c0,.3-.5,1.3-1.3,2-.3.2-.7.3-1.5.5-.8.2-1.5.3-2.3.3s-1.5,0-2.2-.2c-.7,0-1.2,0-1.7-.3h-.5c-.5-.3-1-.5-1.3-.8-.2,0-.5-.3-.7-.5h0c-.5-.5-.8-.8-1.2-1.2h0c-.7-.8-1.3-1.7-1.8-2.5-.7-1.2-1.3-2.3-1.7-3.5,0-.5-.2-.8-.3-1.3v-4.3c1.7,0,3.3-.3,5-.3,2.5-.2,5-.3,7.7-.5,1.7,0,3.3,0,5-.2h12c2.3,0,4.8,0,7.2.3,2.2,0,4.5.2,6.7.3,1.5,0,3,.2,4.3.3h.7v2.7l-1.3-.5Z",
    fill: "#facb48",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.4,61.4l-10.8,10.1c-.7-1.2-1.3-2.3-1.7-3.5,0-.5-.2-.8-.3-1.3l5-4.7c2.5-.2,5-.3,7.7-.5l.2-.2Z",
    fill: "#f2f6f9",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.9,61.1l-15.5,14.5c-.2,0-.5-.3-.7-.5h0c-.5-.5-.8-.8-1.2-1.2l13.8-12.8h3.7-.2Z",
    fill: "#f2f6f9",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.2,61.9l-12.3,11.5c-.5-1.3-1-3.2-2.2-4.7l7.8-7.3c2.2,0,4.5.2,6.7.3v.2Z",
    fill: "#f2f6f9",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M863.3,64.9l-13,12.1c-.3,0-.7,0-1-.2-1-.3-1.3-.3-1.5-.5h0l15.1-14h.7v2.7l-.3-.2Z",
    fill: "#f2f6f9",
    strokeWidth: 0
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "headphones"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.3,159.9h0l.3,21.3h0c1.8,0,3.5-1.2,3.5-2.7v-16c-.3-1.5-1.8-2.7-3.7-2.7h-.2Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M904.4,137.8c-1.7-.3-3.2-.3-4.3-.3s-1.7,0-2.7.3c-2.3.5-4.2,1.3-5.5,2,.3.3.5.7.8,1.2.7-.5,1.7-1,2.8-1.3,1.8-.7,3.5-.7,4.7-.7s3.5-.2,6,.7c1.2.3,2.2,1,2.8,1.3.3-.3.5-.7.8-1.2-1.2-.7-3-1.5-5.5-2h0Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.6,140.6c-2.7-1.5-4.3-2.2-5.8-2.3-.3-.3-1.7,0-1.8,0-.7,0-1.8-.3-2.3.5-1.5.2-3.5.8-5.5,2-2.5,1.3-4,3.2-4.8,4.2.5.7,1,1,1.5,1.3.5.3,1,.5,1.5.3.3-.2.5-.8.3-1.3,0-.3-.2-.5,0-.8,0-.2.3-.3.7-.3.5,0,.5.3,1,.3s.8,0,1-.5-.2-.8,0-1.2.7-.5,1-.3c.3,0,.3.3.7.5.3,0,.7,0,.8-.3.3-.3,0-.8.3-1.2s.5-.3.8-.3c.5,0,.5.5,1,.8,0,0,.5.2.8,0,.2,0,.3-.3.5-.8,0-.2.3-.3.7-.3s.7,0,.8.3c0,.5.2.7.5.8.3.2.8,0,.8,0,.5-.2.5-.7,1-.8.3,0,.7,0,.8.3.3.3,0,.8.3,1.2s.5.3.8.3.3-.3.7-.5c.3,0,.8,0,1,.3s-.2.8,0,1.2c0,.3.7.5,1,.5.5,0,.5-.3,1-.3s.5,0,.7.3v.8c0,.5,0,1.2.3,1.3.3.2,1,0,1.5-.3.3-.2,1-.5,1.5-1.3-.8-1.2-2.5-2.8-4.8-4.2l-.3-.2Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.2,154.1c-.5-.3-.8-.5-1.3-.7-.5,0-1.2-.3-2.3-.8-1.7-.7-2.7-1.2-3-1.5-.3-.3-.3-.5-.5-1,0-.3-.3-1-.8-1.8-.7-1.3-1-2.2-1.7-3-1-1.5-2-2.3-3.2-3.2-.8-.7-2.2-1.8-4-2.7-2.5-1.2-5.3-1.5-8.2-1.2h0c-1.7,0-3.3.5-4.8,1.2-1.7.8-2.8,1.7-4,2.7-1.2,1-2.2,1.8-3.2,3.2-.7.8-1,1.7-1.7,3-.5.8-.7,1.5-.8,1.8-.2.5-.3.7-.5,1-.3.3-1.3.8-3,1.5-1.2.5-1.8.7-2.3.8s-.8.3-1.3.7c-1.3.8-2.2,2.5-2.7,4.7h1.3c.3-1.7,1-3,2-3.7.3-.2.5-.3,1-.5.5,0,1.2-.3,2.3-.8,2.8-1.2,3.3-1.7,3.5-1.8.5-.5.5-.8.8-1.3,0-.3.3-1,.8-1.8.7-1.3,1-2,1.5-2.8.8-1.3,1.8-2,2.8-3,1.2-1,2.2-1.8,3.7-2.5,1.7-.7,3.5-1.2,5.3-1.2h0c1.8,0,4.3,0,6.7,1.2s2.8,1.8,3.7,2.5c1.2,1,2,1.7,2.8,3,.5.8,1,1.7,1.5,2.8.3.8.7,1.3.8,1.8.2.7.3,1,.8,1.3.2.2.7.7,3.5,1.8,1.2.5,1.8.7,2.3.8.5,0,.7.2,1,.5,1,.7,1.7,2,2,3.8h1.3c-.3-2.5-1.3-4-2.7-5l.3.2Z",
    fill: "#263248",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 920.1,
    y: 166.7,
    width: 8.2,
    height: 1.3,
    transform: "translate(589.6 1045) rotate(-79.4)",
    fill: "#ccdcff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.9,
    y: 160.7,
    width: 5.3,
    height: 0.5,
    transform: "translate(597.1 1041.1) rotate(-79.4)",
    fill: "#263248",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 925.7,
    cy: 158.9,
    r: 2,
    fill: "#ffca00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.9,159.4c-.3-.5-.2-1.2.3-1.5.5-.3,1.2-.2,1.5.3.3.5.2,1.2-.3,1.5s-1.2.2-1.5-.3Z",
    fill: "#263248",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 876.6,
    y: 163.5,
    width: 1.3,
    height: 8.2,
    transform: "translate(-15.9 164.2) rotate(-10.6)",
    fill: "#ccdcff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.7,
    y: 158.3,
    width: 0.5,
    height: 5.3,
    transform: "translate(-14.7 163.9) rotate(-10.6)",
    fill: "#263248",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M879,166.7c-2.3,0-3.5,1.8-3.5,3.8s1.2,3.7,3.5,3.7v-7.5Z",
    fill: "#263248",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.1,158.1h0c-.8,2.8-1.8,7-1.8,12.3s1.2,9.6,2.2,12.5h0c1.8,0,3.5-1.5,3.3-3.2l-.3-18.5c0-1.7-1.7-3-3.5-3l.2-.2Z",
    fill: "#263248",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.1,158.1c-7.5.2-11.3,5.7-11.1,12.5,0,6.8,4,12.1,11.5,12.1-.7-3.5-1.2-7.7-1.3-12.5,0-4.7.3-8.8,1-12.3v.2Z",
    fill: "#fdb813",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M911.1,181.2h0l-.3-21.3h0c-1.8,0-3.5,1.2-3.5,2.7v16c.3,1.5,1.8,2.7,3.7,2.7h.2Z",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.4,174.2c2.3,0,3.5-1.8,3.5-3.8s-1.2-3.7-3.5-3.7v7.5Z",
    fill: "#263248",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.3,182.9h0c.5-3.7,1-8.2.8-13.1,0-4.3-.7-8.3-1.2-11.5h0c-1.8,0-3.5,1.5-3.3,3.2l.3,18.5c0,1.7,1.7,3,3.5,3h-.2Z",
    fill: "#263248",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.3,182.9c7.5-.2,11.3-5.7,11.1-12.5,0-6.8-4-12.1-11.5-12.1.7,3.3,1.2,7.2,1.2,11.5s-.3,9.5-.8,13.1h0Z",
    fill: "#fdb813",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 875.7,
    cy: 158.9,
    r: 2,
    fill: "#ffca00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.5,159.4c.3-.5.2-1.2-.3-1.5-.5-.3-1.2-.2-1.5.3-.3.5-.2,1.2.3,1.5s1.2.2,1.5-.3Z",
    fill: "#263248",
    strokeWidth: 0
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 823.9,
    cy: 92.4,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.9,99.5c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM823.9,87.2c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 876.3,
    cy: 182.7,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.3,189.9c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM876.3,177.5c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M662.9,182.7h0v8.2h0c-1.7,0-2.8-1.3-2.8-2.8v-2.5c0-1.7,1.3-2.8,2.8-2.8Z",
    fill: "#372421",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.2,182.7h0c1.7,0,2.8,1.3,2.8,2.8v2.5c0,1.7-1.3,2.8-2.8,2.8h0v-8.2h0Z",
    fill: "#372421",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.5,169.6h-8.2c0-1.7,1.3-2.8,2.8-2.8h2.5c1.7,0,2.8,1.3,2.8,2.8Z",
    fill: "#372421",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.3,169.2h-29.4c-.8,0-1.5.7-1.5,1.5v36.3c0,3.3,2.7,6,6,6h20.6c3.3,0,6-2.7,6-6v-36.3c0-.8-.7-1.5-1.5-1.5h-.2ZM677,207.5c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5s.5.2.5.5v4.5ZM679,207.5c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5s.5.2.5.5v4.5ZM681.2,207.5c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5s.5.2.5.5v4.5Z",
    fill: "#777e79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.3,169.2h-14.8v33.3h0c.3,0,.5.2.5.5v4.5c0,.3-.2.5-.5.5s0,0,0,0v5h10.5c3.3,0,6-2.7,6-6v-36.3c0-.8-.7-1.5-1.5-1.5h-.2ZM681.2,207.5c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5s.5.2.5.5v4.5Z",
    fill: "#626664",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.2,
    y: 183.2,
    width: 26.5,
    height: 10.1,
    fill: "#52003e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.5,
    y: 183.2,
    width: 13.3,
    height: 10.1,
    fill: "#37002a",
    strokeWidth: 0
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "mask",
    filter: "url(#drop-shadow-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.4,481c-2.7,3.3-6.7,5.5-11.3,5.5-7.8,0-14.3-6.3-14.3-14.3s0-.8,0-1.2c.7-7.3,6.7-13.1,14.1-13.1s8.7,2.2,11.3,5.5c.3.3.5.8.8,1.2.3-.3.5-.8.8-1.2-.3-.3-.5-.7-.8-1.2-2.8-3.5-7.2-5.7-12-5.7-8.2,0-15,6.3-15.5,14.5v1.2c0,8.7,7,15.6,15.6,15.6s9.2-2.2,12-5.7c.3-.3.5-.7.8-1.2-.3-.3-.5-.8-.8-1.2-.3.3-.5.8-.8,1.2h0Z",
    fill: "#e3f0ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.8,471.2c-.7-8-7.3-14.5-15.5-14.5s-9.2,2.2-12,5.7c-.3.3-.5.7-.8,1.2.3.3.5.8.8,1.2.3-.3.5-.8.8-1.2,2.7-3.3,6.7-5.5,11.3-5.5,7.5,0,13.6,5.8,14.1,13.1v1.2c0,7.8-6.3,14.3-14.3,14.3s-8.7-2.2-11.3-5.5c-.3-.3-.5-.8-.8-1.2-.3.3-.5.8-.8,1.2.3.3.5.7.8,1.2,2.8,3.5,7.2,5.7,12,5.7,8.7,0,15.6-7,15.6-15.6v-1.2h0Z",
    fill: "#e3f0ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.8,472.3c0,8.7-7,15.6-15.6,15.6s-9.2-2.2-12-5.7c-2.8,3.5-7.2,5.7-12,5.7-8.7,0-15.6-7-15.6-15.6s0-.8,0-1.2h1.3v1.2c0,7.8,6.3,14.3,14.3,14.3s8.7-2.2,11.3-5.5c.3-.3.5-.8.8-1.2.3.3.5.8.8,1.2,2.7,3.3,6.7,5.5,11.3,5.5,7.8,0,14.3-6.3,14.3-14.3s0-.8,0-1.2h1.3v1.2h-.3Z",
    fill: "#c5d1ea",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M940.9,457.2c-3.8-4-8.3-5.8-11-6.8-.7-.2-1.3-.2-1.8,0-2.7.8-7,2.7-11,6.8-1.7,1.8-7.5,7.8-7.3,16.5.2,6.3,3.5,10.8,5.2,13.1,4.3,5.8,9.6,8.7,12.8,9.8.7.3,1.5.3,2.3,0,3.2-1.2,8.5-4,12.8-9.8,1.8-2.5,5-6.8,5.2-13.1.3-8.8-5.5-14.8-7.3-16.5h.2Z",
    fill: "#dee8ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.2,458.2c-3.7-3.8-7.8-5.7-10.3-6.3-.7-.2-1.2-.2-1.8,0-2.5.8-6.7,2.5-10.3,6.3-1.7,1.7-7.2,7.3-6.8,15.6.2,6,3.3,10.1,5,12.5,4,5.5,9.2,8.2,12.1,9.3.7.3,1.5.3,2.2,0,3-1.2,8-3.8,12.1-9.3,1.7-2.3,4.8-6.5,5-12.5.2-8.3-5.3-14-6.8-15.6h-.3Z",
    fill: "#f3f7ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.4,458.2c0-3.8-.3-5.7-.3-6.3s0-.2,0,0c0,.8-.2,2.5-.3,6.3,0,1.7-.3,7.3-.2,15.6,0,6,0,10.1.2,12.5,0,5.5.3,8.2.5,9.3q0,.3,0,0c0-1.2.3-3.8.5-9.3,0-2.3.2-6.5.2-12.5s-.2-14-.2-15.6h-.3Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.6,465.2c1-.7,2-1.2,3-1.7,1-.5,2-1.2,3-1.7,1-.5,2-1,3-1.7l3.2-1.5h.3l3,1.5c1,.5,2,1,3,1.7,1,.5,2,1,3,1.7,1,.5,2,1.2,3,1.7h0c-1-.3-2.2-.8-3.2-1.3s-2.2-1-3.2-1.3c-1-.5-2-1-3.2-1.5l-3.2-1.5h.3l-3.2,1.5c-1,.5-2,1-3.2,1.5-1,.5-2.2,1-3.2,1.3-1,.5-2.2.8-3.2,1.3h.5Z",
    fill: "#dee8ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.2,480.3c-1,.7-2,1.2-3,1.7-1,.5-2,1.2-3,1.7-1,.5-2,1-3,1.7l-3.2,1.5h-.3l-3-1.5c-1-.5-2-1-3-1.7-1-.5-2-1-3-1.7-1-.5-2-1.2-3-1.7h0c1,.3,2.2.8,3.2,1.3s2.2,1,3.2,1.3c1,.5,2,1,3.2,1.5l3.2,1.5h-.3l3.2-1.5c1-.5,2-1,3.2-1.5,1-.5,2.2-1,3.2-1.3,1-.5,2.2-.8,3.2-1.3h-.5Z",
    fill: "#dee8ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M946.5,477.7c-1,4-3.2,6.8-4.3,8.5-4,5.5-9.2,8.2-12.1,9.3-.7.3-1.5.3-2.2,0-3-1.2-8-3.8-12.1-9.3-1.3-1.8-3.3-4.7-4.3-8.5,5.5,2.8,10.8,5.5,16.3,8.3h2.7c5.5-2.7,10.8-5.5,16.3-8.3h-.2Z",
    fill: "#dee8ff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M929.4,494.3h.8-.8ZM928.1,494.3h-.2c-.2,0-.3,0-.5-.2h0c.2,0,.3,0,.5.2h.2ZM931.4,493.5h0v-.2c.2,0,.5-.2.7-.3h.2c.2,0,0,0,0,.2-.3,0-.5.2-.7.3h-.2ZM926.1,493.5h0c-.2,0-.5-.2-.7-.3v-.2h.2c.2,0,.5.3.7.3v.2h-.2ZM933.4,492.5h0v-.2c.2,0,.5-.3.7-.5h.2c.2,0,0,0,0,.2-.2,0-.5.3-.7.5h-.2ZM924.2,492.3h0c-.2,0-.5-.3-.7-.5v-.2h.2c.2,0,.5.3.7.5v.2h-.2ZM935.2,491.3h0v-.2c.2,0,.5-.3.7-.5h.2v.2c-.2,0-.5.3-.7.5h-.2ZM922.4,491.1h0c-.2,0-.5-.3-.7-.5v-.2h.2c.2.2.5.3.7.5v.2h-.2ZM937,490h0v-.2c.2-.2.3-.3.7-.5h.2v.2c-.2.2-.5.3-.7.5h-.2ZM920.6,489.8h0c-.2-.2-.3-.3-.7-.5v-.2h.2c.2.2.3.3.7.5v.2h-.2ZM938.5,488.6h0v-.2l.5-.5h.2v.2c-.2.2-.3.3-.5.7h0l-.2-.2ZM919.1,488.3h0c-.2-.2-.3-.3-.5-.7v-.2h.2c.2.2.3.3.5.7v.2h-.2ZM940,487h0v-.2c.2-.2.3-.3.5-.7h.2v.2c-.2.2-.3.5-.5.7h-.2ZM917.6,486.8h0c-.2-.2-.3-.5-.5-.7v-.2h.2c.2.2.3.5.5.7v.2h-.2ZM941.4,485.3h0v-.2c0-.2.3-.5.5-.7h.2v.2c-.2.2-.3.5-.5.7h-.2ZM916.3,485h0c0-.2-.3-.5-.5-.7v-.2h.2c0,.2.3.5.5.7v.2h-.2ZM942.7,483.5h0v-.2c0-.2.3-.5.5-.7h.2c.2,0,0,0,0,.2s-.3.5-.5.7h-.2ZM914.9,483.2h0c0-.2-.3-.5-.5-.7v-.2h.2c0,.2.3.5.5.7v.2h-.2ZM943.7,481.7h0v-.2c0-.2.2-.5.3-.7h.2v.2c0,.2-.2.5-.3.7h-.2ZM913.9,481.3h0c0-.2-.2-.5-.3-.7h0c0,.2.2.5.3.7v.2h0v-.2ZM944.7,479.7h0c0-.3.2-.5.3-.8h0c0,.3-.2.5-.3.8h0ZM913.1,479.3h0c0-.3-.2-.5-.3-.8h0c0,.3.2.5.3.8h0ZM945.4,477.5h0c0-.3,0-.5.2-.8h0c0,.3,0,.5-.2.8h0ZM912.4,477.2h0c0-.3,0-.5-.2-.8h0v.8h.2ZM945.7,475.3h0v-.8h0v.8h0ZM912.1,475h0v-.8h0v.8h0ZM945.9,473.2h0v-.8h0v.8h0ZM911.9,472.8h0v-.8h0v.8h0ZM945.7,471h0v-.8h0v.8h0ZM912.3,470.7h0v-.8h0v.8h0ZM945.2,468.8h0c0-.3,0-.5-.2-.8h0c0,.3,0,.5.2.8h0ZM912.8,468.7h0c0-.3,0-.5.2-.8h0c0,.3-.2.5-.2.8h0ZM944.5,466.9h0c0-.3-.2-.5-.3-.7h0c0,.2.2.5.3.8h0v-.2ZM913.4,466.5h0c0-.3.2-.5.3-.8h.2v.2c0,.2-.2.5-.3.7h-.2ZM943.7,464.9h0c0-.2-.3-.5-.3-.7v-.2h.2c0,.2.3.5.3.7v.2h-.2ZM914.4,464.5h0v-.2c0-.2.3-.5.3-.7h.2v.2c0,.2-.3.5-.3.7h-.2ZM942.5,463h0c0-.2-.3-.5-.5-.7v-.2h.2c0,.2.3.5.5.7v.2h-.2ZM915.6,462.7h0v-.2c0-.2.3-.5.5-.7h.2v.2c0,.2-.3.5-.5.7h-.2ZM941.2,461.2h0c-.2-.2-.3-.5-.5-.7v-.2h.2c.2.2.3.3.5.7v.2h-.2ZM916.9,461h0v-.2c.2-.2.3-.5.5-.7h.2v.2c-.2.2-.3.3-.5.7h-.2ZM939.7,459.5h0l-.3-.3-.5-.5v-.2h.2c.2.2.3.3.7.5l.3.3v.2h-.3ZM918.2,459.4h0v-.2h0c0-.3.3-.5.5-.7h.2v.2l-.5.5h0l-.2.2ZM919.9,457.9h0v-.2c.2-.2.5-.3.7-.5h.2v.2c-.2.2-.5.3-.7.5h-.2ZM937.9,457.7h0c-.2-.2-.5-.3-.7-.5v-.2h.2c.2.2.5.3.7.5v.2h-.2ZM921.6,456.5h0v-.2c.2,0,.5-.3.7-.5h.2v.2c-.2,0-.5.3-.7.5h-.2ZM936,456.4h0c-.2,0-.5-.3-.7-.5v-.2h.2c.2,0,.5.3.7.5v.2h-.2ZM923.4,455.4h0v-.2c.2,0,.5-.3.7-.3h.2v.2c-.2,0-.5.3-.7.3h-.2ZM934.2,455.2h0c-.2,0-.5-.3-.7-.3v-.2h.2c.2,0,.5.3.7.3v.2h-.2ZM925.4,454.4h0v-.2c.3,0,.5-.2.8-.3h0c-.2,0-.5.2-.7.3h0l-.2.2ZM932.4,454.2h0c-.3,0-.5-.2-.7-.3h0c.2,0,.5.2.8.3h-.2ZM927.4,453.5h0c.2,0,.5,0,.7-.2h0c-.2,0-.5,0-.7.2h0ZM930.2,453.5h0c-.2,0-.3,0-.5-.2h-.2.3c.2,0,.3,0,.5.2h-.2Z",
    fill: "#ced8ea",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 920.4,
    cy: 472.8,
    rx: 3.8,
    ry: 5,
    fill: "#dee8ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 919.7,
    cy: 472.8,
    rx: 2.8,
    ry: 4.3,
    fill: "#f3f7ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M919.6,476.7c-1.3,0-2.5-1.7-2.5-3.8s1.2-3.8,2.5-3.8,2.5,1.7,2.5,3.8-1.2,3.8-2.5,3.8ZM919.6,469.2c-1.2,0-2.3,1.7-2.3,3.7s1,3.7,2.3,3.7,2.3-1.7,2.3-3.7-1-3.7-2.3-3.7Z",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.6,475.2c-.8,0-1.5-1-1.5-2.3s.7-2.3,1.5-2.3,1.5,1,1.5,2.3-.7,2.3-1.5,2.3ZM919.6,470.7c-.7,0-1.3,1-1.3,2.2s.5,2.2,1.3,2.2,1.3-1,1.3-2.2-.5-2.2-1.3-2.2Z",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.9,472.8c0-.3,0-.5-.3-.5s-.3.2-.3.5,0,.5.3.5.3-.2.3-.5Z",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "917.7 475.5 917.9 475.7 921.2 470.2 921.2 470 917.7 475.5",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "917.9 470.2 917.7 470.2 921.2 475.7 921.2 475.5 917.9 470.2",
    fill: "#636365",
    strokeWidth: 0
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.5,
    cy: 472.8,
    rx: 3.8,
    ry: 5,
    fill: "#dee8ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 938,
    cy: 472.8,
    rx: 2.8,
    ry: 4.3,
    fill: "#f3f7ff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M938.4,476.7c-1.3,0-2.5-1.7-2.5-3.8s1.2-3.8,2.5-3.8,2.5,1.7,2.5,3.8-1.2,3.8-2.5,3.8ZM938.4,469.2c-1.2,0-2.3,1.7-2.3,3.7s1,3.7,2.3,3.7,2.3-1.7,2.3-3.7-1-3.7-2.3-3.7Z",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.4,475c-.8,0-1.5-1-1.5-2.3s.7-2.3,1.5-2.3,1.5,1,1.5,2.3-.7,2.3-1.5,2.3ZM938.4,470.8c-.7,0-1.2,1-1.2,2s.5,2,1.2,2,1.2-1,1.2-2-.5-2-1.2-2Z",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938,472.8c0-.3,0-.5.3-.5s.3.2.3.5,0,.5-.3.5-.3-.2-.3-.5Z",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "940 475.5 939.9 475.7 936.5 470.2 936.7 470 940 475.5",
    fill: "#636365",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "939.9 470.2 940 470.2 936.7 475.7 936.5 475.5 939.9 470.2",
    fill: "#636365",
    strokeWidth: 0
  }))))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M838.6,422.9c0-.8.8-1.8,2.2-3.3.3-.3.5-.7.8-.8l.3-.3c1.2-1.3,2.2-2.5,2-4,0-1.5-1.5-1.7-3.7-1.7s-5.7,0-8,.3v-1.2c2.2-.2,5.3-.3,8-.3s4.5,0,4.8,2.8c.2,2-1,3.3-2.3,4.8l-.3.3c-.2.3-.5.5-.8.8-.7.7-1.8,2-1.8,2.5h-1.2,0Z",
    fill: "#52193a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.8,422.9h-1.2c0-.5-1.2-1.8-1.8-2.7-.3-.3-.5-.7-.8-.8l-.3-.3c-1.3-1.5-2.5-2.8-2.3-4.8.2-2.7,3-2.7,4.7-2.8,2.7,0,5.8,0,8.2.3v1.2c-2.3-.2-5.5-.3-8-.3s-3.5,0-3.7,1.7c0,1.5.8,2.5,2,4l.3.3c.2.3.5.5.8.8,1.5,1.5,2.3,2.5,2.2,3.3v.2Z",
    fill: "#52193a",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M822.9,436.9h7.3l6.8-13.1-4.8-12.5c-.8-2-2.7-3.3-4.8-3.3h-2.3c-2.2,0-4.2,1.3-4.8,3.3l-4.8,12.5,7.7,13.1h-.2Z",
    fill: "#814f4f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.2,411.3c-.8-2-2.7-3.3-4.8-3.3h-1v28.9h3.8l6.8-13.1-4.8-12.5Z",
    fill: "#703c40",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.6,430.6c-2.7,0-4.8-2.2-4.8-4.8s2.2-4.8,4.8-4.8,4.8,2.2,4.8,4.8-2.2,4.8-4.8,4.8ZM826.6,422.1c-2,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7,3.7-1.7,3.7-3.7-1.7-3.7-3.7-3.7Z",
    fill: "#e0b399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.1,446.1c-4.2,1.2-8.8-2.7-10.5-8.5s.3-11.6,4.5-12.8c2.2-.7,4.8-1.3,7-2,4.2-1.2,8.8,2.7,10.5,8.5s-.3,11.6-4.5,12.8c-2.2.7-4.8,1.3-7,2Z",
    fill: "#61866d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 808.1,
    cy: 435.4,
    rx: 7.8,
    ry: 11.1,
    transform: "translate(-88.4 238) rotate(-15.9)",
    fill: "#456959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.6,444.7c-3,0-6.2-3.3-7.5-7.7-.7-2.3-.7-4.8,0-6.8.7-2.2,1.8-3.5,3.5-4h1.2c3,0,6.2,3.3,7.5,7.7.7,2.3.7,4.8,0,6.8-.7,2.2-1.8,3.5-3.5,4h-1.2ZM806.6,427.3h-.8c-1.2.3-2.2,1.5-2.7,3.2-.5,1.8-.5,4,0,6.2,1.2,3.8,3.8,6.8,6.3,6.8s.5,0,.8,0c1.2-.3,2.2-1.5,2.7-3.2.5-1.8.5-4,0-6.2-1.2-3.8-3.8-6.8-6.3-6.8Z",
    fill: "#22312d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.1,446.1c4.2,1.2,8.8-2.7,10.5-8.5s-.3-11.6-4.5-12.8c-2.2-.7-4.8-1.3-7-2-4.2-1.2-8.8,2.7-10.5,8.5s.3,11.6,4.5,12.8c2.2.7,4.8,1.3,7,2Z",
    fill: "#61866d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 845.1,
    cy: 435.5,
    rx: 11.1,
    ry: 7.8,
    transform: "translate(194.7 1128.9) rotate(-74.1)",
    fill: "#456959",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.5,444.7h-1.2c-3.2-1-4.8-5.8-3.3-10.8,1.2-4.3,4.5-7.7,7.5-7.7s.8,0,1.2,0c1.7.5,2.8,1.8,3.5,4,.7,2,.5,4.5,0,6.8-1.2,4.3-4.5,7.7-7.5,7.7h-.2ZM846.5,427.3c-2.5,0-5.3,3-6.3,6.8-1.2,4.3,0,8.7,2.5,9.5h.8c2.5,0,5.3-3,6.3-6.8.7-2.2.7-4.3,0-6.2-.5-1.7-1.5-2.8-2.7-3.2h-.8l.2-.2Z",
    fill: "#22312d",
    strokeWidth: 0
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 438.4,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796,445.6c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM796,433.2c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 901.1,
    cy: 487.5,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.1,494.6c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM901.1,482.3c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 654.4,
    cy: 210.8,
    r: 6.2,
    transform: "translate(341.5 823) rotate(-80.8)",
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.4,218c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM654.4,205.7c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 456.7,
    cy: 178,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.7,185.2c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM456.7,172.9c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 412.5,
    cy: 412,
    r: 90.2,
    fill: "#fff",
    strokeWidth: 0
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-14)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "382.5 403 384.4 403 384.4 409.6 391.5 403 393.9 403 385.4 411 394.7 420.9 392.2 420.9 384.4 412.6 384.4 420.9 382.5 420.9 382.5 403 382.5 403",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-15)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M410.3,407.6v13.3h-1.7v-2.3c-.7.8-1.5,1.5-2.3,2-.8.5-1.8.7-2.8.7-1.8,0-3.5-.7-4.8-2-1.3-1.3-2-3-2-5s.7-3.5,2-5,3-2,4.8-2,2,.3,3,.7c.8.5,1.7,1.2,2.3,2v-2.5h1.7l-.2.2ZM403.5,409c-1,0-1.8.3-2.7.7-.8.5-1.5,1.2-2,2-.5.8-.7,1.7-.7,2.7s.3,1.8.7,2.7c.5.8,1.2,1.5,2,2,.8.5,1.7.7,2.7.7s1.8-.3,2.7-.7c.8-.5,1.5-1.2,2-2,.5-.8.7-1.7.7-2.7,0-1.5-.5-2.8-1.5-3.8-.8-1.2-2.2-1.7-3.7-1.7",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.2,407.6h1.7v2.3c.5-.8,1.2-1.5,1.8-1.8.8-.5,1.7-.8,2.7-.8s1.2,0,1.8.3c.5.3,1,.5,1.5,1,.3.3.7,1,1,1.8.5-1,1.3-1.8,2.2-2.3s1.7-.8,2.8-.8,1.7.3,2.5.7c.7.5,1.2,1.2,1.5,2,.3.8.5,2,.5,3.8v7.2h-1.7v-7.3c0-1.5,0-2.3-.3-2.8-.2-.5-.5-1-1-1.3-.5-.3-1.2-.5-1.7-.5s-1.7.3-2.3.7c-.7.5-1.2,1.2-1.5,2-.3.8-.5,2.2-.5,4v5.2h-1.7v-6.8c0-1.7,0-2.7-.3-3.3-.2-.5-.5-1-1-1.3-.5-.3-1.2-.5-1.7-.5s-1.5.3-2.2.7c-.7.5-1.2,1.2-1.5,2-.3.8-.5,2-.5,3.7v5.7h-1.7v-13.3h0l-.5.2Z",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.8,416.4l1.5.8c-.5.8-1,1.7-1.7,2.3-.7.5-1.3,1-2,1.3-.8.3-1.7.5-2.7.5-2.2,0-3.8-.7-5.2-2.2-1.2-1.5-1.8-3-1.8-4.8s.5-3.2,1.5-4.5c1.3-1.7,3-2.5,5.3-2.5s4,.8,5.5,2.7c1,1.2,1.5,2.7,1.5,4.5h-12c0,1.5.5,2.8,1.5,3.8,1,1,2.2,1.5,3.5,1.5s1.3,0,2-.3,1.2-.5,1.7-1c.3-.3.8-1,1.3-1.8M448.8,412.9c-.3-.8-.5-1.7-1-2.2s-1-1-1.7-1.3c-.7-.3-1.5-.5-2.3-.5-1.3,0-2.5.3-3.3,1.2-.7.5-1.2,1.5-1.5,2.8h9.8Z",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,407.6h1.7v2c.5-.8,1.2-1.3,1.7-1.7s1.2-.5,1.8-.5,1,0,1.5.5l-.8,1.5c-.3,0-.7-.3-.8-.3-.5,0-1.2.3-1.7.7-.5.5-.8,1.2-1.2,2.2-.2.8-.3,2.3-.3,4.7v4.5h-1.7v-13.3h0l-.2-.2Z",
    fill: "#4d4d4d",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-17)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.2 394.4 451.2 416.4 451.2 394.4 473.2 394.4",
    fill: "#0059e6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.4 394.4 451.2 416.5 451.2 416.4 473.2 394.4 473.4 394.4",
    fill: "#0059e6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.5 394.4 451.2 416.7 451.2 416.5 473.4 394.4 473.5 394.4",
    fill: "#005ae5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.7 394.4 451.2 416.9 451.2 416.7 473.5 394.4 473.7 394.4",
    fill: "#005be4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.9 394.4 451.2 417.1 451.2 416.9 473.7 394.4 473.9 394.4",
    fill: "#005be3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.1 394.4 451.2 417.2 451.2 417.1 473.9 394.4 474.1 394.4",
    fill: "#005ce2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.3 394.4 451.2 417.4 451.2 417.2 474.1 394.4 474.3 394.4",
    fill: "#005de1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.4 394.4 451.2 417.6 451.2 417.4 474.3 394.4 474.4 394.4",
    fill: "#005ee0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.6 394.4 451.2 417.8 451.2 417.6 474.4 394.4 474.6 394.4",
    fill: "#005edf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.8 394.4 451.2 418 451.2 417.8 474.6 394.4 474.8 394.4",
    fill: "#005fde",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475 394.4 451.2 418.1 451.2 418 474.8 394.4 475 394.4",
    fill: "#0060dd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.2 394.4 451.2 418.3 451.2 418.1 475 394.4 475.2 394.4",
    fill: "#0061dc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.3 394.4 451.2 418.5 451.2 418.3 475.2 394.4 475.3 394.4",
    fill: "#0061db",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.5 394.4 451.2 418.7 451.2 418.5 475.3 394.4 475.5 394.4",
    fill: "#0062da",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.7 394.4 451.2 418.8 451.2 418.7 475.5 394.4 475.7 394.4",
    fill: "#0063d9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.9 394.4 451.2 419 451.2 418.8 475.7 394.4 475.9 394.4",
    fill: "#0064d8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476 394.4 451.2 419.2 451.2 419 475.9 394.4 476 394.4",
    fill: "#0064d6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.2 394.4 451.2 419.4 451.2 419.2 476 394.4 476.2 394.4",
    fill: "#0065d5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.4 394.4 451.2 419.6 451.2 419.4 476.2 394.4 476.4 394.4",
    fill: "#0066d4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.6 394.4 451.2 419.7 451.2 419.6 476.4 394.4 476.6 394.4",
    fill: "#0067d3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.8 394.4 451.2 419.9 451.2 419.7 476.6 394.4 476.8 394.4",
    fill: "#0067d2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.9 394.4 451.2 420.1 451.2 419.9 476.8 394.4 476.9 394.4",
    fill: "#0068d1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.1 394.4 451.2 420.3 451.2 420.1 476.9 394.4 477.1 394.4",
    fill: "#0069d0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.3 394.4 451.2 420.5 451.2 420.3 477.1 394.4 477.3 394.4",
    fill: "#006acf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.5 394.4 451.2 420.6 451.2 420.5 477.3 394.4 477.5 394.4",
    fill: "#006ace",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.7 394.4 451.2 420.8 451.2 420.6 477.5 394.4 477.7 394.4",
    fill: "#006bcd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.8 394.4 451.2 421 451.2 420.8 477.7 394.4 477.8 394.4",
    fill: "#006ccc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478 394.4 451.2 421.2 451.2 421 477.8 394.4 478 394.4",
    fill: "#006dcb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.2 394.4 451.2 421.3 451.2 421.2 478 394.4 478.2 394.4",
    fill: "#006dca",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.4 394.4 451.2 421.5 451.2 421.3 478.2 394.4 478.4 394.4",
    fill: "#006ec9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 394.4 451.2 421.7 451.2 421.5 478.4 394.4 478.5 394.4",
    fill: "#006ec9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.7 394.4 451.2 421.9 451.2 421.7 478.5 394.4 478.7 394.4",
    fill: "#006fc8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.9 394.4 451.2 422.1 451.2 421.9 478.7 394.4 478.9 394.4",
    fill: "#0070c7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.1 394.4 451.2 422.2 451.2 422.1 478.9 394.4 479.1 394.4",
    fill: "#0070c6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.3 394.4 451.2 422.4 451.2 422.2 479.1 394.4 479.3 394.4",
    fill: "#0071c5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.4 394.4 451.2 422.6 451.2 422.4 479.3 394.4 479.4 394.4",
    fill: "#0072c4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.6 394.4 451.2 422.8 451.2 422.6 479.4 394.4 479.6 394.4",
    fill: "#0073c3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.8 394.4 451.2 423 451.2 422.8 479.6 394.4 479.8 394.4",
    fill: "#0073c2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480 394.4 451.2 423.1 451.2 423 479.8 394.4 480 394.4",
    fill: "#0074c1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.2 394.4 451.2 423.3 451.2 423.1 480 394.4 480.2 394.4",
    fill: "#0075c0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.3 394.4 451.2 423.5 451.2 423.3 480.2 394.4 480.3 394.4",
    fill: "#0076bf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.5 394.4 451.2 423.7 451.2 423.5 480.3 394.4 480.5 394.4",
    fill: "#0076be",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.7 394.4 451.2 423.9 451.2 423.7 480.5 394.4 480.7 394.4",
    fill: "#0077bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.9 394.4 451.2 424 451.2 423.9 480.7 394.4 480.9 394.4",
    fill: "#0078bc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.1 394.4 451.2 424.2 451.2 424 480.9 394.4 481.1 394.4",
    fill: "#0079bb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.2 394.4 451.2 424.4 451.2 424.2 481.1 394.4 481.2 394.4",
    fill: "#0079ba",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.4 394.4 451.2 424.6 451.2 424.4 481.2 394.4 481.4 394.4",
    fill: "#007ab9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.6 394.4 451.2 424.8 451.2 424.6 481.4 394.4 481.6 394.4",
    fill: "#007bb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.8 394.4 451.2 424.9 451.2 424.8 481.6 394.4 481.8 394.4",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482 394.4 451.2 425.1 451.2 424.9 481.8 394.4 482 394.4",
    fill: "#007cb6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.1 394.4 451.2 425.3 451.2 425.1 482 394.4 482.1 394.4",
    fill: "#007db5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.3 394.4 451.2 425.5 451.2 425.3 482.1 394.4 482.3 394.4",
    fill: "#007eb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.5 394.4 451.2 425.7 451.2 425.5 482.3 394.4 482.5 394.4",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.7 394.4 451.2 425.8 451.2 425.7 482.5 394.4 482.7 394.4",
    fill: "#007fb2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.9 394.4 451.2 426 451.2 425.8 482.7 394.4 482.9 394.4",
    fill: "#0080b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483 394.4 451.2 426.2 451.2 426 482.9 394.4 483 394.4",
    fill: "#0081b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.2 394.4 451.2 426.4 451.2 426.2 483 394.4 483.2 394.4",
    fill: "#0082af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.4 394.4 451.2 426.6 451.2 426.4 483.2 394.4 483.4 394.4",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.6 394.4 451.2 426.7 451.2 426.6 483.4 394.4 483.6 394.4",
    fill: "#0083ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.8 394.4 451.2 426.9 451.2 426.7 483.6 394.4 483.8 394.4",
    fill: "#0084ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.9 394.4 451.2 427.1 451.2 426.9 483.8 394.4 483.9 394.4",
    fill: "#0085ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.1 394.4 451.2 427.3 451.2 427.1 483.9 394.4 484.1 394.4",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.3 394.4 451.2 427.5 451.2 427.3 484.1 394.4 484.3 394.4",
    fill: "#0086a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.5 394.4 451.2 427.6 451.2 427.5 484.3 394.4 484.5 394.4",
    fill: "#0087a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.7 394.4 451.2 427.8 451.2 427.6 484.5 394.4 484.7 394.4",
    fill: "#0088a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.8 394.4 451.2 428 451.2 427.8 484.7 394.4 484.8 394.4",
    fill: "#0089a6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485 394.4 451.2 428.2 451.2 428 484.8 394.4 485 394.4",
    fill: "#0089a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.2 394.4 451.2 428.4 451.2 428.2 485 394.4 485.2 394.4",
    fill: "#008aa3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.4 394.4 451.2 428.5 451.2 428.4 485.2 394.4 485.4 394.4",
    fill: "#008ba2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.6 394.4 451.2 428.7 451.2 428.5 485.4 394.4 485.6 394.4",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.7 394.4 451.2 428.9 451.2 428.7 485.6 394.4 485.7 394.4",
    fill: "#008ca0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.9 394.4 451.2 429.1 451.2 428.9 485.7 394.4 485.9 394.4",
    fill: "#008d9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.1 394.4 451.2 429.3 451.2 429.1 485.9 394.4 486.1 394.4",
    fill: "#008e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.3 394.4 451.2 429.4 451.2 429.3 486.1 394.4 486.3 394.4",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 394.4 451.2 429.6 451.2 429.4 486.3 394.4 486.5 394.4",
    fill: "#008f9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 394.5 451.3 429.6 451.2 429.6 451.2 429.6 486.5 394.4 486.5 394.4 486.5 394.5",
    fill: "#00909b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 394.7 451.5 429.6 451.3 429.6 486.5 394.5 486.5 394.7",
    fill: "#00919a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 394.9 451.7 429.6 451.5 429.6 486.5 394.7 486.5 394.9",
    fill: "#009299",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 395 451.9 429.6 451.7 429.6 486.5 394.9 486.5 395",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 395.2 452.1 429.6 451.9 429.6 486.5 395 486.5 395.2",
    fill: "#009397",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 395.4 452.2 429.6 452.1 429.6 486.5 395.2 486.5 395.4",
    fill: "#009496",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 395.6 452.4 429.6 452.2 429.6 486.5 395.4 486.5 395.6",
    fill: "#009595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 395.8 452.6 429.6 452.4 429.6 486.5 395.6 486.5 395.8",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 395.9 452.8 429.6 452.6 429.6 486.5 395.8 486.5 395.9",
    fill: "#009693",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 396.1 453 429.6 452.8 429.6 486.5 395.9 486.5 396.1",
    fill: "#009792",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 396.3 453.1 429.6 453 429.6 486.5 396.1 486.5 396.3",
    fill: "#009891",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 396.5 453.3 429.6 453.1 429.6 486.5 396.3 486.5 396.5",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 396.7 453.5 429.6 453.3 429.6 486.5 396.5 486.5 396.7",
    fill: "#00998f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 396.8 453.7 429.6 453.5 429.6 486.5 396.7 486.5 396.8",
    fill: "#009a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 397 453.9 429.6 453.7 429.6 486.5 396.8 486.5 397",
    fill: "#009b8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 397.2 454 429.6 453.9 429.6 486.5 397 486.5 397.2",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 397.4 454.2 429.6 454 429.6 486.5 397.2 486.5 397.4",
    fill: "#009c8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 397.6 454.4 429.6 454.2 429.6 486.5 397.4 486.5 397.6",
    fill: "#009d8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 397.7 454.6 429.6 454.4 429.6 486.5 397.6 486.5 397.7",
    fill: "#009e89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 397.9 454.8 429.6 454.6 429.6 486.5 397.7 486.5 397.9",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 398.1 454.9 429.6 454.8 429.6 486.5 397.9 486.5 398.1",
    fill: "#009f87",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 398.3 455.1 429.6 454.9 429.6 486.5 398.1 486.5 398.3",
    fill: "#00a086",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 398.5 455.3 429.6 455.1 429.6 486.5 398.3 486.5 398.5",
    fill: "#00a185",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 398.6 455.5 429.6 455.3 429.6 486.5 398.5 486.5 398.6",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 398.8 455.7 429.6 455.5 429.6 486.5 398.6 486.5 398.8",
    fill: "#00a283",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 399 455.8 429.6 455.7 429.6 486.5 398.8 486.5 399",
    fill: "#00a382",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 399.2 456 429.6 455.8 429.6 486.5 399 486.5 399.2",
    fill: "#00a481",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 399.4 456.2 429.6 456 429.6 486.5 399.2 486.5 399.4",
    fill: "#00a481",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 399.6 456.4 429.6 456.2 429.6 486.5 399.4 486.5 399.6",
    fill: "#00a580",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 399.8 456.6 429.6 456.4 429.6 486.5 399.6 486.5 399.8",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 400 456.8 429.6 456.6 429.6 486.5 399.8 486.5 400",
    fill: "#00a67e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 400.2 457 429.6 456.8 429.6 486.5 400 486.5 400.2",
    fill: "#00a77d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 400.4 457.2 429.6 457 429.6 486.5 400.2 486.5 400.4",
    fill: "#00a87c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 400.6 457.4 429.6 457.2 429.6 486.5 400.4 486.5 400.6",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 400.8 457.6 429.6 457.4 429.6 486.5 400.6 486.5 400.8",
    fill: "#00a97a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 401 457.9 429.6 457.6 429.6 486.5 400.8 486.5 401",
    fill: "#00aa79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 401.2 458.1 429.6 457.9 429.6 486.5 401 486.5 401.2",
    fill: "#00ab78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 401.4 458.3 429.6 458.1 429.6 486.5 401.2 486.5 401.4",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 401.6 458.5 429.6 458.3 429.6 486.5 401.4 486.5 401.6",
    fill: "#00ac76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 401.8 458.7 429.6 458.5 429.6 486.5 401.6 486.5 401.8",
    fill: "#00ad75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 402 458.9 429.6 458.7 429.6 486.5 401.8 486.5 402",
    fill: "#00ae74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 402.2 459.1 429.6 458.9 429.6 486.5 402 486.5 402.2",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 402.4 459.3 429.6 459.1 429.6 486.5 402.2 486.5 402.4",
    fill: "#00af72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 402.6 459.5 429.6 459.3 429.6 486.5 402.4 486.5 402.6",
    fill: "#00b071",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 402.9 459.7 429.6 459.5 429.6 486.5 402.6 486.5 402.9",
    fill: "#00b170",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 403.1 459.9 429.6 459.7 429.6 486.5 402.9 486.5 403.1",
    fill: "#00b26f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 403.3 460.1 429.6 459.9 429.6 486.5 403.1 486.5 403.3",
    fill: "#00b26d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 403.5 460.3 429.6 460.1 429.6 486.5 403.3 486.5 403.5",
    fill: "#00b36c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 403.7 460.5 429.6 460.3 429.6 486.5 403.5 486.5 403.7",
    fill: "#00b46b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 403.9 460.7 429.6 460.5 429.6 486.5 403.7 486.5 403.9",
    fill: "#00b56a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 404.1 460.9 429.6 460.7 429.6 486.5 403.9 486.5 404.1",
    fill: "#00b569",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 404.3 461.1 429.6 460.9 429.6 486.5 404.1 486.5 404.3",
    fill: "#00b668",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 404.5 461.3 429.6 461.1 429.6 486.5 404.3 486.5 404.5",
    fill: "#00b767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 404.7 461.5 429.6 461.3 429.6 486.5 404.5 486.5 404.7",
    fill: "#00b866",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 404.9 461.7 429.6 461.5 429.6 486.5 404.7 486.5 404.9",
    fill: "#00b865",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 405.1 461.9 429.6 461.7 429.6 486.5 404.9 486.5 405.1",
    fill: "#00b964",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 405.3 462.1 429.6 461.9 429.6 486.5 405.1 486.5 405.3",
    fill: "#00ba63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 405.5 462.3 429.6 462.1 429.6 486.5 405.3 486.5 405.5",
    fill: "#00bb62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 405.7 462.6 429.6 462.3 429.6 486.5 405.5 486.5 405.7",
    fill: "#00bb61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 405.9 462.8 429.6 462.6 429.6 486.5 405.7 486.5 405.9",
    fill: "#00bc60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 406.1 463 429.6 462.8 429.6 486.5 405.9 486.5 406.1",
    fill: "#00bd5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 406.3 463.2 429.6 463 429.6 486.5 406.1 486.5 406.3",
    fill: "#00be5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 406.5 463.4 429.6 463.2 429.6 486.5 406.3 486.5 406.5",
    fill: "#00be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 406.7 463.6 429.6 463.4 429.6 486.5 406.5 486.5 406.7",
    fill: "#00bf5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 406.9 463.8 429.6 463.6 429.6 486.5 406.7 486.5 406.9",
    fill: "#00c05b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.8 429.6 486.5 406.9 486.5 429.6 463.8 429.6",
    fill: "#00c05b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-19)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "471 402 471 402 471 402 471 402",
    fill: "#006fc8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.2 402 471 402.2 471 402 471 402 471.2 402",
    fill: "#0070c7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.4 402 471 402.4 471 402.2 471.2 402 471.4 402",
    fill: "#0070c6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.6 402 471 402.6 471 402.4 471.4 402 471.6 402",
    fill: "#0071c5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.8 402 471 402.7 471 402.6 471.6 402 471.8 402",
    fill: "#0072c4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.9 402 471 402.9 471 402.7 471.8 402 471.9 402",
    fill: "#0073c3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.1 402 471 403.1 471 402.9 471.9 402 472.1 402",
    fill: "#0073c2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.3 402 471 403.3 471 403.1 472.1 402 472.3 402",
    fill: "#0074c1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.5 402 471 403.5 471 403.3 472.3 402 472.5 402",
    fill: "#0075c0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.7 402 471 403.6 471 403.5 472.5 402 472.7 402",
    fill: "#0076bf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.8 402 471 403.8 471 403.6 472.7 402 472.8 402",
    fill: "#0076be",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473 402 471 404 471 403.8 472.8 402 473 402",
    fill: "#0077bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.2 402 471 404.2 471 404 473 402 473.2 402",
    fill: "#0078bc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.4 402 471 404.4 471 404.2 473.2 402 473.4 402",
    fill: "#0079bb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.6 402 471 404.5 471 404.4 473.4 402 473.6 402",
    fill: "#0079ba",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.7 402 471 404.7 471 404.5 473.6 402 473.7 402",
    fill: "#007ab9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.9 402 471 404.9 471 404.7 473.7 402 473.9 402",
    fill: "#007bb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.1 402 471 405.1 471 404.9 473.9 402 474.1 402",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.3 402 471 405.3 471 405.1 474.1 402 474.3 402",
    fill: "#007cb6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.5 402 471 405.4 471 405.3 474.3 402 474.5 402",
    fill: "#007db5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.6 402 471 405.6 471 405.4 474.5 402 474.6 402",
    fill: "#007eb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.8 402 471 405.8 471 405.6 474.6 402 474.8 402",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475 402 471 406 471 405.8 474.8 402 475 402",
    fill: "#007fb2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.2 402 471 406.2 471 406 475 402 475.2 402",
    fill: "#0080b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.4 402 471 406.3 471 406.2 475.2 402 475.4 402",
    fill: "#0081b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.5 402 471 406.5 471 406.3 475.4 402 475.5 402",
    fill: "#0082af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.7 402 471 406.7 471 406.5 475.5 402 475.7 402",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.9 402 471 406.9 471 406.7 475.7 402 475.9 402",
    fill: "#0083ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.1 402 471 407.1 471 406.9 475.9 402 476.1 402",
    fill: "#0084ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.3 402 471 407.2 471 407.1 476.1 402 476.3 402",
    fill: "#0085ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.4 402 471 407.4 471 407.2 476.3 402 476.4 402",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.6 402 471 407.6 471 407.4 476.4 402 476.6 402",
    fill: "#0086a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.8 402 471 407.8 471 407.6 476.6 402 476.8 402",
    fill: "#0087a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477 402 471 408 471 407.8 476.8 402 477 402",
    fill: "#0088a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.2 402 471 408.1 471 408 477 402 477.2 402",
    fill: "#0089a6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.3 402 471 408.3 471 408.1 477.2 402 477.3 402",
    fill: "#0089a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.5 402 471 408.5 471 408.3 477.3 402 477.5 402",
    fill: "#008aa3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.7 402 471 408.7 471 408.5 477.5 402 477.7 402",
    fill: "#008ba2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.9 402 471 408.8 471 408.7 477.7 402 477.9 402",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.1 402 471 409 471 408.8 477.9 402 478.1 402",
    fill: "#008ca0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.2 402 471 409.2 471 409 478.1 402 478.2 402",
    fill: "#008d9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.4 402 471 409.4 471 409.2 478.2 402 478.4 402",
    fill: "#008e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.6 402 471 409.6 471 409.4 478.4 402 478.6 402",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.8 402 471 409.7 471 409.6 478.6 402 478.8 402",
    fill: "#008f9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.9 402 471 409.9 471 409.7 478.8 402 478.9 402",
    fill: "#00909b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.1 402 471 410.1 471 409.9 478.9 402 479.1 402",
    fill: "#00919a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.3 402 471 410.3 471 410.1 479.1 402 479.3 402",
    fill: "#009299",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.5 402 471 410.5 471 410.3 479.3 402 479.5 402",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.7 402 471 410.6 471 410.5 479.5 402 479.7 402",
    fill: "#009397",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.8 402 471 410.8 471 410.6 479.7 402 479.8 402",
    fill: "#009496",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480 402 471 411 471 410.8 479.8 402 480 402",
    fill: "#009595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.2 402 471 411.2 471 411 480 402 480.2 402",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.4 402 471 411.4 471 411.2 480.2 402 480.4 402",
    fill: "#009693",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.6 402 471 411.5 471 411.4 480.4 402 480.6 402",
    fill: "#009792",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.7 402 471 411.7 471 411.5 480.6 402 480.7 402",
    fill: "#009891",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.9 402 471 411.9 471 411.7 480.7 402 480.9 402",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.1 402 471 412.1 471 411.9 480.9 402 481.1 402",
    fill: "#00998f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.3 402 471 412.3 471 412.1 481.1 402 481.3 402",
    fill: "#009a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.5 402 471 412.4 471 412.3 481.3 402 481.5 402",
    fill: "#009b8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.6 402 471 412.6 471 412.4 481.5 402 481.6 402",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.8 402 471 412.8 471 412.6 481.6 402 481.8 402",
    fill: "#009c8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482 402 471 413 471 412.8 481.8 402 482 402",
    fill: "#009d8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.2 402 471 413.2 471 413 482 402 482.2 402",
    fill: "#009e89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.4 402 471 413.3 471 413.2 482.2 402 482.4 402",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.5 402 471 413.5 471 413.3 482.4 402 482.5 402",
    fill: "#009f87",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.7 402 471 413.7 471 413.5 482.5 402 482.7 402",
    fill: "#00a086",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.9 402 471 413.9 471 413.7 482.7 402 482.9 402",
    fill: "#00a185",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.1 402 471 414.1 471 413.9 482.9 402 483.1 402",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.3 402 471 414.2 471 414.1 483.1 402 483.3 402",
    fill: "#00a283",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.4 402 471 414.4 471 414.2 483.3 402 483.4 402",
    fill: "#00a382",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.6 402 471 414.6 471 414.4 483.4 402 483.6 402",
    fill: "#00a481",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.8 402 471 414.8 471 414.6 483.6 402 483.8 402",
    fill: "#00a481",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484 402 471 415 471 414.8 483.8 402 484 402",
    fill: "#00a580",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.2 402 471 415.2 471 415 484 402 484.2 402",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.4 402 471 415.4 471 415.2 484.2 402 484.4 402",
    fill: "#00a67e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.6 402 471 415.6 471 415.4 484.4 402 484.6 402",
    fill: "#00a77d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.8 402 471 415.8 471 415.6 484.6 402 484.8 402",
    fill: "#00a87c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.1 402 471 416 471 415.8 484.8 402 485.1 402",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.3 402 471 416.2 471 416 485.1 402 485.3 402",
    fill: "#00a97a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.5 402 471 416.4 471 416.2 485.3 402 485.5 402",
    fill: "#00aa79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.7 402 471 416.6 471 416.4 485.5 402 485.7 402",
    fill: "#00ab78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.9 402 471 416.8 471 416.6 485.7 402 485.9 402",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.1 402 471 417.1 471 416.8 485.9 402 486.1 402",
    fill: "#00ac76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.3 402 471 417.3 471 417.1 486.1 402 486.3 402",
    fill: "#00ad75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.5 402 471 417.5 471 417.3 486.3 402 486.5 402",
    fill: "#00ae74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.7 402 471 417.7 471 417.5 486.5 402 486.7 402",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.9 402 471 417.9 471 417.7 486.7 402 486.9 402",
    fill: "#00af72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.1 402 471 418.1 471 417.9 486.9 402 487.1 402",
    fill: "#00b071",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.3 402 471 418.3 471 418.1 487.1 402 487.3 402",
    fill: "#00b170",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.5 402 471 418.5 471 418.3 487.3 402 487.5 402",
    fill: "#00b26f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.7 402 471 418.7 471 418.5 487.5 402 487.7 402",
    fill: "#00b26d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.9 402 471 418.9 471 418.7 487.7 402 487.9 402",
    fill: "#00b36c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.1 402 471 419.1 471 418.9 487.9 402 488.1 402",
    fill: "#00b46b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.3 402 471 419.3 471 419.1 488.1 402 488.3 402",
    fill: "#00b56a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.5 402 471 419.5 471 419.3 488.3 402 488.5 402",
    fill: "#00b569",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.7 402 471 419.7 471 419.5 488.5 402 488.7 402",
    fill: "#00b668",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.9 402 471 419.9 471 419.7 488.7 402 488.9 402",
    fill: "#00b767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.1 402 471 420.1 471 419.9 488.9 402 489.1 402",
    fill: "#00b866",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.3 402 471 420.3 471 420.1 489.1 402 489.3 402",
    fill: "#00b865",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.5 402 471 420.5 471 420.3 489.3 402 489.5 402",
    fill: "#00b964",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.8 402 471 420.7 471 420.5 489.5 402 489.8 402",
    fill: "#00ba63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490 402 471 420.9 471 420.7 489.8 402 490 402",
    fill: "#00bb62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.2 402 471 421.1 471 420.9 490 402 490.2 402",
    fill: "#00bb61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.4 402 471 421.3 471 421.1 490.2 402 490.4 402",
    fill: "#00bc60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.6 402 471 421.5 471 421.3 490.4 402 490.6 402",
    fill: "#00bd5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.8 402 471 421.8 471 421.5 490.6 402 490.8 402",
    fill: "#00be5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.8 402.2 471.2 421.8 471 421.8 471 421.8 490.8 402 490.8 402 490.8 402.2",
    fill: "#00be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.8 402.4 471.4 421.8 471.2 421.8 490.8 402.2 490.8 402.4",
    fill: "#00bf5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.8 402.6 471.6 421.8 471.4 421.8 490.8 402.4 490.8 402.6",
    fill: "#00c05b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.6 421.8 490.8 402.6 490.8 421.8 471.6 421.8",
    fill: "#00c05b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-21)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.3 408.1 397.1 408.1 397.1 408.1 397.3 408.1",
    fill: "#005fde",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.6 408.1 397.1 408.2 397.1 408.1 397.3 408.1 397.6 408.1",
    fill: "#0060dd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398 408.1 397.1 408.3 397.1 408.2 397.6 408.1 398 408.1",
    fill: "#0061dc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.3 408.1 397.1 408.4 397.1 408.3 398 408.1 398.3 408.1",
    fill: "#0061db",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.7 408.1 397.1 408.5 397.1 408.4 398.3 408.1 398.7 408.1",
    fill: "#0062da",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399 408.1 397.1 408.6 397.1 408.5 398.7 408.1 399 408.1",
    fill: "#0063d9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.4 408.1 397.1 408.7 397.1 408.6 399 408.1 399.4 408.1",
    fill: "#0064d8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.7 408.1 397.1 408.8 397.1 408.7 399.4 408.1 399.7 408.1",
    fill: "#0064d6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.1 408.1 397.1 408.9 397.1 408.8 399.7 408.1 400.1 408.1",
    fill: "#0065d5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.4 408.1 397.1 409 397.1 408.9 400.1 408.1 400.4 408.1",
    fill: "#0066d4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.8 408.1 397.1 409.1 397.1 409 400.4 408.1 400.8 408.1",
    fill: "#0067d3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.2 408.1 397.1 409.2 397.1 409.1 400.8 408.1 401.2 408.1",
    fill: "#0067d2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.5 408.1 397.1 409.3 397.1 409.2 401.2 408.1 401.5 408.1",
    fill: "#0068d1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.9 408.1 397.1 409.4 397.1 409.3 401.5 408.1 401.9 408.1",
    fill: "#0069d0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.2 408.1 397.1 409.6 397.1 409.4 401.9 408.1 402.2 408.1",
    fill: "#006acf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.6 408.1 397.1 409.7 397.1 409.6 402.2 408.1 402.6 408.1",
    fill: "#006ace",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.9 408.1 397.1 409.8 397.1 409.7 402.6 408.1 402.9 408.1",
    fill: "#006bcd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.3 408.1 397.1 409.9 397.1 409.8 402.9 408.1 403.3 408.1",
    fill: "#006ccc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.6 408.1 397.1 410 397.1 409.9 403.3 408.1 403.6 408.1",
    fill: "#006dcb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404 408.1 397.1 410.1 397.1 410 403.6 408.1 404 408.1",
    fill: "#006dca",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.3 408.1 397.1 410.2 397.1 410.1 404 408.1 404.3 408.1",
    fill: "#006ec9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.7 408.1 397.1 410.3 397.1 410.2 404.3 408.1 404.7 408.1",
    fill: "#006ec9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.1 408.1 397.1 410.4 397.1 410.3 404.7 408.1 405.1 408.1",
    fill: "#006fc8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.4 408.1 397.1 410.5 397.1 410.4 405.1 408.1 405.4 408.1",
    fill: "#0070c7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.8 408.1 397.1 410.6 397.1 410.5 405.4 408.1 405.8 408.1",
    fill: "#0070c6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.1 408.1 397.1 410.7 397.1 410.6 405.8 408.1 406.1 408.1",
    fill: "#0071c5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.5 408.1 397.1 410.8 397.1 410.7 406.1 408.1 406.5 408.1",
    fill: "#0072c4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.8 408.1 397.1 410.9 397.1 410.8 406.5 408.1 406.8 408.1",
    fill: "#0073c3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.2 408.1 397.1 411 397.1 410.9 406.8 408.1 407.2 408.1",
    fill: "#0073c2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.5 408.1 397.1 411.1 397.1 411 407.2 408.1 407.5 408.1",
    fill: "#0074c1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.9 408.1 397.1 411.2 397.1 411.1 407.5 408.1 407.9 408.1",
    fill: "#0075c0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.3 408.1 397.1 411.3 397.1 411.2 407.9 408.1 408.3 408.1",
    fill: "#0076bf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.6 408.1 397.1 411.4 397.1 411.3 408.3 408.1 408.6 408.1",
    fill: "#0076be",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409 408.1 397.1 411.5 397.1 411.4 408.6 408.1 409 408.1",
    fill: "#0077bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.3 408.1 397.1 411.6 397.1 411.5 409 408.1 409.3 408.1",
    fill: "#0078bc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.7 408.1 397.1 411.7 397.1 411.6 409.3 408.1 409.7 408.1",
    fill: "#0079bb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410 408.1 397.1 411.8 397.1 411.7 409.7 408.1 410 408.1",
    fill: "#0079ba",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.2 397.1 411.9 397.1 411.8 410 408.1 410.1 408.1 410.1 408.2",
    fill: "#007ab9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.3 397.1 412 397.1 411.9 410.1 408.2 410.1 408.3",
    fill: "#007bb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.4 397.1 412.1 397.1 412 410.1 408.3 410.1 408.4",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.5 397.1 412.2 397.1 412.1 410.1 408.4 410.1 408.5",
    fill: "#007cb6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.6 397.1 412.3 397.1 412.2 410.1 408.5 410.1 408.6",
    fill: "#007db5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.7 397.1 412.4 397.1 412.3 410.1 408.6 410.1 408.7",
    fill: "#007eb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.8 397.1 412.5 397.1 412.4 410.1 408.7 410.1 408.8",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 408.9 397.1 412.7 397.1 412.5 410.1 408.8 410.1 408.9",
    fill: "#007fb2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409 397.1 412.8 397.1 412.7 410.1 408.9 410.1 409",
    fill: "#0080b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.1 397.1 412.9 397.1 412.8 410.1 409 410.1 409.1",
    fill: "#0081b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.2 397.1 413 397.1 412.9 410.1 409.1 410.1 409.2",
    fill: "#0082af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.3 397.1 413.1 397.1 413 410.1 409.2 410.1 409.3",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.4 397.1 413.2 397.1 413.1 410.1 409.3 410.1 409.4",
    fill: "#0083ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.5 397.1 413.3 397.1 413.2 410.1 409.4 410.1 409.5",
    fill: "#0084ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.6 397.1 413.4 397.1 413.3 410.1 409.5 410.1 409.6",
    fill: "#0085ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.7 397.1 413.5 397.1 413.4 410.1 409.6 410.1 409.7",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.8 397.1 413.6 397.1 413.5 410.1 409.7 410.1 409.8",
    fill: "#0086a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 409.9 397.1 413.7 397.1 413.6 410.1 409.8 410.1 409.9",
    fill: "#0087a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410 397.1 413.8 397.1 413.7 410.1 409.9 410.1 410",
    fill: "#0088a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.1 397.1 413.9 397.1 413.8 410.1 410 410.1 410.1",
    fill: "#0089a6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.2 397.1 414 397.1 413.9 410.1 410.1 410.1 410.2",
    fill: "#0089a4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.3 397.1 414.1 397.1 414 410.1 410.2 410.1 410.3",
    fill: "#008aa3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.4 397.1 414.2 397.1 414.1 410.1 410.3 410.1 410.4",
    fill: "#008ba2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.5 397.1 414.3 397.1 414.2 410.1 410.4 410.1 410.5",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.6 397.1 414.4 397.1 414.3 410.1 410.5 410.1 410.6",
    fill: "#008ca0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.7 397.1 414.5 397.1 414.4 410.1 410.6 410.1 410.7",
    fill: "#008d9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.8 397.1 414.6 397.1 414.5 410.1 410.7 410.1 410.8",
    fill: "#008e9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 410.9 397.1 414.7 397.1 414.6 410.1 410.8 410.1 410.9",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.1 397.1 414.8 397.1 414.7 410.1 410.9 410.1 411.1",
    fill: "#008f9c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.2 397.1 414.9 397.1 414.8 410.1 411.1 410.1 411.2",
    fill: "#00909b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.3 397.1 415 397.1 414.9 410.1 411.2 410.1 411.3",
    fill: "#00919a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.4 397.1 415.1 397.1 415 410.1 411.3 410.1 411.4",
    fill: "#009299",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.5 397.1 415.2 397.1 415.1 410.1 411.4 410.1 411.5",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.6 397.1 415.3 397.1 415.2 410.1 411.5 410.1 411.6",
    fill: "#009397",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.7 397.1 415.4 397.1 415.3 410.1 411.6 410.1 411.7",
    fill: "#009496",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.8 397.1 415.5 397.1 415.4 410.1 411.7 410.1 411.8",
    fill: "#009595",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 411.9 397.1 415.7 397.1 415.5 410.1 411.8 410.1 411.9",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412 397.1 415.8 397.1 415.7 410.1 411.9 410.1 412",
    fill: "#009693",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.1 397.1 415.9 397.1 415.8 410.1 412 410.1 412.1",
    fill: "#009792",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.2 397.1 416 397.1 415.9 410.1 412.1 410.1 412.2",
    fill: "#009891",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.3 397.1 416.1 397.1 416 410.1 412.2 410.1 412.3",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.4 397.1 416.2 397.1 416.1 410.1 412.3 410.1 412.4",
    fill: "#00998f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.5 397.1 416.3 397.1 416.2 410.1 412.4 410.1 412.5",
    fill: "#009a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.6 397.1 416.4 397.1 416.3 410.1 412.5 410.1 412.6",
    fill: "#009b8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.7 397.1 416.5 397.1 416.4 410.1 412.6 410.1 412.7",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.8 397.1 416.6 397.1 416.5 410.1 412.7 410.1 412.8",
    fill: "#009c8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 412.9 397.1 416.7 397.1 416.6 410.1 412.8 410.1 412.9",
    fill: "#009d8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413 397.1 416.8 397.1 416.7 410.1 412.9 410.1 413",
    fill: "#009e89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.1 397.1 416.9 397.1 416.8 410.1 413 410.1 413.1",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.2 397.1 417 397.1 416.9 410.1 413.1 410.1 413.2",
    fill: "#009f87",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.3 397.1 417.1 397.1 417 410.1 413.2 410.1 413.3",
    fill: "#00a086",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.4 397.1 417.2 397.1 417.1 410.1 413.3 410.1 413.4",
    fill: "#00a185",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.5 397.1 417.3 397.1 417.2 410.1 413.4 410.1 413.5",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.6 397.1 417.4 397.1 417.3 410.1 413.5 410.1 413.6",
    fill: "#00a283",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.7 397.1 417.5 397.1 417.4 410.1 413.6 410.1 413.7",
    fill: "#00a382",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 413.8 397.1 417.6 397.1 417.5 410.1 413.7 410.1 413.8",
    fill: "#00a481",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414 397.1 417.7 397.1 417.6 410.1 413.8 410.1 414",
    fill: "#00a481",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.1 397.1 417.9 397.1 417.7 410.1 414 410.1 414.1",
    fill: "#00a580",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.2 397.1 418 397.1 417.9 410.1 414.1 410.1 414.2",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.3 397.1 418.1 397.1 418 410.1 414.2 410.1 414.3",
    fill: "#00a67e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.4 397.1 418.2 397.1 418.1 410.1 414.3 410.1 414.4",
    fill: "#00a77d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.6 397.1 418.3 397.1 418.2 410.1 414.4 410.1 414.6",
    fill: "#00a87c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.7 397.1 418.4 397.1 418.3 410.1 414.6 410.1 414.7",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.8 397.1 418.6 397.1 418.4 410.1 414.7 410.1 414.8",
    fill: "#00a97a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 414.9 397.1 418.7 397.1 418.6 410.1 414.8 410.1 414.9",
    fill: "#00aa79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415 397.1 418.8 397.1 418.7 410.1 414.9 410.1 415",
    fill: "#00ab78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.1 397.1 418.9 397.1 418.8 410.1 415 410.1 415.1",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.3 397.1 419 397.1 418.9 410.1 415.1 410.1 415.3",
    fill: "#00ac76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.4 397.1 419.1 397.1 419 410.1 415.3 410.1 415.4",
    fill: "#00ad75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.5 397.1 419.3 397.1 419.1 410.1 415.4 410.1 415.5",
    fill: "#00ae74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.6 397.1 419.4 397.1 419.3 410.1 415.5 410.1 415.6",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.7 397.1 419.5 397.1 419.4 410.1 415.6 410.1 415.7",
    fill: "#00af72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 415.8 397.1 419.6 397.1 419.5 410.1 415.7 410.1 415.8",
    fill: "#00b071",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416 397.1 419.7 397.1 419.6 410.1 415.8 410.1 416",
    fill: "#00b170",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.1 397.1 419.9 397.1 419.7 410.1 416 410.1 416.1",
    fill: "#00b26f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.2 397.1 420 397.1 419.9 410.1 416.1 410.1 416.2",
    fill: "#00b26d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.3 397.1 420.1 397.1 420 410.1 416.2 410.1 416.3",
    fill: "#00b36c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.4 397.1 420.2 397.1 420.1 410.1 416.3 410.1 416.4",
    fill: "#00b46b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.6 397.1 420.3 397.1 420.2 410.1 416.4 410.1 416.6",
    fill: "#00b56a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.7 397.1 420.4 397.1 420.3 410.1 416.6 410.1 416.7",
    fill: "#00b569",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.8 397.1 420.6 397.1 420.4 410.1 416.7 410.1 416.8",
    fill: "#00b668",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 416.9 397.1 420.7 397.1 420.6 410.1 416.8 410.1 416.9",
    fill: "#00b767",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417 397.1 420.8 397.1 420.7 410.1 416.9 410.1 417",
    fill: "#00b866",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.1 397.1 420.9 397.1 420.8 410.1 417 410.1 417.1",
    fill: "#00b865",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.3 397.1 421 397.1 420.9 410.1 417.1 410.1 417.3",
    fill: "#00b964",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.4 397.4 421.1 397.1 421.1 397.1 421 410.1 417.3 410.1 417.4",
    fill: "#00ba63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.5 397.8 421.1 397.4 421.1 410.1 417.4 410.1 417.5",
    fill: "#00bb62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.6 398.2 421.1 397.8 421.1 410.1 417.5 410.1 417.6",
    fill: "#00bb61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.7 398.6 421.1 398.2 421.1 410.1 417.6 410.1 417.7",
    fill: "#00bc60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 417.8 399 421.1 398.6 421.1 410.1 417.7 410.1 417.8",
    fill: "#00bd5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 418 399.4 421.1 399 421.1 410.1 417.8 410.1 418",
    fill: "#00be5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 418.1 399.8 421.1 399.4 421.1 410.1 418 410.1 418.1",
    fill: "#00be5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 418.2 400.3 421.1 399.8 421.1 410.1 418.1 410.1 418.2",
    fill: "#00bf5c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.1 418.3 400.7 421.1 400.3 421.1 410.1 418.2 410.1 418.3",
    fill: "#00c05b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.7 421.1 410.1 418.3 410.1 421.1 400.7 421.1",
    fill: "#00c05b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-23)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 402.9 362.2 402.8 362.3 402.8 362.3 402.9",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 403.2 361.9 402.8 362.2 402.8 362.3 402.9 362.3 403.2",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 403.5 361.5 402.8 361.9 402.8 362.3 403.2 362.3 403.5",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 403.8 361.2 402.8 361.5 402.8 362.3 403.5 362.3 403.8",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 404.1 360.8 402.8 361.2 402.8 362.3 403.8 362.3 404.1",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 404.4 360.5 402.8 360.8 402.8 362.3 404.1 362.3 404.4",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 404.7 360.1 402.8 360.5 402.8 362.3 404.4 362.3 404.7",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 405.1 359.8 402.8 360.1 402.8 362.3 404.7 362.3 405.1",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 405.4 359.4 402.8 359.8 402.8 362.3 405.1 362.3 405.4",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 405.7 359.1 402.8 359.4 402.8 362.3 405.4 362.3 405.7",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 406 358.7 402.8 359.1 402.8 362.3 405.7 362.3 406",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 406.3 358.4 402.8 358.7 402.8 362.3 406 362.3 406.3",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 406.6 358 402.8 358.4 402.8 362.3 406.3 362.3 406.6",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 406.9 357.7 402.8 358 402.8 362.3 406.6 362.3 406.9",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 407.2 357.3 402.8 357.7 402.8 362.3 406.9 362.3 407.2",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 407.6 357 402.8 357.3 402.8 362.3 407.2 362.3 407.6",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 407.9 356.6 402.8 357 402.8 362.3 407.6 362.3 407.9",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 408.2 356.2 402.8 356.6 402.8 362.3 407.9 362.3 408.2",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 408.6 355.8 402.8 356.2 402.8 362.3 408.2 362.3 408.6",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 408.9 355.5 402.8 355.8 402.8 362.3 408.6 362.3 408.9",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 409.2 355.1 402.8 355.5 402.8 362.3 408.9 362.3 409.2",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 409.6 354.7 402.8 355.1 402.8 362.3 409.2 362.3 409.6",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 409.9 354.3 402.8 354.7 402.8 362.3 409.6 362.3 409.9",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 410.3 353.9 402.8 354.3 402.8 362.3 409.9 362.3 410.3",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 410.6 353.5 402.8 353.9 402.8 362.3 410.3 362.3 410.6",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 411 353.1 402.8 353.5 402.8 362.3 410.6 362.3 411",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 411.3 352.7 402.8 353.1 402.8 362.3 411 362.3 411.3",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 411.7 352.3 402.8 352.7 402.8 362.3 411.3 362.3 411.7",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 412 352 402.8 352.3 402.8 362.3 411.7 362.3 412",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 412.4 351.6 402.8 352 402.8 362.3 412 362.3 412.4",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 412.7 351.2 402.8 351.6 402.8 362.3 412.4 362.3 412.7",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 413.1 350.8 402.8 351.2 402.8 362.3 412.7 362.3 413.1",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 413.4 350.4 402.8 350.8 402.8 362.3 413.1 362.3 413.4",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 413.8 350 402.8 350.4 402.8 362.3 413.4 362.3 413.8",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 414.1 349.6 402.8 350 402.8 362.3 413.8 362.3 414.1",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 414.4 349.2 402.8 349.6 402.8 362.3 414.1 362.3 414.4",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 414.8 348.8 402.8 349.2 402.8 362.3 414.4 362.3 414.8",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 415.1 348.5 402.8 348.8 402.8 362.3 414.8 362.3 415.1",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 415.5 348.1 402.8 348.5 402.8 362.3 415.1 362.3 415.5",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 415.8 347.7 402.8 348.1 402.8 362.3 415.5 362.3 415.8",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 416.2 347.3 402.8 347.7 402.8 362.3 415.8 362.3 416.2",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 416.5 346.9 402.8 347.3 402.8 362.3 416.2 362.3 416.5",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 416.9 346.5 402.8 346.9 402.8 362.3 416.5 362.3 416.9",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 417.2 346.1 402.8 346.5 402.8 362.3 416.9 362.3 417.2",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 417.6 345.7 402.8 346.1 402.8 362.3 417.2 362.3 417.6",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 417.9 345.4 402.8 345.7 402.8 362.3 417.6 362.3 417.9",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 418.3 345 402.8 345.4 402.8 362.3 417.9 362.3 418.3",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 418.6 344.6 402.8 345 402.8 362.3 418.3 362.3 418.6",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 418.9 344.2 402.8 344.6 402.8 362.3 418.6 362.3 418.9",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 419.3 343.8 402.8 344.2 402.8 362.3 418.9 362.3 419.3",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 419.6 343.4 402.8 343.8 402.8 362.3 419.3 362.3 419.6",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 420 343 402.8 343.4 402.8 362.3 419.6 362.3 420",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 420.3 342.6 402.8 343 402.8 362.3 420 362.3 420.3",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 420.7 342.2 402.8 342.6 402.8 362.3 420.3 362.3 420.7",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 421 341.9 402.8 342.2 402.8 362.3 420.7 362.3 421",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 421.4 341.5 402.8 341.9 402.8 362.3 421 362.3 421.4",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.5 402.8 362.3 421.4 362.3 428.4 336.7 428.4 336.7 402.8 341.5 402.8",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-25)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 398 377 397.7 377.4 397.7 377.4 398",
    fill: "#006ccd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 398.3 376.7 397.7 377 397.7 377.4 398 377.4 398.3",
    fill: "#006dcc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 398.6 376.3 397.7 376.7 397.7 377.4 398.3 377.4 398.6",
    fill: "#006dcb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 398.9 376 397.7 376.3 397.7 377.4 398.6 377.4 398.9",
    fill: "#006eca",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 399.3 375.6 397.7 376 397.7 377.4 398.9 377.4 399.3",
    fill: "#006eca",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 399.6 375.3 397.7 375.6 397.7 377.4 399.3 377.4 399.6",
    fill: "#006fc9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 399.9 374.9 397.7 375.3 397.7 377.4 399.6 377.4 399.9",
    fill: "#0070c8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 400.2 374.6 397.7 374.9 397.7 377.4 399.9 377.4 400.2",
    fill: "#0070c7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 400.5 374.2 397.7 374.6 397.7 377.4 400.2 377.4 400.5",
    fill: "#0071c6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 400.8 373.9 397.7 374.2 397.7 377.4 400.5 377.4 400.8",
    fill: "#0072c5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 401.1 373.5 397.7 373.9 397.7 377.4 400.8 377.4 401.1",
    fill: "#0073c4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 401.4 373.2 397.7 373.5 397.7 377.4 401.1 377.4 401.4",
    fill: "#0073c3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 401.8 372.8 397.7 373.2 397.7 377.4 401.4 377.4 401.8",
    fill: "#0074c2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 402.1 372.5 397.7 372.8 397.7 377.4 401.8 377.4 402.1",
    fill: "#0075c1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 402.4 372.1 397.7 372.5 397.7 377.4 402.1 377.4 402.4",
    fill: "#0076c0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 402.7 371.8 397.7 372.1 397.7 377.4 402.4 377.4 402.7",
    fill: "#0076bf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 403 371.4 397.7 371.8 397.7 377.4 402.7 377.4 403",
    fill: "#0077be",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 403.3 371.1 397.7 371.4 397.7 377.4 403 377.4 403.3",
    fill: "#0078bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 403.6 370.7 397.7 371.1 397.7 377.4 403.3 377.4 403.6",
    fill: "#0079bc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 404 370.4 397.7 370.7 397.7 377.4 403.6 377.4 404",
    fill: "#0079bb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 404.3 370 397.7 370.4 397.7 377.4 404 377.4 404.3",
    fill: "#007aba",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 404.6 369.7 397.7 370 397.7 377.4 404.3 377.4 404.6",
    fill: "#007bb9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 404.9 369.3 397.7 369.7 397.7 377.4 404.6 377.4 404.9",
    fill: "#007cb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 405.2 369 397.7 369.3 397.7 377.4 404.9 377.4 405.2",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 405.5 368.6 397.7 369 397.7 377.4 405.2 377.4 405.5",
    fill: "#007db6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 405.8 368.2 397.7 368.6 397.7 377.4 405.5 377.4 405.8",
    fill: "#007eb5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 406.1 367.9 397.7 368.2 397.7 377.4 405.8 377.4 406.1",
    fill: "#007fb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 406.5 367.5 397.7 367.9 397.7 377.4 406.1 377.4 406.5",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 406.8 367.2 397.7 367.5 397.7 377.4 406.5 377.4 406.8",
    fill: "#0080b2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 407.1 366.8 397.7 367.2 397.7 377.4 406.8 377.4 407.1",
    fill: "#0081b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 407.4 366.5 397.7 366.8 397.7 377.4 407.1 377.4 407.4",
    fill: "#0082b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 407.7 366.1 397.7 366.5 397.7 377.4 407.4 377.4 407.7",
    fill: "#0083af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 408 365.8 397.7 366.1 397.7 377.4 407.7 377.4 408",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 408.3 365.4 397.7 365.8 397.7 377.4 408 377.4 408.3",
    fill: "#0084ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 408.6 365.1 397.7 365.4 397.7 377.4 408.3 377.4 408.6",
    fill: "#0085ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 409 364.7 397.7 365.1 397.7 377.4 408.6 377.4 409",
    fill: "#0086ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 409.3 364.4 397.7 364.7 397.7 377.4 409 377.4 409.3",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 409.6 364 397.7 364.4 397.7 377.4 409.3 377.4 409.6",
    fill: "#0087a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 409.9 363.7 397.7 364 397.7 377.4 409.6 377.4 409.9",
    fill: "#0088a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 410.2 363.3 397.7 363.7 397.7 377.4 409.9 377.4 410.2",
    fill: "#0089a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 410.5 363 397.7 363.3 397.7 377.4 410.2 377.4 410.5",
    fill: "#0089a5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 410.8 362.6 397.7 363 397.7 377.4 410.5 377.4 410.8",
    fill: "#008aa4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 411.1 362.3 397.7 362.6 397.7 377.4 410.8 377.4 411.1",
    fill: "#008ba3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 411.5 361.9 397.7 362.3 397.7 377.4 411.1 377.4 411.5",
    fill: "#008ca2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 411.8 361.6 397.7 361.9 397.7 377.4 411.5 377.4 411.8",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 412.1 361.2 397.7 361.6 397.7 377.4 411.8 377.4 412.1",
    fill: "#008da0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 412.4 360.9 397.7 361.2 397.7 377.4 412.1 377.4 412.4",
    fill: "#008e9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 412.7 360.5 397.7 360.9 397.7 377.4 412.4 377.4 412.7",
    fill: "#008f9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 413 360.2 397.7 360.5 397.7 377.4 412.7 377.4 413",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 413.3 359.8 397.7 360.2 397.7 377.4 413 377.4 413.3",
    fill: "#00909c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 413.6 359.5 397.7 359.8 397.7 377.4 413.3 377.4 413.6",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 414 359.1 397.7 359.5 397.7 377.4 413.6 377.4 414",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 414.3 358.8 397.7 359.1 397.7 377.4 414 377.4 414.3",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 414.6 358.4 397.7 358.8 397.7 377.4 414.3 377.4 414.6",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 414.9 358.1 397.7 358.4 397.7 377.4 414.6 377.4 414.9",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 415.2 357.7 397.7 358.1 397.7 377.4 414.9 377.4 415.2",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 415.5 357.4 397.7 357.7 397.7 377.4 415.2 377.4 415.5",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 415.8 357 397.7 357.4 397.7 377.4 415.5 377.4 415.8",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 416.1 356.7 397.7 357 397.7 377.4 415.8 377.4 416.1",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 416.5 356.3 397.7 356.7 397.7 377.4 416.1 377.4 416.5",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 416.8 356 397.7 356.3 397.7 377.4 416.5 377.4 416.8",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 417.1 355.6 397.7 356 397.7 377.4 416.8 377.4 417.1",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 417.4 355.3 397.7 355.6 397.7 377.4 417.1 377.4 417.4",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 417.7 354.9 397.7 355.3 397.7 377.4 417.4 377.4 417.7",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 418 354.6 397.7 354.9 397.7 377.4 417.7 377.4 418",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 418.3 354.2 397.7 354.6 397.7 377.4 418 377.4 418.3",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 418.6 353.9 397.7 354.2 397.7 377.4 418.3 377.4 418.6",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 419 353.5 397.7 353.9 397.7 377.4 418.6 377.4 419",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 419.3 353.2 397.7 353.5 397.7 377.4 419 377.4 419.3",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 419.6 352.8 397.7 353.2 397.7 377.4 419.3 377.4 419.6",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 419.9 352.5 397.7 352.8 397.7 377.4 419.6 377.4 419.9",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 420.2 352.1 397.7 352.5 397.7 377.4 419.9 377.4 420.2",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 420.5 351.8 397.7 352.1 397.7 377.4 420.2 377.4 420.5",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 420.8 351.7 398 351.7 397.7 351.8 397.7 377.4 420.5 377.4 420.8",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 421.1 351.7 398.3 351.7 398 377.4 420.8 377.4 421.1",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 421.5 351.7 398.6 351.7 398.3 377.4 421.1 377.4 421.5",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 421.8 351.7 399 351.7 398.6 377.4 421.5 377.4 421.8",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 422.1 351.7 399.3 351.7 399 377.4 421.8 377.4 422.1",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 422.5 351.7 399.7 351.7 399.3 377.4 422.1 377.4 422.5",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 422.8 351.7 400 351.7 399.7 377.4 422.5 377.4 422.8",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.4 423.2 351.7 400.4 351.7 400 377.4 422.8 377.4 423.2",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.1 423.3 351.7 400.7 351.7 400.4 377.4 423.2 377.4 423.3 377.1 423.3",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.7 423.3 351.7 401.1 351.7 400.7 377.1 423.3 376.7 423.3",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.3 423.3 351.7 401.4 351.7 401.1 376.7 423.3 376.3 423.3",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.9 423.3 351.7 401.8 351.7 401.4 376.3 423.3 375.9 423.3",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.6 423.3 351.7 402.1 351.7 401.8 375.9 423.3 375.6 423.3",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.2 423.3 351.7 402.5 351.7 402.1 375.6 423.3 375.2 423.3",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.8 423.3 351.7 402.8 351.7 402.5 375.2 423.3 374.8 423.3",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.4 423.3 351.7 403.1 351.7 402.8 374.8 423.3 374.4 423.3",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374 423.3 351.7 403.5 351.7 403.1 374.4 423.3 374 423.3",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.6 423.3 351.7 403.8 351.7 403.5 374 423.3 373.6 423.3",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.2 423.3 351.7 404.2 351.7 403.8 373.6 423.3 373.2 423.3",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.8 423.3 351.7 404.5 351.7 404.2 373.2 423.3 372.8 423.3",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 423.3 351.7 404.9 351.7 404.5 372.8 423.3 372.4 423.3",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.1 423.3 351.7 405.2 351.7 404.9 372.4 423.3 372.1 423.3",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.7 423.3 351.7 405.6 351.7 405.2 372.1 423.3 371.7 423.3",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.3 423.3 351.7 405.9 351.7 405.6 371.7 423.3 371.3 423.3",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.9 423.3 351.7 406.3 351.7 405.9 371.3 423.3 370.9 423.3",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.5 423.3 351.7 406.6 351.7 406.3 370.9 423.3 370.5 423.3",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.1 423.3 351.7 407 351.7 406.6 370.5 423.3 370.1 423.3",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.7 423.3 351.7 407.3 351.7 407 370.1 423.3 369.7 423.3",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.3 423.3 351.7 407.6 351.7 407.3 369.7 423.3 369.3 423.3",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369 423.3 351.7 408 351.7 407.6 369.3 423.3 369 423.3",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.6 423.3 351.7 408.3 351.7 408 369 423.3 368.6 423.3",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 423.3 351.7 408.7 351.7 408.3 368.6 423.3 368.2 423.3",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.8 423.3 351.7 409 351.7 408.7 368.2 423.3 367.8 423.3",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 423.3 351.7 409.4 351.7 409 367.8 423.3 367.4 423.3",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 423.3 351.7 409.7 351.7 409.4 367.4 423.3 367 423.3",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.6 423.3 351.7 410.1 351.7 409.7 367 423.3 366.6 423.3",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.2 423.3 351.7 410.4 351.7 410.1 366.6 423.3 366.2 423.3",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.8 423.3 351.7 410.8 351.7 410.4 366.2 423.3 365.8 423.3",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.5 423.3 351.7 411.1 351.7 410.8 365.8 423.3 365.5 423.3",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 423.3 351.7 411.5 351.7 411.1 365.5 423.3 365.1 423.3",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.7 423.3 351.7 411.8 351.7 411.5 365.1 423.3 364.7 423.3",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.3 423.3 351.7 412.1 351.7 411.8 364.7 423.3 364.3 423.3",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.7 412.1 364.3 423.3 351.7 423.3 351.7 412.1",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-26)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-27)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "375 399.9 374.9 399.8 375 399.8 375 399.9",
    fill: "#0076c0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 400.3 374.5 399.8 374.9 399.8 375 399.9 375 400.3",
    fill: "#0076bf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 400.6 374.2 399.8 374.5 399.8 375 400.3 375 400.6",
    fill: "#0077be",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 400.9 373.8 399.8 374.2 399.8 375 400.6 375 400.9",
    fill: "#0078bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 401.2 373.5 399.8 373.8 399.8 375 400.9 375 401.2",
    fill: "#0079bc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 401.5 373.1 399.8 373.5 399.8 375 401.2 375 401.5",
    fill: "#0079bb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 401.8 372.8 399.8 373.1 399.8 375 401.5 375 401.8",
    fill: "#007aba",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 402.1 372.4 399.8 372.8 399.8 375 401.8 375 402.1",
    fill: "#007bb9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 402.4 372.1 399.8 372.4 399.8 375 402.1 375 402.4",
    fill: "#007cb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 402.8 371.7 399.8 372.1 399.8 375 402.4 375 402.8",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 403.1 371.4 399.8 371.7 399.8 375 402.8 375 403.1",
    fill: "#007db6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 403.4 371 399.8 371.4 399.8 375 403.1 375 403.4",
    fill: "#007eb5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 403.7 370.7 399.8 371 399.8 375 403.4 375 403.7",
    fill: "#007fb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 404 370.3 399.8 370.7 399.8 375 403.7 375 404",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 404.3 370 399.8 370.3 399.8 375 404 375 404.3",
    fill: "#0080b2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 404.6 369.6 399.8 370 399.8 375 404.3 375 404.6",
    fill: "#0081b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 404.9 369.3 399.8 369.6 399.8 375 404.6 375 404.9",
    fill: "#0082b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 405.3 368.9 399.8 369.3 399.8 375 404.9 375 405.3",
    fill: "#0083af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 405.6 368.6 399.8 368.9 399.8 375 405.3 375 405.6",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 405.9 368.2 399.8 368.6 399.8 375 405.6 375 405.9",
    fill: "#0084ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 406.2 367.9 399.8 368.2 399.8 375 405.9 375 406.2",
    fill: "#0085ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 406.5 367.5 399.8 367.9 399.8 375 406.2 375 406.5",
    fill: "#0086ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 406.8 367.2 399.8 367.5 399.8 375 406.5 375 406.8",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 407.1 366.8 399.8 367.2 399.8 375 406.8 375 407.1",
    fill: "#0087a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 407.4 366.5 399.8 366.8 399.8 375 407.1 375 407.4",
    fill: "#0088a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 407.8 366.1 399.8 366.5 399.8 375 407.4 375 407.8",
    fill: "#0089a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 408.1 365.8 399.8 366.1 399.8 375 407.8 375 408.1",
    fill: "#0089a5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 408.4 365.4 399.8 365.8 399.8 375 408.1 375 408.4",
    fill: "#008aa4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 408.7 365.1 399.8 365.4 399.8 375 408.4 375 408.7",
    fill: "#008ba3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 409 364.7 399.8 365.1 399.8 375 408.7 375 409",
    fill: "#008ca2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 409.3 364.4 399.8 364.7 399.8 375 409 375 409.3",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 409.6 364 399.8 364.4 399.8 375 409.3 375 409.6",
    fill: "#008da0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 409.9 363.7 399.8 364 399.8 375 409.6 375 409.9",
    fill: "#008e9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 410.3 363.3 399.8 363.7 399.8 375 409.9 375 410.3",
    fill: "#008f9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 410.6 363 399.8 363.3 399.8 375 410.3 375 410.6",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 410.9 362.6 399.8 363 399.8 375 410.6 375 410.9",
    fill: "#00909c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 411.2 362.3 399.8 362.6 399.8 375 410.9 375 411.2",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 411.5 361.9 399.8 362.3 399.8 375 411.2 375 411.5",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 411.8 361.6 399.8 361.9 399.8 375 411.5 375 411.8",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 412.1 361.2 399.8 361.6 399.8 375 411.8 375 412.1",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 412.4 360.9 399.8 361.2 399.8 375 412.1 375 412.4",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 412.8 360.5 399.8 360.9 399.8 375 412.4 375 412.8",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 413.1 360.2 399.8 360.5 399.8 375 412.8 375 413.1",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 413.4 359.8 399.8 360.2 399.8 375 413.1 375 413.4",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 413.7 359.5 399.8 359.8 399.8 375 413.4 375 413.7",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 414 359.1 399.8 359.5 399.8 375 413.7 375 414",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 414.3 358.7 399.8 359.1 399.8 375 414 375 414.3",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 414.6 358.4 399.8 358.7 399.8 375 414.3 375 414.6",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 414.9 358 399.8 358.4 399.8 375 414.6 375 414.9",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 415.3 357.7 399.8 358 399.8 375 414.9 375 415.3",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 415.6 357.3 399.8 357.7 399.8 375 415.3 375 415.6",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 415.9 357 399.8 357.3 399.8 375 415.6 375 415.9",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 416.2 356.6 399.8 357 399.8 375 415.9 375 416.2",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 416.5 356.3 399.8 356.6 399.8 375 416.2 375 416.5",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 416.8 355.9 399.8 356.3 399.8 375 416.5 375 416.8",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 417.1 355.6 399.8 355.9 399.8 375 416.8 375 417.1",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 417.4 355.2 399.8 355.6 399.8 375 417.1 375 417.4",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 417.8 354.9 399.8 355.2 399.8 375 417.4 375 417.8",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 418.1 354.5 399.8 354.9 399.8 375 417.8 375 418.1",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 418.4 354.2 399.8 354.5 399.8 375 418.1 375 418.4",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 418.7 353.8 399.8 354.2 399.8 375 418.4 375 418.7",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 419 353.5 399.8 353.8 399.8 375 418.7 375 419",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 419.4 353.1 399.8 353.5 399.8 375 419 375 419.4",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 419.7 352.7 399.8 353.1 399.8 375 419.4 375 419.7",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 420 352.3 399.8 352.7 399.8 375 419.7 375 420",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 420.4 351.9 399.8 352.3 399.8 375 420 375 420.4",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 420.7 351.5 399.8 351.9 399.8 375 420.4 375 420.7",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 421.1 351.2 399.8 351.5 399.8 375 420.7 375 421.1",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 421.4 350.8 399.8 351.2 399.8 375 421.1 375 421.4",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 421.8 350.4 399.8 350.8 399.8 375 421.4 375 421.8",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 422.1 350 399.8 350.4 399.8 375 421.8 375 422.1",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 422.5 349.6 399.8 350 399.8 375 422.1 375 422.5",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 422.8 349.2 399.8 349.6 399.8 375 422.5 375 422.8",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 423.2 349.2 400.1 349.2 399.8 349.2 399.8 375 422.8 375 423.2",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 423.5 349.2 400.5 349.2 400.1 375 423.2 375 423.5",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 423.9 349.2 400.8 349.2 400.5 375 423.5 375 423.9",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 424.2 349.2 401.2 349.2 400.8 375 423.9 375 424.2",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 424.5 349.2 401.5 349.2 401.2 375 424.2 375 424.5",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 424.9 349.2 401.9 349.2 401.5 375 424.5 375 424.9",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 425.2 349.2 402.2 349.2 401.9 375 424.9 375 425.2",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 425.6 349.2 402.6 349.2 402.2 375 425.2 375 425.6",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.7 425.7 349.2 402.9 349.2 402.6 375 425.6 375 425.7 374.7 425.7",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.3 425.7 349.2 403.3 349.2 402.9 374.7 425.7 374.3 425.7",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.9 425.7 349.2 403.6 349.2 403.3 374.3 425.7 373.9 425.7",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.5 425.7 349.2 404 349.2 403.6 373.9 425.7 373.5 425.7",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.2 425.7 349.2 404.3 349.2 404 373.5 425.7 373.2 425.7",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.8 425.7 349.2 404.6 349.2 404.3 373.2 425.7 372.8 425.7",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 425.7 349.2 405 349.2 404.6 372.8 425.7 372.4 425.7",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372 425.7 349.2 405.3 349.2 405 372.4 425.7 372 425.7",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.6 425.7 349.2 405.7 349.2 405.3 372 425.7 371.6 425.7",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.2 425.7 349.2 406 349.2 405.7 371.6 425.7 371.2 425.7",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.8 425.7 349.2 406.4 349.2 406 371.2 425.7 370.8 425.7",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.4 425.7 349.2 406.7 349.2 406.4 370.8 425.7 370.4 425.7",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.1 425.7 349.2 407.1 349.2 406.7 370.4 425.7 370.1 425.7",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.7 425.7 349.2 407.4 349.2 407.1 370.1 425.7 369.7 425.7",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.3 425.7 349.2 407.8 349.2 407.4 369.7 425.7 369.3 425.7",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.9 425.7 349.2 408.1 349.2 407.8 369.3 425.7 368.9 425.7",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.5 425.7 349.2 408.5 349.2 408.1 368.9 425.7 368.5 425.7",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.1 425.7 349.2 408.8 349.2 408.5 368.5 425.7 368.1 425.7",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.7 425.7 349.2 409.1 349.2 408.8 368.1 425.7 367.7 425.7",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.3 425.7 349.2 409.5 349.2 409.1 367.7 425.7 367.3 425.7",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.2 409.5 367.3 425.7 349.2 425.7 349.2 409.5",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-29)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 402.4 357.6 402.4 357.6 402.4 357.6 402.4",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 402.7 357.2 402.4 357.6 402.4 357.6 402.4 357.6 402.7",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 403 356.9 402.4 357.2 402.4 357.6 402.7 357.6 403",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 403.3 356.5 402.4 356.9 402.4 357.6 403 357.6 403.3",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 403.7 356.2 402.4 356.5 402.4 357.6 403.3 357.6 403.7",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 404 355.8 402.4 356.2 402.4 357.6 403.7 357.6 404",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 404.3 355.4 402.4 355.8 402.4 357.6 404 357.6 404.3",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 404.7 355 402.4 355.4 402.4 357.6 404.3 357.6 404.7",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 405 354.6 402.4 355 402.4 357.6 404.7 357.6 405",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 405.4 354.2 402.4 354.6 402.4 357.6 405 357.6 405.4",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 405.7 353.8 402.4 354.2 402.4 357.6 405.4 357.6 405.7",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 406.1 353.4 402.4 353.8 402.4 357.6 405.7 357.6 406.1",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 406.4 353 402.4 353.4 402.4 357.6 406.1 357.6 406.4",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 406.8 352.7 402.4 353 402.4 357.6 406.4 357.6 406.8",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 407.1 352.3 402.4 352.7 402.4 357.6 406.8 357.6 407.1",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 407.5 351.9 402.4 352.3 402.4 357.6 407.1 357.6 407.5",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 407.8 351.5 402.4 351.9 402.4 357.6 407.5 357.6 407.8",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 408.2 351.1 402.4 351.5 402.4 357.6 407.8 357.6 408.2",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 408.5 350.7 402.4 351.1 402.4 357.6 408.2 357.6 408.5",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 408.8 350.3 402.4 350.7 402.4 357.6 408.5 357.6 408.8",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 409.2 349.9 402.4 350.3 402.4 357.6 408.8 357.6 409.2",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 409.5 349.6 402.4 349.9 402.4 357.6 409.2 357.6 409.5",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 409.9 349.2 402.4 349.6 402.4 357.6 409.5 357.6 409.9",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 410.2 348.8 402.4 349.2 402.4 357.6 409.9 357.6 410.2",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 410.6 348.4 402.4 348.8 402.4 357.6 410.2 357.6 410.6",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 410.9 348 402.4 348.4 402.4 357.6 410.6 357.6 410.9",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 411.3 347.6 402.4 348 402.4 357.6 410.9 357.6 411.3",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 411.6 347.2 402.4 347.6 402.4 357.6 411.3 357.6 411.6",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 412 346.8 402.4 347.2 402.4 357.6 411.6 357.6 412",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 412.3 346.4 402.4 346.8 402.4 357.6 412 357.6 412.3",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 412.7 346.1 402.4 346.4 402.4 357.6 412.3 357.6 412.7",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 413 345.7 402.4 346.1 402.4 357.6 412.7 357.6 413",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 413.3 345.3 402.4 345.7 402.4 357.6 413 357.6 413.3",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 413.7 344.9 402.4 345.3 402.4 357.6 413.3 357.6 413.7",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 414 344.5 402.4 344.9 402.4 357.6 413.7 357.6 414",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 414.4 344.1 402.4 344.5 402.4 357.6 414 357.6 414.4",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 414.7 343.7 402.4 344.1 402.4 357.6 414.4 357.6 414.7",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 415.1 343.3 402.4 343.7 402.4 357.6 414.7 357.6 415.1",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 415.4 342.9 402.4 343.3 402.4 357.6 415.1 357.6 415.4",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 415.8 342.6 402.4 342.9 402.4 357.6 415.4 357.6 415.8",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 416.1 342.2 402.4 342.6 402.4 357.6 415.8 357.6 416.1",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 416.5 341.8 402.4 341.8 402.4 342.2 402.4 357.6 416.1 357.6 416.5",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 416.8 341.8 402.8 341.8 402.4 357.6 416.5 357.6 416.8",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.6 417.2 341.8 403.1 341.8 402.8 357.6 416.8 357.6 417.2",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.8 403.1 357.6 417.2 357.6 418.1 341.8 418.1 341.8 403.1",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-30)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-31)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 397.8 372.2 397.7 372.4 397.7 372.4 397.8",
    fill: "#0076c0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 398.1 371.9 397.7 372.2 397.7 372.4 397.8 372.4 398.1",
    fill: "#0076bf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 398.4 371.5 397.7 371.9 397.7 372.4 398.1 372.4 398.4",
    fill: "#0077be",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 398.7 371.2 397.7 371.5 397.7 372.4 398.4 372.4 398.7",
    fill: "#0078bd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 399.1 370.8 397.7 371.2 397.7 372.4 398.7 372.4 399.1",
    fill: "#0079bc",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 399.4 370.5 397.7 370.8 397.7 372.4 399.1 372.4 399.4",
    fill: "#0079bb",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 399.7 370.1 397.7 370.5 397.7 372.4 399.4 372.4 399.7",
    fill: "#007aba",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 400 369.8 397.7 370.1 397.7 372.4 399.7 372.4 400",
    fill: "#007bb9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 400.3 369.4 397.7 369.8 397.7 372.4 400 372.4 400.3",
    fill: "#007cb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 400.6 369.1 397.7 369.4 397.7 372.4 400.3 372.4 400.6",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 400.9 368.7 397.7 369.1 397.7 372.4 400.6 372.4 400.9",
    fill: "#007db6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 401.2 368.4 397.7 368.7 397.7 372.4 400.9 372.4 401.2",
    fill: "#007eb5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 401.6 368 397.7 368.4 397.7 372.4 401.2 372.4 401.6",
    fill: "#007fb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 401.9 367.7 397.7 368 397.7 372.4 401.6 372.4 401.9",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 402.2 367.3 397.7 367.7 397.7 372.4 401.9 372.4 402.2",
    fill: "#0080b2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 402.5 367 397.7 367.3 397.7 372.4 402.2 372.4 402.5",
    fill: "#0081b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 402.8 366.6 397.7 367 397.7 372.4 402.5 372.4 402.8",
    fill: "#0082b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 403.1 366.3 397.7 366.6 397.7 372.4 402.8 372.4 403.1",
    fill: "#0083af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 403.4 365.9 397.7 366.3 397.7 372.4 403.1 372.4 403.4",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 403.7 365.6 397.7 365.9 397.7 372.4 403.4 372.4 403.7",
    fill: "#0084ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 404.1 365.2 397.7 365.6 397.7 372.4 403.7 372.4 404.1",
    fill: "#0085ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 404.4 364.9 397.7 365.2 397.7 372.4 404.1 372.4 404.4",
    fill: "#0086ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 404.7 364.5 397.7 364.9 397.7 372.4 404.4 372.4 404.7",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 405 364.2 397.7 364.5 397.7 372.4 404.7 372.4 405",
    fill: "#0087a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 405.3 363.8 397.7 364.2 397.7 372.4 405 372.4 405.3",
    fill: "#0088a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 405.6 363.5 397.7 363.8 397.7 372.4 405.3 372.4 405.6",
    fill: "#0089a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 405.9 363.1 397.7 363.5 397.7 372.4 405.6 372.4 405.9",
    fill: "#0089a5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 406.2 362.8 397.7 363.1 397.7 372.4 405.9 372.4 406.2",
    fill: "#008aa4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 406.6 362.4 397.7 362.8 397.7 372.4 406.2 372.4 406.6",
    fill: "#008ba3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 406.9 362.1 397.7 362.4 397.7 372.4 406.6 372.4 406.9",
    fill: "#008ca2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 407.2 361.7 397.7 362.1 397.7 372.4 406.9 372.4 407.2",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 407.5 361.4 397.7 361.7 397.7 372.4 407.2 372.4 407.5",
    fill: "#008da0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 407.8 361 397.7 361.4 397.7 372.4 407.5 372.4 407.8",
    fill: "#008e9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 408.1 360.7 397.7 361 397.7 372.4 407.8 372.4 408.1",
    fill: "#008f9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 408.4 360.3 397.7 360.7 397.7 372.4 408.1 372.4 408.4",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 408.7 360 397.7 360.3 397.7 372.4 408.4 372.4 408.7",
    fill: "#00909c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 409.1 359.6 397.7 360 397.7 372.4 408.7 372.4 409.1",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 409.4 359.3 397.7 359.6 397.7 372.4 409.1 372.4 409.4",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 409.7 358.9 397.7 359.3 397.7 372.4 409.4 372.4 409.7",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 410 358.6 397.7 358.9 397.7 372.4 409.7 372.4 410",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 410.3 358.2 397.7 358.6 397.7 372.4 410 372.4 410.3",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 410.6 357.9 397.7 358.2 397.7 372.4 410.3 372.4 410.6",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 410.9 357.5 397.7 357.9 397.7 372.4 410.6 372.4 410.9",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 411.2 357.2 397.7 357.5 397.7 372.4 410.9 372.4 411.2",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 411.6 356.9 397.7 356.9 397.7 357.2 397.7 372.4 411.2 372.4 411.6",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 411.9 356.9 398.1 356.9 397.7 372.4 411.6 372.4 411.9",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 412.2 356.9 398.4 356.9 398.1 372.4 411.9 372.4 412.2",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 412.5 356.9 398.7 356.9 398.4 372.4 412.2 372.4 412.5",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 412.8 356.9 399 356.9 398.7 372.4 412.5 372.4 412.8",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 413.1 356.9 399.3 356.9 399 372.4 412.8 372.4 413.1",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.1 413.2 356.9 399.6 356.9 399.3 372.4 413.1 372.4 413.2 372.1 413.2",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.8 413.2 356.9 399.9 356.9 399.6 372.1 413.2 371.8 413.2",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.4 413.2 356.9 400.2 356.9 399.9 371.8 413.2 371.4 413.2",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371 413.2 356.9 400.6 356.9 400.2 371.4 413.2 371 413.2",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.7 413.2 356.9 400.9 356.9 400.6 371 413.2 370.7 413.2",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.3 413.2 356.9 401.2 356.9 400.9 370.7 413.2 370.3 413.2",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370 413.2 356.9 401.5 356.9 401.2 370.3 413.2 370 413.2",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.6 413.2 356.9 401.8 356.9 401.5 370 413.2 369.6 413.2",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.3 413.2 356.9 402.1 356.9 401.8 369.6 413.2 369.3 413.2",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.9 413.2 356.9 402.4 356.9 402.1 369.3 413.2 368.9 413.2",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.6 413.2 356.9 402.7 356.9 402.4 368.9 413.2 368.6 413.2",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.2 413.2 356.9 403.1 356.9 402.7 368.6 413.2 368.2 413.2",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.9 413.2 356.9 403.4 356.9 403.1 368.2 413.2 367.9 413.2",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.5 413.2 356.9 403.7 356.9 403.4 367.9 413.2 367.5 413.2",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.1 413.2 356.9 404.1 356.9 403.7 367.5 413.2 367.1 413.2",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.7 413.2 356.9 404.4 356.9 404.1 367.1 413.2 366.7 413.2",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.3 413.2 356.9 404.8 356.9 404.4 366.7 413.2 366.3 413.2",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.9 413.2 356.9 405.1 356.9 404.8 366.3 413.2 365.9 413.2",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.5 413.2 356.9 405.5 356.9 405.1 365.9 413.2 365.5 413.2",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 413.2 356.9 405.8 356.9 405.5 365.5 413.2 365.1 413.2",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.7 413.2 356.9 406.2 356.9 405.8 365.1 413.2 364.7 413.2",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.4 413.2 356.9 406.5 356.9 406.2 364.7 413.2 364.4 413.2",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364 413.2 356.9 406.9 356.9 406.5 364.4 413.2 364 413.2",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.6 413.2 356.9 407.2 356.9 406.9 364 413.2 363.6 413.2",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.2 413.2 356.9 407.6 356.9 407.2 363.6 413.2 363.2 413.2",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.8 413.2 356.9 407.9 356.9 407.6 363.2 413.2 362.8 413.2",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.4 413.2 356.9 408.2 356.9 407.9 362.8 413.2 362.4 413.2",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362 413.2 356.9 408.6 356.9 408.2 362.4 413.2 362 413.2",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.6 413.2 356.9 408.9 356.9 408.6 362 413.2 361.6 413.2",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.2 413.2 356.9 409.3 356.9 408.9 361.6 413.2 361.2 413.2",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.9 413.2 356.9 409.6 356.9 409.3 361.2 413.2 360.9 413.2",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.5 413.2 356.9 410 356.9 409.6 360.9 413.2 360.5 413.2",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.1 413.2 356.9 410.3 356.9 410 360.5 413.2 360.1 413.2",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.7 413.2 356.9 410.7 356.9 410.3 360.1 413.2 359.7 413.2",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.3 413.2 356.9 411 356.9 410.7 359.7 413.2 359.3 413.2",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.9 413.2 356.9 411.4 356.9 411 359.3 413.2 358.9 413.2",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.5 413.2 356.9 411.7 356.9 411.4 358.9 413.2 358.5 413.2",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.1 413.2 356.9 412.1 356.9 411.7 358.5 413.2 358.1 413.2",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.7 413.2 356.9 412.4 356.9 412.1 358.1 413.2 357.7 413.2",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 413.2 356.9 412.7 356.9 412.4 357.7 413.2 357.4 413.2",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357 413.2 356.9 413.1 356.9 412.7 357.4 413.2 357 413.2",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.9 413.1 357 413.2 356.9 413.2 356.9 413.1",
    fill: "#00ba64",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-32)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-33)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 395.3 364.8 395 365.1 395 365.1 395.3",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 395.6 364.4 395 364.8 395 365.1 395.3 365.1 395.6",
    fill: "#0080b2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 395.9 364.1 395 364.4 395 365.1 395.6 365.1 395.9",
    fill: "#0081b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 396.2 363.7 395 364.1 395 365.1 395.9 365.1 396.2",
    fill: "#0082b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 396.5 363.4 395 363.7 395 365.1 396.2 365.1 396.5",
    fill: "#0083af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 396.8 363 395 363.4 395 365.1 396.5 365.1 396.8",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 397.2 362.7 395 363 395 365.1 396.8 365.1 397.2",
    fill: "#0084ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 397.5 362.3 395 362.7 395 365.1 397.2 365.1 397.5",
    fill: "#0085ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 397.8 362 395 362.3 395 365.1 397.5 365.1 397.8",
    fill: "#0086ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 398.1 361.6 395 362 395 365.1 397.8 365.1 398.1",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 398.4 361.3 395 361.6 395 365.1 398.1 365.1 398.4",
    fill: "#0087a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 398.7 360.9 395 361.3 395 365.1 398.4 365.1 398.7",
    fill: "#0088a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 399 360.6 395 360.9 395 365.1 398.7 365.1 399",
    fill: "#0089a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 399.3 360.2 395 360.6 395 365.1 399 365.1 399.3",
    fill: "#0089a5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 399.7 359.9 395 360.2 395 365.1 399.3 365.1 399.7",
    fill: "#008aa4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 400 359.5 395 359.9 395 365.1 399.7 365.1 400",
    fill: "#008ba3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 400.3 359.2 395 359.5 395 365.1 400 365.1 400.3",
    fill: "#008ca2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 400.6 358.8 395 359.2 395 365.1 400.3 365.1 400.6",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 400.9 358.5 395 358.8 395 365.1 400.6 365.1 400.9",
    fill: "#008da0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 401.2 358.1 395 358.5 395 365.1 400.9 365.1 401.2",
    fill: "#008e9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 401.5 357.8 395 358.1 395 365.1 401.2 365.1 401.5",
    fill: "#008f9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 401.8 357.4 395 357.8 395 365.1 401.5 365.1 401.8",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 402.2 357.1 395 357.4 395 365.1 401.8 365.1 402.2",
    fill: "#00909c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 402.5 356.7 395 357.1 395 365.1 402.2 365.1 402.5",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 402.8 356.4 395 356.7 395 365.1 402.5 365.1 402.8",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 403.1 356 395 356.4 395 365.1 402.8 365.1 403.1",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 403.4 355.7 395 356 395 365.1 403.1 365.1 403.4",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 403.7 355.3 395 355.7 395 365.1 403.4 365.1 403.7",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 404 355 395 355.3 395 365.1 403.7 365.1 404",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 404.3 354.6 395 355 395 365.1 404 365.1 404.3",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 404.7 354.3 395 354.6 395 365.1 404.3 365.1 404.7",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 405 353.9 395 354.3 395 365.1 404.7 365.1 405",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 405.3 353.6 395 353.9 395 365.1 405 365.1 405.3",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 405.6 353.2 395 353.6 395 365.1 405.3 365.1 405.6",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 405.9 352.9 395 353.2 395 365.1 405.6 365.1 405.9",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 406.2 352.5 395 352.9 395 365.1 405.9 365.1 406.2",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 406.5 352.2 395 352.5 395 365.1 406.2 365.1 406.5",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 406.8 351.8 395 352.2 395 365.1 406.5 365.1 406.8",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 407.2 351.5 395 351.8 395 365.1 406.8 365.1 407.2",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 407.5 351.1 395 351.5 395 365.1 407.2 365.1 407.5",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 407.8 350.8 395 351.1 395 365.1 407.5 365.1 407.8",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 408.1 350.4 395 350.8 395 365.1 407.8 365.1 408.1",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 408.4 350.1 395 350.4 395 365.1 408.1 365.1 408.4",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 408.7 349.7 395 350.1 395 365.1 408.4 365.1 408.7",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 409 349.4 395 349.4 395 349.7 395 365.1 408.7 365.1 409",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 409.3 349.4 395.3 349.4 395 365.1 409 365.1 409.3",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 409.7 349.4 395.6 349.4 395.3 365.1 409.3 365.1 409.7",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 410 349.4 395.9 349.4 395.6 365.1 409.7 365.1 410",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 410.3 349.4 396.3 349.4 395.9 365.1 410 365.1 410.3",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 410.6 349.4 396.6 349.4 396.3 365.1 410.3 365.1 410.6",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.8 410.7 349.4 397 349.4 396.6 365.1 410.6 365.1 410.7 364.8 410.7",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.4 410.7 349.4 397.3 349.4 397 364.8 410.7 364.4 410.7",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.1 410.7 349.4 397.6 349.4 397.3 364.4 410.7 364.1 410.7",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.7 410.7 349.4 398 349.4 397.6 364.1 410.7 363.7 410.7",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.3 410.7 349.4 398.3 349.4 398 363.7 410.7 363.3 410.7",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.9 410.7 349.4 398.7 349.4 398.3 363.3 410.7 362.9 410.7",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.5 410.7 349.4 399 349.4 398.7 362.9 410.7 362.5 410.7",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.1 410.7 349.4 399.4 349.4 399 362.5 410.7 362.1 410.7",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.7 410.7 349.4 399.7 349.4 399.4 362.1 410.7 361.7 410.7",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.3 410.7 349.4 400.1 349.4 399.7 361.7 410.7 361.3 410.7",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.9 410.7 349.4 400.4 349.4 400.1 361.3 410.7 360.9 410.7",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.6 410.7 349.4 400.8 349.4 400.4 360.9 410.7 360.6 410.7",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.2 410.7 349.4 401.1 349.4 400.8 360.6 410.7 360.2 410.7",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 410.7 349.4 401.5 349.4 401.1 360.2 410.7 359.8 410.7",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.4 410.7 349.4 401.8 349.4 401.5 359.8 410.7 359.4 410.7",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359 410.7 349.4 402.1 349.4 401.8 359.4 410.7 359 410.7",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.6 410.7 349.4 402.5 349.4 402.1 359 410.7 358.6 410.7",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.2 410.7 349.4 402.8 349.4 402.5 358.6 410.7 358.2 410.7",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.8 410.7 349.4 403.2 349.4 402.8 358.2 410.7 357.8 410.7",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 410.7 349.4 403.5 349.4 403.2 357.8 410.7 357.4 410.7",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.1 410.7 349.4 403.9 349.4 403.5 357.4 410.7 357.1 410.7",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.7 410.7 349.4 404.2 349.4 403.9 357.1 410.7 356.7 410.7",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.3 410.7 349.4 404.6 349.4 404.2 356.7 410.7 356.3 410.7",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.9 410.7 349.4 404.9 349.4 404.6 356.3 410.7 355.9 410.7",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.5 410.7 349.4 405.3 349.4 404.9 355.9 410.7 355.5 410.7",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.1 410.7 349.4 405.6 349.4 405.3 355.5 410.7 355.1 410.7",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.7 410.7 349.4 406 349.4 405.6 355.1 410.7 354.7 410.7",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.3 410.7 349.4 406.3 349.4 406 354.7 410.7 354.3 410.7",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354 410.7 349.4 406.6 349.4 406.3 354.3 410.7 354 410.7",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.6 410.7 349.4 407 349.4 406.6 354 410.7 353.6 410.7",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.2 410.7 349.4 407.3 349.4 407 353.6 410.7 353.2 410.7",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.8 410.7 349.4 407.7 349.4 407.3 353.2 410.7 352.8 410.7",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.4 410.7 349.4 408 349.4 407.7 352.8 410.7 352.4 410.7",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352 410.7 349.4 408.4 349.4 408 352.4 410.7 352 410.7",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.6 410.7 349.4 408.7 349.4 408.4 352 410.7 351.6 410.7",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.2 410.7 349.4 409.1 349.4 408.7 351.6 410.7 351.2 410.7",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.8 410.7 349.4 409.4 349.4 409.1 351.2 410.7 350.8 410.7",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.5 410.7 349.4 409.8 349.4 409.4 350.8 410.7 350.5 410.7",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.4 409.8 350.5 410.7 349.4 410.7 349.4 409.8",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-35)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 405.1 377.7 405 377.8 405 377.8 405.1",
    fill: "#007cb8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 405.4 377.3 405 377.7 405 377.8 405.1 377.8 405.4",
    fill: "#007cb7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 405.8 377 405 377.3 405 377.8 405.4 377.8 405.8",
    fill: "#007db6",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 406.1 376.6 405 377 405 377.8 405.8 377.8 406.1",
    fill: "#007eb5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 406.4 376.3 405 376.6 405 377.8 406.1 377.8 406.4",
    fill: "#007fb4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 406.7 375.9 405 376.3 405 377.8 406.4 377.8 406.7",
    fill: "#007fb3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 407 375.6 405 375.9 405 377.8 406.7 377.8 407",
    fill: "#0080b2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 407.3 375.2 405 375.6 405 377.8 407 377.8 407.3",
    fill: "#0081b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 407.6 374.9 405 375.2 405 377.8 407.3 377.8 407.6",
    fill: "#0082b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 407.9 374.5 405 374.9 405 377.8 407.6 377.8 407.9",
    fill: "#0083af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 408.3 374.2 405 374.5 405 377.8 407.9 377.8 408.3",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 408.6 373.8 405 374.2 405 377.8 408.3 377.8 408.6",
    fill: "#0084ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 408.9 373.5 405 373.8 405 377.8 408.6 377.8 408.9",
    fill: "#0085ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 409.2 373.1 405 373.5 405 377.8 408.9 377.8 409.2",
    fill: "#0086ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 409.5 372.8 405 373.1 405 377.8 409.2 377.8 409.5",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 409.8 372.4 405 372.8 405 377.8 409.5 377.8 409.8",
    fill: "#0087a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 410.1 372.1 405 372.4 405 377.8 409.8 377.8 410.1",
    fill: "#0088a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 410.4 371.7 405 372.1 405 377.8 410.1 377.8 410.4",
    fill: "#0089a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 410.8 371.4 405 371.7 405 377.8 410.4 377.8 410.8",
    fill: "#0089a5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 411.1 371 405 371.4 405 377.8 410.8 377.8 411.1",
    fill: "#008aa4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 411.4 370.7 405 371 405 377.8 411.1 377.8 411.4",
    fill: "#008ba3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 411.7 370.3 405 370.7 405 377.8 411.4 377.8 411.7",
    fill: "#008ca2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 412 369.9 405 370.3 405 377.8 411.7 377.8 412",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 412.3 369.6 405 369.9 405 377.8 412 377.8 412.3",
    fill: "#008da0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 412.6 369.2 405 369.6 405 377.8 412.3 377.8 412.6",
    fill: "#008e9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 412.9 368.9 405 369.2 405 377.8 412.6 377.8 412.9",
    fill: "#008f9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 413.3 368.5 405 368.9 405 377.8 412.9 377.8 413.3",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 413.6 368.2 405 368.5 405 377.8 413.3 377.8 413.6",
    fill: "#00909c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 413.9 367.8 405 368.2 405 377.8 413.6 377.8 413.9",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 414.2 367.5 405 367.8 405 377.8 413.9 377.8 414.2",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 414.5 367.1 405 367.5 405 377.8 414.2 377.8 414.5",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 414.8 367 405.2 367 405 367.1 405 377.8 414.5 377.8 414.8",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 415.1 367 405.5 367 405.2 377.8 414.8 377.8 415.1",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 415.4 367 405.8 367 405.5 377.8 415.1 377.8 415.4",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.8 415.8 367 406.1 367 405.8 377.8 415.4 377.8 415.8",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.5 415.9 367 406.5 367 406.1 377.8 415.8 377.8 415.9 377.5 415.9",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.2 415.9 367 406.8 367 406.5 377.5 415.9 377.2 415.9",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.8 415.9 367 407.1 367 406.8 377.2 415.9 376.8 415.9",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.5 415.9 367 407.4 367 407.1 376.8 415.9 376.5 415.9",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.1 415.9 367 407.7 367 407.4 376.5 415.9 376.1 415.9",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.8 415.9 367 408 367 407.7 376.1 415.9 375.8 415.9",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 415.9 367 408.3 367 408 375.8 415.9 375.4 415.9",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.1 415.9 367 408.6 367 408.3 375.4 415.9 375.1 415.9",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.7 415.9 367 409 367 408.6 375.1 415.9 374.7 415.9",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.4 415.9 367 409.3 367 409 374.7 415.9 374.4 415.9",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374 415.9 367 409.6 367 409.3 374.4 415.9 374 415.9",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.7 415.9 367 409.9 367 409.6 374 415.9 373.7 415.9",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.3 415.9 367 410.2 367 409.9 373.7 415.9 373.3 415.9",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373 415.9 367 410.5 367 410.2 373.3 415.9 373 415.9",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.6 415.9 367 410.8 367 410.5 373 415.9 372.6 415.9",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.3 415.9 367 411.1 367 410.8 372.6 415.9 372.3 415.9",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.9 415.9 367 411.5 367 411.1 372.3 415.9 371.9 415.9",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.6 415.9 367 411.8 367 411.5 371.9 415.9 371.6 415.9",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.2 415.9 367 412.1 367 411.8 371.6 415.9 371.2 415.9",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.8 415.9 367 412.4 367 412.1 371.2 415.9 370.8 415.9",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.4 415.9 367 412.8 367 412.4 370.8 415.9 370.4 415.9",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370 415.9 367 413.1 367 412.8 370.4 415.9 370 415.9",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.7 415.9 367 413.5 367 413.1 370 415.9 369.7 415.9",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.3 415.9 367 413.8 367 413.5 369.7 415.9 369.3 415.9",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.9 415.9 367 414.2 367 413.8 369.3 415.9 368.9 415.9",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.5 415.9 367 414.5 367 414.2 368.9 415.9 368.5 415.9",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.1 415.9 367 414.8 367 414.5 368.5 415.9 368.1 415.9",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.7 415.9 367 415.2 367 414.8 368.1 415.9 367.7 415.9",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.3 415.9 367 415.5 367 415.2 367.7 415.9 367.3 415.9",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 415.5 367.3 415.9 367 415.9 367 415.5",
    fill: "#00ac78",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-36)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-37)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 410.3 367.3 410.2 367.4 410.2 367.4 410.3",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 410.7 366.9 410.2 367.3 410.2 367.4 410.3 367.4 410.7",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 411 366.6 410.2 366.9 410.2 367.4 410.7 367.4 411",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 411.3 366.2 410.2 366.6 410.2 367.4 411 367.4 411.3",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 411.6 365.9 410.2 366.2 410.2 367.4 411.3 367.4 411.6",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 411.9 365.5 410.2 365.9 410.2 367.4 411.6 367.4 411.9",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 412.2 365.2 410.2 365.5 410.2 367.4 411.9 367.4 412.2",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 412.5 364.8 410.2 365.2 410.2 367.4 412.2 367.4 412.5",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 412.9 364.4 410.2 364.8 410.2 367.4 412.5 367.4 412.9",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 413.2 364 410.2 364.4 410.2 367.4 412.9 367.4 413.2",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 413.6 363.6 410.2 364 410.2 367.4 413.2 367.4 413.6",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 413.9 363.3 410.2 363.6 410.2 367.4 413.6 367.4 413.9",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 414.3 362.9 410.2 363.3 410.2 367.4 413.9 367.4 414.3",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 414.6 362.5 410.2 362.9 410.2 367.4 414.3 367.4 414.6",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 415 362.1 410.2 362.5 410.2 367.4 414.6 367.4 415",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 415.3 361.7 410.2 362.1 410.2 367.4 415 367.4 415.3",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 415.6 361.3 410.2 361.7 410.2 367.4 415.3 367.4 415.6",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 416 360.9 410.2 361.3 410.2 367.4 415.6 367.4 416",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 416.3 360.5 410.2 360.9 410.2 367.4 416 367.4 416.3",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 416.7 360.1 410.2 360.5 410.2 367.4 416.3 367.4 416.7",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 417 359.8 410.2 360.1 410.2 367.4 416.7 367.4 417",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 417.4 359.4 410.2 359.8 410.2 367.4 417 367.4 417.4",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 417.7 359 410.2 359.4 410.2 367.4 417.4 367.4 417.7",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 418.1 358.6 410.2 359 410.2 367.4 417.7 367.4 418.1",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 418.4 358.2 410.2 358.6 410.2 367.4 418.1 367.4 418.4",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 418.8 357.8 410.2 358.2 410.2 367.4 418.4 367.4 418.8",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 419.1 357.4 410.2 357.8 410.2 367.4 418.8 367.4 419.1",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 419.5 357 410.2 357.4 410.2 367.4 419.1 367.4 419.5",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 419.8 356.8 410.4 356.8 410.2 357 410.2 367.4 419.5 367.4 419.8",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 420.1 356.8 410.7 356.8 410.4 367.4 419.8 367.4 420.1",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.4 420.5 356.8 411.1 356.8 410.7 367.4 420.1 367.4 420.5",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.3 420.8 356.8 411.4 356.8 411.1 367.4 420.5 367.4 420.8 367.3 420.8",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.9 420.8 356.8 411.8 356.8 411.4 367.3 420.8 366.9 420.8",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.5 420.8 356.8 412.1 356.8 411.8 366.9 420.8 366.5 420.8",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.2 420.8 356.8 412.5 356.8 412.1 366.5 420.8 366.2 420.8",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.8 420.8 356.8 412.8 356.8 412.5 366.2 420.8 365.8 420.8",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.4 420.8 356.8 413.1 356.8 412.8 365.8 420.8 365.4 420.8",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365 420.8 356.8 413.5 356.8 413.1 365.4 420.8 365 420.8",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.6 420.8 356.8 413.8 356.8 413.5 365 420.8 364.6 420.8",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.2 420.8 356.8 414.2 356.8 413.8 364.6 420.8 364.2 420.8",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.8 420.8 356.8 414.5 356.8 414.2 364.2 420.8 363.8 420.8",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.4 420.8 356.8 414.9 356.8 414.5 363.8 420.8 363.4 420.8",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.1 420.8 356.8 415.2 356.8 414.9 363.4 420.8 363.1 420.8",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.7 420.8 356.8 415.6 356.8 415.2 363.1 420.8 362.7 420.8",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 420.8 356.8 415.9 356.8 415.6 362.7 420.8 362.3 420.8",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.9 420.8 356.8 416.3 356.8 415.9 362.3 420.8 361.9 420.8",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.5 420.8 356.8 416.6 356.8 416.3 361.9 420.8 361.5 420.8",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.8 416.6 361.5 420.8 356.8 420.8 356.8 416.6",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-38)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-39)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360 402.9 359.7 402.7 360 402.7 360 402.9",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 403.3 359.4 402.7 359.7 402.7 360 402.9 360 403.3",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 403.6 359 402.7 359.4 402.7 360 403.3 360 403.6",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 403.9 358.7 402.7 359 402.7 360 403.6 360 403.9",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 404.2 358.3 402.7 358.7 402.7 360 403.9 360 404.2",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 404.5 358 402.7 358.3 402.7 360 404.2 360 404.5",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 404.8 357.6 402.7 358 402.7 360 404.5 360 404.8",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 405.1 357.2 402.7 357.6 402.7 360 404.8 360 405.1",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 405.4 356.9 402.7 357.2 402.7 360 405.1 360 405.4",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 405.8 356.5 402.7 356.9 402.7 360 405.4 360 405.8",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 406.1 356.2 402.7 356.5 402.7 360 405.8 360 406.1",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 406.5 355.8 402.7 356.2 402.7 360 406.1 360 406.5",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 406.8 355.4 402.7 355.8 402.7 360 406.5 360 406.8",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 407.1 355 402.7 355.4 402.7 360 406.8 360 407.1",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 407.5 354.6 402.7 355 402.7 360 407.1 360 407.5",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 407.8 354.2 402.7 354.6 402.7 360 407.5 360 407.8",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 408.2 353.8 402.7 354.2 402.7 360 407.8 360 408.2",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 408.5 353.4 402.7 353.8 402.7 360 408.2 360 408.5",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 408.9 353 402.7 353.4 402.7 360 408.5 360 408.9",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 409.2 352.7 402.7 353 402.7 360 408.9 360 409.2",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 409.6 352.3 402.7 352.7 402.7 360 409.2 360 409.6",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 409.9 351.9 402.7 352.3 402.7 360 409.6 360 409.9",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 410.3 351.5 402.7 351.9 402.7 360 409.9 360 410.3",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 410.6 351.1 402.7 351.5 402.7 360 410.3 360 410.6",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 411 350.7 402.7 351.1 402.7 360 410.6 360 411",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 411.3 350.3 402.7 350.7 402.7 360 411 360 411.3",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 411.6 349.9 402.7 350.3 402.7 360 411.3 360 411.6",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 412 349.7 402.8 349.7 402.7 349.9 402.7 360 411.6 360 412",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 412.3 349.7 403.1 349.7 402.8 360 412 360 412.3",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 412.7 349.7 403.5 349.7 403.1 360 412.3 360 412.7",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 413 349.7 403.8 349.7 403.5 360 412.7 360 413",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.6 413 349.7 404.2 349.7 403.8 360 413 360 413 359.6 413",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.2 413 349.7 404.5 349.7 404.2 359.6 413 359.2 413",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.8 413 349.7 404.9 349.7 404.5 359.2 413 358.8 413",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.4 413 349.7 405.2 349.7 404.9 358.8 413 358.4 413",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.1 413 349.7 405.6 349.7 405.2 358.4 413 358.1 413",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.7 413 349.7 405.9 349.7 405.6 358.1 413 357.7 413",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.3 413 349.7 406.3 349.7 405.9 357.7 413 357.3 413",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.9 413 349.7 406.6 349.7 406.3 357.3 413 356.9 413",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.5 413 349.7 406.9 349.7 406.6 356.9 413 356.5 413",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.1 413 349.7 407.3 349.7 406.9 356.5 413 356.1 413",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.7 413 349.7 407.6 349.7 407.3 356.1 413 355.7 413",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.3 413 349.7 408 349.7 407.6 355.7 413 355.3 413",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.9 413 349.7 408.3 349.7 408 355.3 413 354.9 413",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.6 413 349.7 408.7 349.7 408.3 354.9 413 354.6 413",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.2 413 349.7 409 349.7 408.7 354.6 413 354.2 413",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.8 413 349.7 409.4 349.7 409 354.2 413 353.8 413",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.4 413 349.7 409.7 349.7 409.4 353.8 413 353.4 413",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353 413 349.7 410.1 349.7 409.7 353.4 413 353 413",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 410.1 353 413 349.7 413 349.7 410.1",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-40)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-41)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 415.3 357.4 415.3 357.4 415.3 357.4 415.3",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 415.7 357 415.3 357.4 415.3 357.4 415.3 357.4 415.7",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 416 356.6 415.3 357 415.3 357.4 415.7 357.4 416",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 416.4 356.2 415.3 356.6 415.3 357.4 416 357.4 416.4",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 416.7 355.8 415.3 356.2 415.3 357.4 416.4 357.4 416.7",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 417 355.4 415.3 355.8 415.3 357.4 416.7 357.4 417",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.4 415.3 357.4 417 357.4 425.9 346.9 425.9 346.9 415.3 355.4 415.3",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-42)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-43)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 397.7 354.7 397.6 354.8 397.6 354.8 397.7",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 398 354.3 397.6 354.7 397.6 354.8 397.7 354.8 398",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 398.3 354 397.6 354.3 397.6 354.8 398 354.8 398.3",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 398.6 353.6 397.6 354 397.6 354.8 398.3 354.8 398.6",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 398.9 353.3 397.6 353.6 397.6 354.8 398.6 354.8 398.9",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 399.2 352.9 397.6 353.3 397.6 354.8 398.9 354.8 399.2",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 399.6 352.6 397.6 352.9 397.6 354.8 399.2 354.8 399.6",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 399.9 352.2 397.6 352.6 397.6 354.8 399.6 354.8 399.9",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 400.2 351.9 397.6 352.2 397.6 354.8 399.9 354.8 400.2",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 400.5 351.5 397.6 351.9 397.6 354.8 400.2 354.8 400.5",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 400.8 351.2 397.6 351.5 397.6 354.8 400.5 354.8 400.8",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 401.1 350.8 397.6 351.2 397.6 354.8 400.8 354.8 401.1",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 401.5 350.4 397.6 350.8 397.6 354.8 401.1 354.8 401.5",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 401.8 350.1 397.6 350.4 397.6 354.8 401.5 354.8 401.8",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 402.2 349.7 397.6 350.1 397.6 354.8 401.8 354.8 402.2",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 402.5 349.3 397.6 349.7 397.6 354.8 402.2 354.8 402.5",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 402.9 348.9 397.6 349.3 397.6 354.8 402.5 354.8 402.9",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 403.2 348.5 397.6 348.9 397.6 354.8 402.9 354.8 403.2",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 403.5 348.1 397.6 348.5 397.6 354.8 403.2 354.8 403.5",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 403.9 347.7 397.6 348.1 397.6 354.8 403.5 354.8 403.9",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 404.2 347.3 397.6 347.7 397.6 354.8 403.9 354.8 404.2",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 404.6 346.9 397.6 347.3 397.6 354.8 404.2 354.8 404.6",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 404.9 346.6 397.6 346.9 397.6 354.8 404.6 354.8 404.9",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 405.3 346.2 397.6 346.6 397.6 354.8 404.9 354.8 405.3",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 405.6 345.8 397.6 346.2 397.6 354.8 405.3 354.8 405.6",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 406 345.4 397.6 345.8 397.6 354.8 405.6 354.8 406",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 406.3 345 397.6 345.4 397.6 354.8 406 354.8 406.3",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 406.7 344.6 397.6 345 397.6 354.8 406.3 354.8 406.7",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 407 344.3 397.7 344.3 397.6 344.6 397.6 354.8 406.7 354.8 407",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 407.4 344.3 398.1 344.3 397.7 354.8 407 354.8 407.4",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 407.7 344.3 398.4 344.3 398.1 354.8 407.4 354.8 407.7",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.8 408 344.3 398.7 344.3 398.4 354.8 407.7 354.8 408",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.4 408.1 344.3 399.1 344.3 398.7 354.8 408 354.8 408.1 354.4 408.1",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354 408.1 344.3 399.4 344.3 399.1 354.4 408.1 354 408.1",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.6 408.1 344.3 399.8 344.3 399.4 354 408.1 353.6 408.1",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.3 408.1 344.3 400.1 344.3 399.8 353.6 408.1 353.3 408.1",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.9 408.1 344.3 400.5 344.3 400.1 353.3 408.1 352.9 408.1",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.5 408.1 344.3 400.8 344.3 400.5 352.9 408.1 352.5 408.1",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.1 408.1 344.3 401.2 344.3 400.8 352.5 408.1 352.1 408.1",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.7 408.1 344.3 401.5 344.3 401.2 352.1 408.1 351.7 408.1",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.3 408.1 344.3 401.9 344.3 401.5 351.7 408.1 351.3 408.1",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.9 408.1 344.3 402.2 344.3 401.9 351.3 408.1 350.9 408.1",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.5 408.1 344.3 402.6 344.3 402.2 350.9 408.1 350.5 408.1",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.1 408.1 344.3 402.9 344.3 402.6 350.5 408.1 350.1 408.1",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.8 408.1 344.3 403.3 344.3 402.9 350.1 408.1 349.8 408.1",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.4 408.1 344.3 403.6 344.3 403.3 349.8 408.1 349.4 408.1",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349 408.1 344.3 403.9 344.3 403.6 349.4 408.1 349 408.1",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.6 408.1 344.3 404.3 344.3 403.9 349 408.1 348.6 408.1",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.2 408.1 344.3 404.6 344.3 404.3 348.6 408.1 348.2 408.1",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.8 408.1 344.3 405 344.3 404.6 348.2 408.1 347.8 408.1",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.4 408.1 344.3 405.3 344.3 405 347.8 408.1 347.4 408.1",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.3 405.3 347.4 408.1 344.3 408.1 344.3 405.3",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-44)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-45)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 402.8 349.6 402.6 349.7 402.6 349.7 402.8",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 403.1 349.2 402.6 349.6 402.6 349.7 402.8 349.7 403.1",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 403.5 348.8 402.6 349.2 402.6 349.7 403.1 349.7 403.5",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 403.8 348.4 402.6 348.8 402.6 349.7 403.5 349.7 403.8",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 404.2 348 402.6 348.4 402.6 349.7 403.8 349.7 404.2",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 404.5 347.6 402.6 348 402.6 349.7 404.2 349.7 404.5",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 404.9 347.2 402.6 347.6 402.6 349.7 404.5 349.7 404.9",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 405.2 346.8 402.6 347.2 402.6 349.7 404.9 349.7 405.2",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 405.5 346.5 402.6 346.8 402.6 349.7 405.2 349.7 405.5",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 405.9 346.1 402.6 346.5 402.6 349.7 405.5 349.7 405.9",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 406.2 345.7 402.6 346.1 402.6 349.7 405.9 349.7 406.2",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 406.6 345.3 402.6 345.7 402.6 349.7 406.2 349.7 406.6",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 406.9 344.9 402.6 345.3 402.6 349.7 406.6 349.7 406.9",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 407.3 344.5 402.6 344.9 402.6 349.7 406.9 349.7 407.3",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 407.6 344.1 402.6 344.5 402.6 349.7 407.3 349.7 407.6",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 408 343.7 402.6 344.1 402.6 349.7 407.6 349.7 408",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 408.3 343.3 402.6 343.7 402.6 349.7 408 349.7 408.3",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 408.7 343 402.6 343.3 402.6 349.7 408.3 349.7 408.7",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 409 342.6 402.6 343 402.6 349.7 408.7 349.7 409",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 409.4 342.2 402.6 342.6 402.6 349.7 409 349.7 409.4",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 409.7 341.8 402.6 342.2 402.6 349.7 409.4 349.7 409.7",
    fill: "#00c05c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.7 410 341.4 402.6 341.8 402.6 349.7 409.7 349.7 410",
    fill: "#00c15b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.4 402.6 349.7 410 349.7 413.1 339.3 413.1 339.3 402.6 341.4 402.6",
    fill: "#00c15b",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-47)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 397.8 359.7 397.7 359.8 397.7 359.8 397.8",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 398.1 359.3 397.7 359.7 397.7 359.8 397.8 359.8 398.1",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 398.5 359 397.7 359.3 397.7 359.8 398.1 359.8 398.5",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 398.8 358.6 397.7 359 397.7 359.8 398.5 359.8 398.8",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 399.1 358.3 397.7 358.6 397.7 359.8 398.8 359.8 399.1",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 399.4 357.9 397.7 358.3 397.7 359.8 399.1 359.8 399.4",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 399.7 357.5 397.7 357.9 397.7 359.8 399.4 359.8 399.7",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 400 357.2 397.7 357.5 397.7 359.8 399.7 359.8 400",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 400.3 356.8 397.7 357.2 397.7 359.8 400 359.8 400.3",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 400.6 356.5 397.7 356.8 397.7 359.8 400.3 359.8 400.6",
    fill: "#009892",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 401 356.1 397.7 356.5 397.7 359.8 400.6 359.8 401",
    fill: "#009991",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 401.3 355.8 397.7 356.1 397.7 359.8 401 359.8 401.3",
    fill: "#009990",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 401.6 355.4 397.7 355.8 397.7 359.8 401.3 359.8 401.6",
    fill: "#009a8f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 401.9 355.1 397.7 355.4 397.7 359.8 401.6 359.8 401.9",
    fill: "#009b8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 402.2 354.7 397.7 355.1 397.7 359.8 401.9 359.8 402.2",
    fill: "#009c8d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 402.5 354.4 397.7 354.7 397.7 359.8 402.2 359.8 402.5",
    fill: "#009c8c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 402.8 354 397.7 354.4 397.7 359.8 402.5 359.8 402.8",
    fill: "#009d8b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 403.1 353.7 397.7 354 397.7 359.8 402.8 359.8 403.1",
    fill: "#009e8a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 403.5 353.3 397.7 353.7 397.7 359.8 403.1 359.8 403.5",
    fill: "#009f89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 403.8 353 397.7 353.3 397.7 359.8 403.5 359.8 403.8",
    fill: "#009f88",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 404.1 352.6 397.7 353 397.7 359.8 403.8 359.8 404.1",
    fill: "#00a087",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 404.4 352.3 397.7 352.6 397.7 359.8 404.1 359.8 404.4",
    fill: "#00a186",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 404.7 351.9 397.7 352.3 397.7 359.8 404.4 359.8 404.7",
    fill: "#00a285",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 405 351.6 397.7 351.9 397.7 359.8 404.7 359.8 405",
    fill: "#00a284",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 405.3 351.2 397.7 351.6 397.7 359.8 405 359.8 405.3",
    fill: "#00a383",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 405.6 350.9 397.7 351.2 397.7 359.8 405.3 359.8 405.6",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 406 350.5 397.7 350.9 397.7 359.8 405.6 359.8 406",
    fill: "#00a482",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 406.3 350.1 397.7 350.5 397.7 359.8 406 359.8 406.3",
    fill: "#00a581",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 406.7 349.7 397.7 350.1 397.7 359.8 406.3 359.8 406.7",
    fill: "#00a680",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 407 349.5 397.8 349.5 397.7 349.7 397.7 359.8 406.7 359.8 407",
    fill: "#00a67f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 407.4 349.5 398.2 349.5 397.8 359.8 407 359.8 407.4",
    fill: "#00a77e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.8 407.7 349.5 398.5 349.5 398.2 359.8 407.4 359.8 407.7",
    fill: "#00a87d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.7 408 349.5 398.8 349.5 398.5 359.8 407.7 359.8 408 359.7 408",
    fill: "#00a97c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.4 408 349.5 399.2 349.5 398.8 359.7 408 359.4 408",
    fill: "#00a97b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359 408 349.5 399.5 349.5 399.2 359.4 408 359 408",
    fill: "#00aa7a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.6 408 349.5 399.9 349.5 399.5 359 408 358.6 408",
    fill: "#00ab79",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.2 408 349.5 400.2 349.5 399.9 358.6 408 358.2 408",
    fill: "#00ac78",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.8 408 349.5 400.6 349.5 400.2 358.2 408 357.8 408",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.4 408 349.5 400.9 349.5 400.6 357.8 408 357.4 408",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357 408 349.5 401.3 349.5 400.9 357.4 408 357 408",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.6 408 349.5 401.6 349.5 401.3 357 408 356.6 408",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.3 408 349.5 402 349.5 401.6 356.6 408 356.3 408",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.9 408 349.5 402.3 349.5 402 356.3 408 355.9 408",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.5 408 349.5 402.7 349.5 402.3 355.9 408 355.5 408",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.1 408 349.5 403 349.5 402.7 355.5 408 355.1 408",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.7 408 349.5 403.4 349.5 403 355.1 408 354.7 408",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.3 408 349.5 403.7 349.5 403.4 354.7 408 354.3 408",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.9 408 349.5 404 349.5 403.7 354.3 408 353.9 408",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.5 408 349.5 404.4 349.5 404 353.9 408 353.5 408",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.1 408 349.5 404.7 349.5 404.4 353.5 408 353.1 408",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.8 408 349.5 405.1 349.5 404.7 353.1 408 352.8 408",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.4 408 349.5 405.4 349.5 405.1 352.8 408 352.4 408",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352 408 349.5 405.8 349.5 405.4 352.4 408 352 408",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.6 408 349.5 406.1 349.5 405.8 352 408 351.6 408",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.2 408 349.5 406.5 349.5 406.1 351.6 408 351.2 408",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.8 408 349.5 406.8 349.5 406.5 351.2 408 350.8 408",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.4 408 349.5 407.2 349.5 406.8 350.8 408 350.4 408",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350 408 349.5 407.5 349.5 407.2 350.4 408 350 408",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 408 349.5 407.9 349.5 407.5 350 408 349.6 408",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.5 407.9 349.6 408 349.5 408 349.5 407.9",
    fill: "#00bd60",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-49)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367 397.9 367 397.8 367 397.8 367 397.9",
    fill: "#0081b1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 398.2 366.6 397.8 367 397.8 367 397.9 367 398.2",
    fill: "#0082b0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 398.5 366.3 397.8 366.6 397.8 367 398.2 367 398.5",
    fill: "#0083af",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 398.9 365.9 397.8 366.3 397.8 367 398.5 367 398.9",
    fill: "#0083ae",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 399.2 365.6 397.8 365.9 397.8 367 398.9 367 399.2",
    fill: "#0084ad",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 399.5 365.2 397.8 365.6 397.8 367 399.2 367 399.5",
    fill: "#0085ac",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 399.8 364.9 397.8 365.2 397.8 367 399.5 367 399.8",
    fill: "#0086ab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 400.1 364.5 397.8 364.9 397.8 367 399.8 367 400.1",
    fill: "#0086aa",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 400.4 364.2 397.8 364.5 397.8 367 400.1 367 400.4",
    fill: "#0087a9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 400.7 363.8 397.8 364.2 397.8 367 400.4 367 400.7",
    fill: "#0088a8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 401 363.5 397.8 363.8 397.8 367 400.7 367 401",
    fill: "#0089a7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 401.4 363.1 397.8 363.5 397.8 367 401 367 401.4",
    fill: "#0089a5",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 401.7 362.8 397.8 363.1 397.8 367 401.4 367 401.7",
    fill: "#008aa4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 402 362.4 397.8 362.8 397.8 367 401.7 367 402",
    fill: "#008ba3",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 402.3 362.1 397.9 362.1 397.8 362.4 397.8 367 402 367 402.3",
    fill: "#008ca2",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367 402.6 362.1 398.2 362.1 397.9 367 402.3 367 402.6",
    fill: "#008ca1",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.9 402.8 362.1 398.5 362.1 398.2 367 402.6 367 402.8 366.9 402.8",
    fill: "#008da0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.5 402.8 362.1 398.8 362.1 398.5 366.9 402.8 366.5 402.8",
    fill: "#008e9f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.2 402.8 362.1 399.1 362.1 398.8 366.5 402.8 366.2 402.8",
    fill: "#008f9e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.8 402.8 362.1 399.5 362.1 399.1 366.2 402.8 365.8 402.8",
    fill: "#008f9d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.5 402.8 362.1 399.8 362.1 399.5 365.8 402.8 365.5 402.8",
    fill: "#00909c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.1 402.8 362.1 400.1 362.1 399.8 365.5 402.8 365.1 402.8",
    fill: "#00919b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.8 402.8 362.1 400.4 362.1 400.1 365.1 402.8 364.8 402.8",
    fill: "#00929a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.4 402.8 362.1 400.7 362.1 400.4 364.8 402.8 364.4 402.8",
    fill: "#009399",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.1 402.8 362.1 401 362.1 400.7 364.4 402.8 364.1 402.8",
    fill: "#009398",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.7 402.8 362.1 401.3 362.1 401 364.1 402.8 363.7 402.8",
    fill: "#009497",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.4 402.8 362.1 401.6 362.1 401.3 363.7 402.8 363.4 402.8",
    fill: "#009596",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363 402.8 362.1 402 362.1 401.6 363.4 402.8 363 402.8",
    fill: "#009695",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.7 402.8 362.1 402.3 362.1 402 363 402.8 362.7 402.8",
    fill: "#009694",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 402.8 362.1 402.6 362.1 402.3 362.7 402.8 362.3 402.8",
    fill: "#009793",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.1 402.6 362.3 402.8 362.1 402.8 362.1 402.6",
    fill: "#009892",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-50)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-51)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 400.8 349.3 400.5 349.6 400.5 349.6 400.8",
    fill: "#00ac77",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 401.1 348.9 400.5 349.3 400.5 349.6 400.8 349.6 401.1",
    fill: "#00ad76",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 401.5 348.5 400.5 348.9 400.5 349.6 401.1 349.6 401.5",
    fill: "#00ae75",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 401.8 348.1 400.5 348.5 400.5 349.6 401.5 349.6 401.8",
    fill: "#00af74",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 402.2 347.7 400.5 348.1 400.5 349.6 401.8 349.6 402.2",
    fill: "#00af73",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 402.5 347.3 400.5 347.7 400.5 349.6 402.2 349.6 402.5",
    fill: "#00b072",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 402.9 346.9 400.5 347.3 400.5 349.6 402.5 349.6 402.9",
    fill: "#00b171",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 403.2 346.6 400.5 346.9 400.5 349.6 402.9 349.6 403.2",
    fill: "#00b270",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 403.6 346.2 400.5 346.6 400.5 349.6 403.2 349.6 403.6",
    fill: "#00b36f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 403.9 345.8 400.5 346.2 400.5 349.6 403.6 349.6 403.9",
    fill: "#00b36d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 404.3 345.4 400.5 345.8 400.5 349.6 403.9 349.6 404.3",
    fill: "#00b46c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 404.6 345 400.5 345.4 400.5 349.6 404.3 349.6 404.6",
    fill: "#00b56b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 405 344.7 400.6 344.7 400.5 345 400.5 349.6 404.6 349.6 405",
    fill: "#00b66a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.6 405.3 344.7 400.9 344.7 400.6 349.6 405 349.6 405.3",
    fill: "#00b669",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.4 405.4 344.7 401.3 344.7 400.9 349.6 405.3 349.6 405.4 349.4 405.4",
    fill: "#00b768",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349 405.4 344.7 401.6 344.7 401.3 349.4 405.4 349 405.4",
    fill: "#00b867",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.6 405.4 344.7 401.9 344.7 401.6 349 405.4 348.6 405.4",
    fill: "#00b966",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.2 405.4 344.7 402.3 344.7 401.9 348.6 405.4 348.2 405.4",
    fill: "#00b965",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.8 405.4 344.7 402.6 344.7 402.3 348.2 405.4 347.8 405.4",
    fill: "#00ba64",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.4 405.4 344.7 403 344.7 402.6 347.8 405.4 347.4 405.4",
    fill: "#00bb63",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347 405.4 344.7 403.3 344.7 403 347.4 405.4 347 405.4",
    fill: "#00bc62",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.6 405.4 344.7 403.7 344.7 403.3 347 405.4 346.6 405.4",
    fill: "#00bc61",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 405.4 344.7 404 344.7 403.7 346.6 405.4 346.3 405.4",
    fill: "#00bd60",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.9 405.4 344.7 404.4 344.7 404 346.3 405.4 345.9 405.4",
    fill: "#00be5f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.5 405.4 344.7 404.7 344.7 404.4 345.9 405.4 345.5 405.4",
    fill: "#00bf5e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.1 405.4 344.7 405.1 344.7 404.7 345.5 405.4 345.1 405.4",
    fill: "#00bf5d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.7 405.1 345.1 405.4 344.7 405.4 344.7 405.1",
    fill: "#00c05c",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-52)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 415.5,
    width: 4.9,
    height: 4.9,
    fill: "#00c15b",
    strokeWidth: 0
  })))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 354.3,
    cy: 609.9,
    r: 6.2,
    fill: "#405a8e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,617.1c-3.9,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2,7.2,3.2,7.2,7.2-3.2,7.2-7.2,7.2ZM354.3,604.8c-2.8,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiPageDesign2);
export default __webpack_public_path__ + "static/media/UI_page_design_2.fce309361b8d96efcf5545ccb53d4ea8.svg";
export { ForwardRef as ReactComponent };